import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'state/graphql/hooks/use-sanity-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
}

export interface IAccordionEntry {
  readonly __typename?: 'AccordionEntry';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly collapsedContent?: Maybe<ILocaleString>;
  readonly expandedContent?: Maybe<ILocaleString>;
}

export interface IAccordionWidget {
  readonly __typename?: 'AccordionWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly accordionContent?: Maybe<ReadonlyArray<Maybe<IAccordionEntry>>>;
  readonly accordionTitle?: Maybe<ILocaleString>;
}

export type IAccordionWidgetOrAnchorLinksWidgetOrAnchorWidgetOrCallToActionWidgetOrDoubleImageWidgetOrDownloadFileWidgetOrHeaderWidgetOrImageWidgetOrLocaleBlockTextWidgetOrMultiWidgetOrNutritionExplorerWidgetOrNutritionInfoWidgetOrPreviewWidgetOrQuoteWidgetOrRewardsCarouselWidgetOrVideoWidgetOrWebViewWidgetOrYoutubeWidget = IAccordionWidget | IAnchorLinksWidget | IAnchorWidget | ICallToActionWidget | IDoubleImageWidget | IDownloadFileWidget | IHeaderWidget | IImageWidget | ILocaleBlockTextWidget | IMultiWidget | INutritionExplorerWidget | INutritionInfoWidget | IPreviewWidget | IQuoteWidget | IRewardsCarouselWidget | IVideoWidget | IWebViewWidget | IYoutubeWidget;

export interface IActionButton {
  readonly __typename?: 'ActionButton';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttonPath?: Maybe<ILocaleString>;
  readonly buttonText?: Maybe<ILocaleString>;
}

export interface IAdaptableMenuCard extends IDocument {
  readonly __typename?: 'AdaptableMenuCard';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundColor?: Maybe<IColor>;
  readonly buttonBackgroundColor?: Maybe<IColor>;
  readonly buttonTextColor?: Maybe<IColor>;
  readonly ctaButtonText?: Maybe<ILocaleString>;
  readonly description?: Maybe<ILocaleString>;
  /** Use custom text and background colors. Please ensure that the colors meet the guidelines for contrast accessibility (https://accessible-colors.com/) */
  readonly hasCustomColors?: Maybe<Scalars['Boolean']>;
  readonly hasTerms?: Maybe<Scalars['Boolean']>;
  readonly header?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImages>;
  /** Menu element linked to the card, usefull to check availability and generate the card url link */
  readonly menuElement?: Maybe<IComboOrConfigOfferOrItemOrPickerOrSystemwideOffer>;
  readonly path?: Maybe<ILocaleUrl>;
  readonly termsButton?: Maybe<ILinkAction>;
  readonly termsText?: Maybe<ILocaleBlockContent>;
  readonly textColor?: Maybe<IColor>;
}

export interface IAdaptableMenuCardFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly hasCustomColors?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasCustomColors_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasCustomColors_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasTerms?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasTerms_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasTerms_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly menuElement?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IAdaptableMenuCardGroup extends IDocument {
  readonly __typename?: 'AdaptableMenuCardGroup';
  readonly Cards?: Maybe<ReadonlyArray<Maybe<IAdaptableMenuCard>>>;
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IAdaptableMenuCardGroupFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IAddOnSection extends IDocument {
  readonly __typename?: 'AddOnSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** This is the max limit for the entire section in total. This will override any max set for individual items if this limit is reached before the items limit. Leaving this blank will not put a limit on the section itself. */
  readonly maxAmount?: Maybe<Scalars['Float']>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IAddOnSectionOption>>>;
  readonly sectionItemsServiceModes?: Maybe<IAddOnSectionServiceModes>;
  /** All the items from this section will be available directly in the cart. The section name will be the header title. */
  readonly showSectionItemsOnCart?: Maybe<Scalars['Boolean']>;
}

export interface IAddOnSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly maxAmount?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly maxAmount_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly maxAmount_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly maxAmount_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly maxAmount_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly maxAmount_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly maxAmount_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly showSectionItemsOnCart?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly showSectionItemsOnCart_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly showSectionItemsOnCart_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IAddOnSectionOption {
  readonly __typename?: 'AddOnSectionOption';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** This is the max limit for this individual Add On Item. If there is a section max we will use that instead based on the other items in the section. If this is left blank this item will be unlimited unless there is a section max. */
  readonly maxAmount?: Maybe<Scalars['Float']>;
  readonly option?: Maybe<IItem>;
}

export interface IAddOnSectionServiceModes {
  readonly __typename?: 'AddOnSectionServiceModes';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly curbsideServiceMode?: Maybe<Scalars['Boolean']>;
  readonly dineInServiceMode?: Maybe<Scalars['Boolean']>;
  readonly driveThruServiceMode?: Maybe<Scalars['Boolean']>;
  readonly pickUpServiceMode?: Maybe<Scalars['Boolean']>;
  readonly tableServiceMode?: Maybe<Scalars['Boolean']>;
}

export interface IAdditionalItemInformation {
  readonly __typename?: 'AdditionalItemInformation';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly additives?: Maybe<ILocaleString>;
  readonly ingredients?: Maybe<ILocaleString>;
  readonly producerDetails?: Maybe<ILocaleString>;
  /** Only used by BK DE - Legal Requirement */
  readonly sourcesOfGluten?: Maybe<Scalars['String']>;
}

export interface IAdditionalTimeSlot {
  readonly __typename?: 'AdditionalTimeSlot';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly close?: Maybe<Scalars['String']>;
  readonly open?: Maybe<Scalars['String']>;
}

export interface IAddress {
  readonly __typename?: 'Address';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly address1?: Maybe<Scalars['String']>;
  readonly address2?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly stateProvince?: Maybe<Scalars['String']>;
  readonly stateProvinceShort?: Maybe<Scalars['String']>;
}

export interface IAdminToolReleaseNotes extends IDocument {
  readonly __typename?: 'AdminToolReleaseNotes';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly releaseDate?: Maybe<Scalars['Date']>;
  readonly releaseNotesRaw?: Maybe<Scalars['JSON']>;
  readonly releaseNotesTitle?: Maybe<Scalars['String']>;
  readonly syncReleaseNotes?: Maybe<Scalars['String']>;
}

export interface IAdminToolReleaseNotesFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly releaseDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly releaseDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly releaseDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly releaseDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly releaseDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly releaseDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly releaseDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly releaseNotesTitle?: InputMaybe<Scalars['String']>;
  readonly releaseNotesTitle_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly releaseNotesTitle_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly releaseNotesTitle_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly releaseNotesTitle_not?: InputMaybe<Scalars['String']>;
  readonly releaseNotesTitle_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly syncReleaseNotes?: InputMaybe<Scalars['String']>;
  readonly syncReleaseNotes_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly syncReleaseNotes_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly syncReleaseNotes_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly syncReleaseNotes_not?: InputMaybe<Scalars['String']>;
  readonly syncReleaseNotes_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IAdyenConfig {
  readonly __typename?: 'AdyenConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly clientKey?: Maybe<Scalars['String']>;
  readonly environment?: Maybe<Scalars['String']>;
  readonly urlPrefix?: Maybe<Scalars['String']>;
}

export interface IAlert extends IDocument {
  readonly __typename?: 'Alert';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly body?: Maybe<ILocaleString>;
  readonly heading?: Maybe<ILocaleString>;
  readonly learnMoreText?: Maybe<ILocaleString>;
  readonly learnMoreUrl?: Maybe<ILocaleString>;
}

export interface IAlertFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export type IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrGoogleAdSlotOrHeroOrLockedOffersOrMainHeroOrMarketingCardGroupOrMarketingTileCarouselOrMarketingTileGroupOrOffersSectionOrOurServicesOrQuestsSectionOrRecentItemsOrRewardsSectionOrRollUpTheRimSectionOrScanForRewardsOrSimpleHomePageOrTimsRewardsPointsSectionOrTrending = IAlert | IAppDownload | IBrazeContentCards | IFanFavorites | IGoogleAdSlot | IHero | ILockedOffers | IMainHero | IMarketingCardGroup | IMarketingTileCarousel | IMarketingTileGroup | IOffersSection | IOurServices | IQuestsSection | IRecentItems | IRewardsSection | IRollUpTheRimSection | IScanForRewards | ISimpleHomePage | ITimsRewardsPointsSection | ITrending;

export type IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrLockedOffersOrMainHeroOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrTrending = IAlert | IAppDownload | IBrazeContentCards | IFanFavorites | ILockedOffers | IMainHero | IMarketingTileGroup | IOffersSection | IOurServices | IRecentItems | ITrending;

export interface IAllowRedemptionWithoutLogin {
  readonly __typename?: 'AllowRedemptionWithoutLogin';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly allowRedemptionWithoutLogin?: Maybe<Scalars['String']>;
}

export type IAllowRedemptionWithoutLoginOrAndOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrOrOrOrderHistoryOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IAnd | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | ILimit | IOr | IOrderHistory | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export type IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICartRequirement | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | IIsStackable | ILimit | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export type IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICartRequirement | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | ILimit | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export interface IAnchorLinksWidget {
  readonly __typename?: 'AnchorLinksWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IAnchorWidget {
  readonly __typename?: 'AnchorWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly anchorName?: Maybe<ILocaleString>;
}

export interface IAnd {
  readonly __typename?: 'And';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ruleSet?: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>;
}

export type IAndOrBetweenTimesOrCartContainsPluOrCartPropertyOrDayOfWeekBandOrOrOrPaymentCardTypeOrPurchase = IAnd | IBetweenTimes | ICartContainsPlu | ICartProperty | IDayOfWeekBand | IOr | IPaymentCardType | IPurchase;

export interface IApiKeysConfig {
  readonly __typename?: 'ApiKeysConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly amplitude?: Maybe<Scalars['String']>;
  readonly amplitudeExperiments?: Maybe<Scalars['String']>;
  readonly branch?: Maybe<Scalars['String']>;
  /** Found in "Braze" > "Manage Settings" > "Settings" > "API Key". */
  readonly braze?: Maybe<Scalars['String']>;
  readonly bringg?: Maybe<Scalars['String']>;
  readonly googleAnalytics?: Maybe<Scalars['String']>;
  readonly googleMaps?: Maybe<Scalars['String']>;
  readonly googleMapsAndroid?: Maybe<Scalars['String']>;
  readonly googleMapsIOS?: Maybe<Scalars['String']>;
  readonly googleMapsWeb?: Maybe<Scalars['String']>;
  readonly launchDarkly?: Maybe<Scalars['String']>;
  readonly launchDarklyMobileKey?: Maybe<Scalars['String']>;
  readonly logRocket?: Maybe<Scalars['String']>;
  readonly mParticle?: Maybe<Scalars['String']>;
  readonly radar?: Maybe<Scalars['String']>;
  readonly salesForceToken?: Maybe<Scalars['String']>;
  readonly tomtom?: Maybe<Scalars['String']>;
}

export interface IAppData extends IDocument {
  readonly __typename?: 'AppData';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly aboutMenuEntries?: Maybe<INavigationSection>;
  readonly appDownloadSection?: Maybe<IAppDownloadSection>;
  readonly appHeaderText?: Maybe<Scalars['String']>;
  readonly appImage?: Maybe<IImage>;
  readonly appImageLocale?: Maybe<ILocaleImage>;
  /** was moved to Feature Mobile App Configuration */
  readonly appVersion?: Maybe<IAppVersion>;
  readonly appleWalletImage?: Maybe<ILocaleImage>;
  readonly calorieDisclaimer?: Maybe<ILocaleBlockContent>;
  /** was moved to Feature/Feature Menu */
  readonly cateringMenu?: Maybe<IMenu>;
  readonly cateringSection?: Maybe<ISection>;
  readonly communicationPreferencesDisclaimer?: Maybe<ILocaleString>;
  readonly communicationPreferencesDisclaimerBlock?: Maybe<ILocaleBlockContent>;
  readonly contentCardsHeader?: Maybe<ILocaleString>;
  readonly contentCardsSubheader?: Maybe<ILocaleString>;
  readonly copyrightAndTrademarkDisclaimer?: Maybe<ILocaleString>;
  readonly countryDisclaimer?: Maybe<ILocaleString>;
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<IDayPart>>>;
  readonly defaultHeroImage?: Maybe<IImage>;
  readonly defaultHeroImageLocale?: Maybe<ILocaleImage>;
  /** was moved to Feature/Feature Menu */
  readonly defaultMenu?: Maybe<IMenu>;
  readonly emailAndPushOptInSettings?: Maybe<ReadonlyArray<Maybe<IOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum>>>;
  readonly fanFavoriteItems?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>;
  readonly favoriteSection?: Maybe<IFavoriteSection>;
  readonly geolocationModalImage?: Maybe<IImage>;
  readonly geolocationModalImageUseLocale?: Maybe<ILocaleImage>;
  readonly giftCardImage?: Maybe<ILocaleImage>;
  readonly giftCardTextImage?: Maybe<ILocaleImage>;
  readonly googlePayImage?: Maybe<ILocaleImage>;
  /** Is the title of this document */
  readonly headerText?: Maybe<Scalars['String']>;
  readonly heroAction?: Maybe<ILinkAction>;
  readonly heroActionAuthenticated?: Maybe<ILinkAction>;
  readonly heroActionLeft?: Maybe<ILinkAction>;
  readonly heroActionLeftIcon?: Maybe<ILocaleImage>;
  readonly heroActionRight?: Maybe<ILinkAction>;
  readonly heroActionRightIcon?: Maybe<ILocaleImage>;
  readonly heroMaskCards?: Maybe<ReadonlyArray<Maybe<ISimpleCard>>>;
  readonly heroSubText?: Maybe<ILocaleString>;
  readonly heroSubTextAuthenticated?: Maybe<ILocaleString>;
  readonly heroSuperText?: Maybe<ILocaleString>;
  readonly heroSuperTextAuthenticated?: Maybe<ILocaleString>;
  /** Is visible to Unauthenticated users */
  readonly heroText?: Maybe<Scalars['String']>;
  /** Is visible to Authenticated users */
  readonly heroTextAuthenticated?: Maybe<Scalars['String']>;
  readonly heroTextAuthenticatedLocale?: Maybe<ILocaleString>;
  /** was moved to Components/Main Hero; Color for all hero content text. White and black align with the brand color scheme equivalent */
  readonly heroTextColor?: Maybe<Scalars['String']>;
  readonly heroTextLocale?: Maybe<ILocaleString>;
  readonly homeGraphic?: Maybe<IHomeGraphic>;
  readonly imagesDisclaimer?: Maybe<ILocaleString>;
  readonly kioskAppData?: Maybe<IKioskAppData>;
  readonly kioskAttractLoopImage?: Maybe<IImage>;
  readonly kioskAttractLoopImageLocale?: Maybe<ILocaleImage>;
  readonly loadingGraphics?: Maybe<ILoadingGraphics>;
  readonly loyaltyCardImage?: Maybe<ILocaleImage>;
  readonly loyaltyHeaderBackgroundImage?: Maybe<IImage>;
  readonly loyaltyHeroAction?: Maybe<ILinkAction>;
  readonly loyaltyHeroSubText?: Maybe<ILocaleString>;
  readonly loyaltyHeroSuperText?: Maybe<ILocaleString>;
  readonly loyaltyInfoImage?: Maybe<ILocaleImage>;
  readonly mainHeroImage?: Maybe<IImage>;
  readonly mainHeroImageAuthenticated?: Maybe<IImage>;
  readonly mainHeroImageAuthenticatedLocale?: Maybe<ILocaleImage>;
  readonly mainHeroImageLocale?: Maybe<ILocaleImage>;
  readonly mainHeroMobileImage?: Maybe<IImage>;
  readonly mainHeroMobileImageLocale?: Maybe<ILocaleImage>;
  readonly menuHeroImage?: Maybe<IImage>;
  readonly menuHeroImageLocale?: Maybe<ILocaleImage>;
  readonly menuHeroText?: Maybe<Scalars['String']>;
  readonly menuHeroTextLocale?: Maybe<ILocaleString>;
  readonly offersDisclaimer?: Maybe<ILocaleString>;
  readonly ourAppHeroImage?: Maybe<IImage>;
  readonly ourAppHeroImageLocale?: Maybe<ILocaleImage>;
  readonly ourServicesHeroImage?: Maybe<IImage>;
  readonly ourServicesHeroImageLocale?: Maybe<ILocaleImage>;
  readonly phoneNumberDisclaimer?: Maybe<ILocaleString>;
  readonly priceDisclaimer?: Maybe<ILocaleString>;
  readonly promotions?: Maybe<ReadonlyArray<Maybe<IComboOrExternalLinkOrItemOrOfferOrPickerOrSection>>>;
  readonly recentOrderHeroText?: Maybe<Scalars['String']>;
  readonly recentOrderHeroTextLocale?: Maybe<ILocaleString>;
  readonly reservedRightsDisclaimer?: Maybe<ILocaleString>;
  readonly rewardsMainImage?: Maybe<IImage>;
  readonly rewardsMainImageLocale?: Maybe<ILocaleImage>;
  readonly servicesHeaderText?: Maybe<Scalars['String']>;
  readonly servicesHeaderTextLocale?: Maybe<ILocaleString>;
  readonly servicesHeroText?: Maybe<Scalars['String']>;
  readonly servicesHeroTextLocale?: Maybe<ILocaleString>;
  /** can be added in Feature Homepage */
  readonly siteAlert?: Maybe<IAlert>;
  readonly sodiumDisclaimer?: Maybe<ILocaleBlockContent>;
  readonly sortedOffers?: Maybe<ReadonlyArray<Maybe<IOffer>>>;
  readonly storeLocatorContent?: Maybe<IStoreLocatorContent>;
  readonly superUpsellDisclaimer?: Maybe<ILocaleBlockContent>;
  /** was moved to Feature/Feature Menu */
  readonly upsellItemAtCheckout?: Maybe<IItem>;
  readonly upsellItemsAtCheckout?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly upsellItemsAtCheckoutCatering?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly upsellItemsAtCheckoutDelivery?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly upsellItemsAtCheckoutRestaurant?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly useSideBySideHeroButtons?: Maybe<Scalars['Boolean']>;
}

export interface IAppDataFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly appHeaderText?: InputMaybe<Scalars['String']>;
  readonly appHeaderText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly appHeaderText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly appHeaderText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly appHeaderText_not?: InputMaybe<Scalars['String']>;
  readonly appHeaderText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly appVersion?: InputMaybe<Scalars['ID']>;
  readonly cateringMenu?: InputMaybe<Scalars['ID']>;
  readonly cateringSection?: InputMaybe<Scalars['ID']>;
  readonly defaultMenu?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly headerText?: InputMaybe<Scalars['String']>;
  readonly headerText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly headerText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly headerText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly headerText_not?: InputMaybe<Scalars['String']>;
  readonly headerText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly heroText?: InputMaybe<Scalars['String']>;
  /** All documents that are equal to given value */
  readonly heroTextAuthenticated?: InputMaybe<Scalars['String']>;
  readonly heroTextAuthenticated_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly heroTextAuthenticated_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly heroTextAuthenticated_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly heroTextAuthenticated_not?: InputMaybe<Scalars['String']>;
  readonly heroTextAuthenticated_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly heroTextColor?: InputMaybe<Scalars['String']>;
  readonly heroTextColor_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly heroTextColor_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly heroTextColor_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly heroTextColor_not?: InputMaybe<Scalars['String']>;
  readonly heroTextColor_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly heroText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly heroText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly heroText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly heroText_not?: InputMaybe<Scalars['String']>;
  readonly heroText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly kioskAppData?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly menuHeroText?: InputMaybe<Scalars['String']>;
  readonly menuHeroText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly menuHeroText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly menuHeroText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly menuHeroText_not?: InputMaybe<Scalars['String']>;
  readonly menuHeroText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly recentOrderHeroText?: InputMaybe<Scalars['String']>;
  readonly recentOrderHeroText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly recentOrderHeroText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly recentOrderHeroText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly recentOrderHeroText_not?: InputMaybe<Scalars['String']>;
  readonly recentOrderHeroText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly servicesHeaderText?: InputMaybe<Scalars['String']>;
  readonly servicesHeaderText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly servicesHeaderText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly servicesHeaderText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly servicesHeaderText_not?: InputMaybe<Scalars['String']>;
  readonly servicesHeaderText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly servicesHeroText?: InputMaybe<Scalars['String']>;
  readonly servicesHeroText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly servicesHeroText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly servicesHeroText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly servicesHeroText_not?: InputMaybe<Scalars['String']>;
  readonly servicesHeroText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly siteAlert?: InputMaybe<Scalars['ID']>;
  readonly upsellItemAtCheckout?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly useSideBySideHeroButtons?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly useSideBySideHeroButtons_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly useSideBySideHeroButtons_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IAppDownload extends IDocument {
  readonly __typename?: 'AppDownload';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly details?: Maybe<IAppDownloadSection>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IAppDownloadFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IAppDownloadSection {
  readonly __typename?: 'AppDownloadSection';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly androidDownloadImage?: Maybe<ILocaleImage>;
  readonly androidDownloadLink?: Maybe<Scalars['String']>;
  readonly backgroundImage?: Maybe<IImage>;
  readonly copy?: Maybe<ILocaleString>;
  readonly header?: Maybe<ILocaleString>;
  readonly headerSuperText?: Maybe<ILocaleString>;
  readonly huaweiDownloadImage?: Maybe<ILocaleImage>;
  readonly huaweiDownloadLink?: Maybe<Scalars['String']>;
  readonly iOSDownloadImage?: Maybe<ILocaleImage>;
  readonly iOSDownloadLink?: Maybe<Scalars['String']>;
  readonly primaryImage?: Maybe<ILocaleImage>;
  readonly submitButtonText?: Maybe<ILocaleString>;
  readonly textDecorationLeft?: Maybe<IImage>;
  readonly textDecorationRight?: Maybe<IImage>;
}

export interface IAppVersion extends IDocument {
  readonly __typename?: 'AppVersion';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** The kiosk app version to be deployed to the App store. This should use semantic versioning and have 2 decimal points, for example 1.0.0. The numbers signify <Major Release>.<Minor Release>.<Patch Number> */
  readonly kioskVersionName?: Maybe<Scalars['String']>;
  /** The native app version to be deployed to the App store. This should use semantic versioning and have 2 decimal points, for example 1.0.0. The numbers signify <Major Release>.<Minor Release>.<Patch Number> */
  readonly nativeVersionName?: Maybe<Scalars['String']>;
  /** This is the build number currently released for the Version Name. When version name changes, this should be re-set to 1. */
  readonly nativeVersionNumber?: Maybe<Scalars['Float']>;
}

export interface IAppVersionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly kioskVersionName?: InputMaybe<Scalars['String']>;
  readonly kioskVersionName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly kioskVersionName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly kioskVersionName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly kioskVersionName_not?: InputMaybe<Scalars['String']>;
  readonly kioskVersionName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly nativeVersionName?: InputMaybe<Scalars['String']>;
  readonly nativeVersionName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly nativeVersionName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly nativeVersionName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly nativeVersionName_not?: InputMaybe<Scalars['String']>;
  readonly nativeVersionName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly nativeVersionNumber?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly nativeVersionNumber_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly nativeVersionNumber_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly nativeVersionNumber_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly nativeVersionNumber_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly nativeVersionNumber_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly nativeVersionNumber_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IAppleConfig {
  readonly __typename?: 'AppleConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly merchantId?: Maybe<Scalars['String']>;
  /** This field should only be used when migrating from one PSP to another */
  readonly migrationMerchantId?: Maybe<Scalars['String']>;
  /** This field should only be used when migrating from one PSP to another */
  readonly migrationPrepaidMerchantId?: Maybe<Scalars['String']>;
  readonly paymentsNetworks?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly prepaidMerchantId?: Maybe<Scalars['String']>;
  readonly socialLogin?: Maybe<ISocialLoginAppleConfig>;
}

export interface IAttachedCombo extends IDocument {
  readonly __typename?: 'AttachedCombo';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly comboMealLabel?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<IImage>;
  readonly internalName?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IComboSlot>>>;
  readonly selectionLabel?: Maybe<Scalars['String']>;
  readonly singleItemMealLabel?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
}

export interface IAttachedComboFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly comboMealLabel?: InputMaybe<Scalars['String']>;
  readonly comboMealLabel_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly comboMealLabel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly comboMealLabel_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly comboMealLabel_not?: InputMaybe<Scalars['String']>;
  readonly comboMealLabel_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly selectionLabel?: InputMaybe<Scalars['String']>;
  readonly selectionLabel_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly selectionLabel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly selectionLabel_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly selectionLabel_not?: InputMaybe<Scalars['String']>;
  readonly selectionLabel_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly singleItemMealLabel?: InputMaybe<Scalars['String']>;
  readonly singleItemMealLabel_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly singleItemMealLabel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly singleItemMealLabel_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly singleItemMealLabel_not?: InputMaybe<Scalars['String']>;
  readonly singleItemMealLabel_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IAwsConfig {
  readonly __typename?: 'AwsConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly gqlApiUrl?: Maybe<Scalars['String']>;
  readonly gqlGatewayApiUrl?: Maybe<Scalars['String']>;
  readonly region?: Maybe<Scalars['String']>;
  readonly userPoolClientId?: Maybe<Scalars['String']>;
  readonly userPoolId?: Maybe<Scalars['String']>;
}

export interface IBarcodes extends IDocument {
  readonly __typename?: 'Barcodes';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Offers ends on... */
  readonly endDate?: Maybe<Scalars['Date']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly offers?: Maybe<ReadonlyArray<Maybe<IOffer>>>;
  /** Four character barcode identifier */
  readonly prefix?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Float']>;
  /** Offers start on... */
  readonly startDate?: Maybe<Scalars['Date']>;
}

export interface IBarcodesFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly endDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly endDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly endDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly endDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly endDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly endDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly endDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly prefix?: InputMaybe<Scalars['String']>;
  readonly prefix_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly prefix_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly prefix_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly prefix_not?: InputMaybe<Scalars['String']>;
  readonly prefix_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly quantity?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly quantity_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly quantity_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly quantity_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly quantity_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly quantity_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly quantity_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly startDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly startDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly startDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly startDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly startDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly startDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly startDate_not?: InputMaybe<Scalars['Date']>;
}

export interface IBetweenDates {
  readonly __typename?: 'BetweenDates';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Ends on... (Time will be set to 23:59:59) */
  readonly endDate?: Maybe<Scalars['DateTime']>;
  /** Starts on... (Time will be set to 00:00:00) */
  readonly startDate?: Maybe<Scalars['DateTime']>;
}

export interface IBetweenTimes {
  readonly __typename?: 'BetweenTimes';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Ends at: 23:59:59 */
  readonly endTime?: Maybe<Scalars['String']>;
  /** Starts at: 00:00:00 */
  readonly startTime?: Maybe<Scalars['String']>;
}

export interface IBirthdayMultiplier {
  readonly __typename?: 'BirthdayMultiplier';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Period (day, week, month) around user's birthday */
  readonly duration?: Maybe<Scalars['String']>;
}

export type IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrExpireAfterOrFirstOrderOnlyOrIncentiveRequirementOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated = IBirthdayMultiplier | ICartLimit | ICartRequirement | ICartRequirementExclusion | ICoolDown | IDayOfWeekBand | IEmailVerifiedRequired | IExpireAfter | IFirstOrderOnly | IIncentiveRequirement | ILimit | ILoyaltyBetweenDates | ILoyaltyBetweenTimes | ILoyaltyPoints | IPaymentMethod | IRequiresAuthentication | IRestaurantGroupRestrictions | IRestaurantRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserAttributes | IUserCreated;

export type IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrExpireAfterOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated = IBirthdayMultiplier | ICartLimit | ICartRequirement | ICartRequirementExclusion | ICoolDown | IDayOfWeekBand | IEmailVerifiedRequired | IExpireAfter | IFirstOrderOnly | IIsStackable | ILimit | ILoyaltyBetweenDates | ILoyaltyBetweenTimes | IPaymentMethod | IRequiresAuthentication | IRestaurantGroupRestrictions | IRestaurantRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserAttributes | IUserCreated;

export type IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrFirstOrderOnlyOrIncentiveRequirementOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated = IBirthdayMultiplier | ICartLimit | ICartRequirement | ICartRequirementExclusion | ICoolDown | IDayOfWeekBand | IEmailVerifiedRequired | IFirstOrderOnly | IIncentiveRequirement | ILimit | ILoyaltyBetweenDates | ILoyaltyBetweenTimes | IPaymentMethod | IRequiresAuthentication | IRestaurantGroupRestrictions | IRestaurantRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserAttributes | IUserCreated;

export type IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated = IBirthdayMultiplier | ICartLimit | ICartRequirement | ICartRequirementExclusion | ICoolDown | IDayOfWeekBand | IEmailVerifiedRequired | IFirstOrderOnly | IIsStackable | ILimit | ILoyaltyBetweenDates | ILoyaltyBetweenTimes | IPaymentMethod | IRequiresAuthentication | IRestaurantGroupRestrictions | IRestaurantRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserAttributes | IUserCreated;

export type IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrFirstOrderOnlyOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated = IBirthdayMultiplier | ICartLimit | ICartRequirement | ICartRequirementExclusion | ICoolDown | IDayOfWeekBand | IEmailVerifiedRequired | IFirstOrderOnly | ILimit | ILoyaltyBetweenDates | ILoyaltyBetweenTimes | ILoyaltyPoints | IPaymentMethod | IRequiresAuthentication | IRestaurantGroupRestrictions | IRestaurantRestrictions | IServiceModeRestrictions | ISubtotalSpend | ITransactionCount | IUserAttributes | IUserCreated;

export interface IBlacklistCharacterReplaceRule {
  readonly __typename?: 'BlacklistCharacterReplaceRule';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly filter?: Maybe<Scalars['String']>;
  readonly replace?: Maybe<Scalars['String']>;
}

export interface IBlock {
  readonly __typename?: 'Block';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly children?: Maybe<ReadonlyArray<Maybe<ISpan>>>;
  readonly level?: Maybe<Scalars['Float']>;
  readonly listItem?: Maybe<Scalars['String']>;
  readonly style?: Maybe<Scalars['String']>;
}

export interface IBlockContentImage {
  readonly __typename?: 'BlockContentImage';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly asset?: Maybe<ISanityImageAsset>;
  readonly caption?: Maybe<Scalars['String']>;
  readonly crop?: Maybe<ISanityImageCrop>;
  readonly hotspot?: Maybe<ISanityImageHotspot>;
}

export type IBlockOrBlockContentImage = IBlock | IBlockContentImage;

export type IBlockOrBlockContentImageOrPlaceholderField = IBlock | IBlockContentImage | IPlaceholderField;

export interface IBogoDiscount {
  readonly __typename?: 'BogoDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
  /** Maximum amount discount this offer can give. */
  readonly maxPriceToDiscount?: Maybe<Scalars['Float']>;
  readonly products?: Maybe<ReadonlyArray<Maybe<IProduct>>>;
  readonly requiredProducts?: Maybe<ReadonlyArray<Maybe<IProduct>>>;
}

export interface IBogoDynamicDiscount {
  readonly __typename?: 'BogoDynamicDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
  /** The number of products that will receive the discount */
  readonly discountedItemsQuantity?: Maybe<Scalars['Float']>;
  /** Maximum amount discount this offer can give. */
  readonly maxPriceToDiscount?: Maybe<Scalars['Float']>;
  /** Product that must be included in the offer to receive another. */
  readonly productItem?: Maybe<IItemGroup>;
  /** The number of products that must be purchased to qualify for the BOGO discount */
  readonly requiredPurchaseQuantity?: Maybe<Scalars['Float']>;
}

export interface IBrand {
  readonly __typename?: 'Brand';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly logo?: Maybe<IImage>;
}

export interface IBrazeContentCards extends IDocument {
  readonly __typename?: 'BrazeContentCards';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly sectionSubheader?: Maybe<ILocaleString>;
  readonly sectionheader?: Maybe<ILocaleString>;
}

export interface IBrazeContentCardsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IBringgConfig {
  readonly __typename?: 'BringgConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly region?: Maybe<Scalars['String']>;
}

export interface IBuildConfiguration extends IDocument {
  readonly __typename?: 'BuildConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly ionic?: Maybe<IIonicConfig>;
}

export interface IBuildConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IBundleDiscount {
  readonly __typename?: 'BundleDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
  /** Maximum amount discount this offer can give. */
  readonly maxPriceToDiscount?: Maybe<Scalars['Float']>;
  readonly products?: Maybe<ReadonlyArray<Maybe<IProduct>>>;
}

export interface ICallToAction {
  readonly __typename?: 'CallToAction';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly buttonLink?: Maybe<Scalars['String']>;
  readonly buttonText?: Maybe<ILocaleString>;
  readonly heading?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly link?: Maybe<ILocaleUrl>;
  readonly subheading?: Maybe<ILocaleString>;
}

export interface ICallToActionWidget {
  readonly __typename?: 'CallToActionWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly callToActionContent?: Maybe<ReadonlyArray<Maybe<ICallToAction>>>;
}

export interface ICartContainsPlu {
  readonly __typename?: 'CartContainsPlu';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly hdxPLUs?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly qstPLUs?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** Quantity that must be in the cart */
  readonly quantity?: Maybe<Scalars['Float']>;
  readonly sicomPLUs?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
}

export interface ICartLimit {
  readonly __typename?: 'CartLimit';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly maximumRedemptions?: Maybe<Scalars['Float']>;
}

export interface ICartProperty {
  readonly __typename?: 'CartProperty';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** the cart property for comparison */
  readonly key?: Maybe<Scalars['String']>;
  /** This value must be set - use false if you are unsure. */
  readonly negated?: Maybe<Scalars['Boolean']>;
  /** Subtotal must be... */
  readonly operator?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
}

export interface ICartRequirement {
  readonly __typename?: 'CartRequirement';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly cartRequirement?: Maybe<ReadonlyArray<Maybe<ICartRequirementEntry>>>;
}

export interface ICartRequirementEntry {
  readonly __typename?: 'CartRequirementEntry';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly item?: Maybe<IComboOrItemOrItemGroup>;
  /** Quantity that must be in the cart */
  readonly quantity?: Maybe<Scalars['Float']>;
}

export interface ICartRequirementExclusion {
  readonly __typename?: 'CartRequirementExclusion';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly cartRequirementExclusion?: Maybe<ReadonlyArray<Maybe<ICartRequirementExclusionEntry>>>;
}

export interface ICartRequirementExclusionEntry {
  readonly __typename?: 'CartRequirementExclusionEntry';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly item?: Maybe<IComboOrItem>;
}

export type ICartRequirementOrCartRequirementExclusionOrDayOfWeekBandOrEmailVerifiedRequiredOrExpireAfterOrIncentiveRequirementOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrRequiresAuthenticationOrServiceModeRestrictionsOrSubtotalSpend = ICartRequirement | ICartRequirementExclusion | IDayOfWeekBand | IEmailVerifiedRequired | IExpireAfter | IIncentiveRequirement | ILoyaltyBetweenDates | ILoyaltyBetweenTimes | IRequiresAuthentication | IServiceModeRestrictions | ISubtotalSpend;

export interface ICartTotalCountdown extends IDocument {
  readonly __typename?: 'CartTotalCountdown';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly bonusPointsPromotion?: Maybe<ISystemwidePromotion>;
  readonly cartSize?: Maybe<Scalars['Float']>;
  /** Toggle between “Free Delivery” and “Bonus Points” modes. */
  readonly enableBonusPointsMode?: Maybe<Scalars['Boolean']>;
  /** Enable or Disable the component */
  readonly enableCartTotalCountdown?: Maybe<Scalars['Boolean']>;
  readonly objectiveAmount?: Maybe<Scalars['String']>;
}

export interface ICartTotalCountdownFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly bonusPointsPromotion?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly cartSize?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly cartSize_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly cartSize_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly cartSize_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly cartSize_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly cartSize_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly cartSize_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly enableBonusPointsMode?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly enableBonusPointsMode_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly enableBonusPointsMode_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly enableCartTotalCountdown?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly enableCartTotalCountdown_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly enableCartTotalCountdown_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly objectiveAmount?: InputMaybe<Scalars['String']>;
  readonly objectiveAmount_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly objectiveAmount_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly objectiveAmount_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly objectiveAmount_not?: InputMaybe<Scalars['String']>;
  readonly objectiveAmount_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ICategory extends IDocument {
  readonly __typename?: 'Category';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<ITier>>>;
}

export interface ICategoryFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ICateringPageConfiguration extends IDocument {
  readonly __typename?: 'CateringPageConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly components?: Maybe<ReadonlyArray<Maybe<IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrLockedOffersOrMainHeroOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrTrending>>>;
}

export interface ICateringPageConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IChannelExclusions {
  readonly __typename?: 'ChannelExclusions';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly delivery?: Maybe<Scalars['Boolean']>;
  readonly googleFoodOrdering?: Maybe<Scalars['Boolean']>;
  readonly kiosk?: Maybe<Scalars['Boolean']>;
  readonly mobile?: Maybe<Scalars['Boolean']>;
  readonly pickup?: Maybe<Scalars['Boolean']>;
  readonly web?: Maybe<Scalars['Boolean']>;
}

export interface IClaimOnHistory {
  readonly __typename?: 'ClaimOnHistory';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly linkText?: Maybe<ILocaleBlockContent>;
}

export interface IClaimPointsFailedSubmissionContent {
  readonly __typename?: 'ClaimPointsFailedSubmissionContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttonTitle?: Maybe<ILocaleString>;
  readonly buttonUrl?: Maybe<ILocaleUrl>;
  readonly failureTextBlock?: Maybe<ILocaleBlockContent>;
  readonly screenTitle?: Maybe<ILocaleString>;
}

export interface IClaimPointsScreenContent {
  readonly __typename?: 'ClaimPointsScreenContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly bottomButtonTitle?: Maybe<ILocaleString>;
  readonly bottomButtonUrl?: Maybe<ILocaleUrl>;
  readonly instructionsTextBlock?: Maybe<ILocaleBlockContent>;
  readonly rewardsIcon?: Maybe<ILocaleImage>;
  readonly screenTitle?: Maybe<ILocaleString>;
  readonly secondImage?: Maybe<ILocaleImage>;
  readonly topButtonTitle?: Maybe<ILocaleString>;
  readonly topButtonUrl?: Maybe<ILocaleUrl>;
}

export interface IClaimPointsSimplifiedContent {
  readonly __typename?: 'ClaimPointsSimplifiedContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttonTitle?: Maybe<ILocaleString>;
  readonly buttonUrl?: Maybe<ILocaleUrl>;
  readonly errorDialogButtonText?: Maybe<ILocaleString>;
  readonly errorDialogMessage?: Maybe<ILocaleBlockContent>;
  readonly errorDialogTitle?: Maybe<ILocaleString>;
  readonly expirationDateInstructionsTextBlock?: Maybe<ILocaleBlockContent>;
  /** To calculate the selection of the transaction date, it should be days in hours (multiple of 24) */
  readonly expirationTimeReceipts?: Maybe<Scalars['Float']>;
  readonly inputBoxExpirationDatePlaceholder?: Maybe<ILocaleString>;
  readonly instructionsTextBlock?: Maybe<ILocaleBlockContent>;
  readonly rewardsIcon?: Maybe<ILocaleImage>;
  readonly screenTitle?: Maybe<ILocaleString>;
  readonly secondImage?: Maybe<ILocaleImage>;
  readonly secondInstructionsTextBlock?: Maybe<ILocaleBlockContent>;
  readonly successDialogButtonText?: Maybe<ILocaleString>;
  readonly successDialogMessage?: Maybe<ILocaleBlockContent>;
  readonly successDialogTitle?: Maybe<ILocaleString>;
}

export interface IClaimPointsSurveyScreenContent {
  readonly __typename?: 'ClaimPointsSurveyScreenContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly bottomButtonTitle?: Maybe<ILocaleString>;
  readonly bottomButtonUrl?: Maybe<ILocaleUrl>;
  readonly expirationDateInstructionsTextBlock?: Maybe<ILocaleBlockContent>;
  /** To calculate the selection of the transaction date, it should be days in hours (multiple of 24) */
  readonly expirationTimeReceipts?: Maybe<Scalars['Float']>;
  readonly inputBoxExpirationDatePlaceholder?: Maybe<ILocaleString>;
  readonly instructionsTextBlock?: Maybe<ILocaleBlockContent>;
  readonly rewardsIcon?: Maybe<ILocaleImage>;
  readonly screenTitle?: Maybe<ILocaleString>;
  readonly secondImage?: Maybe<ILocaleImage>;
  readonly topButtonTitle?: Maybe<ILocaleString>;
  readonly topButtonUrl?: Maybe<ILocaleUrl>;
}

export interface IClaimPointsUi extends IDocument {
  readonly __typename?: 'ClaimPointsUI';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly claimOnHistory?: Maybe<IClaimOnHistory>;
  readonly claimPointsAlreadyClaimedContent?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsDailyAmountExceededContent?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsDuplicateTransactionId?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsExpiredContent?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsHomeScreenContent?: Maybe<IClaimPointsScreenContent>;
  readonly claimPointsInvalidCodeContent?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsInvalidRestaurantContent?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsPendingContent?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsSimplified?: Maybe<IClaimPointsSimplifiedContent>;
  readonly claimPointsSuccessfulSubmissionScreenContent?: Maybe<IClaimPointsScreenContent>;
  readonly claimPointsSurveyContent?: Maybe<IClaimPointsSurveyScreenContent>;
  readonly claimPointsSurveyScreenContent?: Maybe<IClaimPointsScreenContent>;
  readonly claimPointsTooManyRequests?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimPointsTransactionNotFoundContent?: Maybe<IClaimPointsFailedSubmissionContent>;
  readonly claimQrCode?: Maybe<IClaimQrCode>;
}

export interface IClaimPointsUiFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IClaimQrCode {
  readonly __typename?: 'ClaimQrCode';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleBlockContent>;
  readonly link?: Maybe<ILinkWidget>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ICode {
  readonly __typename?: 'Code';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly code?: Maybe<Scalars['String']>;
  readonly filename?: Maybe<Scalars['String']>;
  readonly highlightedLines?: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
  readonly language?: Maybe<Scalars['String']>;
}

export interface IColor {
  readonly __typename?: 'Color';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly alpha?: Maybe<Scalars['Float']>;
  readonly hex?: Maybe<Scalars['String']>;
  readonly hsl?: Maybe<IHslaColor>;
  readonly hsv?: Maybe<IHsvaColor>;
  readonly rgb?: Maybe<IRgbaColor>;
}

export interface IColumn {
  readonly __typename?: 'Column';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly options?: Maybe<ReadonlyArray<Maybe<ICopyrightAndLanguageSelectorOrHighlightedVerticalLinkListWidgetOrHorizontalLinkListWidgetOrImageWidgetOrSocialIconsWithHeaderWidgetOrTextWidgetOrTextWidgetWithUrlOrVerticalLinkListWidgetOrVerticalLinkListWithHeaderWidgetOrWordmarkAndSocialIcons>>>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface ICombo extends IDocument {
  readonly __typename?: 'Combo';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly activationDate?: Maybe<Scalars['Date']>;
  readonly bogoBenefits?: Maybe<ReadonlyArray<Maybe<IComboOrItem>>>;
  readonly channelExclusions?: Maybe<IChannelExclusions>;
  readonly contentOptions?: Maybe<ReadonlyArray<Maybe<IContentOption>>>;
  readonly deactivationDate?: Maybe<Scalars['Date']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly dmbName?: Maybe<ILocaleString>;
  /** Indicate if the modifiers for the mainItem and any comboSlots should be dropped down           and displayed after all comboSlots instead of directly under the item/comboSlot they           pertain to */
  readonly forceModifiersToBottom?: Maybe<Scalars['Boolean']>;
  /** This toggle will no longer impact the Menu Redesign, and will only hide the Main Item         Description in Legacy menu design. To hide a Main Item in Menu Redesign, enable the Is         Dummy Item? boolean on the Main Item document. */
  readonly hideMainItemDescription?: Maybe<Scalars['Boolean']>;
  readonly image?: Maybe<IImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly images?: Maybe<IImages>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** Determines if this Combo can be chosen as a benefit for offers.       Once set to true, this cannot be toggled to false. */
  readonly isOfferBenefit?: Maybe<Scalars['Boolean']>;
  /** Show the the amount being ordered as per person. */
  readonly labelAsPerPerson?: Maybe<Scalars['Boolean']>;
  readonly mainItem?: Maybe<IItem>;
  /** To be used by BK NZ only */
  readonly markerItem?: Maybe<IMarkerItem>;
  readonly menuObjectSettings?: Maybe<IMenuObjectSettings>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IComboSlot>>>;
  readonly prices?: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>;
  /** This field is only for UI purposes. Adding a promotion reference here will make possible to show a bonus point badges in menu pages. The validation of this field will not take care of rules evaluation, so before adding any promotion here, please verify the promotion is still valid to avoid a bad UX. */
  readonly promotion?: Maybe<ISystemwidePromotion>;
  readonly restaurantAvailabilityValidation?: Maybe<IDataValidationObject>;
  /** Show combo in static menu */
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>;
  readonly simplyMenuImage?: Maybe<IImage>;
  readonly simplyMenuShortDescription?: Maybe<ILocaleString>;
  readonly slug?: Maybe<ISlug>;
  readonly toastIdentifier?: Maybe<Scalars['String']>;
  /** Note: This field will soon be deprecated in favor of new menu redesign */
  readonly uiPattern?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  readonly vendorPlus?: Maybe<IVendorPlus>;
}

export interface IComboFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly activationDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly activationDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly activationDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly activationDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly activationDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly activationDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly activationDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly deactivationDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly deactivationDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly deactivationDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly deactivationDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly deactivationDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly deactivationDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly deactivationDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly forceModifiersToBottom?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly forceModifiersToBottom_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly forceModifiersToBottom_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hideMainItemDescription?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hideMainItemDescription_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hideMainItemDescription_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly isOfferBenefit?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isOfferBenefit_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isOfferBenefit_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly labelAsPerPerson?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly labelAsPerPerson_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly labelAsPerPerson_not?: InputMaybe<Scalars['Boolean']>;
  readonly mainItem?: InputMaybe<Scalars['ID']>;
  readonly markerItem?: InputMaybe<Scalars['ID']>;
  readonly promotion?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly showInStaticMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly showInStaticMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly showInStaticMenu_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly toastIdentifier?: InputMaybe<Scalars['String']>;
  readonly toastIdentifier_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly toastIdentifier_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly toastIdentifier_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly toastIdentifier_not?: InputMaybe<Scalars['String']>;
  readonly toastIdentifier_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export type IComboOrConfigOfferOrItemOrPickerOrSystemwideOffer = ICombo | IConfigOffer | IItem | IPicker | ISystemwideOffer;

export type IComboOrExternalLinkOrItemOrOfferOrPickerOrSection = ICombo | IExternalLink | IItem | IOffer | IPicker | ISection;

export type IComboOrFeesV1DiscountOrItemOrItemGroupDiscountOrOfferActivationOrOfferDiscountOrPickerOrSwapMapping = ICombo | IFeesV1Discount | IItem | IItemGroupDiscount | IOfferActivation | IOfferDiscount | IPicker | ISwapMapping;

export type IComboOrItem = ICombo | IItem;

export type IComboOrItemOrItemGroup = ICombo | IItem | IItemGroup;

export type IComboOrItemOrOfferActivationOrOfferDiscountOrOfferItemDiscountOrOfferLoyaltyActionOrPicker = ICombo | IItem | IOfferActivation | IOfferDiscount | IOfferItemDiscount | IOfferLoyaltyAction | IPicker;

export type IComboOrItemOrOfferActivationOrOfferDiscountOrOfferLoyaltyActionOrPicker = ICombo | IItem | IOfferActivation | IOfferDiscount | IOfferLoyaltyAction | IPicker;

export type IComboOrItemOrOfferDiscountOrPicker = ICombo | IItem | IOfferDiscount | IPicker;

export type IComboOrItemOrOfferOrPickerOrSection = ICombo | IItem | IOffer | IPicker | ISection;

export type IComboOrItemOrPicker = ICombo | IItem | IPicker;

export type IComboOrItemOrPickerOrProductCategory = ICombo | IItem | IPicker | IProductCategory;

export type IComboOrItemOrPickerOrSection = ICombo | IItem | IPicker | ISection;

export interface IComboSlot extends IDocument {
  readonly __typename?: 'ComboSlot';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<IImage>;
  readonly images?: Maybe<IImages>;
  readonly internalName?: Maybe<Scalars['String']>;
  readonly maxAmount?: Maybe<Scalars['Float']>;
  readonly minAmount?: Maybe<Scalars['Float']>;
  readonly name?: Maybe<ILocaleString>;
  readonly optionVisibilitySettings?: Maybe<IOptionVisibilitySettings>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IComboSlotOption>>>;
  readonly respectMaximum?: Maybe<Scalars['Boolean']>;
  readonly uiPattern?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  readonly vendorPlus?: Maybe<IVendorPlus>;
}

export interface IComboSlotFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly maxAmount?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly maxAmount_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly maxAmount_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly maxAmount_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly maxAmount_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly maxAmount_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly maxAmount_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly minAmount?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly minAmount_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly minAmount_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly minAmount_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly minAmount_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly minAmount_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly minAmount_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly respectMaximum?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly respectMaximum_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly respectMaximum_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IComboSlotOption {
  readonly __typename?: 'ComboSlotOption';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly defaultAmount?: Maybe<Scalars['Float']>;
  /** This will tell the app that we want to charge for this item. If not turned on all combo slot options are included with the combo(free). */
  readonly isPremium?: Maybe<Scalars['Boolean']>;
  readonly maxAmount?: Maybe<Scalars['Float']>;
  readonly minAmount?: Maybe<Scalars['Float']>;
  readonly option?: Maybe<IItemOrPickerOrSection>;
  readonly prices?: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>;
}

export interface ICompletedState {
  readonly __typename?: 'CompletedState';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly header?: Maybe<ILocaleString>;
}

export interface IConditionAllergen {
  readonly __typename?: 'ConditionAllergen';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly allergenIdentifier?: Maybe<Scalars['String']>;
  readonly comparisonOperator?: Maybe<Scalars['String']>;
  /** 3 = Contains; 2 = May Contain; 1 = Cooked in same equipment; 0 = Free From */
  readonly comparisonValue?: Maybe<Scalars['Float']>;
}

export type IConditionAllergenOrConditionItemOneOfOrConditionNutritionOrConditionParentCategory = IConditionAllergen | IConditionItemOneOf | IConditionNutrition | IConditionParentCategory;

export interface IConditionItemOneOf {
  readonly __typename?: 'ConditionItemOneOf';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly items?: Maybe<ReadonlyArray<Maybe<IItem>>>;
}

export interface IConditionNutrition {
  readonly __typename?: 'ConditionNutrition';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly comparisonOperator?: Maybe<Scalars['String']>;
  readonly comparisonValue?: Maybe<Scalars['Float']>;
  readonly nutritionIdentifier?: Maybe<Scalars['String']>;
}

export interface IConditionParentCategory {
  readonly __typename?: 'ConditionParentCategory';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The top level parent category (picker or section) that an item belongs to */
  readonly parentCategory?: Maybe<IPickerOrSection>;
}

export interface IConfigOffer extends IDocument {
  readonly __typename?: 'ConfigOffer';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<IImage>;
  /** This incentive will only be displayed to a user if set by personalization */
  readonly configOnly?: Maybe<Scalars['Boolean']>;
  readonly daypart?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly howToRedeem?: Maybe<ILocaleBlockContent>;
  readonly inStoreBenefits?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrPicker>>>;
  readonly incentives?: Maybe<ReadonlyArray<Maybe<IComboOrFeesV1DiscountOrItemOrItemGroupDiscountOrOfferActivationOrOfferDiscountOrPickerOrSwapMapping>>>;
  readonly internalName?: Maybe<Scalars['String']>;
  readonly localizedImage?: Maybe<ILocaleImages>;
  readonly lockedOffersPanel?: Maybe<ILockedOffersPanel>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  /** If offer should display the market price of an item (ie: BOGO) link the menu item here */
  readonly marketPrice?: Maybe<IComboOrItem>;
  /** When true, guest will not have option to redeem in-rest */
  readonly mobileOrderOnly?: Maybe<Scalars['Boolean']>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  readonly name?: Maybe<ILocaleBlockContent>;
  readonly notificationDetails?: Maybe<INotificationDetails>;
  /** This represents the price of the offer. Price must be entered in cents. For BOGO offers, the offer price should be entered as 0 */
  readonly offerPrice?: Maybe<Scalars['Float']>;
  /** This represents the PMIX product number */
  readonly pmixId?: Maybe<Scalars['String']>;
  /** Position will be personalized by SSE */
  readonly position?: Maybe<Scalars['Boolean']>;
  readonly pricingDistributionValidation?: Maybe<IDataValidationObject>;
  readonly pricingPermutationValidation?: Maybe<IDataValidationObject>;
  readonly promoCodePanel?: Maybe<IPromoCodePanel>;
  /** Specify the Order redemption method. */
  readonly redemptionMethod?: Maybe<Scalars['String']>;
  /** Controls where/how the user redeems this offer */
  readonly redemptionType?: Maybe<Scalars['String']>;
  readonly restaurantAvailabilityValidation?: Maybe<IDataValidationObject>;
  readonly rules?: Maybe<ReadonlyArray<Maybe<IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrExpireAfterOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated>>>;
  /** Configure the code used for in restaurant redemption. */
  readonly shortCode?: Maybe<Scalars['String']>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
  /** Configure UI pattern to show on the frontend */
  readonly uiPattern?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  /** When true, this item will be assigned to new users */
  readonly welcomeOffer?: Maybe<Scalars['Boolean']>;
}

export interface IConfigOfferFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly configOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly configOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly configOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly marketPrice?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly mobileOrderOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly mobileOrderOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly mobileOrderOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly offerPrice?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly offerPrice_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly offerPrice_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly offerPrice_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly offerPrice_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly offerPrice_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly offerPrice_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly pmixId?: InputMaybe<Scalars['String']>;
  readonly pmixId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly pmixId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly pmixId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly pmixId_not?: InputMaybe<Scalars['String']>;
  readonly pmixId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly position?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly position_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly position_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly redemptionMethod?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly redemptionMethod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly redemptionMethod_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly redemptionMethod_not?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly redemptionType?: InputMaybe<Scalars['String']>;
  readonly redemptionType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly redemptionType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly redemptionType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly redemptionType_not?: InputMaybe<Scalars['String']>;
  readonly redemptionType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly shortCode?: InputMaybe<Scalars['String']>;
  readonly shortCode_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly shortCode_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly shortCode_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly shortCode_not?: InputMaybe<Scalars['String']>;
  readonly shortCode_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly welcomeOffer?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly welcomeOffer_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly welcomeOffer_not?: InputMaybe<Scalars['Boolean']>;
}

export type IConfigOfferOrConfigRewardOrRewardOrSystemwideOffer = IConfigOffer | IConfigReward | IReward | ISystemwideOffer;

export interface IConfigOfferV2 extends IDocument {
  readonly __typename?: 'ConfigOfferV2';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly content?: Maybe<IOffersV2Content>;
  readonly internal?: Maybe<IOffersV2Internal>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly mechanics?: Maybe<IOffersV2Mechanics>;
  /** Switch this value to show systemwide offer on the app */
  readonly systemWideActive?: Maybe<Scalars['Boolean']>;
}

export interface IConfigOfferV2Filter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly systemWideActive?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly systemWideActive_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly systemWideActive_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IConfigQuest extends IDocument {
  readonly __typename?: 'ConfigQuest';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly cardImage?: Maybe<ILocaleImage>;
  readonly completedState?: Maybe<ICompletedState>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly howToRedeem?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly incentive?: Maybe<IQuestIncentive>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  readonly mustActivateBy?: Maybe<Scalars['Date']>;
  readonly name?: Maybe<ILocaleString>;
  readonly questRules?: Maybe<IQuestRules>;
  readonly rules?: Maybe<ReadonlyArray<Maybe<IEmailVerifiedRequiredOrLimitOrLoyaltyBetweenDatesOrRequiresAuthenticationOrUserCreated>>>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
}

export interface IConfigQuestFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly mustActivateBy?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly mustActivateBy_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly mustActivateBy_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly mustActivateBy_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly mustActivateBy_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly mustActivateBy_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly mustActivateBy_not?: InputMaybe<Scalars['Date']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IConfigReward extends IDocument {
  readonly __typename?: 'ConfigReward';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<IImage>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly howToRedeem?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly incentiveNotInMenu?: Maybe<Scalars['Boolean']>;
  readonly incentivePluOverrideMapping?: Maybe<ReadonlyArray<Maybe<IIncentivePluOverride>>>;
  readonly incentives?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferDiscountOrPicker>>>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  /** When true, guest will not have option to redeem in-rest */
  readonly mobileOrderOnly?: Maybe<Scalars['Boolean']>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  readonly name?: Maybe<ILocaleString>;
  readonly notificationDetails?: Maybe<INotificationDetails>;
  /** This represents the PMIX product number */
  readonly pmixId?: Maybe<Scalars['String']>;
  /** Specify the Order redemption method. */
  readonly redemptionMethod?: Maybe<Scalars['String']>;
  readonly ruleSet?: Maybe<ReadonlyArray<Maybe<IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrFirstOrderOnlyOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated>>>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
}

export interface IConfigRewardFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly incentiveNotInMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly incentiveNotInMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly incentiveNotInMenu_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly mobileOrderOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly mobileOrderOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly mobileOrderOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly pmixId?: InputMaybe<Scalars['String']>;
  readonly pmixId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly pmixId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly pmixId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly pmixId_not?: InputMaybe<Scalars['String']>;
  readonly pmixId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly redemptionMethod?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly redemptionMethod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly redemptionMethod_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly redemptionMethod_not?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IConfigRewardV2 extends IDocument {
  readonly __typename?: 'ConfigRewardV2';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly content?: Maybe<IOffersV2Content>;
  readonly internal?: Maybe<IOffersV2Internal>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly mechanics?: Maybe<IOffersV2Mechanics>;
  /** Switch this value to show systemwide offer on the app */
  readonly systemWideActive?: Maybe<Scalars['Boolean']>;
}

export interface IConfigRewardV2Filter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly systemWideActive?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly systemWideActive_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly systemWideActive_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IContentOption {
  readonly __typename?: 'ContentOption';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<IImage>;
  readonly menuVariantReference?: Maybe<IMenu>;
  readonly name?: Maybe<ILocaleString>;
}

export interface ICookieComplianceConfig {
  readonly __typename?: 'CookieComplianceConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly consentCategoryBranch?: Maybe<Scalars['String']>;
  readonly consentCategoryBraze?: Maybe<Scalars['String']>;
  readonly consentCategoryMParticle?: Maybe<Scalars['String']>;
  readonly globalConsentState?: Maybe<Scalars['String']>;
  readonly scriptId?: Maybe<Scalars['String']>;
  readonly scriptUrl?: Maybe<Scalars['String']>;
}

export interface ICoolDown {
  readonly __typename?: 'CoolDown';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Cool down period in seconds */
  readonly minimumElapsedTimeSeconds?: Maybe<Scalars['Float']>;
}

export interface ICopyrightAndLanguageSelector {
  readonly __typename?: 'CopyrightAndLanguageSelector';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly copyrightText?: Maybe<ILocaleString>;
}

export type ICopyrightAndLanguageSelectorOrHighlightedVerticalLinkListWidgetOrHorizontalLinkListWidgetOrImageWidgetOrSocialIconsWithHeaderWidgetOrTextWidgetOrTextWidgetWithUrlOrVerticalLinkListWidgetOrVerticalLinkListWithHeaderWidgetOrWordmarkAndSocialIcons = ICopyrightAndLanguageSelector | IHighlightedVerticalLinkListWidget | IHorizontalLinkListWidget | IImageWidget | ISocialIconsWithHeaderWidget | ITextWidget | ITextWidgetWithUrl | IVerticalLinkListWidget | IVerticalLinkListWithHeaderWidget | IWordmarkAndSocialIcons;

export interface ICrossDatasetReference {
  readonly __typename?: 'CrossDatasetReference';
  readonly _dataset?: Maybe<Scalars['String']>;
  readonly _key?: Maybe<Scalars['String']>;
  readonly _projectId?: Maybe<Scalars['String']>;
  readonly _ref?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly _weak?: Maybe<Scalars['Boolean']>;
}

export interface ICss {
  readonly __typename?: 'Css';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly code?: Maybe<Scalars['String']>;
  readonly filename?: Maybe<Scalars['String']>;
  readonly highlightedLines?: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
  readonly language?: Maybe<Scalars['String']>;
}

export interface IDataDogConfig {
  readonly __typename?: 'DataDogConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly logs?: Maybe<ILogsConfig>;
  readonly rum?: Maybe<IRumConfig>;
  readonly rumRn?: Maybe<IRumConfig>;
}

export interface IDataValidationObject {
  readonly __typename?: 'DataValidationObject';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Date of the last validation run for this document/validation type */
  readonly lastValidated?: Maybe<Scalars['String']>;
  /** a URL that will take us to the S3 CSV output (may want to make this a custom component that is a link) */
  readonly validationOutput?: Maybe<Scalars['String']>;
  /** test */
  readonly validationStatus?: Maybe<Scalars['String']>;
}

export interface IDayOfWeekBand {
  readonly __typename?: 'DayOfWeekBand';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly friday?: Maybe<Scalars['Boolean']>;
  readonly monday?: Maybe<Scalars['Boolean']>;
  readonly saturday?: Maybe<Scalars['Boolean']>;
  readonly sunday?: Maybe<Scalars['Boolean']>;
  readonly thursday?: Maybe<Scalars['Boolean']>;
  readonly tuesday?: Maybe<Scalars['Boolean']>;
  readonly wednesday?: Maybe<Scalars['Boolean']>;
}

export interface IDayPart {
  readonly __typename?: 'DayPart';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly displayName?: Maybe<ILocaleString>;
  readonly endTime?: Maybe<Scalars['String']>;
  readonly icon?: Maybe<IImage>;
  readonly key?: Maybe<Scalars['String']>;
  readonly startTime?: Maybe<Scalars['String']>;
  readonly weekDays?: Maybe<IWeekDays>;
}

export interface IDayParts {
  readonly __typename?: 'DayParts';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly displayName?: Maybe<Scalars['String']>;
  readonly hours?: Maybe<IHoursOfOperation>;
  readonly key?: Maybe<Scalars['String']>;
}

export interface IDaypartRule {
  readonly __typename?: 'DaypartRule';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly daypart?: Maybe<Scalars['String']>;
}

export interface IDeliveryVendor {
  readonly __typename?: 'DeliveryVendor';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly storeIdMapping?: Maybe<Scalars['String']>;
  readonly vendorName?: Maybe<Scalars['String']>;
}

export interface IDialogInformation {
  readonly __typename?: 'DialogInformation';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttonAction?: Maybe<ILinkAction>;
  readonly header?: Maybe<ILocaleString>;
  readonly subtitle?: Maybe<ILocaleString>;
}

export interface IDisplayGroup extends IDocument {
  readonly __typename?: 'DisplayGroup';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** If this is enabled, accordion will be auto expanded when navigating to customization screen */
  readonly autoExpandAccordion?: Maybe<Scalars['Boolean']>;
  readonly displayRank?: Maybe<Scalars['Float']>;
  readonly name?: Maybe<ILocaleString>;
  readonly numberOfCustomizationsAllowed?: Maybe<Scalars['Float']>;
  /** If enabled, items in this display group will show up on the product details page, not the product customization page. */
  readonly simplyMenuShowOnProductDetails?: Maybe<Scalars['Boolean']>;
}

export interface IDisplayGroupFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly autoExpandAccordion?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly autoExpandAccordion_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly autoExpandAccordion_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly displayRank?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly displayRank_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly displayRank_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly displayRank_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly displayRank_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly displayRank_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly displayRank_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly numberOfCustomizationsAllowed?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly numberOfCustomizationsAllowed_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly numberOfCustomizationsAllowed_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly numberOfCustomizationsAllowed_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly numberOfCustomizationsAllowed_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly numberOfCustomizationsAllowed_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly numberOfCustomizationsAllowed_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly simplyMenuShowOnProductDetails?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly simplyMenuShowOnProductDetails_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly simplyMenuShowOnProductDetails_not?: InputMaybe<Scalars['Boolean']>;
}

/** A Sanity document */
export interface IDocument {
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
}

export interface IDoubleImageWidget {
  readonly __typename?: 'DoubleImageWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly image1?: Maybe<IImageWidget>;
  readonly image2?: Maybe<IImageWidget>;
}

export interface IDownloadFileWidget {
  readonly __typename?: 'DownloadFileWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly url?: Maybe<ILocaleString>;
}

export interface IEarningCalculation extends IDocument {
  readonly __typename?: 'EarningCalculation';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** In seconds: the minimum time between purchases for loyalty to be applied */
  readonly cooldownPeriod?: Maybe<Scalars['Float']>;
  /** The basis for how points are earned */
  readonly coreMetric?: Maybe<Scalars['String']>;
  /** The number of points all users will be awarded on Loyalty creation */
  readonly initialUserPointBalance?: Maybe<Scalars['Float']>;
  /** In cents: the minimum purchase subtotal for loyalty to be applied */
  readonly minSpend?: Maybe<Scalars['Float']>;
  /** In minutes: the minimum time between offer redemptions by user */
  readonly offerRedemptionCooldownPeriod?: Maybe<Scalars['Float']>;
  readonly offerRedemptionLimits?: Maybe<IOfferRedemptionLimits>;
  /** Defines the points grouping period */
  readonly pointsExpirationByIssueDateGroup?: Maybe<Scalars['String']>;
  /** In days: the minimum number after which, if a user has not used the points from a group, those will expire */
  readonly pointsExpirationByIssueDateWindowDays?: Maybe<Scalars['Float']>;
  /** Defines the points expiration system to use */
  readonly pointsExpirationType?: Maybe<Scalars['String']>;
  /** In days: the minimum number after which, if a user has not been active, their Loyalty points will expire */
  readonly pointsExpiryDays?: Maybe<Scalars['Float']>;
  readonly pointsPerDollar?: Maybe<Scalars['Float']>;
  readonly pointsPerVisit?: Maybe<Scalars['Float']>;
  readonly rewardsRedemptionConfig?: Maybe<IRewardsRedemptionConfig>;
  readonly transactionEarningConfiguration?: Maybe<ITransactionEarningConfiguration>;
}

export interface IEarningCalculationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly cooldownPeriod?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly cooldownPeriod_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly cooldownPeriod_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly cooldownPeriod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly cooldownPeriod_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly cooldownPeriod_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly cooldownPeriod_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly coreMetric?: InputMaybe<Scalars['String']>;
  readonly coreMetric_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly coreMetric_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly coreMetric_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly coreMetric_not?: InputMaybe<Scalars['String']>;
  readonly coreMetric_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly initialUserPointBalance?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly initialUserPointBalance_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly initialUserPointBalance_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly initialUserPointBalance_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly initialUserPointBalance_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly initialUserPointBalance_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly initialUserPointBalance_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly minSpend?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly minSpend_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly minSpend_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly minSpend_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly minSpend_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly minSpend_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly minSpend_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly offerRedemptionCooldownPeriod?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly offerRedemptionCooldownPeriod_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly offerRedemptionCooldownPeriod_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly offerRedemptionCooldownPeriod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly offerRedemptionCooldownPeriod_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly offerRedemptionCooldownPeriod_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly offerRedemptionCooldownPeriod_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly pointsExpirationByIssueDateGroup?: InputMaybe<Scalars['String']>;
  readonly pointsExpirationByIssueDateGroup_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly pointsExpirationByIssueDateGroup_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly pointsExpirationByIssueDateGroup_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly pointsExpirationByIssueDateGroup_not?: InputMaybe<Scalars['String']>;
  readonly pointsExpirationByIssueDateGroup_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly pointsExpirationByIssueDateWindowDays?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly pointsExpirationByIssueDateWindowDays_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly pointsExpirationByIssueDateWindowDays_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly pointsExpirationByIssueDateWindowDays_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly pointsExpirationByIssueDateWindowDays_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly pointsExpirationByIssueDateWindowDays_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly pointsExpirationByIssueDateWindowDays_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly pointsExpirationType?: InputMaybe<Scalars['String']>;
  readonly pointsExpirationType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly pointsExpirationType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly pointsExpirationType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly pointsExpirationType_not?: InputMaybe<Scalars['String']>;
  readonly pointsExpirationType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly pointsExpiryDays?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly pointsExpiryDays_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly pointsExpiryDays_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly pointsExpiryDays_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly pointsExpiryDays_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly pointsExpiryDays_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly pointsExpiryDays_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly pointsPerDollar?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly pointsPerDollar_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly pointsPerDollar_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly pointsPerDollar_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly pointsPerDollar_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly pointsPerDollar_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly pointsPerDollar_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly pointsPerVisit?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly pointsPerVisit_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly pointsPerVisit_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly pointsPerVisit_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly pointsPerVisit_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly pointsPerVisit_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly pointsPerVisit_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IEmailVerifiedRequired {
  readonly __typename?: 'EmailVerifiedRequired';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Toggles the rule that is only valid if the user's email is verified. If set to true, the user's email needs to be verified to qualify for the incentive. If set to false, then the user's email does not need to be verified to qualify for the incentive */
  readonly emailVerifiedRequired?: Maybe<Scalars['Boolean']>;
}

export type IEmailVerifiedRequiredOrLimitOrLoyaltyBetweenDatesOrRequiresAuthenticationOrUserCreated = IEmailVerifiedRequired | ILimit | ILoyaltyBetweenDates | IRequiresAuthentication | IUserCreated;

export interface IEmptyState extends IDocument {
  readonly __typename?: 'EmptyState';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<IImageBackground>;
  readonly buttonAction?: Maybe<ILinkAction>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly headerText?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImages>;
  readonly logo?: Maybe<ILocaleImages>;
  readonly marketingTileList?: Maybe<IMarketingTileList>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly terms?: Maybe<ILocaleBlockContent>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IEmptyStateFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IEndOfOffersLoggedIn {
  readonly __typename?: 'EndOfOffersLoggedIn';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly endOfOffersImage?: Maybe<ILocaleImage>;
  readonly endOfOffersMessage?: Maybe<ILocaleString>;
}

export interface IEndOfOffersLoggedOut {
  readonly __typename?: 'EndOfOffersLoggedOut';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly ctaButtonText?: Maybe<ILocaleString>;
  readonly link?: Maybe<ILocaleUrl>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IExpireAfter {
  readonly __typename?: 'ExpireAfter';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly day?: Maybe<Scalars['Float']>;
}

export interface IExternalLink {
  readonly __typename?: 'ExternalLink';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly link?: Maybe<ILocaleUrl>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  readonly name?: Maybe<ILocaleString>;
  readonly url?: Maybe<Scalars['String']>;
}

export interface IFacebookConfig {
  readonly __typename?: 'FacebookConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly socialLogin?: Maybe<ISocialLoginFacebookConfig>;
}

export interface IFanFavorites extends IDocument {
  readonly __typename?: 'FanFavorites';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly fanFavoriteItems?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>;
  readonly favoriteSection?: Maybe<IFavoriteSection>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IFanFavoritesFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IFavoriteSection {
  readonly __typename?: 'FavoriteSection';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly headerText?: Maybe<ILocaleString>;
  readonly orderNowText?: Maybe<ILocaleString>;
  readonly subheaderText?: Maybe<ILocaleString>;
}

export interface IFeatureAccount extends IDocument {
  readonly __typename?: 'FeatureAccount';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly emailAndPushOptInSettings?: Maybe<ReadonlyArray<Maybe<IOptInPrivacyPreferencesOrOptInSettingBooleanOrOptInSettingEmailOrOptInSettingEmailAndPushOrOptInSettingEnumOrOptInSettingPush>>>;
}

export interface IFeatureAccountDeletePage extends IDocument {
  readonly __typename?: 'FeatureAccountDeletePage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly cancelButtonText?: Maybe<ILocaleString>;
  readonly confirmButtonText?: Maybe<ILocaleString>;
  readonly content?: Maybe<ILocaleBlockContent>;
  readonly errorText?: Maybe<ILocaleString>;
  readonly headerText?: Maybe<ILocaleString>;
}

export interface IFeatureAccountDeletePageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureAccountFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureAccountForm extends IDocument {
  readonly __typename?: 'FeatureAccountForm';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly activeCampaigns?: Maybe<ReadonlyArray<Maybe<IFeatureAuthCampaign>>>;
  readonly desktopImage?: Maybe<ILocaleImages>;
  readonly postalOrZipDisclaimer?: Maybe<ILocaleString>;
  readonly privacyPolicyDisclaimers?: Maybe<IPrivacyPolicyDisclaimers>;
  readonly signUpTerms?: Maybe<ISignUpTerms>;
}

export interface IFeatureAccountFormFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureAccountRequestInfoPage extends IDocument {
  readonly __typename?: 'FeatureAccountRequestInfoPage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly confirmButtonText?: Maybe<ILocaleString>;
  readonly content?: Maybe<ILocaleBlockContent>;
  readonly errorText?: Maybe<ILocaleString>;
  readonly headerText?: Maybe<ILocaleString>;
}

export interface IFeatureAccountRequestInfoPageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureAuthCampaign extends IDocument {
  readonly __typename?: 'FeatureAuthCampaign';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly campaignId?: Maybe<Scalars['String']>;
  readonly campaignImage?: Maybe<ILocaleImage>;
  readonly campaignImageAltText?: Maybe<ILocaleString>;
  readonly campaignText?: Maybe<ILocaleBlockContent>;
  readonly campaingBackgroundColor?: Maybe<IColor>;
  /** Flag that determines extra fields components visibility */
  readonly shouldDisplayExtraFields?: Maybe<Scalars['Boolean']>;
}

export interface IFeatureAuthCampaignFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly campaignId?: InputMaybe<Scalars['String']>;
  readonly campaignId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly campaignId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly campaignId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly campaignId_not?: InputMaybe<Scalars['String']>;
  readonly campaignId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly shouldDisplayExtraFields?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly shouldDisplayExtraFields_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly shouldDisplayExtraFields_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IFeatureBeeperModal extends IDocument {
  readonly __typename?: 'FeatureBeeperModal';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly beeperButtonText?: Maybe<ILocaleString>;
  readonly beeperModalBody?: Maybe<ILocaleString>;
  readonly beeperModalImage?: Maybe<ILocaleImage>;
  readonly beeperModalTitle?: Maybe<ILocaleString>;
}

export interface IFeatureBeeperModalFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureCateringPage extends IDocument {
  readonly __typename?: 'FeatureCateringPage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly appAuthenticated?: Maybe<ICateringPageConfiguration>;
  readonly appUnauthenticated?: Maybe<ICateringPageConfiguration>;
  readonly webAuthenticated?: Maybe<ICateringPageConfiguration>;
  readonly webUnauthenticated?: Maybe<ICateringPageConfiguration>;
}

export interface IFeatureCateringPageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureDisclaimers extends IDocument {
  readonly __typename?: 'FeatureDisclaimers';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly calorie?: Maybe<ILocaleBlockContent>;
  readonly communicationPreferencesBlock?: Maybe<ILocaleBlockContent>;
  readonly copyrightAndTrademark?: Maybe<ILocaleString>;
  readonly country?: Maybe<ILocaleString>;
  readonly deliveryDisclaimer?: Maybe<ILocaleString>;
  readonly deliveryLogo?: Maybe<ILocaleImage>;
  readonly images?: Maybe<ILocaleString>;
  readonly itemAvailability?: Maybe<ILocaleString>;
  readonly offers?: Maybe<ILocaleString>;
  readonly phoneNumber?: Maybe<ILocaleString>;
  readonly price?: Maybe<ILocaleString>;
  readonly reservedRights?: Maybe<ILocaleString>;
  readonly signUpDisclaimers?: Maybe<ILocaleString>;
  readonly signUpMarketDisclaimers?: Maybe<ILocaleString>;
  readonly superUpsell?: Maybe<ILocaleBlockContent>;
}

export interface IFeatureDisclaimersFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureDonation extends IDocument {
  readonly __typename?: 'FeatureDonation';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly dialogInformation?: Maybe<IDialogInformation>;
  readonly donationItemList?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly header?: Maybe<ILocaleString>;
  readonly logoImage?: Maybe<ILocaleImage>;
  readonly subtitle?: Maybe<ILocaleString>;
}

export interface IFeatureDonationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureFoodware extends IDocument {
  readonly __typename?: 'FeatureFoodware';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly items?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IFeatureFoodwareFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureFooter extends IDocument {
  readonly __typename?: 'FeatureFooter';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly rows?: Maybe<ReadonlyArray<Maybe<IRow>>>;
}

export interface IFeatureFooterFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureFooterV2 extends IDocument {
  readonly __typename?: 'FeatureFooterV2';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly copyrightText?: Maybe<ILocaleString>;
  readonly mainLinks?: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>;
  readonly miscellaneousLinks?: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>;
  readonly socialMediaData?: Maybe<ISocialIconsWidget>;
}

export interface IFeatureFooterV2Filter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureGeolocationMapMarkers extends IDocument {
  readonly __typename?: 'FeatureGeolocationMapMarkers';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly driverIcon?: Maybe<ILocaleImage>;
}

export interface IFeatureGeolocationMapMarkersFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureGeolocationModal extends IDocument {
  readonly __typename?: 'FeatureGeolocationModal';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<ILocaleImage>;
  readonly body?: Maybe<ILocaleString>;
  readonly deliveryImage?: Maybe<ILocaleImage>;
  readonly header?: Maybe<ILocaleString>;
  readonly logo?: Maybe<ILocaleImage>;
}

export interface IFeatureGeolocationModalFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureGift extends IDocument {
  readonly __typename?: 'FeatureGift';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<ILocaleImages>;
  readonly header?: Maybe<ILocaleString>;
  readonly legalDisclaimer?: Maybe<ILocaleBlockContent>;
  readonly receptionModalImage?: Maybe<ILocaleImages>;
  readonly subHeader?: Maybe<ILocaleBlockContent>;
}

export interface IFeatureGiftFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureHomePage extends IDocument {
  readonly __typename?: 'FeatureHomePage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly appAuthenticated?: Maybe<IHomePageConfiguration>;
  readonly appUnauthenticated?: Maybe<IHomePageConfiguration>;
  readonly name?: Maybe<ILocaleString>;
  readonly webAuthenticated?: Maybe<IHomePageConfiguration>;
  readonly webUnauthenticated?: Maybe<IHomePageConfiguration>;
}

export interface IFeatureHomePageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureInvitationCode extends IDocument {
  readonly __typename?: 'FeatureInvitationCode';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly invitationCodeInformationCards?: Maybe<ReadonlyArray<Maybe<IInvitationCodeInformationCard>>>;
  readonly invitationCodeTitle?: Maybe<ILocaleString>;
  readonly shareMyCodeButtonText?: Maybe<ILocaleString>;
  readonly termsAndConditions?: Maybe<ILocaleBlockContent>;
}

export interface IFeatureInvitationCodeFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureKiosk extends IDocument {
  readonly __typename?: 'FeatureKiosk';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly appData?: Maybe<IKioskAppData>;
  readonly attractLoopImage?: Maybe<ILocaleImage>;
  readonly rewardsMainImage?: Maybe<ILocaleImage>;
}

export interface IFeatureKioskFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly appData?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureKioskHomePage extends IDocument {
  readonly __typename?: 'FeatureKioskHomePage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly kioskAuthenticated?: Maybe<IHomePageConfiguration>;
  readonly kioskUnauthenticated?: Maybe<IHomePageConfiguration>;
  readonly name?: Maybe<ILocaleString>;
}

export interface IFeatureKioskHomePageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureKioskMenu extends IDocument {
  readonly __typename?: 'FeatureKioskMenu';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly cartAddOnSections?: Maybe<ReadonlyArray<Maybe<IAddOnSection>>>;
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<IDayPart>>>;
  readonly defaultMenu?: Maybe<IMenu>;
  readonly menuHeroImage?: Maybe<ILocaleImage>;
  readonly menuHeroText?: Maybe<ILocaleString>;
  readonly upsellItemsAtCheckoutRestaurant?: Maybe<ReadonlyArray<Maybe<IItem>>>;
}

export interface IFeatureKioskMenuFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly defaultMenu?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureKioskOffers extends IDocument {
  readonly __typename?: 'FeatureKioskOffers';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly defaultBackgroundImage?: Maybe<IImage>;
  readonly offersPageMarketingTiles?: Maybe<ReadonlyArray<Maybe<IOffersPageMarketingTile>>>;
  readonly sortedOffers?: Maybe<ReadonlyArray<Maybe<IOffer>>>;
  /** KIOSK: Control display of static promo tile for offers */
  readonly staticPromo?: Maybe<Scalars['Boolean']>;
}

export interface IFeatureKioskOffersFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly staticPromo?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly staticPromo_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly staticPromo_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IFeatureKioskScreensaver extends IDocument {
  readonly __typename?: 'FeatureKioskScreensaver';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly delay?: Maybe<Scalars['Float']>;
  readonly images?: Maybe<ReadonlyArray<Maybe<ILocaleImage>>>;
}

export interface IFeatureKioskScreensaverFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly delay?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly delay_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly delay_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly delay_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly delay_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly delay_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly delay_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureLayout extends IDocument {
  readonly __typename?: 'FeatureLayout';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly appleWalletImage?: Maybe<ILocaleImage>;
  readonly defaultHeroImage?: Maybe<ILocaleImage>;
  readonly geolocationModalImage?: Maybe<ILocaleImage>;
  readonly giftCardImage?: Maybe<ILocaleImage>;
  readonly giftCardTextImage?: Maybe<ILocaleImage>;
  readonly googlePayImage?: Maybe<ILocaleImage>;
  readonly loadingGraphics?: Maybe<ILoadingGraphics>;
  readonly reactNativeDesktopWebSplitViewImage?: Maybe<ILocaleImage>;
  readonly recentOrderHeroText?: Maybe<ILocaleString>;
}

export interface IFeatureLayoutFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureLocationPromo extends IDocument {
  readonly __typename?: 'FeatureLocationPromo';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly bottomText?: Maybe<ILocaleString>;
  readonly failLocationHeader?: Maybe<ILocaleString>;
  readonly failLocationSubtext?: Maybe<ILocaleString>;
  readonly legalText?: Maybe<ILocaleString>;
  readonly linkToStaticPage?: Maybe<ILinkAction>;
  readonly menuHeroText?: Maybe<ILocaleString>;
  readonly promoBackgroundImage?: Maybe<IImage>;
}

export interface IFeatureLocationPromoFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureLockers extends IDocument {
  readonly __typename?: 'FeatureLockers';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly lockersCodeTitle?: Maybe<ILocaleBlockContent>;
  readonly lockersDescription?: Maybe<ILocaleBlockContent>;
  readonly lockersHowToUseLockersButtonText?: Maybe<ILocaleString>;
  readonly lockersModalImage?: Maybe<ILocaleImage>;
  readonly lockersPinInstructions?: Maybe<ILocaleBlockContent>;
  readonly lockersTitle?: Maybe<ILocaleString>;
  readonly lockersViewOrderButtonText?: Maybe<ILocaleString>;
}

export interface IFeatureLockersFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureMenu extends IDocument {
  readonly __typename?: 'FeatureMenu';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly authAdaptableMenuCardGroup?: Maybe<IAdaptableMenuCardGroup>;
  readonly cartAddOnSections?: Maybe<ReadonlyArray<Maybe<IAddOnSection>>>;
  readonly cartAddOnSectionsCatering?: Maybe<ReadonlyArray<Maybe<IAddOnSection>>>;
  readonly cateringAlertLinkText?: Maybe<ILocaleString>;
  readonly cateringAlertLinkUrl?: Maybe<ILocaleString>;
  readonly cateringAlertText?: Maybe<ILocaleString>;
  readonly cateringMenu?: Maybe<IMenu>;
  readonly cateringSections?: Maybe<ReadonlyArray<Maybe<ISection>>>;
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<IDayPart>>>;
  readonly defaultMenu?: Maybe<IMenu>;
  readonly donationItemsAtCheckout?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly donationTermAndConditionUrl?: Maybe<ILocaleUrl>;
  /** Picker images will show the pictures of each children document within a picker when it is selected if enabled. */
  readonly enableDynamicPickerImages?: Maybe<Scalars['Boolean']>;
  /** Google Food Ordering Menu. Only supported for BK. */
  readonly gfoMenu?: Maybe<IMenu>;
  readonly menuHeroImage?: Maybe<ILocaleImage>;
  readonly menuHeroText?: Maybe<ILocaleString>;
  readonly menuSummaryHeaderModifiable?: Maybe<ILocaleString>;
  readonly menuSummaryHeaderNotModifiable?: Maybe<ILocaleString>;
  readonly unauthAdaptableMenuCardGroup?: Maybe<IAdaptableMenuCardGroup>;
  readonly upsellItemsAtCheckoutCatering?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly upsellItemsAtCheckoutDelivery?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly upsellItemsAtCheckoutRestaurant?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly variants?: Maybe<ReadonlyArray<Maybe<IMenuVariant>>>;
}

export interface IFeatureMenuFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly authAdaptableMenuCardGroup?: InputMaybe<Scalars['ID']>;
  readonly cateringMenu?: InputMaybe<Scalars['ID']>;
  readonly defaultMenu?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly enableDynamicPickerImages?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly enableDynamicPickerImages_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly enableDynamicPickerImages_not?: InputMaybe<Scalars['Boolean']>;
  readonly gfoMenu?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  readonly unauthAdaptableMenuCardGroup?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureMobileAppConfiguration extends IDocument {
  readonly __typename?: 'FeatureMobileAppConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly appVersion?: Maybe<IAppVersion>;
}

export interface IFeatureMobileAppConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly appVersion?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureNavigation extends IDocument {
  readonly __typename?: 'FeatureNavigation';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly aboutMenuEntries?: Maybe<INavigationSection>;
  readonly navigationDesktop?: Maybe<INavigationDesktop>;
  readonly navigationMobile?: Maybe<INavigationMobile>;
  readonly navigationMobileHeaderButton?: Maybe<INavigationMobileHeaderButton>;
}

export interface IFeatureNavigationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureNutrition extends IDocument {
  readonly __typename?: 'FeatureNutrition';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly nutritionTables?: Maybe<ReadonlyArray<Maybe<INutritionTable>>>;
  readonly roundingRules?: Maybe<IRoundingRules>;
}

export interface IFeatureNutritionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureOffers extends IDocument {
  readonly __typename?: 'FeatureOffers';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly defaultBackgroundImage?: Maybe<IImage>;
  readonly enableMovableInk?: Maybe<Scalars['Boolean']>;
  readonly offersBrowsingPanel?: Maybe<IOffersBrowsingPanel>;
  readonly offersDetailsPanel?: Maybe<IOffersDetailsPanel>;
  readonly offersPageMarketingTiles?: Maybe<ReadonlyArray<Maybe<IOffersPageMarketingTile>>>;
  readonly sortedOffers?: Maybe<ReadonlyArray<Maybe<IOffer>>>;
  /** KIOSK: Control display of static promo tile for offers */
  readonly staticPromo?: Maybe<Scalars['Boolean']>;
}

export interface IFeatureOffersFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly enableMovableInk?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly enableMovableInk_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly enableMovableInk_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly staticPromo?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly staticPromo_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly staticPromo_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IFeatureOnboarding extends IDocument {
  readonly __typename?: 'FeatureOnboarding';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Selection will determine what platform to show onboarding on */
  readonly channel?: Maybe<Scalars['String']>;
  readonly screens?: Maybe<ReadonlyArray<Maybe<IImageWithHeaderAndText>>>;
  /** This is the list of rules where we will trigger this onboarding feature */
  readonly triggerRule?: Maybe<Scalars['String']>;
}

export interface IFeatureOnboardingFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly channel?: InputMaybe<Scalars['String']>;
  readonly channel_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly channel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly channel_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly channel_not?: InputMaybe<Scalars['String']>;
  readonly channel_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly triggerRule?: InputMaybe<Scalars['String']>;
  readonly triggerRule_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly triggerRule_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly triggerRule_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly triggerRule_not?: InputMaybe<Scalars['String']>;
  readonly triggerRule_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IFeaturePayback extends IDocument {
  readonly __typename?: 'FeaturePayback';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly marketingAndLegalTextsModal?: Maybe<IMarketingAndLegalTextsModalContent>;
  readonly paybackBKLogoImage?: Maybe<ILocaleImage>;
  readonly paybackCreateNewAccountButtonText?: Maybe<ILocaleString>;
  readonly paybackDescription?: Maybe<ILocaleBlockContent>;
  /** Name of Section that allows user to view and opt in/out to legal and marketing texts */
  readonly paybackLegalAndMarketingLinkText?: Maybe<Scalars['String']>;
  /** Payback legal link URL text that will be shown under QR code */
  readonly paybackLegalLinkURLText?: Maybe<Scalars['String']>;
  readonly paybackLinkCardButtonText?: Maybe<ILocaleString>;
  readonly paybackLoginMethod?: Maybe<Scalars['String']>;
  /** The location of the login page for Payback (eg: https://www.tst4.pb-nonprod.de/site-partner/login?thirdPartyAuth=lwp&client_id=264&redirect_uri=...) */
  readonly paybackLoginUrl?: Maybe<Scalars['String']>;
  readonly paybackLogoImage?: Maybe<ILocaleImage>;
  readonly paybackLogoSmallImage?: Maybe<ILocaleImage>;
  readonly paybackMainImage?: Maybe<ILocaleImage>;
  /** Payback legal Marketing Communications URL that will be shown under QR code */
  readonly paybackMarketingCommunicationsLinkText?: Maybe<Scalars['String']>;
  readonly paybackNeedHelpButtonText?: Maybe<ILocaleString>;
  /** The ID of the partner that Payback expects */
  readonly paybackPartnerID?: Maybe<Scalars['String']>;
  /** The URL that Payback will be redirecting back to after login */
  readonly paybackRedirectUrl?: Maybe<Scalars['String']>;
  readonly paybackRefreshPointsButtonText?: Maybe<ILocaleString>;
  readonly paybackTitle?: Maybe<ILocaleString>;
  readonly unlinkPaybackAccountModal?: Maybe<IUnlinkPaybackAccountModalContent>;
}

export interface IFeaturePaybackFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly paybackLegalAndMarketingLinkText?: InputMaybe<Scalars['String']>;
  readonly paybackLegalAndMarketingLinkText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paybackLegalAndMarketingLinkText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paybackLegalAndMarketingLinkText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paybackLegalAndMarketingLinkText_not?: InputMaybe<Scalars['String']>;
  readonly paybackLegalAndMarketingLinkText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paybackLegalLinkURLText?: InputMaybe<Scalars['String']>;
  readonly paybackLegalLinkURLText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paybackLegalLinkURLText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paybackLegalLinkURLText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paybackLegalLinkURLText_not?: InputMaybe<Scalars['String']>;
  readonly paybackLegalLinkURLText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paybackLoginMethod?: InputMaybe<Scalars['String']>;
  readonly paybackLoginMethod_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paybackLoginMethod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paybackLoginMethod_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paybackLoginMethod_not?: InputMaybe<Scalars['String']>;
  readonly paybackLoginMethod_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paybackLoginUrl?: InputMaybe<Scalars['String']>;
  readonly paybackLoginUrl_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paybackLoginUrl_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paybackLoginUrl_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paybackLoginUrl_not?: InputMaybe<Scalars['String']>;
  readonly paybackLoginUrl_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paybackMarketingCommunicationsLinkText?: InputMaybe<Scalars['String']>;
  readonly paybackMarketingCommunicationsLinkText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paybackMarketingCommunicationsLinkText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paybackMarketingCommunicationsLinkText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paybackMarketingCommunicationsLinkText_not?: InputMaybe<Scalars['String']>;
  readonly paybackMarketingCommunicationsLinkText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paybackPartnerID?: InputMaybe<Scalars['String']>;
  readonly paybackPartnerID_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paybackPartnerID_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paybackPartnerID_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paybackPartnerID_not?: InputMaybe<Scalars['String']>;
  readonly paybackPartnerID_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paybackRedirectUrl?: InputMaybe<Scalars['String']>;
  readonly paybackRedirectUrl_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paybackRedirectUrl_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paybackRedirectUrl_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paybackRedirectUrl_not?: InputMaybe<Scalars['String']>;
  readonly paybackRedirectUrl_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureQuiz extends IDocument {
  readonly __typename?: 'FeatureQuiz';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly description?: Maybe<ILocaleString>;
  readonly endDate?: Maybe<Scalars['Date']>;
  readonly introPageBackground?: Maybe<IImage>;
  readonly name?: Maybe<ILocaleString>;
  readonly question?: Maybe<ReadonlyArray<Maybe<IQuestionDetails>>>;
  readonly questionPageBackground?: Maybe<IImage>;
  readonly questions?: Maybe<ReadonlyArray<Maybe<IQuestionDetails>>>;
  readonly resultPageBackground?: Maybe<IImage>;
  readonly results?: Maybe<ReadonlyArray<Maybe<IResultDetails>>>;
  readonly startDate?: Maybe<Scalars['Date']>;
}

export interface IFeatureQuizFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly endDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly endDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly endDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly endDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly endDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly endDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly endDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly startDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly startDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly startDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly startDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly startDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly startDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly startDate_not?: InputMaybe<Scalars['Date']>;
}

export interface IFeatureScanAndPay extends IDocument {
  readonly __typename?: 'FeatureScanAndPay';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly activeStateText?: Maybe<ILocaleBlockContent>;
  readonly addNewPaymentMethodStateText?: Maybe<ILocaleBlockContent>;
  readonly header?: Maybe<ILocaleString>;
  readonly inactiveStateText?: Maybe<ILocaleBlockContent>;
  readonly paymentMethodDeletionModalText?: Maybe<IPaymentMethodDeletionModalText>;
}

export interface IFeatureScanAndPayFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureSimplifiedLandingPage extends IDocument {
  readonly __typename?: 'FeatureSimplifiedLandingPage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<ILocaleImage>;
  readonly components?: Maybe<ReadonlyArray<Maybe<IAlert>>>;
}

export interface IFeatureSimplifiedLandingPageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeatureStaticMenu extends IDocument {
  readonly __typename?: 'FeatureStaticMenu';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly itemUnavailableModal?: Maybe<IItemUnavailableModal>;
}

export interface IFeatureStaticMenuFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFeaturedReward {
  readonly __typename?: 'FeaturedReward';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly category?: Maybe<IRewardCategory>;
  readonly reward?: Maybe<IReward>;
}

export interface IFeaturedRewardsCarouselWidget {
  readonly __typename?: 'FeaturedRewardsCarouselWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Displays featured rewards carousel */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly label?: Maybe<ILocaleString>;
  readonly rewards?: Maybe<ReadonlyArray<Maybe<IReward>>>;
}

export type IFeaturedRewardsCarouselWidgetOrLoyaltyDoubleButtonWidgetOrLoyaltyGreetingWidgetOrLoyaltyHistoryWidgetOrLoyaltyLinkWidgetOrLoyaltyLogoWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyNotificationsWidgetOrLoyaltyPointsAndRewardsWidgetOrLoyaltyPointsMeterWidgetOrLoyaltyQuestsTileWidgetOrLoyaltyQuestsWidgetOrLoyaltyTiersWidgetOrRewardsListWidget = IFeaturedRewardsCarouselWidget | ILoyaltyDoubleButtonWidget | ILoyaltyGreetingWidget | ILoyaltyHistoryWidget | ILoyaltyLinkWidget | ILoyaltyLogoWidget | ILoyaltyMarketingTileGroupWidget | ILoyaltyNotificationsWidget | ILoyaltyPointsAndRewardsWidget | ILoyaltyPointsMeterWidget | ILoyaltyQuestsTileWidget | ILoyaltyQuestsWidget | ILoyaltyTiersWidget | IRewardsListWidget;

export interface IFeesDiscount {
  readonly __typename?: 'FeesDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly discountFees?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
}

export interface IFeesV1Discount extends IDocument {
  readonly __typename?: 'FeesV1Discount';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly discountFees?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
  readonly internalName?: Maybe<Scalars['String']>;
}

export interface IFeesV1DiscountFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly discountType?: InputMaybe<Scalars['String']>;
  readonly discountType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly discountType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly discountType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly discountType_not?: InputMaybe<Scalars['String']>;
  readonly discountType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly discountValue?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly discountValue_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly discountValue_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly discountValue_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly discountValue_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly discountValue_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly discountValue_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IFile {
  readonly __typename?: 'File';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly asset?: Maybe<ISanityFileAsset>;
}

export interface IFilter {
  readonly __typename?: 'Filter';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly conditions?: Maybe<ReadonlyArray<Maybe<IConditionAllergenOrConditionItemOneOfOrConditionNutritionOrConditionParentCategory>>>;
  readonly description?: Maybe<ILocaleString>;
}

export interface IFilterGroup {
  readonly __typename?: 'FilterGroup';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly filters?: Maybe<ReadonlyArray<Maybe<IFilter>>>;
}

export interface IFirstDataConfig {
  readonly __typename?: 'FirstDataConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly corporateStoreId?: Maybe<Scalars['String']>;
}

export interface IFirstOrderOnly {
  readonly __typename?: 'FirstOrderOnly';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly firstUserOrder?: Maybe<Scalars['Boolean']>;
}

export interface IFooter extends IDocument {
  readonly __typename?: 'Footer';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly accessibilitystatement?: Maybe<ILink>;
  readonly careers?: Maybe<ILink>;
  readonly company?: Maybe<ILink>;
  readonly contactus?: Maybe<ILink>;
  readonly foundation?: Maybe<ILink>;
  readonly franchiseopportunities?: Maybe<ILink>;
  readonly investorrelations?: Maybe<ILink>;
  readonly legal?: Maybe<ILink>;
  readonly ourstory?: Maybe<ILink>;
  readonly privacypolicy?: Maybe<ILink>;
  readonly sitemap?: Maybe<ILink>;
  readonly support?: Maybe<ILink>;
  readonly termsofuse?: Maybe<ILink>;
}

export interface IFooterFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IForterConfig {
  readonly __typename?: 'ForterConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly siteId?: Maybe<Scalars['String']>;
}

export interface IFrontEndConfiguration extends IDocument {
  readonly __typename?: 'FrontEndConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly adyen?: Maybe<IAdyenConfig>;
  readonly apiKeys?: Maybe<IApiKeysConfig>;
  readonly appStoreDeeplink?: Maybe<Scalars['String']>;
  readonly apple?: Maybe<IAppleConfig>;
  readonly aws?: Maybe<IAwsConfig>;
  readonly bringg?: Maybe<IBringgConfig>;
  readonly dataDog?: Maybe<IDataDogConfig>;
  readonly dateFormat?: Maybe<Scalars['String']>;
  readonly facebook?: Maybe<IFacebookConfig>;
  readonly firstData?: Maybe<IFirstDataConfig>;
  readonly forter?: Maybe<IForterConfig>;
  readonly google?: Maybe<IGoogleConfig>;
  readonly googleAdManager?: Maybe<IGoogleAdManagerConfig>;
  readonly googleTagManager?: Maybe<IGoogleTagManagerConfig>;
  readonly iDEAL?: Maybe<IIDealConfig>;
  readonly kountMerchantId?: Maybe<Scalars['String']>;
  /** How many items are allowed to be in the cart for any given order. Default will be 9 items. */
  readonly maxCartQuantity?: Maybe<Scalars['Float']>;
  readonly oneTrust?: Maybe<IOneTrustConfig>;
  readonly orbital?: Maybe<IOrbitalConfig>;
  readonly pypestream?: Maybe<IPypestreamConfig>;
  readonly restaurants?: Maybe<IRestaurantConfig>;
  readonly timeFormat?: Maybe<Scalars['String']>;
  readonly tokenEx?: Maybe<ITokenExConfig>;
  readonly urls?: Maybe<IUrlsConfig>;
  readonly vrPayment?: Maybe<IVrPaymentConfig>;
  readonly worldpay?: Maybe<IWorldpayConfig>;
}

export interface IFrontEndConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly appStoreDeeplink?: InputMaybe<Scalars['String']>;
  readonly appStoreDeeplink_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly appStoreDeeplink_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly appStoreDeeplink_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly appStoreDeeplink_not?: InputMaybe<Scalars['String']>;
  readonly appStoreDeeplink_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly dateFormat?: InputMaybe<Scalars['String']>;
  readonly dateFormat_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly dateFormat_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly dateFormat_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly dateFormat_not?: InputMaybe<Scalars['String']>;
  readonly dateFormat_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly kountMerchantId?: InputMaybe<Scalars['String']>;
  readonly kountMerchantId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly kountMerchantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly kountMerchantId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly kountMerchantId_not?: InputMaybe<Scalars['String']>;
  readonly kountMerchantId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly maxCartQuantity?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly maxCartQuantity_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly maxCartQuantity_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly maxCartQuantity_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly maxCartQuantity_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly maxCartQuantity_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly maxCartQuantity_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly timeFormat?: InputMaybe<Scalars['String']>;
  readonly timeFormat_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly timeFormat_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly timeFormat_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly timeFormat_not?: InputMaybe<Scalars['String']>;
  readonly timeFormat_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IGeopoint {
  readonly __typename?: 'Geopoint';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly alt?: Maybe<Scalars['Float']>;
  readonly lat?: Maybe<Scalars['Float']>;
  readonly lng?: Maybe<Scalars['Float']>;
}

export interface IGlobalDiscount {
  readonly __typename?: 'GlobalDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
  /** Maximum amount discount this offer can give. */
  readonly maxPriceToDiscount?: Maybe<Scalars['Float']>;
}

export interface IGlobalOfferCooldownContent {
  readonly __typename?: 'GlobalOfferCooldownContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly actionButton?: Maybe<IActionButton>;
  readonly description?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly terms?: Maybe<ILocaleBlockContent>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IGoogleAdManagerConfig {
  readonly __typename?: 'GoogleAdManagerConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly campaignId?: Maybe<Scalars['String']>;
}

export interface IGoogleAdSlot extends IDocument {
  readonly __typename?: 'GoogleAdSlot';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Select a size for the ad slot */
  readonly adSlotSize?: Maybe<Scalars['String']>;
  /** The specific id for the ad slot. (ex. div-gpt-ad-<some-id-number>) */
  readonly adUnitId?: Maybe<Scalars['String']>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IGoogleAdSlotFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly adSlotSize?: InputMaybe<Scalars['String']>;
  readonly adSlotSize_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly adSlotSize_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly adSlotSize_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly adSlotSize_not?: InputMaybe<Scalars['String']>;
  readonly adSlotSize_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly adUnitId?: InputMaybe<Scalars['String']>;
  readonly adUnitId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly adUnitId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly adUnitId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly adUnitId_not?: InputMaybe<Scalars['String']>;
  readonly adUnitId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IGoogleConfig {
  readonly __typename?: 'GoogleConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly googleMerchantId?: Maybe<Scalars['String']>;
  readonly googleMerchantName?: Maybe<Scalars['String']>;
  /** This field should only be used when migrating from one PSP to another */
  readonly migrationPaymentsGateway?: Maybe<Scalars['String']>;
  readonly migrationPaymentsGatewayMerchantId?: Maybe<IPaymentsGatewayMerchantIdConfig>;
  /** This field should only be used when migrating from one PSP to another */
  readonly migrationPrepaidPaymentsGateway?: Maybe<Scalars['String']>;
  readonly migrationPrepaidPaymentsGatewayMerchantId?: Maybe<IPrepaidPaymentsGatewayMerchantIdConfig>;
  readonly paymentsEnvironment?: Maybe<Scalars['String']>;
  readonly paymentsGateway?: Maybe<Scalars['String']>;
  readonly paymentsGatewayMerchantId?: Maybe<IPaymentsGatewayMerchantIdConfig>;
  readonly paymentsNetworks?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly prepaidPaymentsGateway?: Maybe<Scalars['String']>;
  readonly prepaidPaymentsGatewayMerchantId?: Maybe<IPrepaidPaymentsGatewayMerchantIdConfig>;
  readonly socialLogin?: Maybe<ISocialLoginGoogleConfig>;
}

export interface IGoogleTagManagerConfig {
  readonly __typename?: 'GoogleTagManagerConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly containerId?: Maybe<Scalars['String']>;
}

export interface IGroupConditions {
  readonly __typename?: 'GroupConditions';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly attribute?: Maybe<Scalars['String']>;
  readonly option?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
}

export interface IGroups {
  readonly __typename?: 'Groups';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly conditions?: Maybe<ReadonlyArray<Maybe<IGroupConditions>>>;
}

export interface IHeaderWidget {
  readonly __typename?: 'HeaderWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly headerImage?: Maybe<ILocaleImage>;
  readonly headingContent?: Maybe<ILocaleString>;
  readonly taglineContent?: Maybe<ILocaleString>;
}

export interface IHero extends IDocument {
  readonly __typename?: 'Hero';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly altImageText?: Maybe<ILocaleString>;
  readonly complementaryCta?: Maybe<ILinkAction>;
  readonly hasTerms?: Maybe<Scalars['Boolean']>;
  readonly header?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly primaryCta?: Maybe<ILinkAction>;
  /** By checking this, it displays the Hero with reversed colors/darker background colors */
  readonly reversed?: Maybe<Scalars['Boolean']>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly subheader?: Maybe<ILocaleString>;
  readonly termsButton?: Maybe<ILinkAction>;
  readonly termsText?: Maybe<ILocaleBlockContent>;
}

export interface IHeroFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly hasTerms?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasTerms_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasTerms_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly reversed?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly reversed_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly reversed_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IHighlightedLinkWidget {
  readonly __typename?: 'HighlightedLinkWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly link?: Maybe<ILocaleUrl>;
  readonly text?: Maybe<ILocaleString>;
}

export interface IHighlightedVerticalLinkListWidget {
  readonly __typename?: 'HighlightedVerticalLinkListWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly header?: Maybe<ILocaleString>;
  readonly highlightedLinks?: Maybe<ReadonlyArray<Maybe<IHighlightedLinkWidget>>>;
  readonly subheader?: Maybe<ILocaleString>;
}

export interface IHolidayHours {
  readonly __typename?: 'HolidayHours';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly close?: Maybe<Scalars['String']>;
  readonly date?: Maybe<Scalars['String']>;
  readonly holiday?: Maybe<Scalars['String']>;
  readonly open?: Maybe<Scalars['String']>;
}

export interface IHomeGraphic {
  readonly __typename?: 'HomeGraphic';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly asset?: Maybe<ISanityFileAsset>;
  readonly description?: Maybe<Scalars['String']>;
}

export interface IHomePageConfiguration extends IDocument {
  readonly __typename?: 'HomePageConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly components?: Maybe<ReadonlyArray<Maybe<IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrGoogleAdSlotOrHeroOrLockedOffersOrMainHeroOrMarketingCardGroupOrMarketingTileCarouselOrMarketingTileGroupOrOffersSectionOrOurServicesOrQuestsSectionOrRecentItemsOrRewardsSectionOrRollUpTheRimSectionOrScanForRewardsOrSimpleHomePageOrTimsRewardsPointsSectionOrTrending>>>;
}

export interface IHomePageConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IHorizontalLinkListWidget {
  readonly __typename?: 'HorizontalLinkListWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly linkWidgets?: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>;
}

export interface IHoursOfOperation {
  readonly __typename?: 'HoursOfOperation';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly friAdditionalTimeSlot?: Maybe<IAdditionalTimeSlot>;
  readonly friClose?: Maybe<Scalars['String']>;
  readonly friOpen?: Maybe<Scalars['String']>;
  readonly monAdditionalTimeSlot?: Maybe<IAdditionalTimeSlot>;
  readonly monClose?: Maybe<Scalars['String']>;
  readonly monOpen?: Maybe<Scalars['String']>;
  readonly satAdditionalTimeSlot?: Maybe<IAdditionalTimeSlot>;
  readonly satClose?: Maybe<Scalars['String']>;
  readonly satOpen?: Maybe<Scalars['String']>;
  readonly sunAdditionalTimeSlot?: Maybe<IAdditionalTimeSlot>;
  readonly sunClose?: Maybe<Scalars['String']>;
  readonly sunOpen?: Maybe<Scalars['String']>;
  readonly thrAdditionalTimeSlot?: Maybe<IAdditionalTimeSlot>;
  readonly thrClose?: Maybe<Scalars['String']>;
  readonly thrOpen?: Maybe<Scalars['String']>;
  readonly tueAdditionalTimeSlot?: Maybe<IAdditionalTimeSlot>;
  readonly tueClose?: Maybe<Scalars['String']>;
  readonly tueOpen?: Maybe<Scalars['String']>;
  readonly wedAdditionalTimeSlot?: Maybe<IAdditionalTimeSlot>;
  readonly wedClose?: Maybe<Scalars['String']>;
  readonly wedOpen?: Maybe<Scalars['String']>;
}

export interface IHslaColor {
  readonly __typename?: 'HslaColor';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly a?: Maybe<Scalars['Float']>;
  readonly h?: Maybe<Scalars['Float']>;
  readonly l?: Maybe<Scalars['Float']>;
  readonly s?: Maybe<Scalars['Float']>;
}

export interface IHsvaColor {
  readonly __typename?: 'HsvaColor';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly a?: Maybe<Scalars['Float']>;
  readonly h?: Maybe<Scalars['Float']>;
  readonly s?: Maybe<Scalars['Float']>;
  readonly v?: Maybe<Scalars['Float']>;
}

export interface IHtml {
  readonly __typename?: 'Html';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly code?: Maybe<Scalars['String']>;
  readonly filename?: Maybe<Scalars['String']>;
  readonly highlightedLines?: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
  readonly language?: Maybe<Scalars['String']>;
}

export interface IIDealBanks {
  readonly __typename?: 'IDealBanks';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
}

export interface IIDealConfig {
  readonly __typename?: 'IDealConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly iDealBanks?: Maybe<ReadonlyArray<Maybe<IIDealBanks>>>;
}

export interface IImage {
  readonly __typename?: 'Image';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly asset?: Maybe<ISanityImageAsset>;
  readonly crop?: Maybe<ISanityImageCrop>;
  readonly hotspot?: Maybe<ISanityImageHotspot>;
}

export interface IImageBackground {
  readonly __typename?: 'ImageBackground';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly image?: Maybe<IImage>;
}

export interface IImageWidget {
  readonly __typename?: 'ImageWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly attributionLink?: Maybe<Scalars['String']>;
  readonly caption?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
}

export interface IImageWithHeaderAndText extends IDocument {
  readonly __typename?: 'ImageWithHeaderAndText';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly alternativeButtonAction?: Maybe<ILinkAction>;
  readonly buttonAction?: Maybe<ILinkAction>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly secondaryButtonAction?: Maybe<ILinkAction>;
  readonly textContent?: Maybe<ILocaleTypographyBlock>;
  /** This is internal title for viewing purposes */
  readonly title?: Maybe<Scalars['String']>;
}

export interface IImageWithHeaderAndTextFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly title?: InputMaybe<Scalars['String']>;
  readonly title_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly title_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly title_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly title_not?: InputMaybe<Scalars['String']>;
  readonly title_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IImages {
  readonly __typename?: 'Images';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly app?: Maybe<IImage>;
  readonly imageDescription?: Maybe<Scalars['String']>;
  readonly kiosk?: Maybe<IImage>;
}

export interface IIncentiveNotAvailableModalContent {
  readonly __typename?: 'IncentiveNotAvailableModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImages>;
  readonly primaryButton?: Maybe<IActionButton>;
  readonly secondaryButton?: Maybe<IActionButton>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IIncentivePluOverride {
  readonly __typename?: 'IncentivePluOverride';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly incentive?: Maybe<IItem>;
}

export interface IIncentiveRequirement {
  readonly __typename?: 'IncentiveRequirement';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly incentiveRequirement?: Maybe<ReadonlyArray<Maybe<IIncentiveRequirementEntry>>>;
}

export interface IIncentiveRequirementEntry {
  readonly __typename?: 'IncentiveRequirementEntry';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly incentive?: Maybe<IConfigOfferOrConfigRewardOrRewardOrSystemwideOffer>;
  /** Quantity that must be applied */
  readonly quantity?: Maybe<Scalars['Float']>;
}

export interface IInvitationCodeInformationCard {
  readonly __typename?: 'InvitationCodeInformationCard';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly cardDescription?: Maybe<ILocaleBlockContent>;
  readonly cardImage?: Maybe<IImage>;
  readonly cardImageBackgroundColor?: Maybe<IColor>;
  readonly cardTitle?: Maybe<ILocaleString>;
}

export interface IIonicConfig {
  readonly __typename?: 'IonicConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ionicAppId?: Maybe<Scalars['String']>;
  readonly ionicChannelName?: Maybe<Scalars['String']>;
}

export interface IIsStackable {
  readonly __typename?: 'IsStackable';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly stackable?: Maybe<Scalars['Boolean']>;
}

export interface IItem extends IDocument {
  readonly __typename?: 'Item';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly activationDate?: Maybe<Scalars['Date']>;
  readonly additionalItemInformation?: Maybe<IAdditionalItemInformation>;
  readonly allergens?: Maybe<IOpAllergen>;
  readonly channelExclusions?: Maybe<IChannelExclusions>;
  readonly contentOptions?: Maybe<ReadonlyArray<Maybe<IContentOption>>>;
  readonly deactivationDate?: Maybe<Scalars['Date']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly dmbName?: Maybe<ILocaleString>;
  /** Hide all displays of calories on this item */
  readonly hideCalories?: Maybe<Scalars['Boolean']>;
  /** Hide the nutrition legal disclaimer on this item */
  readonly hideNutritionLegalDisclaimer?: Maybe<Scalars['Boolean']>;
  readonly image?: Maybe<IImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly images?: Maybe<IImages>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** This toggle will be used to determine whether the Main Item should be hidden from           the UI. If true, this item will not appear within the menu summary for Menu Redesign. */
  readonly isDummyItem?: Maybe<Scalars['Boolean']>;
  /** Size of an individual item. Used by BK Germany to calculate Price per Filling & Unit */
  readonly itemSize?: Maybe<Scalars['Float']>;
  /** Unit of measurement for an item. Used by BK Germany to calculate Price per           Filling & Unit */
  readonly itemUnit?: Maybe<Scalars['String']>;
  /** Show the the amount being ordered as per person. */
  readonly labelAsPerPerson?: Maybe<Scalars['Boolean']>;
  readonly menuObjectSettings?: Maybe<IMenuObjectSettings>;
  readonly name?: Maybe<ILocaleString>;
  readonly nutrition?: Maybe<INutrition>;
  readonly nutritionWithModifiers?: Maybe<INutrition>;
  readonly operationalItem?: Maybe<IOpItem>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IItemOption>>>;
  readonly prices?: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>;
  readonly productHierarchy?: Maybe<IProductHierarchy>;
  /** This field is only for UI purposes. Adding a promotion reference here will make possible to show a bonus point badges in menu pages. The validation of this field will not take care of rules evaluation, so before adding any promotion here, please verify the promotion is still valid to avoid a bad UX. */
  readonly promotion?: Maybe<ISystemwidePromotion>;
  /** MDM Source Country/Region */
  readonly region?: Maybe<Scalars['String']>;
  readonly restaurantAvailabilityValidation?: Maybe<IDataValidationObject>;
  readonly rewardEligible?: Maybe<Scalars['Boolean']>;
  /** Show item in static menu */
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>;
  /** Display badge used primarily in menu list view. */
  readonly simplyMenuBadge?: Maybe<Scalars['String']>;
  readonly simplyMenuImage?: Maybe<IImage>;
  readonly simplyMenuShortDescription?: Maybe<ILocaleString>;
  readonly slug?: Maybe<ISlug>;
  readonly tier?: Maybe<ITier>;
  readonly toastIdentifier?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  readonly vendorPlus?: Maybe<IVendorPlus>;
}

export interface IItemFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly activationDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly activationDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly activationDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly activationDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly activationDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly activationDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly activationDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly deactivationDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly deactivationDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly deactivationDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly deactivationDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly deactivationDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly deactivationDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly deactivationDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly hideCalories?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hideCalories_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hideCalories_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hideNutritionLegalDisclaimer?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hideNutritionLegalDisclaimer_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hideNutritionLegalDisclaimer_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly isDummyItem?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isDummyItem_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isDummyItem_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly itemSize?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly itemSize_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly itemSize_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly itemSize_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly itemSize_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly itemSize_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly itemSize_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly itemUnit?: InputMaybe<Scalars['String']>;
  readonly itemUnit_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly itemUnit_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly itemUnit_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly itemUnit_not?: InputMaybe<Scalars['String']>;
  readonly itemUnit_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly labelAsPerPerson?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly labelAsPerPerson_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly labelAsPerPerson_not?: InputMaybe<Scalars['Boolean']>;
  readonly promotion?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly region?: InputMaybe<Scalars['String']>;
  readonly region_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly region_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly region_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly region_not?: InputMaybe<Scalars['String']>;
  readonly region_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly rewardEligible?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly rewardEligible_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly rewardEligible_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly showInStaticMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly showInStaticMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly showInStaticMenu_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly simplyMenuBadge?: InputMaybe<Scalars['String']>;
  readonly simplyMenuBadge_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly simplyMenuBadge_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly simplyMenuBadge_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly simplyMenuBadge_not?: InputMaybe<Scalars['String']>;
  readonly simplyMenuBadge_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly tier?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly toastIdentifier?: InputMaybe<Scalars['String']>;
  readonly toastIdentifier_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly toastIdentifier_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly toastIdentifier_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly toastIdentifier_not?: InputMaybe<Scalars['String']>;
  readonly toastIdentifier_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IItemGroup extends IDocument {
  readonly __typename?: 'ItemGroup';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly groupItems?: Maybe<ReadonlyArray<Maybe<IItem>>>;
  readonly groupName?: Maybe<Scalars['String']>;
}

export interface IItemGroupDiscount extends IDocument {
  readonly __typename?: 'ItemGroupDiscount';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly applicableItems?: Maybe<IItemOrItemGroup>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** Empty will apply the discount to all applicable items */
  readonly maxItemsDiscount?: Maybe<Scalars['Float']>;
}

export interface IItemGroupDiscountFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly applicableItems?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly discountType?: InputMaybe<Scalars['String']>;
  readonly discountType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly discountType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly discountType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly discountType_not?: InputMaybe<Scalars['String']>;
  readonly discountType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly discountValue?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly discountValue_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly discountValue_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly discountValue_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly discountValue_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly discountValue_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly discountValue_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly maxItemsDiscount?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly maxItemsDiscount_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly maxItemsDiscount_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly maxItemsDiscount_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly maxItemsDiscount_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly maxItemsDiscount_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly maxItemsDiscount_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IItemGroupFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly groupName?: InputMaybe<Scalars['String']>;
  readonly groupName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly groupName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly groupName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly groupName_not?: InputMaybe<Scalars['String']>;
  readonly groupName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IItemLevelDiscount {
  readonly __typename?: 'ItemLevelDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly applicableItems?: Maybe<IItemOrItemGroup>;
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
  /** Empty will apply the discount to all applicable items */
  readonly maxItemQuantityDiscount?: Maybe<Scalars['Float']>;
  /** Maximum amount discount this offer can give. */
  readonly maxPriceToDiscount?: Maybe<Scalars['Float']>;
}

export interface IItemOption {
  readonly __typename?: 'ItemOption';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Mostly unused */
  readonly activationDate?: Maybe<Scalars['DateTime']>;
  /** This value will no longer be used in the menu redesign, the max will determine how many selections a user is able to make */
  readonly allowMultipleSelections?: Maybe<Scalars['Boolean']>;
  /** Configure UI styling. Selector: Allow selecting between multiple options, Stepper: Allow using + or - to increase or decrease, Boolean: Yes or No */
  readonly componentStyle?: Maybe<Scalars['String']>;
  /** Mostly unused */
  readonly deactivationDate?: Maybe<Scalars['DateTime']>;
  readonly displayGroup?: Maybe<IDisplayGroup>;
  /** If this value is set to true, the quantity of the modifier will be displayed using the modifier multiplier prefix (Ex: Light Ketchup). If this value is set to false, the quantity of the modifier will be displayed using the modifier multiplier number (Ex: 0.5 Ketchup) */
  readonly displayModifierMultiplierName?: Maybe<Scalars['Boolean']>;
  /** Customization options for an item, eg "Cheese" or "Pickles" */
  readonly documentDescription?: Maybe<Scalars['String']>;
  /** This field indicates that the PLU of the default option should be included when communicating to the POS. */
  readonly injectDefaultSelection?: Maybe<Scalars['Boolean']>;
  readonly maxAmount?: Maybe<Scalars['Float']>;
  readonly minAmount?: Maybe<Scalars['Float']>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IItemOptionModifier>>>;
  /** Display group specifically for simply menu, if not defined, we default to the regular display group field. */
  readonly simplyMenuDisplayGroup?: Maybe<IDisplayGroup>;
  /** MDM Sync. This value determines if the item option is within a single choice modifier group (Ex: Dipping Sauces) */
  readonly singleChoiceOnly?: Maybe<Scalars['Boolean']>;
  readonly toastIdentifier?: Maybe<Scalars['String']>;
  /** Configure whether you will charge for an item option modifier */
  readonly upsellModifier?: Maybe<Scalars['Boolean']>;
}

export interface IItemOptionModifier {
  readonly __typename?: 'ItemOptionModifier';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Unused */
  readonly activationDate?: Maybe<Scalars['DateTime']>;
  readonly allergen?: Maybe<IOpAllergen>;
  readonly channelExclusions?: Maybe<IChannelExclusions>;
  /** Unused */
  readonly deactivationDate?: Maybe<Scalars['DateTime']>;
  /** MDM Sync. Established whether it's the default modifier selected */
  readonly default?: Maybe<Scalars['Boolean']>;
  /** Choices for an item option, eg "No Cheese" or "Extra Pickles" */
  readonly documentDescription?: Maybe<Scalars['String']>;
  /** MDM Sync */
  readonly modifierMultiplier?: Maybe<IModifierMultiplier>;
  readonly name?: Maybe<ILocaleString>;
  readonly nutrition?: Maybe<INutrition>;
  readonly prices?: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>;
  readonly toastIdentifier?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  readonly vendorPlus?: Maybe<IVendorPlus>;
}

export type IItemOrItemGroup = IItem | IItemGroup;

export type IItemOrNutritionalSection = IItem | INutritionalSection;

export type IItemOrPickerOrSection = IItem | IPicker | ISection;

export interface IItemUnavailableModal {
  readonly __typename?: 'ItemUnavailableModal';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly continue?: Maybe<ILocaleString>;
  readonly header?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly itemNotAvailableForDelivery?: Maybe<ILocaleString>;
  readonly selectNew?: Maybe<ILocaleString>;
}

export interface IKiosk {
  readonly __typename?: 'Kiosk';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly serialNumber?: Maybe<Scalars['String']>;
}

export interface IKioskAppData extends IDocument {
  readonly __typename?: 'KioskAppData';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly blacklistCharacterReplaceRules?: Maybe<ReadonlyArray<Maybe<IBlacklistCharacterReplaceRule>>>;
  readonly userNameBlacklist?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
}

export interface IKioskAppDataFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IKioskConfiguration extends IDocument {
  readonly __typename?: 'KioskConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly dataDog?: Maybe<IKioskDataDogConfig>;
}

export interface IKioskConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IKioskDataDogConfig {
  readonly __typename?: 'KioskDataDogConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly clientToken?: Maybe<Scalars['String']>;
  readonly site?: Maybe<Scalars['String']>;
}

export interface ILanguageSelectorWidget {
  readonly __typename?: 'LanguageSelectorWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface ILaunchDarklyNavigationLink {
  readonly __typename?: 'LaunchDarklyNavigationLink';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly enabled?: Maybe<Scalars['Boolean']>;
  readonly launchDarklyFlagDependency?: Maybe<ILaunchDarklySelect>;
  readonly navLink?: Maybe<ILinkWidget>;
}

export interface ILaunchDarklyNavigationTab {
  readonly __typename?: 'LaunchDarklyNavigationTab';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly enabled?: Maybe<Scalars['Boolean']>;
  readonly launchDarklyFlagDependency?: Maybe<ILaunchDarklySelect>;
  readonly tabIcon?: Maybe<ILocaleImage>;
  readonly tabIconActive?: Maybe<ILocaleImage>;
  readonly tabLink?: Maybe<ILinkWidget>;
}

export interface ILaunchDarklySelect {
  readonly __typename?: 'LaunchDarklySelect';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly launchDarklyFlag?: Maybe<Scalars['String']>;
}

export interface ILimit {
  readonly __typename?: 'Limit';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Maximum redemptions refresh every... */
  readonly interval?: Maybe<Scalars['String']>;
  /** Maximum redemptions refresh every... */
  readonly limitInterval?: Maybe<Scalars['String']>;
  readonly maximumRedemptions?: Maybe<Scalars['Float']>;
  readonly multiplier?: Maybe<Scalars['Float']>;
  /** time format: 24:00:00 UTC */
  readonly resetAt?: Maybe<Scalars['String']>;
}

export interface ILink {
  readonly __typename?: 'Link';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly link?: Maybe<Scalars['String']>;
  readonly title?: Maybe<Scalars['String']>;
}

export interface ILinkAction {
  readonly __typename?: 'LinkAction';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly actionText?: Maybe<ILocaleString>;
  readonly actionUrl?: Maybe<ILocaleUrl>;
  readonly route?: Maybe<Scalars['String']>;
}

export interface ILinkCardActivationSuccessModal {
  readonly __typename?: 'LinkCardActivationSuccessModal';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly closeButtonLabel?: Maybe<ILocaleString>;
  readonly ctaButtonLabel?: Maybe<ILocaleString>;
  readonly description?: Maybe<ILocaleString>;
  readonly downloadAppButtonLabel?: Maybe<ILocaleString>;
  readonly downloadAppUrl?: Maybe<ILocaleUrl>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILinkCardDefaultModal {
  readonly __typename?: 'LinkCardDefaultModal';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly closeButtonLabel?: Maybe<ILocaleString>;
  readonly content?: Maybe<ILocaleString>;
  readonly ctaButtonLabel?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILinkCardErrorModal {
  readonly __typename?: 'LinkCardErrorModal';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly closeButtonLabel?: Maybe<ILocaleString>;
  readonly ctaButtonLabel?: Maybe<ILocaleString>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILinkCardFaqSection {
  readonly __typename?: 'LinkCardFaqSection';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly marketingTileList?: Maybe<IMarketingTileList>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILinkCardSection {
  readonly __typename?: 'LinkCardSection';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ctaButtonLabel?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILinkPhysicalCardUi extends IDocument {
  readonly __typename?: 'LinkPhysicalCardUi';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly linkCardActivationSuccessModal?: Maybe<ILinkCardActivationSuccessModal>;
  readonly linkCardActivationWithRewardSuccessModal?: Maybe<ILinkCardActivationSuccessModal>;
  readonly linkCardDeactivationModal?: Maybe<ILinkCardDefaultModal>;
  readonly linkCardErrorModalGeneric?: Maybe<ILinkCardErrorModal>;
  readonly linkCardErrorModalLinked?: Maybe<ILinkCardErrorModal>;
  readonly linkCardErrorModalReplace?: Maybe<ILinkCardErrorModal>;
  readonly linkCardFaqSection?: Maybe<ILinkCardFaqSection>;
  readonly linkCardSectionLinkedState?: Maybe<ILinkCardSection>;
  readonly linkCardSectionUnlinkedState?: Maybe<ILinkCardSection>;
}

export interface ILinkPhysicalCardUiFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ILinkWidget {
  readonly __typename?: 'LinkWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly link?: Maybe<ILocaleUrl>;
  readonly text?: Maybe<ILocaleString>;
}

export interface IListItem {
  readonly __typename?: 'ListItem';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly title?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
}

export interface ILoader {
  readonly __typename?: 'Loader';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly desktopGraphic?: Maybe<IImage>;
  readonly mobileGraphic?: Maybe<IImage>;
  readonly text?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoadingGraphics {
  readonly __typename?: 'LoadingGraphics';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly cartInitialLoader?: Maybe<ILoader>;
  readonly cartPricingLoader?: Maybe<ILoader>;
}

export interface ILocaleBlockContent {
  readonly __typename?: 'LocaleBlockContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly caRaw?: Maybe<Scalars['JSON']>;
  readonly csRaw?: Maybe<Scalars['JSON']>;
  readonly deRaw?: Maybe<Scalars['JSON']>;
  readonly enRaw?: Maybe<Scalars['JSON']>;
  readonly esRaw?: Maybe<Scalars['JSON']>;
  readonly euRaw?: Maybe<Scalars['JSON']>;
  readonly frRaw?: Maybe<Scalars['JSON']>;
  readonly glRaw?: Maybe<Scalars['JSON']>;
  readonly idRaw?: Maybe<Scalars['JSON']>;
  readonly itRaw?: Maybe<Scalars['JSON']>;
  readonly jaRaw?: Maybe<Scalars['JSON']>;
  readonly koRaw?: Maybe<Scalars['JSON']>;
  readonly nlRaw?: Maybe<Scalars['JSON']>;
  readonly plRaw?: Maybe<Scalars['JSON']>;
  readonly ptRaw?: Maybe<Scalars['JSON']>;
  readonly roRaw?: Maybe<Scalars['JSON']>;
  readonly thRaw?: Maybe<Scalars['JSON']>;
  readonly zhRaw?: Maybe<Scalars['JSON']>;
}

export interface ILocaleBlockTextWidget {
  readonly __typename?: 'LocaleBlockTextWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly blockTextInversion?: Maybe<Scalars['Boolean']>;
  readonly localeBlockTextContent?: Maybe<ILocaleBlockContent>;
}

export interface ILocaleFile {
  readonly __typename?: 'LocaleFile';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<IFile>;
  readonly cs?: Maybe<IFile>;
  readonly de?: Maybe<IFile>;
  readonly en?: Maybe<IFile>;
  readonly es?: Maybe<IFile>;
  readonly eu?: Maybe<IFile>;
  readonly fr?: Maybe<IFile>;
  readonly gl?: Maybe<IFile>;
  readonly id?: Maybe<IFile>;
  readonly it?: Maybe<IFile>;
  readonly ja?: Maybe<IFile>;
  readonly ko?: Maybe<IFile>;
  readonly nl?: Maybe<IFile>;
  readonly pl?: Maybe<IFile>;
  readonly pt?: Maybe<IFile>;
  readonly ro?: Maybe<IFile>;
  readonly th?: Maybe<IFile>;
  readonly zh?: Maybe<IFile>;
}

export interface ILocaleImage {
  readonly __typename?: 'LocaleImage';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<IImage>;
  readonly cs?: Maybe<IImage>;
  readonly de?: Maybe<IImage>;
  readonly en?: Maybe<IImage>;
  readonly es?: Maybe<IImage>;
  readonly eu?: Maybe<IImage>;
  readonly fr?: Maybe<IImage>;
  readonly gl?: Maybe<IImage>;
  readonly id?: Maybe<IImage>;
  readonly it?: Maybe<IImage>;
  readonly ja?: Maybe<IImage>;
  readonly ko?: Maybe<IImage>;
  readonly nl?: Maybe<IImage>;
  readonly pl?: Maybe<IImage>;
  readonly pt?: Maybe<IImage>;
  readonly ro?: Maybe<IImage>;
  readonly th?: Maybe<IImage>;
  readonly zh?: Maybe<IImage>;
}

export interface ILocaleImages {
  readonly __typename?: 'LocaleImages';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<IImages>;
  readonly cs?: Maybe<IImages>;
  readonly de?: Maybe<IImages>;
  readonly en?: Maybe<IImages>;
  readonly es?: Maybe<IImages>;
  readonly eu?: Maybe<IImages>;
  readonly fr?: Maybe<IImages>;
  readonly gl?: Maybe<IImages>;
  readonly id?: Maybe<IImages>;
  readonly it?: Maybe<IImages>;
  readonly ja?: Maybe<IImages>;
  readonly ko?: Maybe<IImages>;
  readonly nl?: Maybe<IImages>;
  readonly pl?: Maybe<IImages>;
  readonly pt?: Maybe<IImages>;
  readonly ro?: Maybe<IImages>;
  readonly th?: Maybe<IImages>;
  readonly zh?: Maybe<IImages>;
}

export interface ILocaleSlug {
  readonly __typename?: 'LocaleSlug';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<ISlug>;
  readonly cs?: Maybe<ISlug>;
  readonly de?: Maybe<ISlug>;
  readonly en?: Maybe<ISlug>;
  readonly es?: Maybe<ISlug>;
  readonly eu?: Maybe<ISlug>;
  readonly fr?: Maybe<ISlug>;
  readonly gl?: Maybe<ISlug>;
  readonly id?: Maybe<ISlug>;
  readonly it?: Maybe<ISlug>;
  readonly ja?: Maybe<ISlug>;
  readonly ko?: Maybe<ISlug>;
  readonly nl?: Maybe<ISlug>;
  readonly pl?: Maybe<ISlug>;
  readonly pt?: Maybe<ISlug>;
  readonly ro?: Maybe<ISlug>;
  readonly th?: Maybe<ISlug>;
  readonly zh?: Maybe<ISlug>;
}

export interface ILocaleSmartBlockContent {
  readonly __typename?: 'LocaleSmartBlockContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly caRaw?: Maybe<Scalars['JSON']>;
  readonly csRaw?: Maybe<Scalars['JSON']>;
  readonly deRaw?: Maybe<Scalars['JSON']>;
  readonly enRaw?: Maybe<Scalars['JSON']>;
  readonly esRaw?: Maybe<Scalars['JSON']>;
  readonly euRaw?: Maybe<Scalars['JSON']>;
  readonly frRaw?: Maybe<Scalars['JSON']>;
  readonly glRaw?: Maybe<Scalars['JSON']>;
  readonly idRaw?: Maybe<Scalars['JSON']>;
  readonly itRaw?: Maybe<Scalars['JSON']>;
  readonly jaRaw?: Maybe<Scalars['JSON']>;
  readonly koRaw?: Maybe<Scalars['JSON']>;
  readonly nlRaw?: Maybe<Scalars['JSON']>;
  readonly plRaw?: Maybe<Scalars['JSON']>;
  readonly ptRaw?: Maybe<Scalars['JSON']>;
  readonly roRaw?: Maybe<Scalars['JSON']>;
  readonly thRaw?: Maybe<Scalars['JSON']>;
  readonly zhRaw?: Maybe<Scalars['JSON']>;
}

export interface ILocaleSmartTextField {
  readonly __typename?: 'LocaleSmartTextField';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<Scalars['String']>;
  readonly cs?: Maybe<Scalars['String']>;
  readonly de?: Maybe<Scalars['String']>;
  readonly en?: Maybe<Scalars['String']>;
  readonly es?: Maybe<Scalars['String']>;
  readonly eu?: Maybe<Scalars['String']>;
  readonly fr?: Maybe<Scalars['String']>;
  readonly gl?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly it?: Maybe<Scalars['String']>;
  readonly ja?: Maybe<Scalars['String']>;
  readonly ko?: Maybe<Scalars['String']>;
  readonly nl?: Maybe<Scalars['String']>;
  readonly pl?: Maybe<Scalars['String']>;
  readonly pt?: Maybe<Scalars['String']>;
  readonly ro?: Maybe<Scalars['String']>;
  readonly th?: Maybe<Scalars['String']>;
  readonly zh?: Maybe<Scalars['String']>;
}

export interface ILocaleString {
  readonly __typename?: 'LocaleString';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<Scalars['String']>;
  readonly cs?: Maybe<Scalars['String']>;
  readonly de?: Maybe<Scalars['String']>;
  readonly en?: Maybe<Scalars['String']>;
  readonly es?: Maybe<Scalars['String']>;
  readonly eu?: Maybe<Scalars['String']>;
  readonly fr?: Maybe<Scalars['String']>;
  readonly gl?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly it?: Maybe<Scalars['String']>;
  readonly ja?: Maybe<Scalars['String']>;
  readonly ko?: Maybe<Scalars['String']>;
  readonly nl?: Maybe<Scalars['String']>;
  readonly pl?: Maybe<Scalars['String']>;
  readonly pt?: Maybe<Scalars['String']>;
  readonly ro?: Maybe<Scalars['String']>;
  readonly th?: Maybe<Scalars['String']>;
  readonly zh?: Maybe<Scalars['String']>;
}

export interface ILocaleTypographyBlock {
  readonly __typename?: 'LocaleTypographyBlock';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly caRaw?: Maybe<Scalars['JSON']>;
  readonly csRaw?: Maybe<Scalars['JSON']>;
  readonly deRaw?: Maybe<Scalars['JSON']>;
  readonly enRaw?: Maybe<Scalars['JSON']>;
  readonly esRaw?: Maybe<Scalars['JSON']>;
  readonly euRaw?: Maybe<Scalars['JSON']>;
  readonly frRaw?: Maybe<Scalars['JSON']>;
  readonly glRaw?: Maybe<Scalars['JSON']>;
  readonly idRaw?: Maybe<Scalars['JSON']>;
  readonly itRaw?: Maybe<Scalars['JSON']>;
  readonly jaRaw?: Maybe<Scalars['JSON']>;
  readonly koRaw?: Maybe<Scalars['JSON']>;
  readonly nlRaw?: Maybe<Scalars['JSON']>;
  readonly plRaw?: Maybe<Scalars['JSON']>;
  readonly ptRaw?: Maybe<Scalars['JSON']>;
  readonly roRaw?: Maybe<Scalars['JSON']>;
  readonly thRaw?: Maybe<Scalars['JSON']>;
  readonly zhRaw?: Maybe<Scalars['JSON']>;
}

export interface ILocaleUrl {
  readonly __typename?: 'LocaleUrl';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<Scalars['String']>;
  readonly cs?: Maybe<Scalars['String']>;
  readonly de?: Maybe<Scalars['String']>;
  readonly en?: Maybe<Scalars['String']>;
  readonly es?: Maybe<Scalars['String']>;
  readonly eu?: Maybe<Scalars['String']>;
  readonly fr?: Maybe<Scalars['String']>;
  readonly gl?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly it?: Maybe<Scalars['String']>;
  readonly ja?: Maybe<Scalars['String']>;
  readonly ko?: Maybe<Scalars['String']>;
  readonly nl?: Maybe<Scalars['String']>;
  readonly pl?: Maybe<Scalars['String']>;
  readonly pt?: Maybe<Scalars['String']>;
  readonly ro?: Maybe<Scalars['String']>;
  readonly th?: Maybe<Scalars['String']>;
  readonly zh?: Maybe<Scalars['String']>;
}

export interface ILockedOffers extends IDocument {
  readonly __typename?: 'LockedOffers';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface ILockedOffersFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ILockedOffersPanel {
  readonly __typename?: 'LockedOffersPanel';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly completedChallengeDescription?: Maybe<ILocaleBlockContent>;
  readonly completedChallengeHeader?: Maybe<ILocaleBlockContent>;
}

export interface ILogsConfig {
  readonly __typename?: 'LogsConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly clientToken?: Maybe<Scalars['String']>;
  readonly dataCenter?: Maybe<Scalars['String']>;
}

export interface ILoyaltyBasicCardWidget {
  readonly __typename?: 'LoyaltyBasicCardWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly linkedCard?: Maybe<IMarketingTileBasic>;
  readonly unlinkedCard?: Maybe<IMarketingTileBasic>;
}

export type ILoyaltyBasicCardWidgetOrLoyaltyButtonArrayWidgetOrLoyaltyButtonWidgetOrLoyaltyCartWidgetOrLoyaltyImageWidgetOrLoyaltyLegacyShortCodeWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyPaymentMethodWidgetOrLoyaltyQrAndShortCodeWidgetOrLoyaltyQrCodeLoyaltyIdWidgetOrLoyaltyQrCodeWidgetOrLoyaltyQrScanButtonWidgetOrLoyaltyQrScanHeaderWidgetOrLoyaltyShortCodeWidgetOrLoyaltyTextWidgetOrLoyaltyTitleWidget = ILoyaltyBasicCardWidget | ILoyaltyButtonArrayWidget | ILoyaltyButtonWidget | ILoyaltyCartWidget | ILoyaltyImageWidget | ILoyaltyLegacyShortCodeWidget | ILoyaltyMarketingTileGroupWidget | ILoyaltyPaymentMethodWidget | ILoyaltyQrAndShortCodeWidget | ILoyaltyQrCodeLoyaltyIdWidget | ILoyaltyQrCodeWidget | ILoyaltyQrScanButtonWidget | ILoyaltyQrScanHeaderWidget | ILoyaltyShortCodeWidget | ILoyaltyTextWidget | ILoyaltyTitleWidget;

export interface ILoyaltyBetweenDates {
  readonly __typename?: 'LoyaltyBetweenDates';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Ends on... (Time will be set to 23:59:59 and reflect based on user's local time) */
  readonly endDate?: Maybe<Scalars['Date']>;
  /** Starts on... (Time will be set to 00:00:00 and reflect based on user’s local time) */
  readonly startDate?: Maybe<Scalars['Date']>;
}

export interface ILoyaltyBetweenTimes {
  readonly __typename?: 'LoyaltyBetweenTimes';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Time will be converted from your local time to UTC */
  readonly endTime?: Maybe<Scalars['DateTime']>;
  /** Time will be converted from your local time to UTC */
  readonly startTime?: Maybe<Scalars['DateTime']>;
}

export interface ILoyaltyButtonArrayWidget {
  readonly __typename?: 'LoyaltyButtonArrayWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttons?: Maybe<ReadonlyArray<Maybe<ILoyaltyButtonLinkTextWidget>>>;
  readonly componentKey?: Maybe<Scalars['String']>;
}

export interface ILoyaltyButtonLinkTextWidget {
  readonly __typename?: 'LoyaltyButtonLinkTextWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly link?: Maybe<ILinkWidget>;
  readonly type?: Maybe<Scalars['String']>;
}

export interface ILoyaltyButtonWidget {
  readonly __typename?: 'LoyaltyButtonWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly link?: Maybe<ILinkWidget>;
}

export interface ILoyaltyCartWidget {
  readonly __typename?: 'LoyaltyCartWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  /** Marketing Tile to show in case the In Store cart is empty */
  readonly loyaltyEmptyCartTileWidget?: Maybe<IMarketingTileBasic>;
}

export interface ILoyaltyConfiguration extends IDocument {
  readonly __typename?: 'LoyaltyConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly bankMyRewardTier?: Maybe<ITier>;
  readonly categories?: Maybe<ReadonlyArray<Maybe<ICategory>>>;
  readonly defaultTier?: Maybe<ITier>;
  readonly name?: Maybe<ILocaleString>;
  readonly onboardingQuickSelectTiers?: Maybe<ReadonlyArray<Maybe<ITier>>>;
}

export interface ILoyaltyConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly bankMyRewardTier?: InputMaybe<Scalars['ID']>;
  readonly defaultTier?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ILoyaltyContent extends IDocument {
  readonly __typename?: 'LoyaltyContent';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly addCardHeaderText?: Maybe<ILocaleString>;
  readonly addCardImage?: Maybe<ILocaleImages>;
  readonly addCardSkipText?: Maybe<ILocaleString>;
  readonly addCardTextBlock?: Maybe<ILocaleBlockContent>;
  readonly birthdayLegalText?: Maybe<ILocaleString>;
  readonly detailsIconFour?: Maybe<ILocaleImage>;
  readonly detailsIconOne?: Maybe<ILocaleImage>;
  readonly detailsIconThree?: Maybe<ILocaleImage>;
  readonly detailsIconTwo?: Maybe<ILocaleImage>;
  readonly detailsInstructionsFour?: Maybe<ILocaleString>;
  readonly detailsInstructionsOne?: Maybe<ILocaleString>;
  readonly detailsInstructionsThree?: Maybe<ILocaleString>;
  readonly detailsInstructionsTwo?: Maybe<ILocaleString>;
  readonly detailsPageHeroImage?: Maybe<ILocaleImage>;
  readonly detailsPageHeroImageMobile?: Maybe<ILocaleImage>;
  readonly detailsPageHeroImageWeb?: Maybe<ILocaleImage>;
  readonly detailsSetupPageSubtext?: Maybe<ILocaleString>;
  readonly detailsSetupPageText?: Maybe<ILocaleString>;
  readonly detailsTabName?: Maybe<ILocaleString>;
  readonly historyPageSubtext?: Maybe<ILocaleString>;
  readonly historyPageText?: Maybe<ILocaleString>;
  readonly historyTabName?: Maybe<ILocaleString>;
  readonly lostCardSectionBlockText?: Maybe<ILocaleBlockContent>;
  readonly lostCardSectionTitle?: Maybe<ILocaleString>;
  readonly loyaltyCardSectionText?: Maybe<ILocaleString>;
  readonly loyaltyCardSectionTitle?: Maybe<ILocaleString>;
  readonly loyaltyProgramInstructionsBlockText?: Maybe<ILocaleBlockContent>;
  readonly mainHeroLoyaltyImage?: Maybe<ILocaleImage>;
  readonly mainHeroLoyaltySubtext?: Maybe<ILocaleString>;
  readonly mainHeroLoyaltyText?: Maybe<ILocaleString>;
  readonly name?: Maybe<Scalars['String']>;
  readonly newPointsDisclaimerTextBlock?: Maybe<ILocaleBlockContent>;
  readonly newPointsImage?: Maybe<ILocaleImages>;
  readonly newPointsTextBlockBottom?: Maybe<ILocaleBlockContent>;
  readonly newPointsTextBlockTop?: Maybe<ILocaleBlockContent>;
  readonly onboardingBackgroundImage?: Maybe<ILocaleImages>;
  readonly onboardingButtonLink?: Maybe<Scalars['String']>;
  readonly onboardingButtonText?: Maybe<ILocaleString>;
  readonly onboardingContentCardBackgroundImage?: Maybe<ILocaleImages>;
  readonly onboardingImage?: Maybe<ILocaleImages>;
  readonly onboardingTextBlock?: Maybe<ILocaleBlockContent>;
  readonly onboardingTimsRewardHeaderImage?: Maybe<ILocaleImages>;
  readonly pointsUpdateText?: Maybe<ILocaleString>;
  readonly registerCardImage?: Maybe<ILocaleImage>;
  readonly registerCardSectionBlockText?: Maybe<ILocaleBlockContent>;
  readonly registerCardSectionTitle?: Maybe<ILocaleString>;
  readonly rewardSetupPageBlockText?: Maybe<ILocaleBlockContent>;
  readonly rewardSetupPageSubtext?: Maybe<ILocaleString>;
  readonly rewardSetupPageText?: Maybe<ILocaleString>;
  readonly rewardSetupTabName?: Maybe<ILocaleString>;
  readonly rewardsUnavailableBlockText?: Maybe<ILocaleBlockContent>;
  readonly seeMoreOptionsText?: Maybe<ILocaleString>;
  readonly tierCardTextBlock?: Maybe<ILocaleBlockContent>;
  readonly tierHeaderText?: Maybe<ILocaleString>;
  readonly timsRewardsImage?: Maybe<ILocaleImage>;
  readonly timsRewardsLevelImage?: Maybe<ILocaleImages>;
}

export interface ILoyaltyContentFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly onboardingButtonLink?: InputMaybe<Scalars['String']>;
  readonly onboardingButtonLink_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly onboardingButtonLink_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly onboardingButtonLink_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly onboardingButtonLink_not?: InputMaybe<Scalars['String']>;
  readonly onboardingButtonLink_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ILoyaltyDashboard {
  readonly __typename?: 'LoyaltyDashboard';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly widgets?: Maybe<ReadonlyArray<Maybe<IFeaturedRewardsCarouselWidgetOrLoyaltyDoubleButtonWidgetOrLoyaltyGreetingWidgetOrLoyaltyHistoryWidgetOrLoyaltyLinkWidgetOrLoyaltyLogoWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyNotificationsWidgetOrLoyaltyPointsAndRewardsWidgetOrLoyaltyPointsMeterWidgetOrLoyaltyQuestsTileWidgetOrLoyaltyQuestsWidgetOrLoyaltyTiersWidgetOrRewardsListWidget>>>;
}

export interface ILoyaltyDoubleButtonWidget {
  readonly __typename?: 'LoyaltyDoubleButtonWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Double Button Widget */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly leftButtonPath?: Maybe<ILocaleString>;
  readonly leftButtonText?: Maybe<ILocaleString>;
  readonly rightButtonPath?: Maybe<ILocaleString>;
  readonly rightButtonText?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyGreetingWidget {
  readonly __typename?: 'LoyaltyGreetingWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Greeting widget i.e. "Good Afternoon, John". */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyHistoryWidget {
  readonly __typename?: 'LoyaltyHistoryWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Displays loyalty transaction history. */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyImageWidget {
  readonly __typename?: 'LoyaltyImageWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly image?: Maybe<ILocaleImage>;
}

export interface ILoyaltyInRestaurantRedemption {
  readonly __typename?: 'LoyaltyInRestaurantRedemption';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly bottomWidgets?: Maybe<ReadonlyArray<Maybe<ILoyaltyBasicCardWidgetOrLoyaltyButtonArrayWidgetOrLoyaltyButtonWidgetOrLoyaltyCartWidgetOrLoyaltyImageWidgetOrLoyaltyLegacyShortCodeWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyPaymentMethodWidgetOrLoyaltyQrAndShortCodeWidgetOrLoyaltyQrCodeLoyaltyIdWidgetOrLoyaltyQrCodeWidgetOrLoyaltyQrScanButtonWidgetOrLoyaltyQrScanHeaderWidgetOrLoyaltyShortCodeWidgetOrLoyaltyTextWidgetOrLoyaltyTitleWidget>>>;
  readonly topWidgets?: Maybe<ReadonlyArray<Maybe<ILoyaltyBasicCardWidgetOrLoyaltyButtonArrayWidgetOrLoyaltyButtonWidgetOrLoyaltyCartWidgetOrLoyaltyImageWidgetOrLoyaltyLegacyShortCodeWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyPaymentMethodWidgetOrLoyaltyQrAndShortCodeWidgetOrLoyaltyQrCodeLoyaltyIdWidgetOrLoyaltyQrCodeWidgetOrLoyaltyQrScanButtonWidgetOrLoyaltyQrScanHeaderWidgetOrLoyaltyShortCodeWidgetOrLoyaltyTextWidgetOrLoyaltyTitleWidget>>>;
}

export interface ILoyaltyLegacyShortCodeWidget {
  readonly __typename?: 'LoyaltyLegacyShortCodeWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly instructions?: Maybe<ILocaleString>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyLinkWidget {
  readonly __typename?: 'LoyaltyLinkWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly links?: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyLogoWidget {
  readonly __typename?: 'LoyaltyLogoWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
}

export interface ILoyaltyMarketingTileGroupWidget {
  readonly __typename?: 'LoyaltyMarketingTileGroupWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Marketing Tile Group widget */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly marketingTileGroup?: Maybe<IMarketingTileGroup>;
  readonly marketingTileWidgetDisclaimer?: Maybe<ILocaleBlockContent>;
  readonly marketingTileWidgetTitle?: Maybe<ILocaleString>;
}

export interface ILoyaltyNotAuthenticated {
  readonly __typename?: 'LoyaltyNotAuthenticated';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly loyaltySignupButtonText?: Maybe<ILocaleString>;
  readonly loyaltySignupCells?: Maybe<ReadonlyArray<Maybe<ILoyaltyNotAuthenticatedCell>>>;
  readonly loyaltySignupLegalText?: Maybe<ILocaleString>;
  readonly loyaltySignupTitle?: Maybe<ILocaleString>;
}

export interface ILoyaltyNotAuthenticatedCell {
  readonly __typename?: 'LoyaltyNotAuthenticatedCell';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly loyaltySignupCellDescription?: Maybe<ILocaleString>;
  readonly loyaltySignupCellImage?: Maybe<ILocaleImage>;
  readonly loyaltySignupCellTitle?: Maybe<ILocaleString>;
}

export interface ILoyaltyNotAvailableAtDeliveryMode {
  readonly __typename?: 'LoyaltyNotAvailableAtDeliveryMode';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly firstButtonText?: Maybe<ILocaleString>;
  readonly firstRedirectPath?: Maybe<ILocaleUrl>;
  readonly image?: Maybe<ILocaleImages>;
  readonly needHelpBlockContent?: Maybe<ILocaleBlockContent>;
  readonly needHelpSectionTitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyNotAvailableAtThisRestaurant {
  readonly __typename?: 'LoyaltyNotAvailableAtThisRestaurant';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly firstButtonText?: Maybe<ILocaleString>;
  readonly firstRedirectPath?: Maybe<ILocaleUrl>;
  readonly image?: Maybe<ILocaleImages>;
  readonly secondButtonText?: Maybe<ILocaleString>;
  readonly secondRedirectPath?: Maybe<ILocaleUrl>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyNotificationsWidget {
  readonly __typename?: 'LoyaltyNotificationsWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Displays a loyalty notifications widget */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly notifications?: Maybe<ReadonlyArray<Maybe<IRewardOrSystemwideOfferOrSystemwidePromotion>>>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyOffersUi extends IDocument {
  readonly __typename?: 'LoyaltyOffersUI';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly endOfOffersLoggedIn?: Maybe<IEndOfOffersLoggedIn>;
  readonly endOfOffersLoggedOut?: Maybe<IEndOfOffersLoggedOut>;
  readonly globalOfferCooldownContent?: Maybe<IGlobalOfferCooldownContent>;
  readonly liveConfigOffers?: Maybe<ReadonlyArray<Maybe<IConfigOffer>>>;
  readonly offerNotAvailableModalContent?: Maybe<IIncentiveNotAvailableModalContent>;
  /** The templateId selected below will be the template Id associated with all redeemed offers using Promo Codes */
  readonly offerPromotionTemplate?: Maybe<IOfferTemplate>;
  readonly rewardNotAvailableModalContent?: Maybe<IIncentiveNotAvailableModalContent>;
  readonly sortedSystemwideOffers?: Maybe<ReadonlyArray<Maybe<ISystemwideOffer>>>;
}

export interface ILoyaltyOffersUiFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly offerPromotionTemplate?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ILoyaltyPaymentMethodWidget {
  readonly __typename?: 'LoyaltyPaymentMethodWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyPoints {
  readonly __typename?: 'LoyaltyPoints';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly points?: Maybe<Scalars['Float']>;
}

export interface ILoyaltyPointsAndRewardsWidget {
  readonly __typename?: 'LoyaltyPointsAndRewardsWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Displays the loyalty points and rewards carousel. */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyPointsMeterWidget {
  readonly __typename?: 'LoyaltyPointsMeterWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Displays a loyalty points meter */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly ctaButton?: Maybe<IActionButton>;
  readonly imageBackground?: Maybe<IImageBackground>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyQrAndShortCodeModalContent {
  readonly __typename?: 'LoyaltyQRAndShortCodeModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttonCtaLabel?: Maybe<ILocaleString>;
  readonly details?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<IImage>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyQrAndShortCodeWidget {
  readonly __typename?: 'LoyaltyQRAndShortCodeWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly qrAndShortCodeErrorModalContent?: Maybe<ILoyaltyQrAndShortCodeModalContent>;
  readonly qrAndShortCodeHowToEarnModalContent?: Maybe<ILoyaltyQrAndShortCodeModalContent>;
  readonly qrAndShortCodeSuccessModalContent?: Maybe<ILoyaltyQrAndShortCodeModalContent>;
  readonly shortCodeAlwaysDisplayGenerateButton?: Maybe<Scalars['Boolean']>;
  readonly shortCodeExpirationButtonCtaLabel?: Maybe<ILocaleString>;
  readonly shortCodeExpirationTitle?: Maybe<ILocaleString>;
  readonly shortCodeText?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyQrCodeLoyaltyIdWidget {
  readonly __typename?: 'LoyaltyQRCodeLoyaltyIdWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyQrCodeWidget {
  readonly __typename?: 'LoyaltyQRCodeWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly expirationMessage?: Maybe<ILocaleString>;
  readonly phoneNumberTextMessage?: Maybe<ILocaleString>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyQrScanButtonWidget {
  readonly __typename?: 'LoyaltyQRScanButtonWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly expirationMessage?: Maybe<ILocaleString>;
  readonly link?: Maybe<ILinkWidget>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyQrScanHeaderWidget {
  readonly __typename?: 'LoyaltyQRScanHeaderWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly expirationMessage?: Maybe<ILocaleString>;
  readonly link?: Maybe<ILinkWidget>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyQuestsTileWidget {
  readonly __typename?: 'LoyaltyQuestsTileWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Challenges Tile widget */
  readonly componentKey?: Maybe<Scalars['String']>;
}

export interface ILoyaltyQuestsUi extends IDocument {
  readonly __typename?: 'LoyaltyQuestsUI';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly bonusPointsIncentiveDescription?: Maybe<ILocaleString>;
  readonly completedAndRedeemedBonusPointsDescription?: Maybe<ILocaleString>;
  readonly completedAndRedeemedDescription?: Maybe<ILocaleString>;
  readonly completedButton?: Maybe<ILocaleString>;
  readonly completedDescription?: Maybe<ILocaleString>;
  readonly enrolledButton?: Maybe<ILocaleString>;
  readonly genericStepImage?: Maybe<ILocaleImage>;
  readonly genericStepText?: Maybe<ILocaleString>;
  readonly notEnrolledButton?: Maybe<ILocaleString>;
  readonly sortedSystemwideQuests?: Maybe<ReadonlyArray<Maybe<ISystemwideQuest>>>;
}

export interface ILoyaltyQuestsUiFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ILoyaltyQuestsWidget {
  readonly __typename?: 'LoyaltyQuestsWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Quests widget */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyReceiptVariants {
  readonly __typename?: 'LoyaltyReceiptVariants';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly claimed?: Maybe<ILoyaltyTransactionReceipt>;
  readonly mobile?: Maybe<ILoyaltyTransactionReceipt>;
  readonly unclaimed?: Maybe<ILoyaltyTransactionReceipt>;
}

export interface ILoyaltyReceipts extends IDocument {
  readonly __typename?: 'LoyaltyReceipts';
  readonly CARROLS?: Maybe<ILoyaltyReceiptVariants>;
  readonly NCR?: Maybe<ILoyaltyReceiptVariants>;
  readonly PARTNER?: Maybe<ILoyaltyReceiptVariants>;
  readonly QDI?: Maybe<ILoyaltyReceiptVariants>;
  readonly QST?: Maybe<ILoyaltyReceiptVariants>;
  readonly RPOS?: Maybe<ILoyaltyReceiptVariants>;
  readonly SICOM?: Maybe<ILoyaltyReceiptVariants>;
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly claimed?: Maybe<ILoyaltyTransactionReceipt>;
  readonly mobile?: Maybe<ILoyaltyTransactionReceipt>;
  readonly unclaimed?: Maybe<ILoyaltyTransactionReceipt>;
}

export interface ILoyaltyReceiptsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ILoyaltyShortCodeWidget {
  readonly __typename?: 'LoyaltyShortCodeWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly alternativeTitle?: Maybe<ILocaleString>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly defaultCode?: Maybe<ILocaleString>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyTextWidget {
  readonly __typename?: 'LoyaltyTextWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly text?: Maybe<ILocaleString>;
}

export interface ILoyaltyTiersWidget {
  readonly __typename?: 'LoyaltyTiersWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly sortByPointValue?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyTitleWidget {
  readonly __typename?: 'LoyaltyTitleWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ILoyaltyTransactionReceipt {
  readonly __typename?: 'LoyaltyTransactionReceipt';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly footer?: Maybe<ILocaleString>;
  readonly guestDisplay?: Maybe<ILocaleString>;
  readonly header?: Maybe<ILocaleString>;
  readonly identifierPrefix?: Maybe<ILocaleString>;
  readonly marketing?: Maybe<ILocaleString>;
  readonly operatorDisplay?: Maybe<ILocaleString>;
  readonly pointsEarnedPrefix?: Maybe<ILocaleString>;
  readonly pointsRedeemedPrefix?: Maybe<ILocaleString>;
  readonly qrCode?: Maybe<ILocaleString>;
  readonly totalPointsPrefix?: Maybe<ILocaleString>;
}

export interface ILoyaltyUi extends IDocument {
  readonly __typename?: 'LoyaltyUI';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly featuredRewards?: Maybe<IRewardsSection>;
  readonly imageBackground?: Maybe<IImageBackground>;
  readonly loyaltyDashboard?: Maybe<ILoyaltyDashboard>;
  readonly loyaltyInRestaurantRedemption?: Maybe<ILoyaltyInRestaurantRedemption>;
  readonly loyaltyNotAuthenticated?: Maybe<ILoyaltyNotAuthenticated>;
  readonly loyaltyNotAvailableAtDeliveryMode?: Maybe<ILoyaltyNotAvailableAtDeliveryMode>;
  readonly loyaltyNotAvailableAtThisRestaurant?: Maybe<ILoyaltyNotAvailableAtThisRestaurant>;
  readonly noRewardPoints?: Maybe<IEmptyState>;
  readonly noRewardsAvailable?: Maybe<IEmptyState>;
  readonly notEnrolledState?: Maybe<IEmptyState>;
  readonly notEnrolledStateMobile?: Maybe<IEmptyState>;
  readonly optInModal?: Maybe<IOptInModalContent>;
  readonly optInModalError?: Maybe<IOptInModalContent>;
  readonly optInModalLoading?: Maybe<IOptInModalLoading>;
  readonly overrideShortCodeModalContent?: Maybe<IOverrideShortCodeModalContent>;
  readonly rewardsLearnMoreIcon?: Maybe<ILocaleImage>;
  /** Display rewards list format */
  readonly rewardsListWidgetType?: Maybe<Scalars['String']>;
  readonly rewardsLogo?: Maybe<ILocaleImage>;
  readonly rewardsLogoInverted?: Maybe<ILocaleImage>;
  readonly rewardsProgressBarIcon?: Maybe<ILocaleImage>;
  readonly shortCodeConfirmationModalContent?: Maybe<IShortCodeConfirmationModalContent>;
  readonly surpriseAndDelightModalContent?: Maybe<ISurpriseAndDelightModalContent>;
  readonly swapModalContent?: Maybe<ISwapModalContent>;
}

export interface ILoyaltyUiFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly featuredRewards?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly noRewardPoints?: InputMaybe<Scalars['ID']>;
  readonly noRewardsAvailable?: InputMaybe<Scalars['ID']>;
  readonly notEnrolledState?: InputMaybe<Scalars['ID']>;
  readonly notEnrolledStateMobile?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly rewardsListWidgetType?: InputMaybe<Scalars['String']>;
  readonly rewardsListWidgetType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly rewardsListWidgetType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly rewardsListWidgetType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly rewardsListWidgetType_not?: InputMaybe<Scalars['String']>;
  readonly rewardsListWidgetType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IMainHero extends IDocument {
  readonly __typename?: 'MainHero';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly action?: Maybe<ILinkAction>;
  readonly actionLeft?: Maybe<ILinkAction>;
  readonly actionLeftIcon?: Maybe<ILocaleImage>;
  readonly actionRight?: Maybe<ILinkAction>;
  readonly actionRightIcon?: Maybe<ILocaleImage>;
  readonly image?: Maybe<ILocaleImage>;
  readonly kioskImage?: Maybe<ILocaleImage>;
  readonly loyaltyAction?: Maybe<ILinkAction>;
  readonly mainText?: Maybe<ILocaleString>;
  readonly maskCards?: Maybe<ReadonlyArray<Maybe<ISimpleCard>>>;
  readonly mobileImage?: Maybe<ILocaleImage>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly subText?: Maybe<ILocaleString>;
  readonly superText?: Maybe<ILocaleString>;
  /** Color for all hero content text. White and black align with the brand color scheme equivalent */
  readonly textColor?: Maybe<Scalars['String']>;
}

export interface IMainHeroFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly textColor?: InputMaybe<Scalars['String']>;
  readonly textColor_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly textColor_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly textColor_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly textColor_not?: InputMaybe<Scalars['String']>;
  readonly textColor_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IMarkerItem extends IDocument {
  readonly __typename?: 'MarkerItem';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly name?: Maybe<ILocaleString>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
}

export interface IMarkerItemFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IMarketingAndLegalTextsModalContent {
  readonly __typename?: 'MarketingAndLegalTextsModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly paybackBKLogoImage?: Maybe<ILocaleImage>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IMarketingCard extends IDocument {
  readonly __typename?: 'MarketingCard';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundColor?: Maybe<IColor>;
  readonly buttonBackgroundColor?: Maybe<IColor>;
  readonly buttonTextColor?: Maybe<IColor>;
  readonly callToAction?: Maybe<ILinkAction>;
  readonly daysOfWeek?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly description?: Maybe<ILocaleString>;
  /** Use custom text and background colors. Please ensure that the colors meet the guidelines for contrast accessibility (https://accessible-colors.com/) */
  readonly hasCustomColors?: Maybe<Scalars['Boolean']>;
  readonly hasTerms?: Maybe<Scalars['Boolean']>;
  readonly header?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImages>;
  readonly termsButton?: Maybe<ILinkAction>;
  readonly termsText?: Maybe<ILocaleBlockContent>;
  readonly textColor?: Maybe<IColor>;
  readonly timeRanges?: Maybe<ReadonlyArray<Maybe<ITimeRange>>>;
}

export interface IMarketingCardFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly hasCustomColors?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasCustomColors_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasCustomColors_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasTerms?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasTerms_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasTerms_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IMarketingCardGroup extends IDocument {
  readonly __typename?: 'MarketingCardGroup';
  readonly Cards?: Maybe<ReadonlyArray<Maybe<IMarketingCard>>>;
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IMarketingCardGroupFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IMarketingTile extends IDocument {
  readonly __typename?: 'MarketingTile';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<ILocaleImages>;
  readonly buttonAction?: Maybe<ILinkAction>;
  readonly buttonAlignment?: Maybe<Scalars['String']>;
  /** Should the Marketing Tile have a locked aspect ratio? If you are unsure, leave checked. If checked, the background image will not be cropped, and the aspect ratio of the Background Image will be maintained. Image will be maintained on both Desktop and Mobile. If this Marketing Tile is part of a  Marketing Tile pair, then you must ensure that both background images have the same aspect ratio, e.g. 2:1 If not checked, the desktop version will have a max aspect ratio of 4:1. And aspect ratio of ~1:1 on mobile devices  */
  readonly lockedAspectRatio?: Maybe<Scalars['Boolean']>;
  readonly ruleSet?: Maybe<IMarketingTileRuleSet>;
  readonly termsButton?: Maybe<ILinkAction>;
  readonly termsText?: Maybe<ILocaleBlockContent>;
  readonly textAlignment?: Maybe<Scalars['String']>;
  readonly textBlock?: Maybe<ILocaleTypographyBlock>;
  /** Change the color of the text to make it more readable with a darker background */
  readonly textColor?: Maybe<Scalars['String']>;
}

export interface IMarketingTileBasic extends IDocument {
  readonly __typename?: 'MarketingTileBasic';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly link?: Maybe<ILocaleUrl>;
  readonly linkLabel?: Maybe<ILocaleString>;
  readonly marketingBasicTileDescription?: Maybe<ILocaleTypographyBlock>;
  readonly marketingBasicTileImage?: Maybe<ILocaleImages>;
  readonly marketingBasicTileTitle?: Maybe<ILocaleString>;
}

export interface IMarketingTileBasicFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IMarketingTileCarousel extends IDocument {
  readonly __typename?: 'MarketingTileCarousel';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly header?: Maybe<ILocaleString>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly tiles?: Maybe<ReadonlyArray<Maybe<IMarketingTileBasic>>>;
}

export interface IMarketingTileCarouselFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IMarketingTileFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly buttonAlignment?: InputMaybe<Scalars['String']>;
  readonly buttonAlignment_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly buttonAlignment_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly buttonAlignment_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly buttonAlignment_not?: InputMaybe<Scalars['String']>;
  readonly buttonAlignment_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly lockedAspectRatio?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly lockedAspectRatio_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly lockedAspectRatio_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly textAlignment?: InputMaybe<Scalars['String']>;
  readonly textAlignment_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly textAlignment_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly textAlignment_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly textAlignment_not?: InputMaybe<Scalars['String']>;
  readonly textAlignment_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly textColor?: InputMaybe<Scalars['String']>;
  readonly textColor_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly textColor_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly textColor_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly textColor_not?: InputMaybe<Scalars['String']>;
  readonly textColor_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IMarketingTileGroup extends IDocument {
  readonly __typename?: 'MarketingTileGroup';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly tiles?: Maybe<ReadonlyArray<Maybe<IMarketingTileOrMarketingTileBasicOrMarketingTileListOrMarketingTilePairOrMarketingTileQuad>>>;
}

export interface IMarketingTileGroupFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IMarketingTileList {
  readonly __typename?: 'MarketingTileList';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly tiles?: Maybe<ReadonlyArray<Maybe<IMarketingTileBasic>>>;
}

export type IMarketingTileOrMarketingTileBasic = IMarketingTile | IMarketingTileBasic;

export type IMarketingTileOrMarketingTileBasicOrMarketingTileListOrMarketingTilePairOrMarketingTileQuad = IMarketingTile | IMarketingTileBasic | IMarketingTileList | IMarketingTilePair | IMarketingTileQuad;

export interface IMarketingTilePair {
  readonly __typename?: 'MarketingTilePair';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly left?: Maybe<IMarketingTile>;
  readonly right?: Maybe<IMarketingTile>;
}

export interface IMarketingTileQuad {
  readonly __typename?: 'MarketingTileQuad';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly bottomLeftTile?: Maybe<IMarketingTileBasic>;
  readonly bottomRightTile?: Maybe<IMarketingTileBasic>;
  readonly topLeftTile?: Maybe<IMarketingTileBasic>;
  readonly topRightTile?: Maybe<IMarketingTileBasic>;
}

export interface IMarketingTileRuleSet {
  readonly __typename?: 'MarketingTileRuleSet';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly betweenTimes?: Maybe<IBetweenTimes>;
  readonly dayOfWeek?: Maybe<IDayOfWeekBand>;
}

export interface IMediaTag extends IDocument {
  readonly __typename?: 'MediaTag';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly name?: Maybe<ISlug>;
}

export interface IMediaTagFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IMenu extends IDocument {
  readonly __typename?: 'Menu';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly headerSuperText?: Maybe<ILocaleString>;
  readonly headerText?: Maybe<ILocaleString>;
  readonly image?: Maybe<IImage>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrPickerOrSection>>>;
  readonly pickerBackgroundImage?: Maybe<IImage>;
}

export interface IMenuFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IMenuObjectSettings {
  readonly __typename?: 'MenuObjectSettings';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Maximum quantity allowed in a single order for this menu object. Leave unset to fallback to the the global limit. */
  readonly limitPerOrder?: Maybe<Scalars['Float']>;
}

export interface IMenuVariant {
  readonly __typename?: 'MenuVariant';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly displayName?: Maybe<Scalars['String']>;
  readonly key?: Maybe<ISlug>;
  readonly menuVariantReference?: Maybe<IMenu>;
  readonly targetMenu?: Maybe<Scalars['String']>;
}

export interface IModifier extends IDocument {
  readonly __typename?: 'Modifier';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly image?: Maybe<IImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly images?: Maybe<IImages>;
  readonly name?: Maybe<ILocaleString>;
  /** MDM Source Country/Region */
  readonly region?: Maybe<Scalars['String']>;
  readonly specificationName?: Maybe<Scalars['String']>;
  readonly specificationNumber?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  readonly vendorPlus?: Maybe<IVendorPlus>;
}

export interface IModifierFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly region?: InputMaybe<Scalars['String']>;
  readonly region_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly region_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly region_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly region_not?: InputMaybe<Scalars['String']>;
  readonly region_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly specificationName?: InputMaybe<Scalars['String']>;
  readonly specificationName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly specificationName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly specificationName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly specificationName_not?: InputMaybe<Scalars['String']>;
  readonly specificationName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly specificationNumber?: InputMaybe<Scalars['String']>;
  readonly specificationNumber_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly specificationNumber_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly specificationNumber_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly specificationNumber_not?: InputMaybe<Scalars['String']>;
  readonly specificationNumber_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IModifierMultiplier extends IDocument {
  readonly __typename?: 'ModifierMultiplier';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly channelExclusions?: Maybe<IChannelExclusions>;
  readonly internalName?: Maybe<Scalars['String']>;
  readonly modifier?: Maybe<IModifier>;
  readonly multiplier?: Maybe<Scalars['Float']>;
  readonly prefix?: Maybe<ILocaleString>;
  /** MDM Source Country/Region */
  readonly region?: Maybe<Scalars['String']>;
  readonly toastIdentifier?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  readonly vendorPlus?: Maybe<IVendorPlus>;
}

export interface IModifierMultiplierFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly modifier?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly multiplier?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly multiplier_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly multiplier_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly multiplier_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly multiplier_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly multiplier_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly multiplier_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly region?: InputMaybe<Scalars['String']>;
  readonly region_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly region_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly region_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly region_not?: InputMaybe<Scalars['String']>;
  readonly region_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly toastIdentifier?: InputMaybe<Scalars['String']>;
  readonly toastIdentifier_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly toastIdentifier_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly toastIdentifier_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly toastIdentifier_not?: InputMaybe<Scalars['String']>;
  readonly toastIdentifier_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IMultiWidget {
  readonly __typename?: 'MultiWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Select which widget you would like to render at this position. */
  readonly widget?: Maybe<Scalars['String']>;
}

export interface INavigationDesktop {
  readonly __typename?: 'NavigationDesktop';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly aboutMenuEntries?: Maybe<INavigationSection>;
  readonly navigationLinks?: Maybe<ReadonlyArray<Maybe<INavigationDesktopLink>>>;
  readonly navigationLinksWithServiceModeOrStoreSelected?: Maybe<ReadonlyArray<Maybe<INavigationDesktopLink>>>;
}

export interface INavigationDesktopLink {
  readonly __typename?: 'NavigationDesktopLink';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly hideLinkBasedOnLdFlag?: Maybe<ILaunchDarklySelect>;
  readonly launchDarklyAlternateNavigationLink?: Maybe<ILaunchDarklyNavigationLink>;
  readonly navLink?: Maybe<ILinkWidget>;
}

export interface INavigationMobile {
  readonly __typename?: 'NavigationMobile';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly aboutMenuEntries?: Maybe<INavigationSection>;
  readonly navigationTabs?: Maybe<ReadonlyArray<Maybe<INavigationMobileTab>>>;
  readonly navigationTabsWithServiceModeSelected?: Maybe<ReadonlyArray<Maybe<INavigationMobileTab>>>;
}

export interface INavigationMobileHeaderButton {
  readonly __typename?: 'NavigationMobileHeaderButton';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly icon?: Maybe<ILocaleImage>;
  readonly iconActive?: Maybe<ILocaleImage>;
  readonly link?: Maybe<ILocaleUrl>;
}

export interface INavigationMobileTab {
  readonly __typename?: 'NavigationMobileTab';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly hideLinkBasedOnLdFlag?: Maybe<ILaunchDarklySelect>;
  readonly hideOnDesktop?: Maybe<Scalars['Boolean']>;
  readonly launchDarklyAlternateMobileTab?: Maybe<ILaunchDarklyNavigationTab>;
  readonly tabIcon?: Maybe<ILocaleImage>;
  readonly tabIconActive?: Maybe<ILocaleImage>;
  readonly tabLink?: Maybe<ILinkWidget>;
}

export interface INavigationSection extends IDocument {
  readonly __typename?: 'NavigationSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly name?: Maybe<ILocaleString>;
  readonly pages?: Maybe<ReadonlyArray<Maybe<INavigationSectionOrStaticPage>>>;
}

export interface INavigationSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export type INavigationSectionOrStaticPage = INavigationSection | IStaticPage;

export interface INotificationDetails {
  readonly __typename?: 'NotificationDetails';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  /** When true, this notification will be enabled */
  readonly enabled?: Maybe<Scalars['Boolean']>;
  readonly image?: Maybe<ILocaleImage>;
  readonly path?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface INutrition {
  readonly __typename?: 'Nutrition';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Unit: (Cal) */
  readonly calories?: Maybe<Scalars['Float']>;
  /** Unit: (Cal) */
  readonly caloriesPer100?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly carbohydrates?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly carbohydratesPer100?: Maybe<Scalars['Float']>;
  /** Unit: (mg) */
  readonly cholesterol?: Maybe<Scalars['Float']>;
  /** Unit: (KJ) */
  readonly energyKJ?: Maybe<Scalars['Float']>;
  /** Unit: (KJ) */
  readonly energyKJPer100?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly fat?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly fatPer100?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly fiber?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly proteins?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly proteinsPer100?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly salt?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly saltPer100?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly saturatedFat?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly saturatedFatPer100?: Maybe<Scalars['Float']>;
  /** Unit: (mg) */
  readonly sodium?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly sugar?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly sugarPer100?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly transFat?: Maybe<Scalars['Float']>;
  /** Unit: (g) */
  readonly weight?: Maybe<Scalars['Float']>;
}

export interface INutritionExplorerWidget {
  readonly __typename?: 'NutritionExplorerWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly categoryWhitelist?: Maybe<ReadonlyArray<Maybe<IPickerOrSection>>>;
  readonly madLibFilterGroup?: Maybe<IFilterGroup>;
  readonly menu?: Maybe<IMenu>;
  readonly modalFilterGroups?: Maybe<ReadonlyArray<Maybe<IFilterGroup>>>;
  readonly moreOptionsButtonText?: Maybe<ILocaleString>;
  readonly tastySwaps?: Maybe<ITastySwaps>;
  readonly viewMenuButtonText?: Maybe<ILocaleString>;
}

export interface INutritionInfoWidget {
  readonly __typename?: 'NutritionInfoWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly nutritionalSection?: Maybe<INutritionalSection>;
}

export interface INutritionItem {
  readonly __typename?: 'NutritionItem';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly additionalItems?: Maybe<ReadonlyArray<Maybe<INutritionItem>>>;
  readonly name?: Maybe<ILocaleString>;
  /** The key to the corresponding row in the nutrition data per item, e.g. calories or caloriesPer100 */
  readonly nutritionKey?: Maybe<Scalars['String']>;
  readonly unit?: Maybe<ILocaleString>;
}

export interface INutritionItemGroup {
  readonly __typename?: 'NutritionItemGroup';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly lineItems?: Maybe<ReadonlyArray<Maybe<INutritionItem>>>;
  readonly mainItem?: Maybe<INutritionItem>;
}

export type INutritionItemOrNutritionItemGroup = INutritionItem | INutritionItemGroup;

export interface INutritionTable {
  readonly __typename?: 'NutritionTable';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly items?: Maybe<ReadonlyArray<Maybe<INutritionItemOrNutritionItemGroup>>>;
  readonly title?: Maybe<ILocaleString>;
}

export interface INutritionalSection extends IDocument {
  readonly __typename?: 'NutritionalSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly name?: Maybe<ILocaleString>;
  readonly products?: Maybe<ReadonlyArray<Maybe<IItemOrNutritionalSection>>>;
}

export interface INutritionalSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOffer extends IDocument {
  readonly __typename?: 'Offer';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly activationDate?: Maybe<Scalars['Date']>;
  readonly backgroundImage?: Maybe<IImage>;
  readonly channelExclusions?: Maybe<IChannelExclusions>;
  readonly daypart?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly deactivationDate?: Maybe<Scalars['Date']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly dmbName?: Maybe<ILocaleString>;
  /** Configure an offer which will be available for guests */
  readonly documentDescription?: Maybe<Scalars['String']>;
  /** This value will be used only for support coupons to be displayed in the support tool */
  readonly forSupport?: Maybe<Scalars['Boolean']>;
  readonly headerSuperText?: Maybe<ILocaleString>;
  readonly howToRedeem?: Maybe<ILocaleBlockContent>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly images?: Maybe<IImages>;
  readonly incentives?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrOfferItemDiscountOrOfferLoyaltyActionOrPicker>>>;
  readonly internalName?: Maybe<Scalars['String']>;
  readonly localizedImage?: Maybe<ILocaleImages>;
  readonly lockedOffersPanel?: Maybe<ILockedOffersPanel>;
  /** If offer should display the market price of an item (ie: BOGO) link the menu item here */
  readonly marketPrice?: Maybe<IComboOrItem>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  /** This offer must be assigned to individual users */
  readonly mustBeAssigned?: Maybe<Scalars['Boolean']>;
  readonly name?: Maybe<ILocaleBlockContent>;
  readonly offerCTA?: Maybe<ILinkAction>;
  /** This is a field relevant for NZ and will be used for offers that require discount amount, input amount in cents. If you are not NZ do not use it */
  readonly offerDiscount?: Maybe<Scalars['Float']>;
  readonly offerPrice?: Maybe<Scalars['Float']>;
  readonly offerTags?: Maybe<ReadonlyArray<Maybe<ITag>>>;
  /** This is the benefit of the offer, eg the combo or item you will receive for redeeming the offer. */
  readonly option?: Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrOfferLoyaltyActionOrPicker>;
  readonly percentageDiscount?: Maybe<Scalars['Boolean']>;
  readonly prices?: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>;
  readonly pricingDistributionValidation?: Maybe<IDataValidationObject>;
  readonly pricingPermutationValidation?: Maybe<IDataValidationObject>;
  readonly promoCodePanel?: Maybe<IPromoCodePanel>;
  /** Specify an order redemption method (this option overrides the "For Support?" option above). */
  readonly redemptionMethod?: Maybe<Scalars['String']>;
  readonly requirements?: Maybe<IRequirements>;
  readonly restaurantAvailabilityValidation?: Maybe<IDataValidationObject>;
  readonly ruleSet?: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrAndOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrOrOrOrderHistoryOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>;
  /** Configure the code used for in restaurant redemption. */
  readonly shortCode?: Maybe<Scalars['String']>;
  /** Configure UI pattern to show on the frontend. */
  readonly uiPattern?: Maybe<Scalars['String']>;
  readonly upsellOptions?: Maybe<ReadonlyArray<Maybe<IOffer>>>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  readonly vendorPlus?: Maybe<IVendorPlus>;
}

export interface IOfferActivation extends IDocument {
  readonly __typename?: 'OfferActivation';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly fakeField?: Maybe<Scalars['Boolean']>;
}

export interface IOfferActivationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly fakeField?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly fakeField_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly fakeField_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOfferCampaign extends IDocument {
  readonly __typename?: 'OfferCampaign';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** A Name for the campaign */
  readonly name?: Maybe<Scalars['String']>;
  readonly sortedSystemwideOffers?: Maybe<ReadonlyArray<Maybe<ISystemwideOffer>>>;
}

export interface IOfferCampaignFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOfferCategorization extends IDocument {
  readonly __typename?: 'OfferCategorization';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly name?: Maybe<Scalars['String']>;
}

export interface IOfferCategorizationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOfferDiscount extends IDocument {
  readonly __typename?: 'OfferDiscount';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Types: amount | percentage */
  readonly discountType?: Maybe<Scalars['String']>;
  /** Should be a positive number */
  readonly discountValue?: Maybe<Scalars['Float']>;
}

export interface IOfferDiscountFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly discountType?: InputMaybe<Scalars['String']>;
  readonly discountType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly discountType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly discountType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly discountType_not?: InputMaybe<Scalars['String']>;
  readonly discountType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly discountValue?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly discountValue_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly discountValue_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly discountValue_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly discountValue_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly discountValue_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly discountValue_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOfferFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly activationDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly activationDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly activationDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly activationDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly activationDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly activationDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly activationDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly deactivationDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly deactivationDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly deactivationDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly deactivationDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly deactivationDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly deactivationDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly deactivationDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly documentDescription?: InputMaybe<Scalars['String']>;
  readonly documentDescription_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly documentDescription_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly documentDescription_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly documentDescription_not?: InputMaybe<Scalars['String']>;
  readonly documentDescription_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly forSupport?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly forSupport_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly forSupport_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly marketPrice?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly mustBeAssigned?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly mustBeAssigned_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly mustBeAssigned_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly offerDiscount?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly offerDiscount_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly offerDiscount_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly offerDiscount_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly offerDiscount_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly offerDiscount_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly offerDiscount_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly offerPrice?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly offerPrice_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly offerPrice_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly offerPrice_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly offerPrice_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly offerPrice_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly offerPrice_not?: InputMaybe<Scalars['Float']>;
  readonly option?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly percentageDiscount?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly percentageDiscount_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly percentageDiscount_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly redemptionMethod?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly redemptionMethod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly redemptionMethod_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly redemptionMethod_not?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly shortCode?: InputMaybe<Scalars['String']>;
  readonly shortCode_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly shortCode_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly shortCode_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly shortCode_not?: InputMaybe<Scalars['String']>;
  readonly shortCode_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IOfferItemDiscount extends IDocument {
  readonly __typename?: 'OfferItemDiscount';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly discountType?: Maybe<Scalars['String']>;
  /** The value of the discount to be applied. Dollar values (fixed, flat) are represented as dollars (e.g. 3.53 => $3.53) while percent is represented as integers (25 => 25%). */
  readonly discountValue?: Maybe<Scalars['Float']>;
  readonly option?: Maybe<IComboOrItemOrPicker>;
}

export interface IOfferItemDiscountFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly discountType?: InputMaybe<Scalars['String']>;
  readonly discountType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly discountType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly discountType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly discountType_not?: InputMaybe<Scalars['String']>;
  readonly discountType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly discountValue?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly discountValue_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly discountValue_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly discountValue_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly discountValue_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly discountValue_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly discountValue_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly option?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOfferLoyaltyAction extends IDocument {
  readonly __typename?: 'OfferLoyaltyAction';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly loyaltyType?: Maybe<Scalars['String']>;
  /** Must be an integer. Can be negative (e.g. redeeming a coffee that costs 70 points). */
  readonly loyaltyValue?: Maybe<Scalars['Float']>;
}

export interface IOfferLoyaltyActionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyType?: InputMaybe<Scalars['String']>;
  readonly loyaltyType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyType_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly loyaltyValue?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly loyaltyValue_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly loyaltyValue_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly loyaltyValue_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly loyaltyValue_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly loyaltyValue_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly loyaltyValue_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOfferRedemptionLimits {
  readonly __typename?: 'OfferRedemptionLimits';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** This represents the number of stackable standard systemwide or config offers allowed per transaction. Standard offers do not include swap or surprise offers. Default is one. */
  readonly standardOffersLimit?: Maybe<Scalars['Float']>;
}

export interface IOfferRequirementCode {
  readonly __typename?: 'OfferRequirementCode';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Code to redeem in store */
  readonly shortCode?: Maybe<Scalars['String']>;
}

export interface IOfferRequirementPlatform {
  readonly __typename?: 'OfferRequirementPlatform';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly platform?: Maybe<Scalars['String']>;
}

export interface IOfferRequirementPurchase {
  readonly __typename?: 'OfferRequirementPurchase';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Required purchase in order to redeem */
  readonly option?: Maybe<IComboOrItem>;
}

export interface IOfferRequirementUser {
  readonly __typename?: 'OfferRequirementUser';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
}

export interface IOfferTemplate extends IDocument {
  readonly __typename?: 'OfferTemplate';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<IImage>;
  /** Specify the Config Offer to use with this template */
  readonly configIncentive?: Maybe<IConfigOffer>;
  readonly description?: Maybe<ILocaleSmartBlockContent>;
  readonly internalName?: Maybe<Scalars['String']>;
  readonly localizedImage?: Maybe<ILocaleImages>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleSmartBlockContent>;
  readonly requiredRules?: Maybe<IRequiredRules>;
  /** Determines where this template can be used */
  readonly templateType?: Maybe<Scalars['String']>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
}

export interface IOfferTemplateFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly configIncentive?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly templateType?: InputMaybe<Scalars['String']>;
  readonly templateType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly templateType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly templateType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly templateType_not?: InputMaybe<Scalars['String']>;
  readonly templateType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IOfferTier {
  readonly __typename?: 'OfferTier';
  readonly BOGO_DISCOUNT?: Maybe<IBogoDiscount>;
  readonly BOGO_DYNAMIC_DISCOUNT?: Maybe<IBogoDynamicDiscount>;
  readonly BUNDLE_DISCOUNT?: Maybe<IBundleDiscount>;
  readonly FEES_DISCOUNT?: Maybe<IFeesDiscount>;
  readonly GLOBAL_DISCOUNT?: Maybe<IGlobalDiscount>;
  readonly ITEM_LEVEL_DISCOUNT?: Maybe<IItemLevelDiscount>;
  readonly PRICE_POINT_DISCOUNT?: Maybe<IPricePointDiscount>;
  readonly REWARD?: Maybe<IRewardDiscount>;
  readonly STEPPER_DISCOUNT?: Maybe<IStepperDiscount>;
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly incentiveType?: Maybe<Scalars['String']>;
  readonly localizedImage?: Maybe<ILocaleImages>;
  readonly name?: Maybe<Scalars['String']>;
}

export interface IOffersBrowsingPanel {
  readonly __typename?: 'OffersBrowsingPanel';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly emptyStateBody?: Maybe<ILocaleString>;
  readonly emptyStateImage?: Maybe<ILocaleImage>;
  readonly emptyStateTitle?: Maybe<ILocaleString>;
  readonly endOfOffersImage?: Maybe<ILocaleImage>;
  readonly endOfOffersMessage?: Maybe<ILocaleString>;
  readonly offersSelectRestaurantCta?: Maybe<IOffersSelectRestaurantCta>;
}

export interface IOffersDetailsPanel {
  readonly __typename?: 'OffersDetailsPanel';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly emptyStateAction?: Maybe<ILinkAction>;
  readonly emptyStateBody?: Maybe<ILocaleString>;
  readonly emptyStateImage?: Maybe<ILocaleImage>;
  readonly emptyStateTitle?: Maybe<ILocaleString>;
  readonly missingOfferAction?: Maybe<ILinkAction>;
  readonly missingOfferBody?: Maybe<ILocaleString>;
  readonly missingOfferImage?: Maybe<ILocaleImage>;
  readonly missingOfferTitle?: Maybe<ILocaleString>;
}

export interface IOffersPageMarketingTile {
  readonly __typename?: 'OffersPageMarketingTile';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** (select "custom" from the display position above to use this field). The number chosen will correspond to its position in the offers pannel. 2 is the second slot at the top, higher numbers means lower position. */
  readonly customPosition?: Maybe<Scalars['Float']>;
  /** Determines the position in the offers panel that the marketing tile will appear. */
  readonly displayPosition?: Maybe<Scalars['String']>;
  readonly marketingTileReference?: Maybe<IMarketingTile>;
}

export interface IOffersSection extends IDocument {
  readonly __typename?: 'OffersSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IOffersSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IOffersSelectRestaurantCta {
  readonly __typename?: 'OffersSelectRestaurantCta';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly ctaButtonText?: Maybe<ILocaleString>;
  readonly link?: Maybe<ILocaleUrl>;
  /** Minimum number of national offers before CTA card hides those that are available. */
  readonly minimumNumberOfOffers?: Maybe<Scalars['Float']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IOffersV2Content {
  readonly __typename?: 'OffersV2Content';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly localizedImage?: Maybe<ILocaleImages>;
  readonly name?: Maybe<ILocaleString>;
  readonly termsAndConditions?: Maybe<ILocaleBlockContent>;
}

export interface IOffersV2Internal {
  readonly __typename?: 'OffersV2Internal';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** This is for internal name being used for lookup */
  readonly internalName?: Maybe<Scalars['String']>;
  readonly internalNotesRaw?: Maybe<Scalars['JSON']>;
}

export interface IOffersV2Mechanics {
  readonly __typename?: 'OffersV2Mechanics';
  readonly BOGO_DISCOUNT?: Maybe<IBogoDiscount>;
  readonly BOGO_DYNAMIC_DISCOUNT?: Maybe<IBogoDynamicDiscount>;
  readonly BUNDLE_DISCOUNT?: Maybe<IBundleDiscount>;
  readonly FEES_DISCOUNT?: Maybe<IFeesDiscount>;
  readonly GLOBAL_DISCOUNT?: Maybe<IGlobalDiscount>;
  readonly ITEM_LEVEL_DISCOUNT?: Maybe<IItemLevelDiscount>;
  readonly PRICE_POINT_DISCOUNT?: Maybe<IPricePointDiscount>;
  readonly REWARD?: Maybe<IRewardDiscount>;
  readonly STEPPER_DISCOUNT?: Maybe<IStepperDiscount>;
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly incentiveType?: Maybe<Scalars['String']>;
  readonly offerCategorization?: Maybe<IOfferCategorization>;
  readonly rank?: Maybe<Scalars['Float']>;
  readonly rules?: Maybe<ReadonlyArray<Maybe<IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrExpireAfterOrFirstOrderOnlyOrIncentiveRequirementOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated>>>;
  /** When true, this item will be assigned to new users */
  readonly welcomeOffer?: Maybe<Scalars['Boolean']>;
}

export interface IOneTrustConfig {
  readonly __typename?: 'OneTrustConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly cookieCompliance?: Maybe<ICookieComplianceConfig>;
  readonly deleteAccountUrl?: Maybe<Scalars['String']>;
}

export interface IOpAllergen {
  readonly __typename?: 'OpAllergen';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly celery?: Maybe<Scalars['Float']>;
  readonly eggs?: Maybe<Scalars['Float']>;
  readonly fish?: Maybe<Scalars['Float']>;
  readonly gluten?: Maybe<Scalars['Float']>;
  readonly lupin?: Maybe<Scalars['Float']>;
  readonly milk?: Maybe<Scalars['Float']>;
  readonly mustard?: Maybe<Scalars['Float']>;
  readonly peanuts?: Maybe<Scalars['Float']>;
  readonly sesame?: Maybe<Scalars['Float']>;
  readonly shellfish?: Maybe<Scalars['Float']>;
  readonly soy?: Maybe<Scalars['Float']>;
  readonly sulphurDioxide?: Maybe<Scalars['Float']>;
  readonly treeNuts?: Maybe<Scalars['Float']>;
  readonly wheat?: Maybe<Scalars['Float']>;
}

export interface IOpItem {
  readonly __typename?: 'OpItem';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly daypart?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly launchDate?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly product?: Maybe<Scalars['String']>;
  readonly productNumber?: Maybe<Scalars['Float']>;
}

export interface IOpPricingRegion extends IDocument {
  readonly __typename?: 'OpPricingRegion';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly name?: Maybe<Scalars['String']>;
  readonly restaurants?: Maybe<ReadonlyArray<Maybe<IRestaurant>>>;
}

export interface IOpPricingRegionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IOptInModalContent {
  readonly __typename?: 'OptInModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly blockText?: Maybe<ILocaleBlockContent>;
  readonly buttonText?: Maybe<ILocaleString>;
  readonly description?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImages>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IOptInModalLoading {
  readonly __typename?: 'OptInModalLoading';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IOptInPrivacyPreferences {
  readonly __typename?: 'OptInPrivacyPreferences';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  /** This is the id the backend will use to save the users value as */
  readonly key?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  readonly view?: Maybe<ILocaleString>;
}

export type IOptInPrivacyPreferencesOrOptInSettingBooleanOrOptInSettingEmailOrOptInSettingEmailAndPushOrOptInSettingEnumOrOptInSettingPush = IOptInPrivacyPreferences | IOptInSettingBoolean | IOptInSettingEmail | IOptInSettingEmailAndPush | IOptInSettingEnum | IOptInSettingPush;

export interface IOptInSettingBoolean {
  readonly __typename?: 'OptInSettingBoolean';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  /** This is the id the backend will use to save the users value as */
  readonly key?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
}

export type IOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum = IOptInSettingBoolean | IOptInSettingEmailAndPush | IOptInSettingEnum;

export interface IOptInSettingEmail {
  readonly __typename?: 'OptInSettingEmail';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  /** This is the id the backend will use to save the users value as */
  readonly emailKey?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
}

export interface IOptInSettingEmailAndPush {
  readonly __typename?: 'OptInSettingEmailAndPush';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  /** This is the id the backend will use to save the users value as */
  readonly emailKey?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  /** This is the id the backend will use to save the users value as */
  readonly pushKey?: Maybe<Scalars['String']>;
}

export interface IOptInSettingEnum {
  readonly __typename?: 'OptInSettingEnum';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly enumStrings?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** This is the id the backend will use to save the users value as */
  readonly key?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
}

export interface IOptInSettingPush {
  readonly __typename?: 'OptInSettingPush';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly name?: Maybe<ILocaleString>;
  /** This is the id the backend will use to save the users value as */
  readonly pushKey?: Maybe<Scalars['String']>;
}

export interface IOptionVisibilitySettings {
  readonly __typename?: 'OptionVisibilitySettings';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly toggleButtonTextClosed?: Maybe<ILocaleString>;
  readonly toggleButtonTextOpen?: Maybe<ILocaleString>;
  /** The number of options to show by default. Remaining options will only show after a button click. Leave empty to show all options. */
  readonly visibleOptions?: Maybe<Scalars['Float']>;
}

export interface IOr {
  readonly __typename?: 'Or';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ruleSet?: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>;
}

export interface IOrbitalConfig {
  readonly __typename?: 'OrbitalConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly baseUrl?: Maybe<Scalars['String']>;
  readonly mode?: Maybe<Scalars['String']>;
  readonly pieFormat?: Maybe<Scalars['String']>;
  readonly subscriberId?: Maybe<Scalars['String']>;
}

export interface IOrderHistory {
  readonly __typename?: 'OrderHistory';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Query orders from (including) this date... */
  readonly from?: Maybe<Scalars['Date']>;
  /** User must perform each step in the order specified via the Rule Set */
  readonly isSequential?: Maybe<Scalars['Boolean']>;
  /** Look back in user history n seconds */
  readonly lastNSeconds?: Maybe<Scalars['Float']>;
  /** Indicates what time range to use */
  readonly rangeType?: Maybe<Scalars['String']>;
  readonly ruleSet?: Maybe<ReadonlyArray<Maybe<IAndOrBetweenTimesOrCartContainsPluOrCartPropertyOrDayOfWeekBandOrOrOrPaymentCardTypeOrPurchase>>>;
  /** Until (including) this date */
  readonly to?: Maybe<Scalars['Date']>;
}

export interface IOurServices extends IDocument {
  readonly __typename?: 'OurServices';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly ourServicesHeroImageLocale?: Maybe<ILocaleImage>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly servicesHeaderTextLocale?: Maybe<ILocaleString>;
  readonly servicesHeroTextLocale?: Maybe<ILocaleString>;
}

export interface IOurServicesFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IOverrideShortCodeModalContent {
  readonly __typename?: 'OverrideShortCodeModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly confirmButton?: Maybe<ILocaleString>;
  readonly discardButton?: Maybe<ILocaleString>;
  readonly header?: Maybe<ILocaleString>;
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly childPlu?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<Scalars['String']>;
}

export interface IPaymentCardType {
  readonly __typename?: 'PaymentCardType';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** What card/method is the guest using to pay for the order */
  readonly cardType?: Maybe<Scalars['String']>;
}

export interface IPaymentMethod {
  readonly __typename?: 'PaymentMethod';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** What payment method is the guest using to pay for the order */
  readonly paymentMethod?: Maybe<Scalars['String']>;
}

export interface IPaymentMethodDeletionModalText {
  readonly __typename?: 'PaymentMethodDeletionModalText';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly paymentMethodDeletionModalTextBody?: Maybe<ILocaleBlockContent>;
  readonly paymentMethodDeletionModalTextHeader?: Maybe<ILocaleString>;
}

export interface IPaymentsGatewayMerchantIdConfig {
  readonly __typename?: 'PaymentsGatewayMerchantIdConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<Scalars['String']>;
  readonly us?: Maybe<Scalars['String']>;
}

export interface IPicker extends IDocument {
  readonly __typename?: 'Picker';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly channelExclusions?: Maybe<IChannelExclusions>;
  readonly contentOptions?: Maybe<ReadonlyArray<Maybe<IContentOption>>>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly dmbName?: Maybe<ILocaleString>;
  /** Hide all displays of calories on this item */
  readonly hideCalories?: Maybe<Scalars['Boolean']>;
  /** Hide the nutrition legal disclaimer on this item */
  readonly hideNutritionLegalDisclaimer?: Maybe<Scalars['Boolean']>;
  readonly image?: Maybe<IImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly images?: Maybe<IImages>;
  /** Option to be auto-injected when customer redeems offer in-store whose benefit is         the picker, but does not choose an option. */
  readonly inStoreDefaultOption?: Maybe<IComboOrItem>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** Determines if this Picker can be chosen as a benefit for offers.       Once set to true, this cannot be toggled to false. */
  readonly isOfferBenefit?: Maybe<Scalars['Boolean']>;
  /** Is a Real Meal Picker? */
  readonly isRealMeal?: Maybe<Scalars['Boolean']>;
  /** Used to render Wings sauce selections for more than 6pc on the menu wizard.         If true, the UI will render the sauces incrementable by 6 under the picker aspect group.         Otherwise, they will render as true combo slot options in the order summary. */
  readonly isWings?: Maybe<Scalars['Boolean']>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IPickerOption>>>;
  readonly pickerAspectItemOptionMappings?: Maybe<ReadonlyArray<Maybe<IPickerAspectItemOptions>>>;
  readonly pickerAspects?: Maybe<ReadonlyArray<Maybe<IPickerAspect>>>;
  readonly pickerDefaults?: Maybe<ReadonlyArray<Maybe<IPickerItemMapping>>>;
  readonly quickConfigs?: Maybe<ReadonlyArray<Maybe<IQuickConfig>>>;
  /** Show picker in static menu */
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>;
  readonly simpleMenuAttachedCombo?: Maybe<IAttachedCombo>;
  /** Display badge used primarily in menu list view. */
  readonly simplyMenuBadge?: Maybe<Scalars['String']>;
  readonly simplyMenuImage?: Maybe<IImage>;
  readonly simplyMenuOptions?: Maybe<ReadonlyArray<Maybe<IPickerOption>>>;
  readonly simplyMenuPickerAspectItemOptionMappings?: Maybe<ReadonlyArray<Maybe<IPickerAspectItemOptions>>>;
  readonly simplyMenuPickerAspects?: Maybe<ReadonlyArray<Maybe<IPickerAspect>>>;
  readonly simplyMenuPickerDefaults?: Maybe<ReadonlyArray<Maybe<IPickerItemMapping>>>;
  readonly simplyMenuShortDescription?: Maybe<ILocaleString>;
  readonly slug?: Maybe<ISlug>;
  /** Note: This field will soon be deprecated in favor of new menu redesign */
  readonly uiPattern?: Maybe<Scalars['String']>;
}

export interface IPickerAspect extends IDocument {
  readonly __typename?: 'PickerAspect';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly internalName?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  readonly pickerAspectOptions?: Maybe<ReadonlyArray<Maybe<IPickerAspectValue>>>;
  /** Note: This field will soon be deprecated in favor of new menu redesign using only radios */
  readonly uiPattern?: Maybe<Scalars['String']>;
}

export interface IPickerAspectFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IPickerAspectItemOptions {
  readonly __typename?: 'PickerAspectItemOptions';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IListItem>>>;
  readonly pickerAspect?: Maybe<IPickerAspect>;
}

export interface IPickerAspectValue {
  readonly __typename?: 'PickerAspectValue';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  /** If true, do not add the picker aspect name above to the item preview */
  readonly hideNameInItemPreview?: Maybe<Scalars['Boolean']>;
  /** A stable identifier used to refer to this value in the backend. */
  readonly identifier?: Maybe<Scalars['String']>;
  readonly image?: Maybe<IImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly name?: Maybe<ILocaleString>;
  /** Show aspect in static menu */
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>;
}

export interface IPickerFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly hideCalories?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hideCalories_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hideCalories_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hideNutritionLegalDisclaimer?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hideNutritionLegalDisclaimer_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hideNutritionLegalDisclaimer_not?: InputMaybe<Scalars['Boolean']>;
  readonly inStoreDefaultOption?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly isOfferBenefit?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isOfferBenefit_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isOfferBenefit_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly isRealMeal?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isRealMeal_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isRealMeal_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly isWings?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isWings_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isWings_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly showInStaticMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly showInStaticMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly showInStaticMenu_not?: InputMaybe<Scalars['Boolean']>;
  readonly simpleMenuAttachedCombo?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly simplyMenuBadge?: InputMaybe<Scalars['String']>;
  readonly simplyMenuBadge_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly simplyMenuBadge_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly simplyMenuBadge_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly simplyMenuBadge_not?: InputMaybe<Scalars['String']>;
  readonly simplyMenuBadge_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IPickerItemMapping {
  readonly __typename?: 'PickerItemMapping';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly pickerAspect?: Maybe<IPickerAspect>;
  readonly pickerAspectValueIdentifier?: Maybe<Scalars['String']>;
}

export interface IPickerOption {
  readonly __typename?: 'PickerOption';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly default?: Maybe<Scalars['Boolean']>;
  readonly option?: Maybe<IComboOrItem>;
  readonly pickerItemMappings?: Maybe<ReadonlyArray<Maybe<IPickerItemMapping>>>;
}

export type IPickerOrSection = IPicker | ISection;

export interface IPlaceholderField extends IDocument {
  readonly __typename?: 'PlaceholderField';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Defines whether the field should check its availability */
  readonly alwaysAvailable?: Maybe<Scalars['Boolean']>;
  readonly applicableTo?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** The placeholder id to identify the replacement */
  readonly fieldId?: Maybe<Scalars['String']>;
  /** The formatter to use for rendering this field */
  readonly formatter?: Maybe<Scalars['String']>;
  readonly path?: Maybe<Scalars['String']>;
  /** The required field for this field to be available if alwaysAvailable is false */
  readonly requiredField?: Maybe<Scalars['String']>;
}

export interface IPlaceholderFieldFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly alwaysAvailable?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly alwaysAvailable_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly alwaysAvailable_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly fieldId?: InputMaybe<Scalars['String']>;
  readonly fieldId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fieldId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fieldId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fieldId_not?: InputMaybe<Scalars['String']>;
  readonly fieldId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly formatter?: InputMaybe<Scalars['String']>;
  readonly formatter_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly formatter_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly formatter_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly formatter_not?: InputMaybe<Scalars['String']>;
  readonly formatter_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly path?: InputMaybe<Scalars['String']>;
  readonly path_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly path_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly path_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly path_not?: InputMaybe<Scalars['String']>;
  readonly path_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly requiredField?: InputMaybe<Scalars['String']>;
  readonly requiredField_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly requiredField_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly requiredField_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly requiredField_not?: InputMaybe<Scalars['String']>;
  readonly requiredField_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IPlu {
  readonly __typename?: 'Plu';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<Scalars['String']>;
  /** This field is only used in Tim Horton's because their PLUs need to have two separate values. */
  readonly qualifier?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Float']>;
}

export interface IPluData {
  readonly __typename?: 'PluData';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly available?: Maybe<Scalars['Boolean']>;
  readonly pluNumber?: Maybe<Scalars['Float']>;
  readonly price?: Maybe<Scalars['Float']>;
}

export interface IPos {
  readonly __typename?: 'Pos';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly vendor?: Maybe<Scalars['String']>;
  readonly version?: Maybe<Scalars['String']>;
}

export interface IPosConfiguration extends IDocument {
  readonly __typename?: 'PosConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** This is a field relevant for NZ and will be used to enable offers discount injection */
  readonly offerDiscountReferencePlu?: Maybe<Scalars['String']>;
  readonly posVendors?: Maybe<ReadonlyArray<Maybe<IPosVendorConfigOption>>>;
}

export interface IPosConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly offerDiscountReferencePlu?: InputMaybe<Scalars['String']>;
  readonly offerDiscountReferencePlu_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly offerDiscountReferencePlu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly offerDiscountReferencePlu_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly offerDiscountReferencePlu_not?: InputMaybe<Scalars['String']>;
  readonly offerDiscountReferencePlu_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IPosValidationThreshold {
  readonly __typename?: 'PosValidationThreshold';
  readonly BRINK_DELIVERY?: Maybe<Scalars['Float']>;
  readonly BRINK_PICKUP?: Maybe<Scalars['Float']>;
  readonly CARROLS_DELIVERY?: Maybe<Scalars['Float']>;
  readonly CARROLS_PICKUP?: Maybe<Scalars['Float']>;
  readonly HDX_PICKUP?: Maybe<Scalars['Float']>;
  readonly NCR_DELIVERY?: Maybe<Scalars['Float']>;
  readonly NCR_PICKUP?: Maybe<Scalars['Float']>;
  readonly OHEICS_DELIVERY?: Maybe<Scalars['Float']>;
  readonly OHEICS_PICKUP?: Maybe<Scalars['Float']>;
  readonly PARTNER_DELIVERY?: Maybe<Scalars['Float']>;
  readonly PARTNER_PICKUP?: Maybe<Scalars['Float']>;
  readonly PRODUCTNUMBER_DELIVERY?: Maybe<Scalars['Float']>;
  readonly PRODUCTNUMBER_PICKUP?: Maybe<Scalars['Float']>;
  readonly QDI_DELIVERY?: Maybe<Scalars['Float']>;
  readonly QDI_PICKUP?: Maybe<Scalars['Float']>;
  readonly QST_DELIVERY?: Maybe<Scalars['Float']>;
  readonly QST_PICKUP?: Maybe<Scalars['Float']>;
  readonly RPOS_DELIVERY?: Maybe<Scalars['Float']>;
  readonly RPOS_PICKUP?: Maybe<Scalars['Float']>;
  readonly SICOM_DELIVERY?: Maybe<Scalars['Float']>;
  readonly SICOM_PICKUP?: Maybe<Scalars['Float']>;
  readonly SIMPLYDELIVERY_DELIVERY?: Maybe<Scalars['Float']>;
  readonly SIMPLYDELIVERY_PICKUP?: Maybe<Scalars['Float']>;
  readonly TABLET_DELIVERY?: Maybe<Scalars['Float']>;
  readonly TABLET_PICKUP?: Maybe<Scalars['Float']>;
  readonly TOAST_DELIVERY?: Maybe<Scalars['Float']>;
  readonly TOAST_PICKUP?: Maybe<Scalars['Float']>;
  readonly XENIAL_DELIVERY?: Maybe<Scalars['Float']>;
  readonly XENIAL_PICKUP?: Maybe<Scalars['Float']>;
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
}

export interface IPosVendorConfigOption {
  readonly __typename?: 'PosVendorConfigOption';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly posVendor?: Maybe<Scalars['String']>;
}

export interface IPrepaidPaymentsGatewayMerchantIdConfig {
  readonly __typename?: 'PrepaidPaymentsGatewayMerchantIdConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly ca?: Maybe<Scalars['String']>;
  readonly us?: Maybe<Scalars['String']>;
}

export interface IPreviewEntry {
  readonly __typename?: 'PreviewEntry';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly bodyText?: Maybe<ILocaleString>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly linkText?: Maybe<ILocaleString>;
  readonly linkURL?: Maybe<Scalars['String']>;
  readonly localizedLinkURL?: Maybe<ILocaleString>;
  readonly previewImage?: Maybe<ILocaleImage>;
  readonly titleText?: Maybe<ILocaleString>;
}

export interface IPreviewWidget {
  readonly __typename?: 'PreviewWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly previewContent?: Maybe<ReadonlyArray<Maybe<IPreviewEntry>>>;
}

export interface IPriceGroup {
  readonly __typename?: 'PriceGroup';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** That’s the fallback price that will be used if the selected restaurant does not belong to any of the price group */
  readonly defaultPrice?: Maybe<Scalars['Float']>;
  readonly priceGroups?: Maybe<ReadonlyArray<Maybe<IPriceRestaurantGroupItem>>>;
}

export interface IPricePointDiscount {
  readonly __typename?: 'PricePointDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly price?: Maybe<IPriceGroup>;
  readonly products?: Maybe<ReadonlyArray<Maybe<IProduct>>>;
}

export interface IPriceRestaurantGroupItem {
  readonly __typename?: 'PriceRestaurantGroupItem';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The price for this group */
  readonly price?: Maybe<Scalars['Float']>;
  readonly restaurantGroup?: Maybe<IRestaurantGroup>;
}

export interface IPricingRegionPrice {
  readonly __typename?: 'PricingRegionPrice';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly opPricingRegion?: Maybe<IOpPricingRegion>;
  readonly price?: Maybe<Scalars['Float']>;
}

export interface IPrivacyPolicyDisclaimers {
  readonly __typename?: 'PrivacyPolicyDisclaimers';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly privacyPolicyDisclaimersCells?: Maybe<ReadonlyArray<Maybe<IPrivacyPolicyDisclaimersCell>>>;
}

export interface IPrivacyPolicyDisclaimersCell {
  readonly __typename?: 'PrivacyPolicyDisclaimersCell';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly border?: Maybe<Scalars['Boolean']>;
  readonly disclaimerContent?: Maybe<ILocaleBlockContent>;
  readonly disclaimerDescription?: Maybe<Scalars['String']>;
  readonly disclaimerTitle?: Maybe<Scalars['String']>;
  readonly fontSize?: Maybe<Scalars['Float']>;
  readonly paddingBottom?: Maybe<Scalars['Float']>;
  readonly paddingLeft?: Maybe<Scalars['Float']>;
  readonly paddingRight?: Maybe<Scalars['Float']>;
  readonly paddingTop?: Maybe<Scalars['Float']>;
  readonly radius?: Maybe<Scalars['Float']>;
}

export interface IPrizes {
  readonly __typename?: 'Prizes';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttonText?: Maybe<ILocaleBlockContent>;
  readonly excludeInAlberta?: Maybe<Scalars['Boolean']>;
  readonly header?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<ILocaleImages>;
  readonly numberAwarded?: Maybe<ILocaleBlockContent>;
  readonly text?: Maybe<ILocaleBlockContent>;
}

export interface IProduct {
  readonly __typename?: 'Product';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly productItem?: Maybe<IComboOrItemOrItemGroup>;
  readonly quantity?: Maybe<Scalars['Float']>;
}

export interface IProductCategory extends IDocument {
  readonly __typename?: 'ProductCategory';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly hierarchyLevel?: Maybe<Scalars['String']>;
  readonly image?: Maybe<IImage>;
  readonly name?: Maybe<ILocaleString>;
}

export interface IProductCategoryFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly hierarchyLevel?: InputMaybe<Scalars['String']>;
  readonly hierarchyLevel_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly hierarchyLevel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly hierarchyLevel_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly hierarchyLevel_not?: InputMaybe<Scalars['String']>;
  readonly hierarchyLevel_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IProductHierarchy {
  readonly __typename?: 'ProductHierarchy';
  readonly L1?: Maybe<Scalars['String']>;
  readonly L2?: Maybe<Scalars['String']>;
  readonly L3?: Maybe<Scalars['String']>;
  readonly L4?: Maybe<Scalars['String']>;
  readonly L5?: Maybe<Scalars['String']>;
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
}

export interface IPromoCodePanel {
  readonly __typename?: 'PromoCodePanel';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly promoCodeDescription?: Maybe<ILocaleBlockContent>;
  readonly promoCodeLabel?: Maybe<ILocaleBlockContent>;
  /** Promo code external link  */
  readonly promoCodeLink?: Maybe<Scalars['String']>;
}

export interface IPurchase {
  readonly __typename?: 'Purchase';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly isPicker?: Maybe<Scalars['Boolean']>;
  readonly option?: Maybe<IComboOrItemOrPickerOrProductCategory>;
  /** Quantity that must be in the cart */
  readonly quantity?: Maybe<Scalars['Float']>;
  readonly sanityId?: Maybe<Scalars['String']>;
}

export interface IPypestreamConfig {
  readonly __typename?: 'PypestreamConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly appId?: Maybe<Scalars['String']>;
  readonly scriptUrl?: Maybe<Scalars['String']>;
}

export interface IQuestIncentive {
  readonly __typename?: 'QuestIncentive';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly bonusPoints?: Maybe<Scalars['Float']>;
  readonly offer?: Maybe<IConfigOffer>;
  readonly reward?: Maybe<IConfigReward>;
  readonly type?: Maybe<Scalars['String']>;
}

export interface IQuestRules {
  readonly __typename?: 'QuestRules';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Steps should be completed in sequential order */
  readonly isSequential?: Maybe<Scalars['Boolean']>;
  /** Steps have to be completed in different purchases */
  readonly onDistinctPurchases?: Maybe<Scalars['Boolean']>;
  readonly steps?: Maybe<ReadonlyArray<Maybe<IQuestStep>>>;
}

export interface IQuestStep {
  readonly __typename?: 'QuestStep';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly rules?: Maybe<ReadonlyArray<Maybe<ICartRequirementOrCartRequirementExclusionOrDayOfWeekBandOrEmailVerifiedRequiredOrExpireAfterOrIncentiveRequirementOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrRequiresAuthenticationOrServiceModeRestrictionsOrSubtotalSpend>>>;
}

export interface IQuestTemplate extends IDocument {
  readonly __typename?: 'QuestTemplate';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<IImage>;
  /** Specify the Config Challenge to use with this template */
  readonly configIncentive?: Maybe<IConfigQuest>;
  readonly description?: Maybe<ILocaleSmartBlockContent>;
  readonly localizedImage?: Maybe<ILocaleImages>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleSmartBlockContent>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
}

export interface IQuestTemplateFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly configIncentive?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IQuestionDetails extends IDocument {
  readonly __typename?: 'QuestionDetails';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly countdownTimer?: Maybe<Scalars['Float']>;
  readonly responses?: Maybe<ReadonlyArray<Maybe<IResponseDetails>>>;
  readonly text?: Maybe<ILocaleString>;
}

export interface IQuestionDetailsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly countdownTimer?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly countdownTimer_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly countdownTimer_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly countdownTimer_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly countdownTimer_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly countdownTimer_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly countdownTimer_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IQuestsSection extends IDocument {
  readonly __typename?: 'QuestsSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IQuestsSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IQuickConfig {
  readonly __typename?: 'QuickConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  readonly rules?: Maybe<ReadonlyArray<Maybe<IQuickConfigRule>>>;
}

export interface IQuickConfigRule {
  readonly __typename?: 'QuickConfigRule';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly itemOptions?: Maybe<ReadonlyArray<Maybe<IListItem>>>;
  readonly modifier?: Maybe<IListItem>;
}

export interface IQuoteWidget {
  readonly __typename?: 'QuoteWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly attributionImage?: Maybe<IImage>;
  readonly attributionName?: Maybe<Scalars['String']>;
  readonly attributionTitle?: Maybe<ILocaleString>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly quoteText?: Maybe<ILocaleString>;
}

export interface IRecentItems extends IDocument {
  readonly __typename?: 'RecentItems';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IRecentItemsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IRemediationReason {
  readonly __typename?: 'RemediationReason';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The text that will be displayed */
  readonly reasonLabel?: Maybe<Scalars['String']>;
  readonly reasonSlug?: Maybe<ISlug>;
  readonly reasonValue?: Maybe<Scalars['String']>;
}

export interface IRemediationReasons extends IDocument {
  readonly __typename?: 'RemediationReasons';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly reasons?: Maybe<ReadonlyArray<Maybe<IRemediationReason>>>;
}

export interface IRemediationReasonsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IRequiredRules {
  readonly __typename?: 'RequiredRules';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly authenticationRequired?: Maybe<Scalars['Boolean']>;
  readonly cartLimit?: Maybe<Scalars['Boolean']>;
  readonly cartRequirement?: Maybe<Scalars['Boolean']>;
  readonly cartRequirementExclusion?: Maybe<Scalars['Boolean']>;
  readonly cooldown?: Maybe<Scalars['Boolean']>;
  readonly dateBand?: Maybe<Scalars['Boolean']>;
  readonly dayOfTheWeek?: Maybe<Scalars['Boolean']>;
  readonly emailVerificationRequired?: Maybe<Scalars['Boolean']>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly maxRedemption?: Maybe<Scalars['Boolean']>;
  readonly minimumSpend?: Maybe<Scalars['Boolean']>;
  readonly paymentMethod?: Maybe<Scalars['Boolean']>;
  readonly restaurantGroups?: Maybe<Scalars['Boolean']>;
  readonly restaurantRestrictions?: Maybe<Scalars['Boolean']>;
  readonly serviceModes?: Maybe<Scalars['Boolean']>;
  readonly stackable?: Maybe<Scalars['Boolean']>;
  readonly timeBand?: Maybe<Scalars['Boolean']>;
  readonly transactionCount?: Maybe<Scalars['Boolean']>;
  readonly userAttributes?: Maybe<Scalars['Boolean']>;
  readonly userBirthday?: Maybe<Scalars['Boolean']>;
  readonly userEnrollment?: Maybe<Scalars['Boolean']>;
}

export interface IRequirements {
  readonly __typename?: 'Requirements';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly platform?: Maybe<Scalars['String']>;
  readonly purchase?: Maybe<IComboOrItemOrPickerOrSection>;
  readonly shortCode?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
}

export interface IRequiresAssignment {
  readonly __typename?: 'RequiresAssignment';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly requiresAssignment?: Maybe<Scalars['String']>;
}

export interface IRequiresAuthentication {
  readonly __typename?: 'RequiresAuthentication';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Toggles the rule that is only valid if the user is authenticated. If set to true, the user needs to be authenticated to qualify for the incentive. If set to false, then the user does not need to be authenticated to qualify for the incentive */
  readonly requiresAuthentication?: Maybe<Scalars['Boolean']>;
}

export interface IResponseDetails extends IDocument {
  readonly __typename?: 'ResponseDetails';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly content?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly resultsValuesDetails?: Maybe<ReadonlyArray<Maybe<IResultValueDetails>>>;
  readonly text?: Maybe<ILocaleString>;
}

export interface IResponseDetailsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IRestaurant extends IDocument {
  readonly __typename?: 'Restaurant';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly adi?: Maybe<Scalars['String']>;
  readonly amenities?: Maybe<ReadonlyArray<Maybe<IRestaurantAmenity>>>;
  readonly cateringHolidayHours?: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>;
  readonly cateringHours?: Maybe<IHoursOfOperation>;
  /** Tim Hortons, BK CA and PLK CA only */
  readonly chaseMerchantId?: Maybe<Scalars['String']>;
  readonly curbsideHolidayHours?: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>;
  readonly curbsideHours?: Maybe<IHoursOfOperation>;
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<IDayParts>>>;
  readonly deliveryConfiguration?: Maybe<ReadonlyArray<Maybe<IDeliveryVendor>>>;
  readonly deliveryHolidayHours?: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>;
  readonly deliveryHours?: Maybe<IHoursOfOperation>;
  readonly deliveryProviders?: Maybe<ReadonlyArray<Maybe<IRestaurantDeliveryProvider>>>;
  readonly diningRoomHolidayHours?: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>;
  readonly diningRoomHours?: Maybe<IHoursOfOperation>;
  /** Restaurant level configuration. Determines restaurant details like amenities and in app functionality like restaurant availability. */
  readonly documentDescription?: Maybe<Scalars['String']>;
  /** MDM Sync */
  readonly drinkStationType?: Maybe<Scalars['String']>;
  readonly driveThruHolidayHours?: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>;
  readonly driveThruHours?: Maybe<IHoursOfOperation>;
  /** MDM Sync */
  readonly driveThruLaneType?: Maybe<Scalars['String']>;
  readonly email?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** Determines whether a store will appear in the selected environment. Note that "dev" refers to all testing environments (dev, staging) and prop refers to all upper environments (qa, prod). So a restaurant marked as "dev" will not appear in our QA environment. */
  readonly environment?: Maybe<Scalars['String']>;
  /** PLK KR only */
  readonly firstpayMerchantId?: Maybe<Scalars['String']>;
  /** MDM Sync. In Adyen, this is used to help construct the merchant account ID */
  readonly franchiseGroupId?: Maybe<Scalars['Float']>;
  /** MDM Sync. */
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  /** MDM Sync */
  readonly frontCounterClosed?: Maybe<Scalars['Boolean']>;
  readonly fzAddress?: Maybe<Scalars['String']>;
  readonly fzAuthorizedRepresentative?: Maybe<Scalars['String']>;
  readonly fzCity?: Maybe<Scalars['String']>;
  readonly fzEmail?: Maybe<Scalars['String']>;
  readonly fzHrb?: Maybe<Scalars['String']>;
  readonly fzRegistryCourt?: Maybe<Scalars['String']>;
  readonly fzTelephone?: Maybe<Scalars['String']>;
  readonly fzUstNr?: Maybe<Scalars['String']>;
  readonly fzZipCode?: Maybe<Scalars['String']>;
  readonly fzeeGroup?: Maybe<Scalars['String']>;
  readonly glovoChannel?: Maybe<Scalars['Boolean']>;
  /** Determines whether a store is available in Google Food Ordering */
  readonly googleOrderingStatus?: Maybe<Scalars['String']>;
  /** MDM Sync */
  readonly hasBreakfast?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly hasBurgersForBreakfast?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines where "catering" service mode is available. */
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines where "curbside" service mode is availabile. */
  readonly hasCurbside?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly hasDMBSuggestiveSelling?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines where "delivery" service mode is availabile. */
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines where "dine in" service mode is availabile. */
  readonly hasDineIn?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines where "drive thru" service mode is availabile. */
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Used by restaurants with their own delivery drivers. Our Bringg delivery integration can be configured on a per store basis to required this field to be true */
  readonly hasInternalDeliveryFleet?: Maybe<Scalars['Boolean']>;
  /** Determines if restaurant has opted in to display a late night menu */
  readonly hasLateNightMenu?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines whether loyalty is available */
  readonly hasLoyalty?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. One of the fields required to be "true" for the ordering button to be enabled on the restaurant in the store locator. LaunchDarkly flag "enableOrdering" must also be on for ordering button to be enabled. */
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly hasModifiedTakeout?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly hasParking?: Maybe<Scalars['Boolean']>;
  /** Determines if restaurant has opted in to have tips for Pick Up orders. */
  readonly hasPickUpTips?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines whether "Pickup Window" service mode is available */
  readonly hasPickupWindow?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly hasPlayground?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines whether "table" service mode is available */
  readonly hasTableService?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. Determines where "takeout" service mode is availabile. */
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly hasWifi?: Maybe<Scalars['Boolean']>;
  readonly hideInEnvironments?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly inStorePosChannel?: Maybe<Scalars['Boolean']>;
  /** Dark Kitchen restaurants can ONLY be ordered from for delivery and are hidden from the store selector. */
  readonly isDarkKitchen?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly isHalal?: Maybe<Scalars['Boolean']>;
  readonly justEatChannel?: Maybe<Scalars['Boolean']>;
  readonly kioskChannel?: Maybe<Scalars['Boolean']>;
  readonly landmark?: Maybe<ILocaleString>;
  readonly lastModifiedTime?: Maybe<Scalars['DateTime']>;
  /** MDM Sync */
  readonly latitude?: Maybe<Scalars['Float']>;
  /** MDM Sync */
  readonly longitude?: Maybe<Scalars['Float']>;
  /** Determines whether ordering is available in the selected environment. "dev" is only available in lower environments (dev & staging). "live" will only appear in upper environments (qa & prod). Alpha and beta are no longer used, as we now use LaunchDarkly. */
  readonly mobileOrderingStatus?: Maybe<Scalars['String']>;
  /** MDM Sync: Populated by restaurant field "address1" */
  readonly name?: Maybe<Scalars['String']>;
  /** MDM Sync */
  readonly nbrDriveThruWindows?: Maybe<Scalars['Float']>;
  /** MDM Sync: Populated by restaurant field "number" */
  readonly number?: Maybe<Scalars['String']>;
  /** MDM Sync. */
  readonly ownership?: Maybe<Scalars['String']>;
  readonly parkingType?: Maybe<Scalars['String']>;
  /** BK/PLK ES and BK PT */
  readonly paycometMerchantId?: Maybe<Scalars['String']>;
  /** BK/PLK ES and BK PT */
  readonly paycometTerminal?: Maybe<Scalars['String']>;
  /** BK NZ only */
  readonly paymarkMerchantId?: Maybe<Scalars['Float']>;
  /** MDM Sync */
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly physicalAddress?: Maybe<IAddress>;
  readonly pickupWindowHolidayHours?: Maybe<ReadonlyArray<Maybe<IHolidayHours>>>;
  readonly pickupWindowHours?: Maybe<IHoursOfOperation>;
  /** MDM Sync */
  readonly playgroundType?: Maybe<Scalars['String']>;
  readonly pos?: Maybe<IPos>;
  readonly posRestaurantId?: Maybe<Scalars['String']>;
  readonly restaurantImage?: Maybe<IImage>;
  readonly restaurantKioskData?: Maybe<IRestaurantKioskData>;
  readonly restaurantPosData?: Maybe<IRestaurantPosData>;
  readonly servicesHasDriveThru?: Maybe<Scalars['Boolean']>;
  /** MDM Sync. **Restaurant Availability**: Restaurants will only appear in the store locator if the status is "open" */
  readonly status?: Maybe<Scalars['String']>;
  /** MDM Sync. Restaurant timezone. */
  readonly timezone?: Maybe<Scalars['String']>;
  readonly uberEatsChannel?: Maybe<Scalars['Boolean']>;
  /** MDM Sync */
  readonly vatNumber?: Maybe<Scalars['String']>;
  /** MDM Sync. BK DE only */
  readonly vrPaymentMerchantId?: Maybe<Scalars['String']>;
  readonly whitelabelAppChannel?: Maybe<Scalars['Boolean']>;
  /** FHS US only */
  readonly worldpayMerchantId?: Maybe<Scalars['String']>;
}

export interface IRestaurantAmenity extends IDocument {
  readonly __typename?: 'RestaurantAmenity';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly icon?: Maybe<IImage>;
  readonly name?: Maybe<ILocaleString>;
}

export interface IRestaurantAmenityFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IRestaurantConfig {
  readonly __typename?: 'RestaurantConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly displayEnv?: Maybe<Scalars['String']>;
  readonly validMobileOrderingEnvs?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
}

export interface IRestaurantDeliveryProvider extends IDocument {
  readonly __typename?: 'RestaurantDeliveryProvider';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly icon?: Maybe<IImage>;
  readonly name?: Maybe<ILocaleString>;
  /** The MDM defined ID (this is pulled directly from MDM and should not be changed manually). */
  readonly providerId?: Maybe<Scalars['String']>;
}

export interface IRestaurantDeliveryProviderFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly providerId?: InputMaybe<Scalars['String']>;
  readonly providerId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly providerId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly providerId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly providerId_not?: InputMaybe<Scalars['String']>;
  readonly providerId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IRestaurantFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly adi?: InputMaybe<Scalars['String']>;
  readonly adi_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly adi_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly adi_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly adi_not?: InputMaybe<Scalars['String']>;
  readonly adi_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly chaseMerchantId?: InputMaybe<Scalars['String']>;
  readonly chaseMerchantId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly chaseMerchantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly chaseMerchantId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly chaseMerchantId_not?: InputMaybe<Scalars['String']>;
  readonly chaseMerchantId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly documentDescription?: InputMaybe<Scalars['String']>;
  readonly documentDescription_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly documentDescription_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly documentDescription_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly documentDescription_not?: InputMaybe<Scalars['String']>;
  readonly documentDescription_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly drinkStationType?: InputMaybe<Scalars['String']>;
  readonly drinkStationType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly drinkStationType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly drinkStationType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly drinkStationType_not?: InputMaybe<Scalars['String']>;
  readonly drinkStationType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly driveThruLaneType?: InputMaybe<Scalars['String']>;
  readonly driveThruLaneType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly driveThruLaneType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly driveThruLaneType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly driveThruLaneType_not?: InputMaybe<Scalars['String']>;
  readonly driveThruLaneType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly environment?: InputMaybe<Scalars['String']>;
  readonly environment_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly environment_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly environment_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly environment_not?: InputMaybe<Scalars['String']>;
  readonly environment_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly firstpayMerchantId?: InputMaybe<Scalars['String']>;
  readonly firstpayMerchantId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly firstpayMerchantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly firstpayMerchantId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly firstpayMerchantId_not?: InputMaybe<Scalars['String']>;
  readonly firstpayMerchantId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly franchiseGroupId?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly franchiseGroupId_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly franchiseGroupId_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly franchiseGroupId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly franchiseGroupId_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly franchiseGroupId_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly franchiseGroupId_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly franchiseGroupName?: InputMaybe<Scalars['String']>;
  readonly franchiseGroupName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly franchiseGroupName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly franchiseGroupName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly franchiseGroupName_not?: InputMaybe<Scalars['String']>;
  readonly franchiseGroupName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly frontCounterClosed?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly frontCounterClosed_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly frontCounterClosed_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly fzAddress?: InputMaybe<Scalars['String']>;
  readonly fzAddress_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzAddress_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzAddress_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzAddress_not?: InputMaybe<Scalars['String']>;
  readonly fzAddress_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzAuthorizedRepresentative?: InputMaybe<Scalars['String']>;
  readonly fzAuthorizedRepresentative_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzAuthorizedRepresentative_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzAuthorizedRepresentative_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzAuthorizedRepresentative_not?: InputMaybe<Scalars['String']>;
  readonly fzAuthorizedRepresentative_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzCity?: InputMaybe<Scalars['String']>;
  readonly fzCity_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzCity_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzCity_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzCity_not?: InputMaybe<Scalars['String']>;
  readonly fzCity_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzEmail?: InputMaybe<Scalars['String']>;
  readonly fzEmail_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzEmail_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzEmail_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzEmail_not?: InputMaybe<Scalars['String']>;
  readonly fzEmail_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzHrb?: InputMaybe<Scalars['String']>;
  readonly fzHrb_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzHrb_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzHrb_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzHrb_not?: InputMaybe<Scalars['String']>;
  readonly fzHrb_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzRegistryCourt?: InputMaybe<Scalars['String']>;
  readonly fzRegistryCourt_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzRegistryCourt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzRegistryCourt_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzRegistryCourt_not?: InputMaybe<Scalars['String']>;
  readonly fzRegistryCourt_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzTelephone?: InputMaybe<Scalars['String']>;
  readonly fzTelephone_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzTelephone_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzTelephone_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzTelephone_not?: InputMaybe<Scalars['String']>;
  readonly fzTelephone_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzUstNr?: InputMaybe<Scalars['String']>;
  readonly fzUstNr_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzUstNr_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzUstNr_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzUstNr_not?: InputMaybe<Scalars['String']>;
  readonly fzUstNr_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzZipCode?: InputMaybe<Scalars['String']>;
  readonly fzZipCode_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzZipCode_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzZipCode_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzZipCode_not?: InputMaybe<Scalars['String']>;
  readonly fzZipCode_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly fzeeGroup?: InputMaybe<Scalars['String']>;
  readonly fzeeGroup_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly fzeeGroup_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly fzeeGroup_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly fzeeGroup_not?: InputMaybe<Scalars['String']>;
  readonly fzeeGroup_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly glovoChannel?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly glovoChannel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly glovoChannel_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly googleOrderingStatus?: InputMaybe<Scalars['String']>;
  readonly googleOrderingStatus_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly googleOrderingStatus_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly googleOrderingStatus_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly googleOrderingStatus_not?: InputMaybe<Scalars['String']>;
  readonly googleOrderingStatus_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly hasBreakfast?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasBreakfast_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasBreakfast_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasBurgersForBreakfast?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasBurgersForBreakfast_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasBurgersForBreakfast_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasCatering?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasCatering_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasCatering_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasCurbside?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasCurbside_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasCurbside_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasDMBSuggestiveSelling?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasDMBSuggestiveSelling_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasDMBSuggestiveSelling_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasDelivery?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasDelivery_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasDelivery_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasDineIn?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasDineIn_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasDineIn_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasDriveThru?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasDriveThru_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasDriveThru_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasInternalDeliveryFleet?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasInternalDeliveryFleet_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasInternalDeliveryFleet_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasLateNightMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasLateNightMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasLateNightMenu_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasLoyalty?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasLoyalty_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasLoyalty_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasMobileOrdering?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasMobileOrdering_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasMobileOrdering_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasModifiedTakeout?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasModifiedTakeout_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasModifiedTakeout_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasParking?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasParking_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasParking_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasPickUpTips?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasPickUpTips_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasPickUpTips_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasPickupWindow?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasPickupWindow_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasPickupWindow_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasPlayground?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasPlayground_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasPlayground_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasTableService?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasTableService_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasTableService_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasTakeOut?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasTakeOut_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasTakeOut_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly hasWifi?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hasWifi_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hasWifi_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly inStorePosChannel?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly inStorePosChannel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly inStorePosChannel_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly isDarkKitchen?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isDarkKitchen_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isDarkKitchen_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly isHalal?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isHalal_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isHalal_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly justEatChannel?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly justEatChannel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly justEatChannel_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly kioskChannel?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly kioskChannel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly kioskChannel_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly lastModifiedTime?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly lastModifiedTime_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly lastModifiedTime_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly lastModifiedTime_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly lastModifiedTime_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly lastModifiedTime_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly lastModifiedTime_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly latitude?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly latitude_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly latitude_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly latitude_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly latitude_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly latitude_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly latitude_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly longitude?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly longitude_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly longitude_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly longitude_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly longitude_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly longitude_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly longitude_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly mobileOrderingStatus?: InputMaybe<Scalars['String']>;
  readonly mobileOrderingStatus_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly mobileOrderingStatus_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly mobileOrderingStatus_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly mobileOrderingStatus_not?: InputMaybe<Scalars['String']>;
  readonly mobileOrderingStatus_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly nbrDriveThruWindows?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly nbrDriveThruWindows_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly nbrDriveThruWindows_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly nbrDriveThruWindows_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly nbrDriveThruWindows_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly nbrDriveThruWindows_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly nbrDriveThruWindows_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly number?: InputMaybe<Scalars['String']>;
  readonly number_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly number_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly number_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly number_not?: InputMaybe<Scalars['String']>;
  readonly number_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly ownership?: InputMaybe<Scalars['String']>;
  readonly ownership_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly ownership_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly ownership_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly ownership_not?: InputMaybe<Scalars['String']>;
  readonly ownership_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly parkingType?: InputMaybe<Scalars['String']>;
  readonly parkingType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly parkingType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly parkingType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly parkingType_not?: InputMaybe<Scalars['String']>;
  readonly parkingType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paycometMerchantId?: InputMaybe<Scalars['String']>;
  readonly paycometMerchantId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paycometMerchantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paycometMerchantId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paycometMerchantId_not?: InputMaybe<Scalars['String']>;
  readonly paycometMerchantId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paycometTerminal?: InputMaybe<Scalars['String']>;
  readonly paycometTerminal_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly paycometTerminal_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly paycometTerminal_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly paycometTerminal_not?: InputMaybe<Scalars['String']>;
  readonly paycometTerminal_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly paymarkMerchantId?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly paymarkMerchantId_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly paymarkMerchantId_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly paymarkMerchantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly paymarkMerchantId_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly paymarkMerchantId_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly paymarkMerchantId_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly phoneNumber_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly phoneNumber_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly phoneNumber_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly phoneNumber_not?: InputMaybe<Scalars['String']>;
  readonly phoneNumber_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly playgroundType?: InputMaybe<Scalars['String']>;
  readonly playgroundType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly playgroundType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly playgroundType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly playgroundType_not?: InputMaybe<Scalars['String']>;
  readonly playgroundType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly posRestaurantId?: InputMaybe<Scalars['String']>;
  readonly posRestaurantId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly posRestaurantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly posRestaurantId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly posRestaurantId_not?: InputMaybe<Scalars['String']>;
  readonly posRestaurantId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  readonly restaurantKioskData?: InputMaybe<Scalars['ID']>;
  readonly restaurantPosData?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly servicesHasDriveThru?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly servicesHasDriveThru_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly servicesHasDriveThru_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly status?: InputMaybe<Scalars['String']>;
  readonly status_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly status_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly status_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly status_not?: InputMaybe<Scalars['String']>;
  readonly status_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly timezone?: InputMaybe<Scalars['String']>;
  readonly timezone_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly timezone_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly timezone_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly timezone_not?: InputMaybe<Scalars['String']>;
  readonly timezone_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly uberEatsChannel?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly uberEatsChannel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly uberEatsChannel_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly vatNumber?: InputMaybe<Scalars['String']>;
  readonly vatNumber_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly vatNumber_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly vatNumber_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly vatNumber_not?: InputMaybe<Scalars['String']>;
  readonly vatNumber_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly vrPaymentMerchantId?: InputMaybe<Scalars['String']>;
  readonly vrPaymentMerchantId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly vrPaymentMerchantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly vrPaymentMerchantId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly vrPaymentMerchantId_not?: InputMaybe<Scalars['String']>;
  readonly vrPaymentMerchantId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly whitelabelAppChannel?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly whitelabelAppChannel_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly whitelabelAppChannel_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly worldpayMerchantId?: InputMaybe<Scalars['String']>;
  readonly worldpayMerchantId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly worldpayMerchantId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly worldpayMerchantId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly worldpayMerchantId_not?: InputMaybe<Scalars['String']>;
  readonly worldpayMerchantId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IRestaurantGroup extends IDocument {
  readonly __typename?: 'RestaurantGroup';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Show offers based on geolocation */
  readonly geolocation?: Maybe<Scalars['Boolean']>;
  /** This is used by the frontend team to query for a specific Restaurant Group.         This needs to be unique and constant. */
  readonly groupId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly restaurants?: Maybe<ReadonlyArray<Maybe<IRestaurant>>>;
}

export interface IRestaurantGroupFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly geolocation?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly geolocation_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly geolocation_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly groupId?: InputMaybe<Scalars['String']>;
  readonly groupId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly groupId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly groupId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly groupId_not?: InputMaybe<Scalars['String']>;
  readonly groupId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IRestaurantGroupRestrictions {
  readonly __typename?: 'RestaurantGroupRestrictions';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Defines if the offer should be included or excluded from the restaurants in the Restaurant Group Restriction List */
  readonly inclusive?: Maybe<Scalars['Boolean']>;
  readonly restaurantGroupRestrictionList?: Maybe<ReadonlyArray<Maybe<IRestaurantGroup>>>;
}

export interface IRestaurantKioskData extends IDocument {
  readonly __typename?: 'RestaurantKioskData';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly kiosks?: Maybe<ReadonlyArray<Maybe<IKiosk>>>;
  readonly restaurantNumber?: Maybe<Scalars['Float']>;
}

export interface IRestaurantKioskDataFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly restaurantNumber?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly restaurantNumber_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly restaurantNumber_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly restaurantNumber_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly restaurantNumber_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly restaurantNumber_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly restaurantNumber_not?: InputMaybe<Scalars['Float']>;
}

export interface IRestaurantPosData extends IDocument {
  readonly __typename?: 'RestaurantPosData';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly base64DeliveryPLUs?: Maybe<Scalars['String']>;
  readonly base64PLUs?: Maybe<Scalars['String']>;
  readonly deliveryPLUs?: Maybe<Scalars['String']>;
  /** deprecated */
  readonly disableChickenSandwich?: Maybe<Scalars['Boolean']>;
  /** deprecated */
  readonly heartbeatOverride?: Maybe<Scalars['String']>;
  /** deprecated */
  readonly heartbeatStatus?: Maybe<Scalars['Boolean']>;
  /** deprecated */
  readonly lastHeartbeatTimestamp?: Maybe<Scalars['DateTime']>;
  readonly plus?: Maybe<Scalars['String']>;
  readonly restaurant?: Maybe<IRestaurant>;
  /** Deprecated since restaurant numbers are strings. Unclear if this field was being used. */
  readonly restaurantNumber?: Maybe<Scalars['Float']>;
}

export interface IRestaurantPosDataFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly base64DeliveryPLUs?: InputMaybe<Scalars['String']>;
  readonly base64DeliveryPLUs_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly base64DeliveryPLUs_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly base64DeliveryPLUs_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly base64DeliveryPLUs_not?: InputMaybe<Scalars['String']>;
  readonly base64DeliveryPLUs_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly base64PLUs?: InputMaybe<Scalars['String']>;
  readonly base64PLUs_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly base64PLUs_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly base64PLUs_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly base64PLUs_not?: InputMaybe<Scalars['String']>;
  readonly base64PLUs_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly deliveryPLUs?: InputMaybe<Scalars['String']>;
  readonly deliveryPLUs_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly deliveryPLUs_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly deliveryPLUs_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly deliveryPLUs_not?: InputMaybe<Scalars['String']>;
  readonly deliveryPLUs_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly disableChickenSandwich?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly disableChickenSandwich_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly disableChickenSandwich_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly heartbeatOverride?: InputMaybe<Scalars['String']>;
  readonly heartbeatOverride_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly heartbeatOverride_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly heartbeatOverride_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly heartbeatOverride_not?: InputMaybe<Scalars['String']>;
  readonly heartbeatOverride_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly heartbeatStatus?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly heartbeatStatus_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly heartbeatStatus_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly lastHeartbeatTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly lastHeartbeatTimestamp_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly lastHeartbeatTimestamp_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly lastHeartbeatTimestamp_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly lastHeartbeatTimestamp_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly lastHeartbeatTimestamp_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly lastHeartbeatTimestamp_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly plus?: InputMaybe<Scalars['String']>;
  readonly plus_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly plus_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly plus_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly plus_not?: InputMaybe<Scalars['String']>;
  readonly plus_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  readonly restaurant?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly restaurantNumber?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly restaurantNumber_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly restaurantNumber_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly restaurantNumber_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly restaurantNumber_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly restaurantNumber_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly restaurantNumber_not?: InputMaybe<Scalars['Float']>;
}

export interface IRestaurantRestrictions {
  readonly __typename?: 'RestaurantRestrictions';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Defines if the offer should be included or excluded from the restaurants in the Restaurant Restriction List */
  readonly inclusive?: Maybe<Scalars['Boolean']>;
  readonly restaurantRestrictionList?: Maybe<ReadonlyArray<Maybe<IRestaurant>>>;
}

export interface IResultDetails extends IDocument {
  readonly __typename?: 'ResultDetails';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly description?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly offer?: Maybe<IOffer>;
  readonly prefix?: Maybe<ILocaleString>;
  readonly text?: Maybe<ILocaleString>;
}

export interface IResultDetailsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly offer?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IResultValueDetails {
  readonly __typename?: 'ResultValueDetails';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly result?: Maybe<IResultDetails>;
  readonly value?: Maybe<Scalars['Float']>;
}

export interface IReward extends IDocument {
  readonly __typename?: 'Reward';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<IImage>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly howToRedeem?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly incentiveNotInMenu?: Maybe<Scalars['Boolean']>;
  readonly incentivePluOverrideMapping?: Maybe<ReadonlyArray<Maybe<IIncentivePluOverride>>>;
  readonly incentives?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferDiscountOrPicker>>>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  /** When true, guest will not have option to redeem in-rest */
  readonly mobileOrderOnly?: Maybe<Scalars['Boolean']>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  readonly name?: Maybe<ILocaleString>;
  readonly notificationDetails?: Maybe<INotificationDetails>;
  /** This represents the PMIX product number */
  readonly pmixId?: Maybe<Scalars['String']>;
  /** Specify the Order redemption method. */
  readonly redemptionMethod?: Maybe<Scalars['String']>;
  readonly ruleSet?: Maybe<ReadonlyArray<Maybe<IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrFirstOrderOnlyOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated>>>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
}

export interface IRewardCategory extends IDocument {
  readonly __typename?: 'RewardCategory';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly label?: Maybe<ILocaleString>;
  readonly rewards?: Maybe<ReadonlyArray<Maybe<IReward>>>;
  readonly validations?: Maybe<ReadonlyArray<Maybe<IValidationLoyaltyPoints>>>;
}

export interface IRewardCategoryFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IRewardDiscount {
  readonly __typename?: 'RewardDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly products?: Maybe<ReadonlyArray<Maybe<IProduct>>>;
}

export interface IRewardFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly incentiveNotInMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly incentiveNotInMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly incentiveNotInMenu_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly mobileOrderOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly mobileOrderOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly mobileOrderOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly pmixId?: InputMaybe<Scalars['String']>;
  readonly pmixId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly pmixId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly pmixId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly pmixId_not?: InputMaybe<Scalars['String']>;
  readonly pmixId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly redemptionMethod?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly redemptionMethod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly redemptionMethod_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly redemptionMethod_not?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IRewardList extends IDocument {
  readonly __typename?: 'RewardList';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly rewardCategories?: Maybe<ReadonlyArray<Maybe<IRewardCategory>>>;
}

export interface IRewardListFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export type IRewardOrSystemwideOfferOrSystemwidePromotion = IReward | ISystemwideOffer | ISystemwidePromotion;

export interface IRewardV2 extends IDocument {
  readonly __typename?: 'RewardV2';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly content?: Maybe<IOffersV2Content>;
  readonly internal?: Maybe<IOffersV2Internal>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly mechanics?: Maybe<IOffersV2Mechanics>;
  /** Switch this value to show systemwide offer on the app */
  readonly systemWideActive?: Maybe<Scalars['Boolean']>;
}

export interface IRewardV2Filter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly systemWideActive?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly systemWideActive_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly systemWideActive_not?: InputMaybe<Scalars['Boolean']>;
}

export interface IRewards {
  readonly __typename?: 'Rewards';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly allSetBlurbBlock?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<ILocaleImages>;
  readonly key?: Maybe<Scalars['String']>;
  readonly requireSkillsQuestion?: Maybe<Scalars['Boolean']>;
  readonly rewardCodeDescription?: Maybe<ILocaleBlockContent>;
  readonly rewardLink?: Maybe<ILocaleString>;
  readonly rewardName?: Maybe<ILocaleString>;
  readonly rewardYouWonMessageBlock?: Maybe<ILocaleBlockContent>;
}

export interface IRewardsCarouselWidget {
  readonly __typename?: 'RewardsCarouselWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly rewardCarouselCategories?: Maybe<ReadonlyArray<Maybe<IRewardCategory>>>;
  readonly rewardsCarouselDescription?: Maybe<ILocaleString>;
  readonly rewardsCarouselTitle?: Maybe<ILocaleString>;
}

export interface IRewardsListWidget {
  readonly __typename?: 'RewardsListWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Displays rewards list */
  readonly componentKey?: Maybe<Scalars['String']>;
  readonly title?: Maybe<ILocaleString>;
}

export interface IRewardsRedemptionConfig {
  readonly __typename?: 'RewardsRedemptionConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Controls the number of rewards that can be used in a single order. Default is 1. */
  readonly standardRewardsLimit?: Maybe<Scalars['Float']>;
}

export interface IRewardsSection extends IDocument {
  readonly __typename?: 'RewardsSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly rewards?: Maybe<ReadonlyArray<Maybe<IFeaturedReward>>>;
  readonly rewardsList?: Maybe<ReadonlyArray<Maybe<IFeaturedReward>>>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IRewardsSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IRgbaColor {
  readonly __typename?: 'RgbaColor';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly a?: Maybe<Scalars['Float']>;
  readonly b?: Maybe<Scalars['Float']>;
  readonly g?: Maybe<Scalars['Float']>;
  readonly r?: Maybe<Scalars['Float']>;
}

export interface IRollUpTheRim extends IDocument {
  readonly __typename?: 'RollUpTheRim';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly allSetClaimFailedHeaderText?: Maybe<ILocaleString>;
  readonly allSetEmailSentText?: Maybe<ILocaleString>;
  readonly allSetHeaderBlock?: Maybe<ILocaleBlockContent>;
  readonly allSetHeaderText?: Maybe<ILocaleString>;
  readonly allSetLegalBlock?: Maybe<ILocaleBlockContent>;
  readonly allSetTextBlock?: Maybe<ILocaleBlockContent>;
  readonly countdownText?: Maybe<ILocaleBlockContent>;
  readonly cupImage?: Maybe<ILocaleImages>;
  readonly dailyDrawEntryScreenButtonText?: Maybe<ILocaleString>;
  readonly dailyDrawEntryScreenEmailSentText?: Maybe<ILocaleBlockContent>;
  readonly dailyDrawEntryScreenOfficialRulesLink?: Maybe<ILocaleString>;
  readonly dailyDrawEntryScreenOfficialRulesText?: Maybe<ILocaleBlockContent>;
  readonly dailyDrawEntryScreenPrizeImage?: Maybe<ILocaleImages>;
  readonly dailyDrawEntryScreenPrizeName?: Maybe<ILocaleString>;
  readonly dailyDrawEntryScreenPrizeTimer?: Maybe<Scalars['DateTime']>;
  readonly dailyDrawEntryScreenSubtitle?: Maybe<ILocaleString>;
  readonly dailyDrawEntryScreenTitle?: Maybe<ILocaleString>;
  readonly desktopGamePlayImage?: Maybe<ILocaleImages>;
  readonly desktopPrizesImage?: Maybe<ILocaleImages>;
  readonly desktopReusablesImage?: Maybe<ILocaleImages>;
  readonly desktopShareImage?: Maybe<ILocaleImages>;
  readonly desktopSponsorsImage?: Maybe<ILocaleImages>;
  readonly emptyTimelineButtonBlock?: Maybe<ILocaleBlockContent>;
  readonly emptyTimelineImage?: Maybe<ILocaleImages>;
  readonly emptyTimelineTextBlock?: Maybe<ILocaleBlockContent>;
  readonly endText?: Maybe<ILocaleBlockContent>;
  readonly enterButtonText?: Maybe<ILocaleBlockContent>;
  readonly entriesText?: Maybe<ILocaleBlockContent>;
  readonly errorTimelineButtonText?: Maybe<ILocaleString>;
  readonly errorTimelineImage?: Maybe<ILocaleImages>;
  readonly errorTimelineText?: Maybe<ILocaleString>;
  readonly firstDrawing?: Maybe<Scalars['DateTime']>;
  readonly footerLinks?: Maybe<ReadonlyArray<Maybe<IRutrFooter>>>;
  readonly fourthDrawing?: Maybe<Scalars['DateTime']>;
  readonly gameBackgroundImage?: Maybe<ILocaleImages>;
  readonly gameButtonText?: Maybe<ILocaleBlockContent>;
  readonly gameErrorBlock?: Maybe<ILocaleBlockContent>;
  readonly gameErrorHeaderText?: Maybe<ILocaleString>;
  readonly gameHeader?: Maybe<ILocaleBlockContent>;
  readonly gameHeaderText?: Maybe<ILocaleString>;
  readonly gameNeedHelp?: Maybe<ILocaleString>;
  readonly gamePlayButtonText?: Maybe<ILocaleBlockContent>;
  readonly gamePlayHeader?: Maybe<ILocaleBlockContent>;
  readonly gamePlayImage?: Maybe<ILocaleImages>;
  readonly gamePlayTextBlock?: Maybe<ILocaleBlockContent>;
  readonly gamePlayUnauthButtonText?: Maybe<ILocaleString>;
  /** If you select INVERSE, the button will set the color background to white and PRIMARY to red and GOLD to gold. */
  readonly gamePlayUnauthButtonVariant?: Maybe<Scalars['String']>;
  readonly gameRollButtonText?: Maybe<ILocaleString>;
  readonly gameTextBlock?: Maybe<ILocaleBlockContent>;
  readonly gameplayRollAudio?: Maybe<IFile>;
  readonly gameplayWinAudio?: Maybe<IFile>;
  readonly homepageBackgroundImage?: Maybe<ILocaleImages>;
  readonly homepageCupImage?: Maybe<ILocaleImages>;
  readonly homepageHeader?: Maybe<ILocaleBlockContent>;
  readonly howManyTextBlock?: Maybe<ILocaleBlockContent>;
  readonly localeSwitchModalDisclaimerText?: Maybe<ILocaleString>;
  readonly localeSwitchModalHeaderText?: Maybe<ILocaleString>;
  readonly localeSwitchModalPrimaryText?: Maybe<ILocaleString>;
  readonly localeSwitchModalSecondaryText?: Maybe<ILocaleString>;
  readonly lockoutScreenButtonText?: Maybe<ILocaleString>;
  readonly lockoutScreenImage?: Maybe<ILocaleImages>;
  readonly lockoutScreenTextBlock?: Maybe<ILocaleBlockContent>;
  readonly losingScreenButtonText?: Maybe<ILocaleString>;
  readonly losingScreenImage?: Maybe<ILocaleImages>;
  readonly losingScreenSubtitle?: Maybe<ILocaleString>;
  readonly losingScreenTitle?: Maybe<ILocaleString>;
  readonly modalTimelineHeader?: Maybe<ILocaleBlockContent>;
  readonly modalWinnersHeader?: Maybe<ILocaleBlockContent>;
  readonly modalWinnersTextBlock?: Maybe<ILocaleBlockContent>;
  readonly moneyStackImage?: Maybe<ILocaleImages>;
  readonly nextDrawText?: Maybe<ILocaleBlockContent>;
  readonly planeImage?: Maybe<ILocaleImages>;
  readonly prizes?: Maybe<ReadonlyArray<Maybe<IPrizes>>>;
  readonly prizesButtonText?: Maybe<ILocaleBlockContent>;
  readonly prizesDisclaimerText?: Maybe<ILocaleString>;
  readonly prizesHeader?: Maybe<ILocaleBlockContent>;
  readonly prizesImage?: Maybe<ILocaleImages>;
  readonly prizesSeparator?: Maybe<ILocaleBlockContent>;
  readonly prizesTabDescriptionText?: Maybe<ILocaleString>;
  readonly prizesTabHeader?: Maybe<ILocaleBlockContent>;
  readonly prizesTabHeaderText?: Maybe<ILocaleString>;
  readonly prizesTextBlock?: Maybe<ILocaleBlockContent>;
  readonly reusablesButtonText?: Maybe<ILocaleBlockContent>;
  readonly reusablesHeader?: Maybe<ILocaleBlockContent>;
  readonly reusablesImage?: Maybe<ILocaleImages>;
  readonly reusablesTextBlock?: Maybe<ILocaleBlockContent>;
  readonly rewards?: Maybe<ReadonlyArray<Maybe<IRewards>>>;
  readonly rewardsBackgroundImage?: Maybe<ILocaleImages>;
  readonly rewardsButtonText?: Maybe<ILocaleBlockContent>;
  readonly rewardsCupImage?: Maybe<ILocaleImages>;
  readonly rewardsHeader?: Maybe<ILocaleBlockContent>;
  readonly rewardsHeaderSubtitleText?: Maybe<ILocaleString>;
  readonly rewardsHeaderText?: Maybe<ILocaleString>;
  readonly rewardsTextBlock?: Maybe<ILocaleBlockContent>;
  readonly rollsRemainingText?: Maybe<ILocaleBlockContent>;
  readonly rollupAnimationFrames?: Maybe<ReadonlyArray<Maybe<ILocaleImages>>>;
  readonly rrrollButtonText?: Maybe<ILocaleBlockContent>;
  readonly rulesLinkPath?: Maybe<ILocaleString>;
  readonly rulesLinkText?: Maybe<ILocaleString>;
  readonly rulesText?: Maybe<ILocaleBlockContent>;
  readonly rutwLogo?: Maybe<ILocaleImages>;
  readonly secondDrawing?: Maybe<Scalars['DateTime']>;
  readonly shareButtonText?: Maybe<ILocaleBlockContent>;
  readonly shareHeader?: Maybe<ILocaleBlockContent>;
  readonly shareImage?: Maybe<ILocaleImages>;
  readonly shareRollHeader?: Maybe<ILocaleBlockContent>;
  readonly shareRollIncrementText?: Maybe<ILocaleString>;
  readonly shareRollLinkTitle?: Maybe<ILocaleString>;
  readonly shareRollReclaimButtonText?: Maybe<ILocaleString>;
  readonly shareRollReclaimDescriptionText?: Maybe<ILocaleString>;
  readonly shareRollReclaimQuestionText?: Maybe<ILocaleString>;
  readonly shareRollShare?: Maybe<ILocaleString>;
  readonly shareRollTextBlock?: Maybe<ILocaleBlockContent>;
  readonly shareRollTo?: Maybe<ILocaleString>;
  readonly shareRollURL?: Maybe<ILocaleString>;
  readonly shareRollYouHave?: Maybe<ILocaleString>;
  readonly shareRollsBackgroundImage?: Maybe<ILocaleImages>;
  readonly shareRollsDisclaimer?: Maybe<ILocaleBlockContent>;
  readonly shareRollsImage?: Maybe<ILocaleImages>;
  readonly shareRolluttonText?: Maybe<ILocaleBlockContent>;
  readonly shareTextBlock?: Maybe<ILocaleBlockContent>;
  readonly shareYourRollsLinkText?: Maybe<ILocaleString>;
  readonly sharedLandingAddedBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingBackgroundImage?: Maybe<ILocaleImages>;
  readonly sharedLandingBadLinkButtonBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingBadLinkHeaderBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingBadLinkImage?: Maybe<ILocaleImages>;
  readonly sharedLandingBadLinkTextBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingButtonBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingHeaderBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingImage?: Maybe<ILocaleImages>;
  readonly sharedLandingMoreThanOneRollAddedBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingMoreThanOneRollHeaderBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingMoreThanOneRollTextBlock?: Maybe<ILocaleBlockContent>;
  readonly sharedLandingTextBlock?: Maybe<ILocaleBlockContent>;
  readonly skillsQuestionAcknowledgeText?: Maybe<ILocaleString>;
  readonly skillsQuestionDescriptionText?: Maybe<ILocaleString>;
  readonly skillsQuestionHeaderText?: Maybe<ILocaleString>;
  readonly skillsQuestionHintText?: Maybe<ILocaleString>;
  readonly skillsQuestionMathBlock?: Maybe<ILocaleBlockContent>;
  readonly skillsQuestionReleaseBlock?: Maybe<ILocaleBlockContent>;
  readonly skillsQuestionsGroup?: Maybe<ReadonlyArray<Maybe<ISkillsTest>>>;
  readonly sponsorTitle?: Maybe<ILocaleString>;
  readonly sponsorsImage?: Maybe<ILocaleImages>;
  readonly thirdDrawing?: Maybe<Scalars['DateTime']>;
  readonly timelineButtonText?: Maybe<ILocaleBlockContent>;
  readonly timelineComponents?: Maybe<ReadonlyArray<Maybe<ITimelineComponents>>>;
  readonly timelineConfetti?: Maybe<ILocaleImages>;
  readonly timelineDailyDrawButtonLink?: Maybe<ILocaleString>;
  readonly timelineHeader?: Maybe<ILocaleBlockContent>;
  readonly timelinePrizeClaimedText?: Maybe<ILocaleString>;
  readonly timelineRollSharedText?: Maybe<ILocaleString>;
  readonly timelineTextBlock?: Maybe<ILocaleBlockContent>;
  readonly timelineTextLoadMore?: Maybe<ILocaleString>;
  readonly unauthenticatedEmptyTimelineButtonBlock?: Maybe<ILocaleBlockContent>;
  readonly unauthenticatedEmptyTimelineImage?: Maybe<ILocaleImages>;
  readonly unauthenticatedEmptyTimelineTextBlock?: Maybe<ILocaleBlockContent>;
  readonly unauthenticatedGamePlayHeader?: Maybe<ILocaleBlockContent>;
  readonly unauthenticatedgGamePlayTextBlock?: Maybe<ILocaleBlockContent>;
  readonly winnersButtonText?: Maybe<ILocaleBlockContent>;
  readonly winnersHeader?: Maybe<ILocaleBlockContent>;
  readonly winnersTextBlock?: Maybe<ILocaleBlockContent>;
}

export interface IRollUpTheRimFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly dailyDrawEntryScreenPrizeTimer?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly dailyDrawEntryScreenPrizeTimer_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly dailyDrawEntryScreenPrizeTimer_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly dailyDrawEntryScreenPrizeTimer_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly dailyDrawEntryScreenPrizeTimer_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly dailyDrawEntryScreenPrizeTimer_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly dailyDrawEntryScreenPrizeTimer_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly firstDrawing?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly firstDrawing_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly firstDrawing_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly firstDrawing_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly firstDrawing_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly firstDrawing_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly firstDrawing_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly fourthDrawing?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly fourthDrawing_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly fourthDrawing_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly fourthDrawing_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly fourthDrawing_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly fourthDrawing_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly fourthDrawing_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly gamePlayUnauthButtonVariant?: InputMaybe<Scalars['String']>;
  readonly gamePlayUnauthButtonVariant_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly gamePlayUnauthButtonVariant_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly gamePlayUnauthButtonVariant_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly gamePlayUnauthButtonVariant_not?: InputMaybe<Scalars['String']>;
  readonly gamePlayUnauthButtonVariant_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly secondDrawing?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly secondDrawing_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly secondDrawing_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly secondDrawing_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly secondDrawing_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly secondDrawing_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly secondDrawing_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly thirdDrawing?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly thirdDrawing_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly thirdDrawing_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly thirdDrawing_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly thirdDrawing_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly thirdDrawing_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly thirdDrawing_not?: InputMaybe<Scalars['DateTime']>;
}

export interface IRollUpTheRimSection extends IDocument {
  readonly __typename?: 'RollUpTheRimSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IRollUpTheRimSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IRootQuery {
  readonly __typename?: 'RootQuery';
  readonly AdaptableMenuCard?: Maybe<IAdaptableMenuCard>;
  readonly AdaptableMenuCardGroup?: Maybe<IAdaptableMenuCardGroup>;
  readonly AddOnSection?: Maybe<IAddOnSection>;
  readonly AdminToolReleaseNotes?: Maybe<IAdminToolReleaseNotes>;
  readonly Alert?: Maybe<IAlert>;
  readonly AppData?: Maybe<IAppData>;
  readonly AppDownload?: Maybe<IAppDownload>;
  readonly AppVersion?: Maybe<IAppVersion>;
  readonly AttachedCombo?: Maybe<IAttachedCombo>;
  readonly Barcodes?: Maybe<IBarcodes>;
  readonly BrazeContentCards?: Maybe<IBrazeContentCards>;
  readonly BuildConfiguration?: Maybe<IBuildConfiguration>;
  readonly CartTotalCountdown?: Maybe<ICartTotalCountdown>;
  readonly Category?: Maybe<ICategory>;
  readonly CateringPageConfiguration?: Maybe<ICateringPageConfiguration>;
  readonly ClaimPointsUI?: Maybe<IClaimPointsUi>;
  readonly Combo?: Maybe<ICombo>;
  readonly ComboSlot?: Maybe<IComboSlot>;
  readonly ConfigOffer?: Maybe<IConfigOffer>;
  readonly ConfigOfferV2?: Maybe<IConfigOfferV2>;
  readonly ConfigQuest?: Maybe<IConfigQuest>;
  readonly ConfigReward?: Maybe<IConfigReward>;
  readonly ConfigRewardV2?: Maybe<IConfigRewardV2>;
  readonly DisplayGroup?: Maybe<IDisplayGroup>;
  readonly EarningCalculation?: Maybe<IEarningCalculation>;
  readonly EmptyState?: Maybe<IEmptyState>;
  readonly FanFavorites?: Maybe<IFanFavorites>;
  readonly FeatureAccount?: Maybe<IFeatureAccount>;
  readonly FeatureAccountDeletePage?: Maybe<IFeatureAccountDeletePage>;
  readonly FeatureAccountForm?: Maybe<IFeatureAccountForm>;
  readonly FeatureAccountRequestInfoPage?: Maybe<IFeatureAccountRequestInfoPage>;
  readonly FeatureAuthCampaign?: Maybe<IFeatureAuthCampaign>;
  readonly FeatureBeeperModal?: Maybe<IFeatureBeeperModal>;
  readonly FeatureCateringPage?: Maybe<IFeatureCateringPage>;
  readonly FeatureDisclaimers?: Maybe<IFeatureDisclaimers>;
  readonly FeatureDonation?: Maybe<IFeatureDonation>;
  readonly FeatureFoodware?: Maybe<IFeatureFoodware>;
  readonly FeatureFooter?: Maybe<IFeatureFooter>;
  readonly FeatureFooterV2?: Maybe<IFeatureFooterV2>;
  readonly FeatureGeolocationMapMarkers?: Maybe<IFeatureGeolocationMapMarkers>;
  readonly FeatureGeolocationModal?: Maybe<IFeatureGeolocationModal>;
  readonly FeatureGift?: Maybe<IFeatureGift>;
  readonly FeatureHomePage?: Maybe<IFeatureHomePage>;
  readonly FeatureInvitationCode?: Maybe<IFeatureInvitationCode>;
  readonly FeatureKiosk?: Maybe<IFeatureKiosk>;
  readonly FeatureKioskHomePage?: Maybe<IFeatureKioskHomePage>;
  readonly FeatureKioskMenu?: Maybe<IFeatureKioskMenu>;
  readonly FeatureKioskOffers?: Maybe<IFeatureKioskOffers>;
  readonly FeatureKioskScreensaver?: Maybe<IFeatureKioskScreensaver>;
  readonly FeatureLayout?: Maybe<IFeatureLayout>;
  readonly FeatureLocationPromo?: Maybe<IFeatureLocationPromo>;
  readonly FeatureLockers?: Maybe<IFeatureLockers>;
  readonly FeatureMenu?: Maybe<IFeatureMenu>;
  readonly FeatureMobileAppConfiguration?: Maybe<IFeatureMobileAppConfiguration>;
  readonly FeatureNavigation?: Maybe<IFeatureNavigation>;
  readonly FeatureNutrition?: Maybe<IFeatureNutrition>;
  readonly FeatureOffers?: Maybe<IFeatureOffers>;
  readonly FeatureOnboarding?: Maybe<IFeatureOnboarding>;
  readonly FeaturePayback?: Maybe<IFeaturePayback>;
  readonly FeatureQuiz?: Maybe<IFeatureQuiz>;
  readonly FeatureScanAndPay?: Maybe<IFeatureScanAndPay>;
  readonly FeatureSimplifiedLandingPage?: Maybe<IFeatureSimplifiedLandingPage>;
  readonly FeatureStaticMenu?: Maybe<IFeatureStaticMenu>;
  readonly FeesV1Discount?: Maybe<IFeesV1Discount>;
  readonly Footer?: Maybe<IFooter>;
  readonly FrontEndConfiguration?: Maybe<IFrontEndConfiguration>;
  readonly GoogleAdSlot?: Maybe<IGoogleAdSlot>;
  readonly Hero?: Maybe<IHero>;
  readonly HomePageConfiguration?: Maybe<IHomePageConfiguration>;
  readonly ImageWithHeaderAndText?: Maybe<IImageWithHeaderAndText>;
  readonly Item?: Maybe<IItem>;
  readonly ItemGroup?: Maybe<IItemGroup>;
  readonly ItemGroupDiscount?: Maybe<IItemGroupDiscount>;
  readonly KioskAppData?: Maybe<IKioskAppData>;
  readonly KioskConfiguration?: Maybe<IKioskConfiguration>;
  readonly LinkPhysicalCardUi?: Maybe<ILinkPhysicalCardUi>;
  readonly LockedOffers?: Maybe<ILockedOffers>;
  readonly LoyaltyConfiguration?: Maybe<ILoyaltyConfiguration>;
  readonly LoyaltyContent?: Maybe<ILoyaltyContent>;
  readonly LoyaltyOffersUI?: Maybe<ILoyaltyOffersUi>;
  readonly LoyaltyQuestsUI?: Maybe<ILoyaltyQuestsUi>;
  readonly LoyaltyReceipts?: Maybe<ILoyaltyReceipts>;
  readonly LoyaltyUI?: Maybe<ILoyaltyUi>;
  readonly MainHero?: Maybe<IMainHero>;
  readonly MarkerItem?: Maybe<IMarkerItem>;
  readonly MarketingCard?: Maybe<IMarketingCard>;
  readonly MarketingCardGroup?: Maybe<IMarketingCardGroup>;
  readonly MarketingTile?: Maybe<IMarketingTile>;
  readonly MarketingTileBasic?: Maybe<IMarketingTileBasic>;
  readonly MarketingTileCarousel?: Maybe<IMarketingTileCarousel>;
  readonly MarketingTileGroup?: Maybe<IMarketingTileGroup>;
  readonly MediaTag?: Maybe<IMediaTag>;
  readonly Menu?: Maybe<IMenu>;
  readonly Modifier?: Maybe<IModifier>;
  readonly ModifierMultiplier?: Maybe<IModifierMultiplier>;
  readonly NavigationSection?: Maybe<INavigationSection>;
  readonly NutritionalSection?: Maybe<INutritionalSection>;
  readonly Offer?: Maybe<IOffer>;
  readonly OfferActivation?: Maybe<IOfferActivation>;
  readonly OfferCampaign?: Maybe<IOfferCampaign>;
  readonly OfferCategorization?: Maybe<IOfferCategorization>;
  readonly OfferDiscount?: Maybe<IOfferDiscount>;
  readonly OfferItemDiscount?: Maybe<IOfferItemDiscount>;
  readonly OfferLoyaltyAction?: Maybe<IOfferLoyaltyAction>;
  readonly OfferTemplate?: Maybe<IOfferTemplate>;
  readonly OffersSection?: Maybe<IOffersSection>;
  readonly OpPricingRegion?: Maybe<IOpPricingRegion>;
  readonly OurServices?: Maybe<IOurServices>;
  readonly Picker?: Maybe<IPicker>;
  readonly PickerAspect?: Maybe<IPickerAspect>;
  readonly PlaceholderField?: Maybe<IPlaceholderField>;
  readonly PosConfiguration?: Maybe<IPosConfiguration>;
  readonly ProductCategory?: Maybe<IProductCategory>;
  readonly QuestTemplate?: Maybe<IQuestTemplate>;
  readonly QuestionDetails?: Maybe<IQuestionDetails>;
  readonly QuestsSection?: Maybe<IQuestsSection>;
  readonly RecentItems?: Maybe<IRecentItems>;
  readonly RemediationReasons?: Maybe<IRemediationReasons>;
  readonly ResponseDetails?: Maybe<IResponseDetails>;
  readonly Restaurant?: Maybe<IRestaurant>;
  readonly RestaurantAmenity?: Maybe<IRestaurantAmenity>;
  readonly RestaurantDeliveryProvider?: Maybe<IRestaurantDeliveryProvider>;
  readonly RestaurantGroup?: Maybe<IRestaurantGroup>;
  readonly RestaurantKioskData?: Maybe<IRestaurantKioskData>;
  readonly RestaurantPosData?: Maybe<IRestaurantPosData>;
  readonly ResultDetails?: Maybe<IResultDetails>;
  readonly Reward?: Maybe<IReward>;
  readonly RewardCategory?: Maybe<IRewardCategory>;
  readonly RewardList?: Maybe<IRewardList>;
  readonly RewardV2?: Maybe<IRewardV2>;
  readonly RewardsSection?: Maybe<IRewardsSection>;
  readonly RollUpTheRim?: Maybe<IRollUpTheRim>;
  readonly RollUpTheRimSection?: Maybe<IRollUpTheRimSection>;
  readonly SanityFileAsset?: Maybe<ISanityFileAsset>;
  readonly SanityImageAsset?: Maybe<ISanityImageAsset>;
  readonly SanityReleaseNotes?: Maybe<ISanityReleaseNotes>;
  readonly SanityValidationConfiguration?: Maybe<ISanityValidationConfiguration>;
  readonly ScanForRewards?: Maybe<IScanForRewards>;
  readonly Section?: Maybe<ISection>;
  readonly SimpleHomePage?: Maybe<ISimpleHomePage>;
  readonly StaticPage?: Maybe<IStaticPage>;
  readonly SupportCategoryGroup?: Maybe<ISupportCategoryGroup>;
  readonly SupportData?: Maybe<ISupportData>;
  readonly SupportFaq?: Maybe<ISupportFaq>;
  readonly SupportSubcategory?: Maybe<ISupportSubcategory>;
  readonly SwapMapping?: Maybe<ISwapMapping>;
  readonly SystemwideOffer?: Maybe<ISystemwideOffer>;
  readonly SystemwideOfferV2?: Maybe<ISystemwideOfferV2>;
  readonly SystemwidePromotion?: Maybe<ISystemwidePromotion>;
  readonly SystemwideQuest?: Maybe<ISystemwideQuest>;
  readonly Tag?: Maybe<ITag>;
  readonly Tier?: Maybe<ITier>;
  readonly TimsRewardsPointsSection?: Maybe<ITimsRewardsPointsSection>;
  readonly Trending?: Maybe<ITrending>;
  readonly allAdaptableMenuCardGroups: ReadonlyArray<IAdaptableMenuCardGroup>;
  readonly allAdaptableMenuCards: ReadonlyArray<IAdaptableMenuCard>;
  readonly allAddOnSections: ReadonlyArray<IAddOnSection>;
  readonly allAdminToolReleaseNotes: ReadonlyArray<IAdminToolReleaseNotes>;
  readonly allAlerts: ReadonlyArray<IAlert>;
  readonly allAppData: ReadonlyArray<IAppData>;
  readonly allAppDownloads: ReadonlyArray<IAppDownload>;
  readonly allAppVersions: ReadonlyArray<IAppVersion>;
  readonly allAttachedCombos: ReadonlyArray<IAttachedCombo>;
  readonly allBarcodes: ReadonlyArray<IBarcodes>;
  readonly allBrazeContentCards: ReadonlyArray<IBrazeContentCards>;
  readonly allBuildConfigurations: ReadonlyArray<IBuildConfiguration>;
  readonly allCartTotalCountdowns: ReadonlyArray<ICartTotalCountdown>;
  readonly allCategories: ReadonlyArray<ICategory>;
  readonly allCateringPageConfigurations: ReadonlyArray<ICateringPageConfiguration>;
  readonly allClaimPointsUis: ReadonlyArray<IClaimPointsUi>;
  readonly allComboSlots: ReadonlyArray<IComboSlot>;
  readonly allCombos: ReadonlyArray<ICombo>;
  readonly allConfigOfferV2S: ReadonlyArray<IConfigOfferV2>;
  readonly allConfigOffers: ReadonlyArray<IConfigOffer>;
  readonly allConfigQuests: ReadonlyArray<IConfigQuest>;
  readonly allConfigRewardV2S: ReadonlyArray<IConfigRewardV2>;
  readonly allConfigRewards: ReadonlyArray<IConfigReward>;
  readonly allDisplayGroups: ReadonlyArray<IDisplayGroup>;
  readonly allEarningCalculations: ReadonlyArray<IEarningCalculation>;
  readonly allEmptyStates: ReadonlyArray<IEmptyState>;
  readonly allFanFavorites: ReadonlyArray<IFanFavorites>;
  readonly allFeatureAccountDeletePages: ReadonlyArray<IFeatureAccountDeletePage>;
  readonly allFeatureAccountForms: ReadonlyArray<IFeatureAccountForm>;
  readonly allFeatureAccountRequestInfoPages: ReadonlyArray<IFeatureAccountRequestInfoPage>;
  readonly allFeatureAccounts: ReadonlyArray<IFeatureAccount>;
  readonly allFeatureAuthCampaigns: ReadonlyArray<IFeatureAuthCampaign>;
  readonly allFeatureBeeperModals: ReadonlyArray<IFeatureBeeperModal>;
  readonly allFeatureCateringPages: ReadonlyArray<IFeatureCateringPage>;
  readonly allFeatureDisclaimers: ReadonlyArray<IFeatureDisclaimers>;
  readonly allFeatureDonations: ReadonlyArray<IFeatureDonation>;
  readonly allFeatureFoodwares: ReadonlyArray<IFeatureFoodware>;
  readonly allFeatureFooterV2S: ReadonlyArray<IFeatureFooterV2>;
  readonly allFeatureFooters: ReadonlyArray<IFeatureFooter>;
  readonly allFeatureGeolocationMapMarkers: ReadonlyArray<IFeatureGeolocationMapMarkers>;
  readonly allFeatureGeolocationModals: ReadonlyArray<IFeatureGeolocationModal>;
  readonly allFeatureGifts: ReadonlyArray<IFeatureGift>;
  readonly allFeatureHomePages: ReadonlyArray<IFeatureHomePage>;
  readonly allFeatureInvitationCodes: ReadonlyArray<IFeatureInvitationCode>;
  readonly allFeatureKioskHomePages: ReadonlyArray<IFeatureKioskHomePage>;
  readonly allFeatureKioskMenus: ReadonlyArray<IFeatureKioskMenu>;
  readonly allFeatureKioskOffers: ReadonlyArray<IFeatureKioskOffers>;
  readonly allFeatureKioskScreensavers: ReadonlyArray<IFeatureKioskScreensaver>;
  readonly allFeatureKiosks: ReadonlyArray<IFeatureKiosk>;
  readonly allFeatureLayouts: ReadonlyArray<IFeatureLayout>;
  readonly allFeatureLocationPromos: ReadonlyArray<IFeatureLocationPromo>;
  readonly allFeatureLockers: ReadonlyArray<IFeatureLockers>;
  readonly allFeatureMenus: ReadonlyArray<IFeatureMenu>;
  readonly allFeatureMobileAppConfigurations: ReadonlyArray<IFeatureMobileAppConfiguration>;
  readonly allFeatureNavigations: ReadonlyArray<IFeatureNavigation>;
  readonly allFeatureNutritions: ReadonlyArray<IFeatureNutrition>;
  readonly allFeatureOffers: ReadonlyArray<IFeatureOffers>;
  readonly allFeatureOnboardings: ReadonlyArray<IFeatureOnboarding>;
  readonly allFeaturePaybacks: ReadonlyArray<IFeaturePayback>;
  readonly allFeatureQuizzes: ReadonlyArray<IFeatureQuiz>;
  readonly allFeatureScanAndPays: ReadonlyArray<IFeatureScanAndPay>;
  readonly allFeatureSimplifiedLandingPages: ReadonlyArray<IFeatureSimplifiedLandingPage>;
  readonly allFeatureStaticMenus: ReadonlyArray<IFeatureStaticMenu>;
  readonly allFeesV1Discounts: ReadonlyArray<IFeesV1Discount>;
  readonly allFooters: ReadonlyArray<IFooter>;
  readonly allFrontEndConfigurations: ReadonlyArray<IFrontEndConfiguration>;
  readonly allGoogleAdSlots: ReadonlyArray<IGoogleAdSlot>;
  readonly allHeroes: ReadonlyArray<IHero>;
  readonly allHomePageConfigurations: ReadonlyArray<IHomePageConfiguration>;
  readonly allImageWithHeaderAndTexts: ReadonlyArray<IImageWithHeaderAndText>;
  readonly allItemGroupDiscounts: ReadonlyArray<IItemGroupDiscount>;
  readonly allItemGroups: ReadonlyArray<IItemGroup>;
  readonly allItems: ReadonlyArray<IItem>;
  readonly allKioskAppData: ReadonlyArray<IKioskAppData>;
  readonly allKioskConfigurations: ReadonlyArray<IKioskConfiguration>;
  readonly allLinkPhysicalCardUis: ReadonlyArray<ILinkPhysicalCardUi>;
  readonly allLockedOffers: ReadonlyArray<ILockedOffers>;
  readonly allLoyaltyConfigurations: ReadonlyArray<ILoyaltyConfiguration>;
  readonly allLoyaltyContents: ReadonlyArray<ILoyaltyContent>;
  readonly allLoyaltyOffersUis: ReadonlyArray<ILoyaltyOffersUi>;
  readonly allLoyaltyQuestsUis: ReadonlyArray<ILoyaltyQuestsUi>;
  readonly allLoyaltyReceipts: ReadonlyArray<ILoyaltyReceipts>;
  readonly allLoyaltyUis: ReadonlyArray<ILoyaltyUi>;
  readonly allMainHeroes: ReadonlyArray<IMainHero>;
  readonly allMarkerItems: ReadonlyArray<IMarkerItem>;
  readonly allMarketingCardGroups: ReadonlyArray<IMarketingCardGroup>;
  readonly allMarketingCards: ReadonlyArray<IMarketingCard>;
  readonly allMarketingTileBasics: ReadonlyArray<IMarketingTileBasic>;
  readonly allMarketingTileCarousels: ReadonlyArray<IMarketingTileCarousel>;
  readonly allMarketingTileGroups: ReadonlyArray<IMarketingTileGroup>;
  readonly allMarketingTiles: ReadonlyArray<IMarketingTile>;
  readonly allMediaTags: ReadonlyArray<IMediaTag>;
  readonly allMenus: ReadonlyArray<IMenu>;
  readonly allModifierMultipliers: ReadonlyArray<IModifierMultiplier>;
  readonly allModifiers: ReadonlyArray<IModifier>;
  readonly allNavigationSections: ReadonlyArray<INavigationSection>;
  readonly allNutritionalSections: ReadonlyArray<INutritionalSection>;
  readonly allOfferActivations: ReadonlyArray<IOfferActivation>;
  readonly allOfferCampaigns: ReadonlyArray<IOfferCampaign>;
  readonly allOfferCategorizations: ReadonlyArray<IOfferCategorization>;
  readonly allOfferDiscounts: ReadonlyArray<IOfferDiscount>;
  readonly allOfferItemDiscounts: ReadonlyArray<IOfferItemDiscount>;
  readonly allOfferLoyaltyActions: ReadonlyArray<IOfferLoyaltyAction>;
  readonly allOfferTemplates: ReadonlyArray<IOfferTemplate>;
  readonly allOffers: ReadonlyArray<IOffer>;
  readonly allOffersSections: ReadonlyArray<IOffersSection>;
  readonly allOpPricingRegions: ReadonlyArray<IOpPricingRegion>;
  readonly allOurServices: ReadonlyArray<IOurServices>;
  readonly allPickerAspects: ReadonlyArray<IPickerAspect>;
  readonly allPickers: ReadonlyArray<IPicker>;
  readonly allPlaceholderFields: ReadonlyArray<IPlaceholderField>;
  readonly allPosConfigurations: ReadonlyArray<IPosConfiguration>;
  readonly allProductCategories: ReadonlyArray<IProductCategory>;
  readonly allQuestTemplates: ReadonlyArray<IQuestTemplate>;
  readonly allQuestionDetails: ReadonlyArray<IQuestionDetails>;
  readonly allQuestsSections: ReadonlyArray<IQuestsSection>;
  readonly allRecentItems: ReadonlyArray<IRecentItems>;
  readonly allRemediationReasons: ReadonlyArray<IRemediationReasons>;
  readonly allResponseDetails: ReadonlyArray<IResponseDetails>;
  readonly allRestaurantAmenities: ReadonlyArray<IRestaurantAmenity>;
  readonly allRestaurantDeliveryProviders: ReadonlyArray<IRestaurantDeliveryProvider>;
  readonly allRestaurantGroups: ReadonlyArray<IRestaurantGroup>;
  readonly allRestaurantKioskData: ReadonlyArray<IRestaurantKioskData>;
  readonly allRestaurantPosData: ReadonlyArray<IRestaurantPosData>;
  readonly allRestaurants: ReadonlyArray<IRestaurant>;
  readonly allResultDetails: ReadonlyArray<IResultDetails>;
  readonly allRewardCategories: ReadonlyArray<IRewardCategory>;
  readonly allRewardLists: ReadonlyArray<IRewardList>;
  readonly allRewardV2S: ReadonlyArray<IRewardV2>;
  readonly allRewards: ReadonlyArray<IReward>;
  readonly allRewardsSections: ReadonlyArray<IRewardsSection>;
  readonly allRollUpTheRimSections: ReadonlyArray<IRollUpTheRimSection>;
  readonly allRollUpTheRims: ReadonlyArray<IRollUpTheRim>;
  readonly allSanityFileAssets: ReadonlyArray<ISanityFileAsset>;
  readonly allSanityImageAssets: ReadonlyArray<ISanityImageAsset>;
  readonly allSanityReleaseNotes: ReadonlyArray<ISanityReleaseNotes>;
  readonly allSanityValidationConfigurations: ReadonlyArray<ISanityValidationConfiguration>;
  readonly allScanForRewards: ReadonlyArray<IScanForRewards>;
  readonly allSections: ReadonlyArray<ISection>;
  readonly allSimpleHomePages: ReadonlyArray<ISimpleHomePage>;
  readonly allStaticPages: ReadonlyArray<IStaticPage>;
  readonly allSupportCategoryGroups: ReadonlyArray<ISupportCategoryGroup>;
  readonly allSupportData: ReadonlyArray<ISupportData>;
  readonly allSupportFaqs: ReadonlyArray<ISupportFaq>;
  readonly allSupportSubcategories: ReadonlyArray<ISupportSubcategory>;
  readonly allSwapMappings: ReadonlyArray<ISwapMapping>;
  readonly allSystemwideOfferV2S: ReadonlyArray<ISystemwideOfferV2>;
  readonly allSystemwideOffers: ReadonlyArray<ISystemwideOffer>;
  readonly allSystemwidePromotions: ReadonlyArray<ISystemwidePromotion>;
  readonly allSystemwideQuests: ReadonlyArray<ISystemwideQuest>;
  readonly allTags: ReadonlyArray<ITag>;
  readonly allTiers: ReadonlyArray<ITier>;
  readonly allTimsRewardsPointsSections: ReadonlyArray<ITimsRewardsPointsSection>;
  readonly allTrendings: ReadonlyArray<ITrending>;
}


export interface IRootQueryAdaptableMenuCardArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAdaptableMenuCardGroupArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAddOnSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAdminToolReleaseNotesArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAlertArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAppDataArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAppDownloadArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAppVersionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAttachedComboArgs {
  id: Scalars['ID'];
}


export interface IRootQueryBarcodesArgs {
  id: Scalars['ID'];
}


export interface IRootQueryBrazeContentCardsArgs {
  id: Scalars['ID'];
}


export interface IRootQueryBuildConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryCartTotalCountdownArgs {
  id: Scalars['ID'];
}


export interface IRootQueryCategoryArgs {
  id: Scalars['ID'];
}


export interface IRootQueryCateringPageConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryClaimPointsUiArgs {
  id: Scalars['ID'];
}


export interface IRootQueryComboArgs {
  id: Scalars['ID'];
}


export interface IRootQueryComboSlotArgs {
  id: Scalars['ID'];
}


export interface IRootQueryConfigOfferArgs {
  id: Scalars['ID'];
}


export interface IRootQueryConfigOfferV2Args {
  id: Scalars['ID'];
}


export interface IRootQueryConfigQuestArgs {
  id: Scalars['ID'];
}


export interface IRootQueryConfigRewardArgs {
  id: Scalars['ID'];
}


export interface IRootQueryConfigRewardV2Args {
  id: Scalars['ID'];
}


export interface IRootQueryDisplayGroupArgs {
  id: Scalars['ID'];
}


export interface IRootQueryEarningCalculationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryEmptyStateArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFanFavoritesArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureAccountArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureAccountDeletePageArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureAccountFormArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureAccountRequestInfoPageArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureAuthCampaignArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureBeeperModalArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureCateringPageArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureDisclaimersArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureDonationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureFoodwareArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureFooterArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureFooterV2Args {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureGeolocationMapMarkersArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureGeolocationModalArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureGiftArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureHomePageArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureInvitationCodeArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureKioskArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureKioskHomePageArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureKioskMenuArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureKioskOffersArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureKioskScreensaverArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureLayoutArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureLocationPromoArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureLockersArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureMenuArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureMobileAppConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureNavigationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureNutritionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureOffersArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureOnboardingArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeaturePaybackArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureQuizArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureScanAndPayArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureSimplifiedLandingPageArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeatureStaticMenuArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFeesV1DiscountArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFooterArgs {
  id: Scalars['ID'];
}


export interface IRootQueryFrontEndConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryGoogleAdSlotArgs {
  id: Scalars['ID'];
}


export interface IRootQueryHeroArgs {
  id: Scalars['ID'];
}


export interface IRootQueryHomePageConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryImageWithHeaderAndTextArgs {
  id: Scalars['ID'];
}


export interface IRootQueryItemArgs {
  id: Scalars['ID'];
}


export interface IRootQueryItemGroupArgs {
  id: Scalars['ID'];
}


export interface IRootQueryItemGroupDiscountArgs {
  id: Scalars['ID'];
}


export interface IRootQueryKioskAppDataArgs {
  id: Scalars['ID'];
}


export interface IRootQueryKioskConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLinkPhysicalCardUiArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLockedOffersArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLoyaltyConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLoyaltyContentArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLoyaltyOffersUiArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLoyaltyQuestsUiArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLoyaltyReceiptsArgs {
  id: Scalars['ID'];
}


export interface IRootQueryLoyaltyUiArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMainHeroArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMarkerItemArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMarketingCardArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMarketingCardGroupArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMarketingTileArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMarketingTileBasicArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMarketingTileCarouselArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMarketingTileGroupArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMediaTagArgs {
  id: Scalars['ID'];
}


export interface IRootQueryMenuArgs {
  id: Scalars['ID'];
}


export interface IRootQueryModifierArgs {
  id: Scalars['ID'];
}


export interface IRootQueryModifierMultiplierArgs {
  id: Scalars['ID'];
}


export interface IRootQueryNavigationSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryNutritionalSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferActivationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferCampaignArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferCategorizationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferDiscountArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferItemDiscountArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferLoyaltyActionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOfferTemplateArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOffersSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOpPricingRegionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryOurServicesArgs {
  id: Scalars['ID'];
}


export interface IRootQueryPickerArgs {
  id: Scalars['ID'];
}


export interface IRootQueryPickerAspectArgs {
  id: Scalars['ID'];
}


export interface IRootQueryPlaceholderFieldArgs {
  id: Scalars['ID'];
}


export interface IRootQueryPosConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryProductCategoryArgs {
  id: Scalars['ID'];
}


export interface IRootQueryQuestTemplateArgs {
  id: Scalars['ID'];
}


export interface IRootQueryQuestionDetailsArgs {
  id: Scalars['ID'];
}


export interface IRootQueryQuestsSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRecentItemsArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRemediationReasonsArgs {
  id: Scalars['ID'];
}


export interface IRootQueryResponseDetailsArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRestaurantArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRestaurantAmenityArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRestaurantDeliveryProviderArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRestaurantGroupArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRestaurantKioskDataArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRestaurantPosDataArgs {
  id: Scalars['ID'];
}


export interface IRootQueryResultDetailsArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRewardArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRewardCategoryArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRewardListArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRewardV2Args {
  id: Scalars['ID'];
}


export interface IRootQueryRewardsSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRollUpTheRimArgs {
  id: Scalars['ID'];
}


export interface IRootQueryRollUpTheRimSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySanityFileAssetArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySanityImageAssetArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySanityReleaseNotesArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySanityValidationConfigurationArgs {
  id: Scalars['ID'];
}


export interface IRootQueryScanForRewardsArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySectionArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySimpleHomePageArgs {
  id: Scalars['ID'];
}


export interface IRootQueryStaticPageArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySupportCategoryGroupArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySupportDataArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySupportFaqArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySupportSubcategoryArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySwapMappingArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySystemwideOfferArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySystemwideOfferV2Args {
  id: Scalars['ID'];
}


export interface IRootQuerySystemwidePromotionArgs {
  id: Scalars['ID'];
}


export interface IRootQuerySystemwideQuestArgs {
  id: Scalars['ID'];
}


export interface IRootQueryTagArgs {
  id: Scalars['ID'];
}


export interface IRootQueryTierArgs {
  id: Scalars['ID'];
}


export interface IRootQueryTimsRewardsPointsSectionArgs {
  id: Scalars['ID'];
}


export interface IRootQueryTrendingArgs {
  id: Scalars['ID'];
}


export interface IRootQueryAllAdaptableMenuCardGroupsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAdaptableMenuCardGroupFilter>;
}


export interface IRootQueryAllAdaptableMenuCardsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAdaptableMenuCardFilter>;
}


export interface IRootQueryAllAddOnSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAddOnSectionFilter>;
}


export interface IRootQueryAllAdminToolReleaseNotesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAdminToolReleaseNotesFilter>;
}


export interface IRootQueryAllAlertsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAlertFilter>;
}


export interface IRootQueryAllAppDataArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAppDataFilter>;
}


export interface IRootQueryAllAppDownloadsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAppDownloadFilter>;
}


export interface IRootQueryAllAppVersionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAppVersionFilter>;
}


export interface IRootQueryAllAttachedCombosArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAttachedComboFilter>;
}


export interface IRootQueryAllBarcodesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IBarcodesFilter>;
}


export interface IRootQueryAllBrazeContentCardsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IBrazeContentCardsFilter>;
}


export interface IRootQueryAllBuildConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IBuildConfigurationFilter>;
}


export interface IRootQueryAllCartTotalCountdownsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ICartTotalCountdownFilter>;
}


export interface IRootQueryAllCategoriesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ICategoryFilter>;
}


export interface IRootQueryAllCateringPageConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ICateringPageConfigurationFilter>;
}


export interface IRootQueryAllClaimPointsUisArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IClaimPointsUiFilter>;
}


export interface IRootQueryAllComboSlotsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IComboSlotFilter>;
}


export interface IRootQueryAllCombosArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IComboFilter>;
}


export interface IRootQueryAllConfigOfferV2SArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IConfigOfferV2Filter>;
}


export interface IRootQueryAllConfigOffersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IConfigOfferFilter>;
}


export interface IRootQueryAllConfigQuestsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IConfigQuestFilter>;
}


export interface IRootQueryAllConfigRewardV2SArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IConfigRewardV2Filter>;
}


export interface IRootQueryAllConfigRewardsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IConfigRewardFilter>;
}


export interface IRootQueryAllDisplayGroupsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IDisplayGroupFilter>;
}


export interface IRootQueryAllEarningCalculationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IEarningCalculationFilter>;
}


export interface IRootQueryAllEmptyStatesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IEmptyStateFilter>;
}


export interface IRootQueryAllFanFavoritesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFanFavoritesFilter>;
}


export interface IRootQueryAllFeatureAccountDeletePagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureAccountDeletePageFilter>;
}


export interface IRootQueryAllFeatureAccountFormsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureAccountFormFilter>;
}


export interface IRootQueryAllFeatureAccountRequestInfoPagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureAccountRequestInfoPageFilter>;
}


export interface IRootQueryAllFeatureAccountsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureAccountFilter>;
}


export interface IRootQueryAllFeatureAuthCampaignsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureAuthCampaignFilter>;
}


export interface IRootQueryAllFeatureBeeperModalsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureBeeperModalFilter>;
}


export interface IRootQueryAllFeatureCateringPagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureCateringPageFilter>;
}


export interface IRootQueryAllFeatureDisclaimersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureDisclaimersFilter>;
}


export interface IRootQueryAllFeatureDonationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureDonationFilter>;
}


export interface IRootQueryAllFeatureFoodwaresArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureFoodwareFilter>;
}


export interface IRootQueryAllFeatureFooterV2SArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureFooterV2Filter>;
}


export interface IRootQueryAllFeatureFootersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureFooterFilter>;
}


export interface IRootQueryAllFeatureGeolocationMapMarkersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureGeolocationMapMarkersFilter>;
}


export interface IRootQueryAllFeatureGeolocationModalsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureGeolocationModalFilter>;
}


export interface IRootQueryAllFeatureGiftsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureGiftFilter>;
}


export interface IRootQueryAllFeatureHomePagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureHomePageFilter>;
}


export interface IRootQueryAllFeatureInvitationCodesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureInvitationCodeFilter>;
}


export interface IRootQueryAllFeatureKioskHomePagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureKioskHomePageFilter>;
}


export interface IRootQueryAllFeatureKioskMenusArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureKioskMenuFilter>;
}


export interface IRootQueryAllFeatureKioskOffersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureKioskOffersFilter>;
}


export interface IRootQueryAllFeatureKioskScreensaversArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureKioskScreensaverFilter>;
}


export interface IRootQueryAllFeatureKiosksArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureKioskFilter>;
}


export interface IRootQueryAllFeatureLayoutsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureLayoutFilter>;
}


export interface IRootQueryAllFeatureLocationPromosArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureLocationPromoFilter>;
}


export interface IRootQueryAllFeatureLockersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureLockersFilter>;
}


export interface IRootQueryAllFeatureMenusArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureMenuFilter>;
}


export interface IRootQueryAllFeatureMobileAppConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureMobileAppConfigurationFilter>;
}


export interface IRootQueryAllFeatureNavigationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureNavigationFilter>;
}


export interface IRootQueryAllFeatureNutritionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureNutritionFilter>;
}


export interface IRootQueryAllFeatureOffersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureOffersFilter>;
}


export interface IRootQueryAllFeatureOnboardingsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureOnboardingFilter>;
}


export interface IRootQueryAllFeaturePaybacksArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeaturePaybackFilter>;
}


export interface IRootQueryAllFeatureQuizzesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureQuizFilter>;
}


export interface IRootQueryAllFeatureScanAndPaysArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureScanAndPayFilter>;
}


export interface IRootQueryAllFeatureSimplifiedLandingPagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureSimplifiedLandingPageFilter>;
}


export interface IRootQueryAllFeatureStaticMenusArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeatureStaticMenuFilter>;
}


export interface IRootQueryAllFeesV1DiscountsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFeesV1DiscountFilter>;
}


export interface IRootQueryAllFootersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFooterFilter>;
}


export interface IRootQueryAllFrontEndConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IFrontEndConfigurationFilter>;
}


export interface IRootQueryAllGoogleAdSlotsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IGoogleAdSlotFilter>;
}


export interface IRootQueryAllHeroesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IHeroFilter>;
}


export interface IRootQueryAllHomePageConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IHomePageConfigurationFilter>;
}


export interface IRootQueryAllImageWithHeaderAndTextsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IImageWithHeaderAndTextFilter>;
}


export interface IRootQueryAllItemGroupDiscountsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IItemGroupDiscountFilter>;
}


export interface IRootQueryAllItemGroupsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IItemGroupFilter>;
}


export interface IRootQueryAllItemsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IItemFilter>;
}


export interface IRootQueryAllKioskAppDataArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IKioskAppDataFilter>;
}


export interface IRootQueryAllKioskConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IKioskConfigurationFilter>;
}


export interface IRootQueryAllLinkPhysicalCardUisArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILinkPhysicalCardUiFilter>;
}


export interface IRootQueryAllLockedOffersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILockedOffersFilter>;
}


export interface IRootQueryAllLoyaltyConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyConfigurationFilter>;
}


export interface IRootQueryAllLoyaltyContentsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyContentFilter>;
}


export interface IRootQueryAllLoyaltyOffersUisArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyOffersUiFilter>;
}


export interface IRootQueryAllLoyaltyQuestsUisArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyQuestsUiFilter>;
}


export interface IRootQueryAllLoyaltyReceiptsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyReceiptsFilter>;
}


export interface IRootQueryAllLoyaltyUisArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyUiFilter>;
}


export interface IRootQueryAllMainHeroesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMainHeroFilter>;
}


export interface IRootQueryAllMarkerItemsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMarkerItemFilter>;
}


export interface IRootQueryAllMarketingCardGroupsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMarketingCardGroupFilter>;
}


export interface IRootQueryAllMarketingCardsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMarketingCardFilter>;
}


export interface IRootQueryAllMarketingTileBasicsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMarketingTileBasicFilter>;
}


export interface IRootQueryAllMarketingTileCarouselsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMarketingTileCarouselFilter>;
}


export interface IRootQueryAllMarketingTileGroupsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMarketingTileGroupFilter>;
}


export interface IRootQueryAllMarketingTilesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMarketingTileFilter>;
}


export interface IRootQueryAllMediaTagsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMediaTagFilter>;
}


export interface IRootQueryAllMenusArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IMenuFilter>;
}


export interface IRootQueryAllModifierMultipliersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IModifierMultiplierFilter>;
}


export interface IRootQueryAllModifiersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IModifierFilter>;
}


export interface IRootQueryAllNavigationSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<INavigationSectionFilter>;
}


export interface IRootQueryAllNutritionalSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<INutritionalSectionFilter>;
}


export interface IRootQueryAllOfferActivationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferActivationFilter>;
}


export interface IRootQueryAllOfferCampaignsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferCampaignFilter>;
}


export interface IRootQueryAllOfferCategorizationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferCategorizationFilter>;
}


export interface IRootQueryAllOfferDiscountsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferDiscountFilter>;
}


export interface IRootQueryAllOfferItemDiscountsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferItemDiscountFilter>;
}


export interface IRootQueryAllOfferLoyaltyActionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferLoyaltyActionFilter>;
}


export interface IRootQueryAllOfferTemplatesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferTemplateFilter>;
}


export interface IRootQueryAllOffersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOfferFilter>;
}


export interface IRootQueryAllOffersSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOffersSectionFilter>;
}


export interface IRootQueryAllOpPricingRegionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOpPricingRegionFilter>;
}


export interface IRootQueryAllOurServicesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOurServicesFilter>;
}


export interface IRootQueryAllPickerAspectsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IPickerAspectFilter>;
}


export interface IRootQueryAllPickersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IPickerFilter>;
}


export interface IRootQueryAllPlaceholderFieldsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IPlaceholderFieldFilter>;
}


export interface IRootQueryAllPosConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IPosConfigurationFilter>;
}


export interface IRootQueryAllProductCategoriesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IProductCategoryFilter>;
}


export interface IRootQueryAllQuestTemplatesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IQuestTemplateFilter>;
}


export interface IRootQueryAllQuestionDetailsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IQuestionDetailsFilter>;
}


export interface IRootQueryAllQuestsSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IQuestsSectionFilter>;
}


export interface IRootQueryAllRecentItemsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRecentItemsFilter>;
}


export interface IRootQueryAllRemediationReasonsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRemediationReasonsFilter>;
}


export interface IRootQueryAllResponseDetailsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IResponseDetailsFilter>;
}


export interface IRootQueryAllRestaurantAmenitiesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRestaurantAmenityFilter>;
}


export interface IRootQueryAllRestaurantDeliveryProvidersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRestaurantDeliveryProviderFilter>;
}


export interface IRootQueryAllRestaurantGroupsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRestaurantGroupFilter>;
}


export interface IRootQueryAllRestaurantKioskDataArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRestaurantKioskDataFilter>;
}


export interface IRootQueryAllRestaurantPosDataArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRestaurantPosDataFilter>;
}


export interface IRootQueryAllRestaurantsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRestaurantFilter>;
}


export interface IRootQueryAllResultDetailsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IResultDetailsFilter>;
}


export interface IRootQueryAllRewardCategoriesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRewardCategoryFilter>;
}


export interface IRootQueryAllRewardListsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRewardListFilter>;
}


export interface IRootQueryAllRewardV2SArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRewardV2Filter>;
}


export interface IRootQueryAllRewardsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRewardFilter>;
}


export interface IRootQueryAllRewardsSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRewardsSectionFilter>;
}


export interface IRootQueryAllRollUpTheRimSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRollUpTheRimSectionFilter>;
}


export interface IRootQueryAllRollUpTheRimsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRollUpTheRimFilter>;
}


export interface IRootQueryAllSanityFileAssetsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISanityFileAssetFilter>;
}


export interface IRootQueryAllSanityImageAssetsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISanityImageAssetFilter>;
}


export interface IRootQueryAllSanityReleaseNotesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISanityReleaseNotesFilter>;
}


export interface IRootQueryAllSanityValidationConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISanityValidationConfigurationFilter>;
}


export interface IRootQueryAllScanForRewardsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IScanForRewardsFilter>;
}


export interface IRootQueryAllSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISectionFilter>;
}


export interface IRootQueryAllSimpleHomePagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISimpleHomePageFilter>;
}


export interface IRootQueryAllStaticPagesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IStaticPageFilter>;
}


export interface IRootQueryAllSupportCategoryGroupsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISupportCategoryGroupFilter>;
}


export interface IRootQueryAllSupportDataArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISupportDataFilter>;
}


export interface IRootQueryAllSupportFaqsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISupportFaqFilter>;
}


export interface IRootQueryAllSupportSubcategoriesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISupportSubcategoryFilter>;
}


export interface IRootQueryAllSwapMappingsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISwapMappingFilter>;
}


export interface IRootQueryAllSystemwideOfferV2SArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISystemwideOfferV2Filter>;
}


export interface IRootQueryAllSystemwideOffersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISystemwideOfferFilter>;
}


export interface IRootQueryAllSystemwidePromotionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISystemwidePromotionFilter>;
}


export interface IRootQueryAllSystemwideQuestsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ISystemwideQuestFilter>;
}


export interface IRootQueryAllTagsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ITagFilter>;
}


export interface IRootQueryAllTiersArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ITierFilter>;
}


export interface IRootQueryAllTimsRewardsPointsSectionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ITimsRewardsPointsSectionFilter>;
}


export interface IRootQueryAllTrendingsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ITrendingFilter>;
}

export interface IRoundingRules {
  readonly __typename?: 'RoundingRules';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The number of decimal places that will be shown in the app, e.g. 2.01 is two decimal places */
  readonly decimalPlaces?: Maybe<Scalars['Float']>;
  /** If true, enables rounding rules within the application */
  readonly enabled?: Maybe<Scalars['Boolean']>;
  /** The type of rounding that will be used on each nutrition value. Applied to the decimal place as specified in preceding rule. */
  readonly roundingType?: Maybe<Scalars['String']>;
}

export interface IRow {
  readonly __typename?: 'Row';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly columns?: Maybe<ReadonlyArray<Maybe<IColumn>>>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IRumConfig {
  readonly __typename?: 'RumConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly applicationId?: Maybe<Scalars['String']>;
  readonly clientToken?: Maybe<Scalars['String']>;
  readonly dataCenter?: Maybe<Scalars['String']>;
}

export interface IRutrFooter {
  readonly __typename?: 'RutrFooter';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly footerLinkLocalizedPath?: Maybe<ILocaleString>;
  readonly footerLinkText?: Maybe<ILocaleString>;
  readonly footerText?: Maybe<ILocaleString>;
  readonly footerTitle?: Maybe<ILocaleString>;
}

export interface ISanityAssetSourceData {
  readonly __typename?: 'SanityAssetSourceData';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  readonly id?: Maybe<Scalars['String']>;
  /** A canonical name for the source this asset is originating from */
  readonly name?: Maybe<Scalars['String']>;
  /** A URL to find more information about this asset in the originating source */
  readonly url?: Maybe<Scalars['String']>;
}

export interface ISanityFileAsset extends IDocument {
  readonly __typename?: 'SanityFileAsset';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly altText?: Maybe<Scalars['String']>;
  readonly assetId?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly extension?: Maybe<Scalars['String']>;
  readonly label?: Maybe<Scalars['String']>;
  readonly mimeType?: Maybe<Scalars['String']>;
  readonly originalFilename?: Maybe<Scalars['String']>;
  readonly path?: Maybe<Scalars['String']>;
  readonly sha1hash?: Maybe<Scalars['String']>;
  readonly size?: Maybe<Scalars['Float']>;
  readonly source?: Maybe<ISanityAssetSourceData>;
  readonly title?: Maybe<Scalars['String']>;
  readonly uploadId?: Maybe<Scalars['String']>;
  readonly url?: Maybe<Scalars['String']>;
}

export interface ISanityFileAssetFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly altText?: InputMaybe<Scalars['String']>;
  readonly altText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly altText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly altText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly altText_not?: InputMaybe<Scalars['String']>;
  readonly altText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly assetId?: InputMaybe<Scalars['String']>;
  readonly assetId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly assetId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly assetId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly assetId_not?: InputMaybe<Scalars['String']>;
  readonly assetId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly description?: InputMaybe<Scalars['String']>;
  readonly description_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly description_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly description_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly description_not?: InputMaybe<Scalars['String']>;
  readonly description_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly extension?: InputMaybe<Scalars['String']>;
  readonly extension_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly extension_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly extension_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly extension_not?: InputMaybe<Scalars['String']>;
  readonly extension_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly label?: InputMaybe<Scalars['String']>;
  readonly label_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly label_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly label_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly label_not?: InputMaybe<Scalars['String']>;
  readonly label_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly mimeType?: InputMaybe<Scalars['String']>;
  readonly mimeType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly mimeType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly mimeType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly mimeType_not?: InputMaybe<Scalars['String']>;
  readonly mimeType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly originalFilename?: InputMaybe<Scalars['String']>;
  readonly originalFilename_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly originalFilename_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly originalFilename_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly originalFilename_not?: InputMaybe<Scalars['String']>;
  readonly originalFilename_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly path?: InputMaybe<Scalars['String']>;
  readonly path_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly path_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly path_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly path_not?: InputMaybe<Scalars['String']>;
  readonly path_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sha1hash?: InputMaybe<Scalars['String']>;
  readonly sha1hash_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sha1hash_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sha1hash_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sha1hash_not?: InputMaybe<Scalars['String']>;
  readonly sha1hash_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly size?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly size_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly size_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly size_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly size_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly size_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly size_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly title?: InputMaybe<Scalars['String']>;
  readonly title_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly title_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly title_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly title_not?: InputMaybe<Scalars['String']>;
  readonly title_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly uploadId?: InputMaybe<Scalars['String']>;
  readonly uploadId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uploadId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uploadId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uploadId_not?: InputMaybe<Scalars['String']>;
  readonly uploadId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly url?: InputMaybe<Scalars['String']>;
  readonly url_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly url_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly url_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly url_not?: InputMaybe<Scalars['String']>;
  readonly url_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ISanityImageAsset extends IDocument {
  readonly __typename?: 'SanityImageAsset';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly altText?: Maybe<Scalars['String']>;
  readonly assetId?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly extension?: Maybe<Scalars['String']>;
  readonly label?: Maybe<Scalars['String']>;
  readonly metadata?: Maybe<ISanityImageMetadata>;
  readonly mimeType?: Maybe<Scalars['String']>;
  readonly originalFilename?: Maybe<Scalars['String']>;
  readonly path?: Maybe<Scalars['String']>;
  readonly sha1hash?: Maybe<Scalars['String']>;
  readonly size?: Maybe<Scalars['Float']>;
  readonly source?: Maybe<ISanityAssetSourceData>;
  readonly title?: Maybe<Scalars['String']>;
  readonly uploadId?: Maybe<Scalars['String']>;
  readonly url?: Maybe<Scalars['String']>;
}

export interface ISanityImageAssetFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly altText?: InputMaybe<Scalars['String']>;
  readonly altText_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly altText_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly altText_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly altText_not?: InputMaybe<Scalars['String']>;
  readonly altText_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly assetId?: InputMaybe<Scalars['String']>;
  readonly assetId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly assetId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly assetId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly assetId_not?: InputMaybe<Scalars['String']>;
  readonly assetId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly description?: InputMaybe<Scalars['String']>;
  readonly description_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly description_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly description_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly description_not?: InputMaybe<Scalars['String']>;
  readonly description_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly extension?: InputMaybe<Scalars['String']>;
  readonly extension_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly extension_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly extension_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly extension_not?: InputMaybe<Scalars['String']>;
  readonly extension_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly label?: InputMaybe<Scalars['String']>;
  readonly label_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly label_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly label_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly label_not?: InputMaybe<Scalars['String']>;
  readonly label_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly mimeType?: InputMaybe<Scalars['String']>;
  readonly mimeType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly mimeType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly mimeType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly mimeType_not?: InputMaybe<Scalars['String']>;
  readonly mimeType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly originalFilename?: InputMaybe<Scalars['String']>;
  readonly originalFilename_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly originalFilename_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly originalFilename_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly originalFilename_not?: InputMaybe<Scalars['String']>;
  readonly originalFilename_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly path?: InputMaybe<Scalars['String']>;
  readonly path_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly path_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly path_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly path_not?: InputMaybe<Scalars['String']>;
  readonly path_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sha1hash?: InputMaybe<Scalars['String']>;
  readonly sha1hash_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sha1hash_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sha1hash_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sha1hash_not?: InputMaybe<Scalars['String']>;
  readonly sha1hash_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly size?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly size_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly size_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly size_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly size_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly size_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly size_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly title?: InputMaybe<Scalars['String']>;
  readonly title_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly title_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly title_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly title_not?: InputMaybe<Scalars['String']>;
  readonly title_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly uploadId?: InputMaybe<Scalars['String']>;
  readonly uploadId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uploadId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uploadId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uploadId_not?: InputMaybe<Scalars['String']>;
  readonly uploadId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly url?: InputMaybe<Scalars['String']>;
  readonly url_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly url_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly url_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly url_not?: InputMaybe<Scalars['String']>;
  readonly url_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly bottom?: Maybe<Scalars['Float']>;
  readonly left?: Maybe<Scalars['Float']>;
  readonly right?: Maybe<Scalars['Float']>;
  readonly top?: Maybe<Scalars['Float']>;
}

export interface ISanityImageDimensions {
  readonly __typename?: 'SanityImageDimensions';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly aspectRatio?: Maybe<Scalars['Float']>;
  readonly height?: Maybe<Scalars['Float']>;
  readonly width?: Maybe<Scalars['Float']>;
}

export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly height?: Maybe<Scalars['Float']>;
  readonly width?: Maybe<Scalars['Float']>;
  readonly x?: Maybe<Scalars['Float']>;
  readonly y?: Maybe<Scalars['Float']>;
}

export interface ISanityImageMetadata {
  readonly __typename?: 'SanityImageMetadata';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly blurHash?: Maybe<Scalars['String']>;
  readonly dimensions?: Maybe<ISanityImageDimensions>;
  readonly hasAlpha?: Maybe<Scalars['Boolean']>;
  readonly isOpaque?: Maybe<Scalars['Boolean']>;
  readonly location?: Maybe<IGeopoint>;
  readonly lqip?: Maybe<Scalars['String']>;
  readonly palette?: Maybe<ISanityImagePalette>;
}

export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly darkMuted?: Maybe<ISanityImagePaletteSwatch>;
  readonly darkVibrant?: Maybe<ISanityImagePaletteSwatch>;
  readonly dominant?: Maybe<ISanityImagePaletteSwatch>;
  readonly lightMuted?: Maybe<ISanityImagePaletteSwatch>;
  readonly lightVibrant?: Maybe<ISanityImagePaletteSwatch>;
  readonly muted?: Maybe<ISanityImagePaletteSwatch>;
  readonly vibrant?: Maybe<ISanityImagePaletteSwatch>;
}

export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly background?: Maybe<Scalars['String']>;
  readonly foreground?: Maybe<Scalars['String']>;
  readonly population?: Maybe<Scalars['Float']>;
  readonly title?: Maybe<Scalars['String']>;
}

export interface ISanityReleaseNotes extends IDocument {
  readonly __typename?: 'SanityReleaseNotes';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly releaseDate?: Maybe<Scalars['Date']>;
  readonly releaseNotesRaw?: Maybe<Scalars['JSON']>;
  readonly syncReleaseNotes?: Maybe<Scalars['String']>;
}

export interface ISanityReleaseNotesFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly releaseDate?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly releaseDate_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly releaseDate_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly releaseDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly releaseDate_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly releaseDate_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly releaseDate_not?: InputMaybe<Scalars['Date']>;
  /** All documents that are equal to given value */
  readonly syncReleaseNotes?: InputMaybe<Scalars['String']>;
  readonly syncReleaseNotes_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly syncReleaseNotes_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly syncReleaseNotes_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly syncReleaseNotes_not?: InputMaybe<Scalars['String']>;
  readonly syncReleaseNotes_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ISanityValidationConfiguration extends IDocument {
  readonly __typename?: 'SanityValidationConfiguration';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly clearValidationsButton?: Maybe<Scalars['String']>;
  readonly pricingDistributionValidation?: Maybe<IPosValidationThreshold>;
  readonly restaurantAvailabilityValidation?: Maybe<IPosValidationThreshold>;
}

export interface ISanityValidationConfigurationFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly clearValidationsButton?: InputMaybe<Scalars['String']>;
  readonly clearValidationsButton_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly clearValidationsButton_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly clearValidationsButton_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly clearValidationsButton_not?: InputMaybe<Scalars['String']>;
  readonly clearValidationsButton_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface IScanForRewards extends IDocument {
  readonly __typename?: 'ScanForRewards';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface IScanForRewardsFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ISection extends IDocument {
  readonly __typename?: 'Section';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly carouselImage?: Maybe<IImage>;
  readonly carouselImageDescription?: Maybe<ILocaleString>;
  readonly channelExclusions?: Maybe<IChannelExclusions>;
  readonly contentOptions?: Maybe<ReadonlyArray<Maybe<IContentOption>>>;
  readonly daypart?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly dmbName?: Maybe<ILocaleString>;
  readonly headerSuperText?: Maybe<ILocaleString>;
  readonly headerText?: Maybe<ILocaleString>;
  /** Use this toggle to hide this section from main menu UI */
  readonly hiddenFromMainMenu?: Maybe<Scalars['Boolean']>;
  readonly image?: Maybe<IImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly images?: Maybe<IImages>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** Is Burgers for Breakfast Section */
  readonly isBurgersForBreakfastSection?: Maybe<Scalars['Boolean']>;
  /** Is a Real Meal Section? */
  readonly isRealMeal?: Maybe<Scalars['Boolean']>;
  readonly kioskImage?: Maybe<IImage>;
  readonly kioskImageDescription?: Maybe<ILocaleString>;
  readonly name?: Maybe<ILocaleString>;
  readonly options?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>;
  /** This field is only for UI purposes. Adding a promotion reference here will make possible to show a bonus point badges in menu pages. The validation of this field will not take care of rules evaluation, so before adding any promotion here, please verify the promotion is still valid to avoid a bad UX. */
  readonly promotion?: Maybe<ISystemwidePromotion>;
  readonly redirectLink?: Maybe<ILocaleUrl>;
  /** Show section in static menu */
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>;
  readonly simplyMenuImage?: Maybe<IImage>;
  readonly simplyMenuShortName?: Maybe<ILocaleString>;
  readonly slug?: Maybe<ISlug>;
  readonly uiPattern?: Maybe<Scalars['String']>;
}

export interface ISectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly hiddenFromMainMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly hiddenFromMainMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly hiddenFromMainMenu_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly isBurgersForBreakfastSection?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isBurgersForBreakfastSection_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isBurgersForBreakfastSection_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly isRealMeal?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly isRealMeal_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly isRealMeal_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly promotion?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly showInStaticMenu?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly showInStaticMenu_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly showInStaticMenu_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IServiceModeRestrictions {
  readonly __typename?: 'ServiceModeRestrictions';
  readonly CATERING_DELIVERY?: Maybe<Scalars['Boolean']>;
  readonly CATERING_PICKUP?: Maybe<Scalars['Boolean']>;
  readonly CURBSIDE?: Maybe<Scalars['Boolean']>;
  readonly DELIVERY?: Maybe<Scalars['Boolean']>;
  readonly DRIVE_THRU?: Maybe<Scalars['Boolean']>;
  readonly EAT_IN?: Maybe<Scalars['Boolean']>;
  readonly TABLE_SERVICE?: Maybe<Scalars['Boolean']>;
  readonly TAKEOUT?: Maybe<Scalars['Boolean']>;
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
}

export interface IShortCodeConfirmationModalContent {
  readonly __typename?: 'ShortCodeConfirmationModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly actionButton?: Maybe<IActionButton>;
  readonly body?: Maybe<ILocaleString>;
  readonly dismissButtonText?: Maybe<ILocaleString>;
  readonly header?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImages>;
}

export interface ISignUpTerms {
  readonly __typename?: 'SignUpTerms';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly signUpTermsCells?: Maybe<ReadonlyArray<Maybe<ISignUpTermsCell>>>;
}

export interface ISignUpTermsCell {
  readonly __typename?: 'SignUpTermsCell';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly signUpTermsCellDescription?: Maybe<Scalars['String']>;
  readonly signUpTermsCellDisplayedText?: Maybe<ILocaleString>;
  readonly signUpTermsCellIsRequired?: Maybe<Scalars['Boolean']>;
  readonly signUpTermsCellTitle?: Maybe<Scalars['String']>;
  readonly signUpTermsCellUrl?: Maybe<ILocaleString>;
}

export interface ISimpleCard {
  readonly __typename?: 'SimpleCard';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly image?: Maybe<IImage>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ISimpleHomePage extends IDocument {
  readonly __typename?: 'SimpleHomePage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly altImageText?: Maybe<ILocaleString>;
  readonly desktopImage?: Maybe<ILocaleImage>;
  readonly header?: Maybe<ILocaleString>;
  readonly mobileImage?: Maybe<ILocaleImage>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface ISimpleHomePageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly comboPlu?: Maybe<Scalars['String']>;
  /** Only used for BK, to distinguish between different combo sizes. */
  readonly comboSize?: Maybe<Scalars['String']>;
}

export interface ISkillsTest {
  readonly __typename?: 'SkillsTest';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly answersList?: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
  /** This is the correct answer to the math question. */
  readonly correctAnswer?: Maybe<Scalars['Float']>;
  readonly mathBlock?: Maybe<ILocaleBlockContent>;
}

export interface ISlug {
  readonly __typename?: 'Slug';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly current?: Maybe<Scalars['String']>;
  readonly source?: Maybe<Scalars['String']>;
}

export interface ISocialIconsWidget {
  readonly __typename?: 'SocialIconsWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly facebookUrl?: Maybe<ILocaleUrl>;
  readonly instagramUrl?: Maybe<ILocaleUrl>;
  readonly linkedinUrl?: Maybe<ILocaleUrl>;
  readonly snapchatUrl?: Maybe<ILocaleUrl>;
  readonly tiktokUrl?: Maybe<ILocaleUrl>;
  readonly twitterUrl?: Maybe<ILocaleUrl>;
  readonly youtubeUrl?: Maybe<ILocaleUrl>;
}

export interface ISocialIconsWithHeaderWidget {
  readonly __typename?: 'SocialIconsWithHeaderWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly header?: Maybe<ILocaleString>;
  readonly socialIconsWidget?: Maybe<ISocialIconsWidget>;
}

export interface ISocialLoginAppleConfig {
  readonly __typename?: 'SocialLoginAppleConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The developer’s client identifier, as provided by WWDR. */
  readonly clientId?: Maybe<Scalars['String']>;
  /** The redirect URIs are the endpoints to which the authentication server can send responses. */
  readonly redirectURI?: Maybe<Scalars['String']>;
}

export interface ISocialLoginFacebookConfig {
  readonly __typename?: 'SocialLoginFacebookConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Unique number that identifies your app */
  readonly appId?: Maybe<Scalars['String']>;
  /** The redirect URIs are the endpoints to which the authentication server can send responses. */
  readonly redirectURI?: Maybe<Scalars['String']>;
}

export interface ISocialLoginGoogleConfig {
  readonly __typename?: 'SocialLoginGoogleConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Unique number that identifies your app */
  readonly clientId?: Maybe<Scalars['String']>;
  /** The redirect URIs are the endpoints to which the authentication server can send responses. */
  readonly redirectURI?: Maybe<Scalars['String']>;
}

export interface ISpan {
  readonly __typename?: 'Span';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly marks?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly text?: Maybe<Scalars['String']>;
}

export interface IStaticPage extends IDocument {
  readonly __typename?: 'StaticPage';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly displayIndex?: Maybe<Scalars['Float']>;
  readonly image?: Maybe<IImage>;
  readonly includedInSitemap?: Maybe<Scalars['Boolean']>;
  readonly localePath?: Maybe<ILocaleSlug>;
  readonly localeTitle?: Maybe<ILocaleString>;
  readonly pageCSS?: Maybe<ICss>;
  readonly pageHtml?: Maybe<IHtml>;
  readonly pageVariablesRaw?: Maybe<Scalars['JSON']>;
  readonly parent?: Maybe<IStaticPage>;
  readonly path?: Maybe<ISlug>;
  readonly redirectUrl?: Maybe<ILocaleString>;
  readonly requiredUserAcceptance?: Maybe<Scalars['Boolean']>;
  readonly title?: Maybe<Scalars['String']>;
  readonly vendorId?: Maybe<Scalars['String']>;
  readonly vendorRedirectPath?: Maybe<ILocaleString>;
  readonly widgets?: Maybe<ReadonlyArray<Maybe<IAccordionWidgetOrAnchorLinksWidgetOrAnchorWidgetOrCallToActionWidgetOrDoubleImageWidgetOrDownloadFileWidgetOrHeaderWidgetOrImageWidgetOrLocaleBlockTextWidgetOrMultiWidgetOrNutritionExplorerWidgetOrNutritionInfoWidgetOrPreviewWidgetOrQuoteWidgetOrRewardsCarouselWidgetOrVideoWidgetOrWebViewWidgetOrYoutubeWidget>>>;
}

export interface IStaticPageFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly displayIndex?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly displayIndex_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly displayIndex_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly displayIndex_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly displayIndex_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly displayIndex_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly displayIndex_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly includedInSitemap?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly includedInSitemap_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly includedInSitemap_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly parent?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly requiredUserAcceptance?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly requiredUserAcceptance_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly requiredUserAcceptance_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly title?: InputMaybe<Scalars['String']>;
  readonly title_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly title_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly title_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly title_not?: InputMaybe<Scalars['String']>;
  readonly title_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly vendorId?: InputMaybe<Scalars['String']>;
  readonly vendorId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly vendorId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly vendorId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly vendorId_not?: InputMaybe<Scalars['String']>;
  readonly vendorId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IStepperDiscount {
  readonly __typename?: 'StepperDiscount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly tiers?: Maybe<ReadonlyArray<Maybe<IOfferTier>>>;
}

export interface IStoreLocatorContent {
  readonly __typename?: 'StoreLocatorContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly findStoresCard?: Maybe<ITextCard>;
  readonly noStoresCard?: Maybe<ITextCard>;
  readonly searchThisAreaButtonLabel?: Maybe<ILocaleString>;
  readonly tabsContent?: Maybe<ITabsContent>;
  readonly tabsStoreLocatorContent?: Maybe<ITabsStoreLocatorContent>;
}

export interface ISubtotalSpend {
  readonly __typename?: 'SubtotalSpend';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Minimum subtotal spend in cents in the cart */
  readonly minimumSpend?: Maybe<Scalars['Float']>;
}

export interface ISupportCategory {
  readonly __typename?: 'SupportCategory';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly directTicketProcessingPercentage?: Maybe<Scalars['Float']>;
  readonly knowledgeForceIssueId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
}

export interface ISupportCategoryGroup extends IDocument {
  readonly __typename?: 'SupportCategoryGroup';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly guestTicketingMiddlewareRedirect?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  readonly showRestaurantSelector?: Maybe<Scalars['Boolean']>;
  readonly supportSubcategories?: Maybe<ReadonlyArray<Maybe<ISupportSubcategory>>>;
  readonly suppotCategoryFaqs?: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>;
}

export interface ISupportCategoryGroupFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly guestTicketingMiddlewareRedirect?: InputMaybe<Scalars['String']>;
  readonly guestTicketingMiddlewareRedirect_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly guestTicketingMiddlewareRedirect_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly guestTicketingMiddlewareRedirect_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly guestTicketingMiddlewareRedirect_not?: InputMaybe<Scalars['String']>;
  readonly guestTicketingMiddlewareRedirect_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly showRestaurantSelector?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly showRestaurantSelector_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly showRestaurantSelector_not?: InputMaybe<Scalars['Boolean']>;
}

export interface ISupportCategorySubTypes {
  readonly __typename?: 'SupportCategorySubTypes';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly directTicketProcessingPercentage?: Maybe<Scalars['Float']>;
  readonly knowledgeForceIssueId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
}

export interface ISupportCategoryTypes {
  readonly __typename?: 'SupportCategoryTypes';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  readonly supportCategorySubTypes?: Maybe<ReadonlyArray<Maybe<ISupportCategorySubTypes>>>;
}

export interface ISupportData extends IDocument {
  readonly __typename?: 'SupportData';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly categories?: Maybe<ReadonlyArray<Maybe<ISupportCategory>>>;
  readonly deliveryMissingItemsSubcategory?: Maybe<ISupportSubcategory>;
  readonly deliveryNeverArriveSubcategory?: Maybe<ISupportSubcategory>;
  /** A support category group for customers who need general help with an order they've placed. */
  readonly orderingIssuesCategoryGroup?: Maybe<ISupportCategoryGroup>;
  readonly supportCategories?: Maybe<ReadonlyArray<Maybe<ISupportCategoryTypes>>>;
  readonly supportCategoryGroups?: Maybe<ReadonlyArray<Maybe<ISupportCategoryGroup>>>;
  readonly supportDataFaqs?: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>;
  readonly supportFaqs?: Maybe<ReadonlyArray<Maybe<ISupportFaqs>>>;
  /** Choose the subcategory used by customers to request date of birth changes. This subcategory will only be visible to signed-in customers (signed-out customers can't make this request). */
  readonly updateDateOfBirthSubcategory?: Maybe<ISupportSubcategory>;
}

export interface ISupportDataFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  readonly deliveryMissingItemsSubcategory?: InputMaybe<Scalars['ID']>;
  readonly deliveryNeverArriveSubcategory?: InputMaybe<Scalars['ID']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  readonly orderingIssuesCategoryGroup?: InputMaybe<Scalars['ID']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  readonly updateDateOfBirthSubcategory?: InputMaybe<Scalars['ID']>;
}

export interface ISupportFaq extends IDocument {
  readonly __typename?: 'SupportFaq';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly supportFaqContent?: Maybe<ILocaleBlockContent>;
  /** Name of the mParticle event emitted when expanded for the first time. */
  readonly supportFaqMParticleEvent?: Maybe<Scalars['String']>;
  readonly supportFaqTitle?: Maybe<ILocaleString>;
}

export interface ISupportFaqFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly supportFaqMParticleEvent?: InputMaybe<Scalars['String']>;
  readonly supportFaqMParticleEvent_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly supportFaqMParticleEvent_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly supportFaqMParticleEvent_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly supportFaqMParticleEvent_not?: InputMaybe<Scalars['String']>;
  readonly supportFaqMParticleEvent_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ISupportFaqs {
  readonly __typename?: 'SupportFaqs';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly accordionWidget?: Maybe<IAccordionWidget>;
  readonly key?: Maybe<Scalars['String']>;
}

export interface ISupportSubcategory extends IDocument {
  readonly __typename?: 'SupportSubcategory';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly directTicketProcessingPercentage?: Maybe<Scalars['Float']>;
  readonly knowledgeForceIssueId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<ILocaleString>;
  /** FAQ linked to this support subcategory */
  readonly supportSubcategoryFaq?: Maybe<ISupportFaq>;
  readonly supportSubcategoryFaqs?: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>;
  /** When selected, this subcategory will forward the customer to recent orders selection. */
  readonly supportSubcategoryForwardToOrders?: Maybe<Scalars['Boolean']>;
  /** When selected, this subcategory will provide the user with a dropdown menu to specify the service mode of their order, but only when there is no order with a service mode available. */
  readonly supportSubcategoryServiceModeSelector?: Maybe<Scalars['Boolean']>;
  /** When selected, support form submissions in this subcategory will be sent to External Partners rather than Zendesk. */
  readonly supportSubcategorySubmitToExternalPartners?: Maybe<Scalars['Boolean']>;
  /** When selected, support form submissions in this subcategory will be sent to Sutherland rather than Zendesk. This is intended for guest support issues. */
  readonly supportSubcategorySubmitToSutherland?: Maybe<Scalars['Boolean']>;
}

export interface ISupportSubcategoryFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly directTicketProcessingPercentage?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly directTicketProcessingPercentage_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly directTicketProcessingPercentage_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly directTicketProcessingPercentage_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly directTicketProcessingPercentage_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly directTicketProcessingPercentage_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly directTicketProcessingPercentage_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly knowledgeForceIssueId?: InputMaybe<Scalars['String']>;
  readonly knowledgeForceIssueId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly knowledgeForceIssueId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly knowledgeForceIssueId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly knowledgeForceIssueId_not?: InputMaybe<Scalars['String']>;
  readonly knowledgeForceIssueId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  readonly supportSubcategoryFaq?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly supportSubcategoryForwardToOrders?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly supportSubcategoryForwardToOrders_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly supportSubcategoryForwardToOrders_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly supportSubcategoryServiceModeSelector?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly supportSubcategoryServiceModeSelector_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly supportSubcategoryServiceModeSelector_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly supportSubcategorySubmitToExternalPartners?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly supportSubcategorySubmitToExternalPartners_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly supportSubcategorySubmitToExternalPartners_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly supportSubcategorySubmitToSutherland?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly supportSubcategorySubmitToSutherland_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly supportSubcategorySubmitToSutherland_not?: InputMaybe<Scalars['Boolean']>;
}

export interface ISurpriseAndDelightModalContent {
  readonly __typename?: 'SurpriseAndDelightModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly backgroundImage?: Maybe<ILocaleImage>;
  readonly buttonText?: Maybe<ILocaleString>;
  readonly description?: Maybe<ILocaleString>;
  readonly noThanksText?: Maybe<ILocaleString>;
  readonly prompt?: Maybe<ILocaleString>;
  readonly termsText?: Maybe<ILocaleBlockContent>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ISwap {
  readonly __typename?: 'Swap';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** If this item is added to cart... */
  readonly initialItem?: Maybe<IComboOrItem>;
  /** Type of swap */
  readonly swapType?: Maybe<Scalars['String']>;
  /** User can swap to this instead */
  readonly swappedItem?: Maybe<IComboOrItem>;
}

export interface ISwapMapping extends IDocument {
  readonly __typename?: 'SwapMapping';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly eligibleSwaps?: Maybe<ReadonlyArray<Maybe<ISwap>>>;
  /** Only used internally */
  readonly internalName?: Maybe<Scalars['String']>;
}

export interface ISwapMappingFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ISwapModalContent {
  readonly __typename?: 'SwapModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly description?: Maybe<ILocaleString>;
  readonly itemSelectionHeader?: Maybe<ILocaleString>;
  readonly noThanksButtonText?: Maybe<ILocaleString>;
  readonly swapButtonText?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ISystemwideOffer extends IDocument {
  readonly __typename?: 'SystemwideOffer';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly backgroundImage?: Maybe<IImage>;
  /** This incentive will only be displayed to a user if set by personalization */
  readonly configOnly?: Maybe<Scalars['Boolean']>;
  readonly daypart?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly howToRedeem?: Maybe<ILocaleBlockContent>;
  readonly inStoreBenefits?: Maybe<ReadonlyArray<Maybe<IComboOrItemOrPicker>>>;
  readonly incentives?: Maybe<ReadonlyArray<Maybe<IComboOrFeesV1DiscountOrItemOrItemGroupDiscountOrOfferActivationOrOfferDiscountOrPickerOrSwapMapping>>>;
  readonly internalName?: Maybe<Scalars['String']>;
  readonly localizedImage?: Maybe<ILocaleImages>;
  readonly lockedOffersPanel?: Maybe<ILockedOffersPanel>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  /** If offer should display the market price of an item (ie: BOGO) link the menu item here */
  readonly marketPrice?: Maybe<IComboOrItem>;
  /** When true, guest will not have option to redeem in-rest */
  readonly mobileOrderOnly?: Maybe<Scalars['Boolean']>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  readonly name?: Maybe<ILocaleBlockContent>;
  readonly notificationDetails?: Maybe<INotificationDetails>;
  /** This represents the price of the offer. Price must be entered in cents. For BOGO offers, the offer price should be entered as 0 */
  readonly offerPrice?: Maybe<Scalars['Float']>;
  /** This represents the PMIX product number */
  readonly pmixId?: Maybe<Scalars['String']>;
  /** Position will be personalized by SSE */
  readonly position?: Maybe<Scalars['Boolean']>;
  readonly pricingDistributionValidation?: Maybe<IDataValidationObject>;
  readonly pricingPermutationValidation?: Maybe<IDataValidationObject>;
  readonly promoCodePanel?: Maybe<IPromoCodePanel>;
  /** Specify the Order redemption method. */
  readonly redemptionMethod?: Maybe<Scalars['String']>;
  /** Controls where/how the user redeems this offer */
  readonly redemptionType?: Maybe<Scalars['String']>;
  readonly restaurantAvailabilityValidation?: Maybe<IDataValidationObject>;
  readonly rules?: Maybe<ReadonlyArray<Maybe<IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated>>>;
  /** Configure the code used for in restaurant redemption. */
  readonly shortCode?: Maybe<Scalars['String']>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
  /** Configure UI pattern to show on the frontend */
  readonly uiPattern?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
  /** When true, this item will be assigned to new users */
  readonly welcomeOffer?: Maybe<Scalars['Boolean']>;
}

export interface ISystemwideOfferFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly configOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly configOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly configOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly marketPrice?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly mobileOrderOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly mobileOrderOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly mobileOrderOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly offerPrice?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly offerPrice_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly offerPrice_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly offerPrice_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly offerPrice_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly offerPrice_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly offerPrice_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly pmixId?: InputMaybe<Scalars['String']>;
  readonly pmixId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly pmixId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly pmixId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly pmixId_not?: InputMaybe<Scalars['String']>;
  readonly pmixId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly position?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly position_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly position_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly redemptionMethod?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly redemptionMethod_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly redemptionMethod_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly redemptionMethod_not?: InputMaybe<Scalars['String']>;
  readonly redemptionMethod_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly redemptionType?: InputMaybe<Scalars['String']>;
  readonly redemptionType_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly redemptionType_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly redemptionType_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly redemptionType_not?: InputMaybe<Scalars['String']>;
  readonly redemptionType_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly shortCode?: InputMaybe<Scalars['String']>;
  readonly shortCode_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly shortCode_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly shortCode_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly shortCode_not?: InputMaybe<Scalars['String']>;
  readonly shortCode_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly uiPattern?: InputMaybe<Scalars['String']>;
  readonly uiPattern_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly uiPattern_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly uiPattern_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly uiPattern_not?: InputMaybe<Scalars['String']>;
  readonly uiPattern_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly welcomeOffer?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly welcomeOffer_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly welcomeOffer_not?: InputMaybe<Scalars['Boolean']>;
}

export interface ISystemwideOfferV2 extends IDocument {
  readonly __typename?: 'SystemwideOfferV2';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly content?: Maybe<IOffersV2Content>;
  readonly internal?: Maybe<IOffersV2Internal>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly mechanics?: Maybe<IOffersV2Mechanics>;
  /** Switch this value to show systemwide offer on the app */
  readonly systemWideActive?: Maybe<Scalars['Boolean']>;
}

export interface ISystemwideOfferV2Filter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly systemWideActive?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly systemWideActive_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly systemWideActive_not?: InputMaybe<Scalars['Boolean']>;
}

export interface ISystemwidePromotion extends IDocument {
  readonly __typename?: 'SystemwidePromotion';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly bonusPoints?: Maybe<Scalars['Float']>;
  readonly desktopImage?: Maybe<ILocaleImage>;
  /** Deprecated - Please use the between-dates rule to add an end date */
  readonly endDate?: Maybe<Scalars['DateTime']>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly mobileImage?: Maybe<ILocaleImage>;
  /** This is an internal name only */
  readonly name?: Maybe<Scalars['String']>;
  readonly notificationDetails?: Maybe<INotificationDetails>;
  readonly pointsMultiplier?: Maybe<Scalars['Float']>;
  readonly promoMessage?: Maybe<ILocaleString>;
  /** Deprecated - Please use the between-dates rule to add a start date */
  readonly startDate?: Maybe<Scalars['DateTime']>;
  readonly systemwidePromotion?: Maybe<ReadonlyArray<Maybe<IBirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementExclusionOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrFirstOrderOnlyOrIncentiveRequirementOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRestaurantGroupRestrictionsOrRestaurantRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserAttributesOrUserCreated>>>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
}

export interface ISystemwidePromotionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly bonusPoints?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly bonusPoints_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly bonusPoints_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly bonusPoints_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly bonusPoints_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly bonusPoints_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly bonusPoints_not?: InputMaybe<Scalars['Float']>;
  /** All documents that are equal to given value */
  readonly endDate?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly endDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly endDate_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly name_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly name_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly name_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly name_not?: InputMaybe<Scalars['String']>;
  readonly name_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly pointsMultiplier?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly pointsMultiplier_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly pointsMultiplier_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly pointsMultiplier_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly pointsMultiplier_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly pointsMultiplier_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly pointsMultiplier_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly startDate?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly startDate_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly startDate_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
}

export interface ISystemwideQuest extends IDocument {
  readonly __typename?: 'SystemwideQuest';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly cardImage?: Maybe<ILocaleImage>;
  readonly completedState?: Maybe<ICompletedState>;
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly howToRedeem?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<ILocaleImage>;
  readonly imageDescription?: Maybe<ILocaleString>;
  readonly incentive?: Maybe<IQuestIncentive>;
  readonly internalName?: Maybe<Scalars['String']>;
  /** If filled when data is migrated, record already exists in Engine */
  readonly loyaltyEngineId?: Maybe<Scalars['String']>;
  readonly moreInfo?: Maybe<ILocaleBlockContent>;
  readonly mustActivateBy?: Maybe<Scalars['Date']>;
  readonly name?: Maybe<ILocaleString>;
  readonly questRules?: Maybe<IQuestRules>;
  readonly rules?: Maybe<ReadonlyArray<Maybe<IEmailVerifiedRequiredOrLimitOrLoyaltyBetweenDatesOrRequiresAuthenticationOrUserCreated>>>;
  /** When false, this item will be visible in production */
  readonly testOnly?: Maybe<Scalars['Boolean']>;
}

export interface ISystemwideQuestFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly internalName?: InputMaybe<Scalars['String']>;
  readonly internalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly internalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly internalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly internalName_not?: InputMaybe<Scalars['String']>;
  readonly internalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly loyaltyEngineId?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly loyaltyEngineId_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly loyaltyEngineId_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly loyaltyEngineId_not?: InputMaybe<Scalars['String']>;
  readonly loyaltyEngineId_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly mustActivateBy?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than given value */
  readonly mustActivateBy_gt?: InputMaybe<Scalars['Date']>;
  /** All documents are greater than or equal to given value */
  readonly mustActivateBy_gte?: InputMaybe<Scalars['Date']>;
  /** All documents that have a value for this field */
  readonly mustActivateBy_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly mustActivateBy_lt?: InputMaybe<Scalars['Date']>;
  /** All documents are less than or equal to given value */
  readonly mustActivateBy_lte?: InputMaybe<Scalars['Date']>;
  /** All documents that are not equal to given value */
  readonly mustActivateBy_not?: InputMaybe<Scalars['Date']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly testOnly?: InputMaybe<Scalars['Boolean']>;
  /** All documents that have a value for this field */
  readonly testOnly_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are not equal to given value */
  readonly testOnly_not?: InputMaybe<Scalars['Boolean']>;
}

export interface ITabDetailContent {
  readonly __typename?: 'TabDetailContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly image?: Maybe<ILocaleImage>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ITabsContent {
  readonly __typename?: 'TabsContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly favoritesTab?: Maybe<ITitleAndBody>;
  readonly nearbyTab?: Maybe<ITitleAndBody>;
  readonly recentTab?: Maybe<ITitleAndBody>;
}

export interface ITabsStoreLocatorContent {
  readonly __typename?: 'TabsStoreLocatorContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly favoritesTab?: Maybe<ITabDetailContent>;
  readonly nearbyTab?: Maybe<ITabDetailContent>;
  readonly recentTab?: Maybe<ITabDetailContent>;
}

export interface ITag extends IDocument {
  readonly __typename?: 'Tag';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly value?: Maybe<Scalars['String']>;
}

export interface ITagFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly value?: InputMaybe<Scalars['String']>;
  readonly value_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly value_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly value_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly value_not?: InputMaybe<Scalars['String']>;
  readonly value_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ITastySwap {
  readonly __typename?: 'TastySwap';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The product the user is looking at */
  readonly selectedProduct?: Maybe<IComboOrItem>;
  /** The product we propose instead */
  readonly suggestedProduct?: Maybe<IComboOrItem>;
  readonly swapTitle?: Maybe<ILocaleString>;
}

export interface ITastySwaps {
  readonly __typename?: 'TastySwaps';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly mainSubtitle?: Maybe<ILocaleString>;
  readonly mainTitle?: Maybe<ILocaleString>;
  readonly modalSubtitle?: Maybe<ILocaleString>;
  readonly modalTitle?: Maybe<ILocaleString>;
  readonly swaps?: Maybe<ReadonlyArray<Maybe<ITastySwap>>>;
}

export interface ITextCard {
  readonly __typename?: 'TextCard';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly heading?: Maybe<ILocaleString>;
  readonly superHeading?: Maybe<ILocaleString>;
}

export interface ITextWidget {
  readonly __typename?: 'TextWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly text?: Maybe<ILocaleString>;
}

export interface ITextWidgetWithUrl {
  readonly __typename?: 'TextWidgetWithUrl';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly text?: Maybe<ILocaleString>;
  readonly textUrl?: Maybe<ILocaleString>;
  readonly url?: Maybe<ILocaleString>;
}

export interface ITier extends IDocument {
  readonly __typename?: 'Tier';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly description?: Maybe<ILocaleBlockContent>;
  readonly image?: Maybe<IImage>;
  readonly name?: Maybe<ILocaleString>;
  readonly points?: Maybe<Scalars['Float']>;
}

export interface ITierFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents that are equal to given value */
  readonly points?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than given value */
  readonly points_gt?: InputMaybe<Scalars['Float']>;
  /** All documents are greater than or equal to given value */
  readonly points_gte?: InputMaybe<Scalars['Float']>;
  /** All documents that have a value for this field */
  readonly points_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly points_lt?: InputMaybe<Scalars['Float']>;
  /** All documents are less than or equal to given value */
  readonly points_lte?: InputMaybe<Scalars['Float']>;
  /** All documents that are not equal to given value */
  readonly points_not?: InputMaybe<Scalars['Float']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
}

export interface ITimeRange {
  readonly __typename?: 'TimeRange';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly endTime?: Maybe<Scalars['String']>;
  readonly startTime?: Maybe<Scalars['String']>;
}

export interface ITimelineComponents {
  readonly __typename?: 'TimelineComponents';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly buttonText?: Maybe<ILocaleString>;
  readonly description?: Maybe<ILocaleString>;
  readonly headerColor?: Maybe<Scalars['String']>;
  readonly image?: Maybe<ILocaleImages>;
  readonly key?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly timelineEventType?: Maybe<Scalars['String']>;
  readonly timelineHeader?: Maybe<ILocaleString>;
}

export interface ITimsRewardsPointsSection extends IDocument {
  readonly __typename?: 'TimsRewardsPointsSection';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly welcomeText?: Maybe<ILocaleString>;
}

export interface ITimsRewardsPointsSectionFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ITitleAndBody {
  readonly __typename?: 'TitleAndBody';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly body?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
}

export interface ITokenExConfig {
  readonly __typename?: 'TokenExConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly publicKey?: Maybe<Scalars['String']>;
}

export interface ITransactionCount {
  readonly __typename?: 'TransactionCount';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Every number of transactions */
  readonly everyNumberOfTransaction?: Maybe<Scalars['Float']>;
  /** transactions from */
  readonly from?: Maybe<Scalars['Float']>;
  /** When the transaction count rule will trigger */
  readonly schedule?: Maybe<Scalars['String']>;
  /** transactions up to */
  readonly to?: Maybe<Scalars['Float']>;
  /** Minimum of transactions required */
  readonly transactionNumber?: Maybe<Scalars['Float']>;
}

export interface ITransactionEarningConfiguration {
  readonly __typename?: 'TransactionEarningConfiguration';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** The daily maximum number of reward redemption for a given user */
  readonly maxRewardRedemptionLimit?: Maybe<Scalars['Float']>;
  /** The daily maximum number of transactions that would yield points for a given user */
  readonly maxTransactionLimit?: Maybe<Scalars['Float']>;
}

export interface ITrending extends IDocument {
  readonly __typename?: 'Trending';
  /** Date the document was created */
  readonly _createdAt: Scalars['DateTime'];
  /** Document ID */
  readonly _id: Scalars['ID'];
  readonly _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  readonly _rev: Scalars['String'];
  /** Document type */
  readonly _type: Scalars['String'];
  /** Date the document was last modified */
  readonly _updatedAt: Scalars['DateTime'];
  readonly promotions?: Maybe<ReadonlyArray<Maybe<IComboOrExternalLinkOrItemOrOfferOrPickerOrSection>>>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
}

export interface ITrendingFilter {
  /** All documents that are equal to given value */
  readonly _createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _createdAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are equal to given value */
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly _id_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _id_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _id_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _id_not?: InputMaybe<Scalars['ID']>;
  readonly _id_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _key?: InputMaybe<Scalars['String']>;
  readonly _key_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _key_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _key_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _key_not?: InputMaybe<Scalars['String']>;
  readonly _key_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _rev?: InputMaybe<Scalars['String']>;
  readonly _rev_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _rev_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _rev_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _rev_not?: InputMaybe<Scalars['String']>;
  readonly _rev_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _type?: InputMaybe<Scalars['String']>;
  readonly _type_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly _type_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly _type_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly _type_not?: InputMaybe<Scalars['String']>;
  readonly _type_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that are equal to given value */
  readonly _updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than given value */
  readonly _updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are greater than or equal to given value */
  readonly _updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that have a value for this field */
  readonly _updatedAt_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents are less than given value */
  readonly _updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All documents are less than or equal to given value */
  readonly _updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are not equal to given value */
  readonly _updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All documents that are drafts */
  readonly is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents references the given document ID */
  readonly references?: InputMaybe<Scalars['ID']>;
  /** All documents that are equal to given value */
  readonly sanityInternalName?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** All documents that have a value for this field */
  readonly sanityInternalName_is_defined?: InputMaybe<Scalars['Boolean']>;
  /** All documents contain (match) the given word/words */
  readonly sanityInternalName_matches?: InputMaybe<Scalars['String']>;
  /** All documents that are not equal to given value */
  readonly sanityInternalName_not?: InputMaybe<Scalars['String']>;
  readonly sanityInternalName_not_in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface IUnlinkPaybackAccountModalContent {
  readonly __typename?: 'UnlinkPaybackAccountModalContent';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly cancelButtonText?: Maybe<ILocaleString>;
  readonly subtitle?: Maybe<ILocaleString>;
  readonly title?: Maybe<ILocaleString>;
  readonly unlinkAccountText?: Maybe<ILocaleString>;
}

export interface IUrlsConfig {
  readonly __typename?: 'UrlsConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly braze?: Maybe<Scalars['String']>;
  readonly firstData?: Maybe<Scalars['String']>;
  readonly firstDataTh?: Maybe<Scalars['String']>;
  readonly kount?: Maybe<Scalars['String']>;
  readonly thDigital?: Maybe<Scalars['String']>;
  readonly tokenEx?: Maybe<Scalars['String']>;
  /** Main site URL without ending slash ("/"), eg "https://www.bk.com". Used for opening external links (Simplex SEO) */
  readonly webBaseUrl?: Maybe<Scalars['String']>;
}

export interface IUserAttributes {
  readonly __typename?: 'UserAttributes';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<IGroups>>>;
}

export interface IUserCreated {
  readonly __typename?: 'UserCreated';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Must be created before/on... */
  readonly endDate?: Maybe<Scalars['Date']>;
  /** Must be created after/on... */
  readonly startDate?: Maybe<Scalars['Date']>;
}

export interface IValidationLoyaltyPoints {
  readonly __typename?: 'ValidationLoyaltyPoints';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly maxPoints?: Maybe<Scalars['Float']>;
  readonly minPoints?: Maybe<Scalars['Float']>;
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Constant is for a single value PLU */
  readonly constantPlu?: Maybe<Scalars['String']>;
  /** Discount plu is an extension of the constant plu type for pos vendors that may use both depending on the entry point */
  readonly discountPlu?: Maybe<Scalars['String']>;
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IPlu>>>;
  /** This is a field relevant for NZ and will be used for offers that require discount amount, input amount in cents. If you are not NZ do not use it */
  readonly offerDiscount?: Maybe<IOfferDiscount>;
  readonly parentChildPlu?: Maybe<IParentChildPlu>;
  /** If provided this vendorConfig will be moved under the cartEntry with Sanity ID equal to parentSanityId for injection. */
  readonly parentSanityId?: Maybe<Scalars['String']>;
  /** This indicates the type of PLU the Vendor needs. Ignore means that this is just for UI and not used by POS. See below for other types. */
  readonly pluType?: Maybe<Scalars['String']>;
  /** This field indicates how many levels up the PLU belongs. */
  readonly pullUpLevels?: Maybe<Scalars['Float']>;
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IPlu>>>;
  readonly sizeBasedPlu?: Maybe<ISizeBasedPlu>;
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly brink?: Maybe<IVendorConfig>;
  readonly brinkDelivery?: Maybe<IVendorConfig>;
  readonly carrols?: Maybe<IVendorConfig>;
  readonly carrolsDelivery?: Maybe<IVendorConfig>;
  readonly hdx?: Maybe<IVendorConfig>;
  readonly ncr?: Maybe<IVendorConfig>;
  readonly ncrDelivery?: Maybe<IVendorConfig>;
  readonly oheics?: Maybe<IVendorConfig>;
  readonly oheicsDelivery?: Maybe<IVendorConfig>;
  readonly partner?: Maybe<IVendorConfig>;
  readonly partnerDelivery?: Maybe<IVendorConfig>;
  readonly productNumber?: Maybe<IVendorConfig>;
  readonly productNumberDelivery?: Maybe<IVendorConfig>;
  readonly qdi?: Maybe<IVendorConfig>;
  readonly qdiDelivery?: Maybe<IVendorConfig>;
  readonly qst?: Maybe<IVendorConfig>;
  readonly qstDelivery?: Maybe<IVendorConfig>;
  readonly rpos?: Maybe<IVendorConfig>;
  readonly rposDelivery?: Maybe<IVendorConfig>;
  readonly sicom?: Maybe<IVendorConfig>;
  readonly sicomDelivery?: Maybe<IVendorConfig>;
  readonly simplyDelivery?: Maybe<IVendorConfig>;
  readonly simplyDeliveryDelivery?: Maybe<IVendorConfig>;
  readonly tablet?: Maybe<IVendorConfig>;
  readonly tabletDelivery?: Maybe<IVendorConfig>;
  readonly toast?: Maybe<IVendorConfig>;
  readonly toastDelivery?: Maybe<IVendorConfig>;
  readonly xenial?: Maybe<IVendorConfig>;
  readonly xenialDelivery?: Maybe<IVendorConfig>;
}

export interface IVendorPlus {
  readonly __typename?: 'VendorPlus';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly carrols?: Maybe<Scalars['String']>;
  readonly carrolsDelivery?: Maybe<Scalars['String']>;
  readonly ncr?: Maybe<Scalars['String']>;
  readonly ncrDelivery?: Maybe<Scalars['String']>;
  readonly oheics?: Maybe<Scalars['String']>;
  readonly oheicsDelivery?: Maybe<Scalars['String']>;
  readonly partner?: Maybe<Scalars['String']>;
  readonly partnerDelivery?: Maybe<Scalars['String']>;
  /** TH Product Number used for Connector */
  readonly productNumber?: Maybe<Scalars['String']>;
  /** TH Product Number Delivery used for Connector */
  readonly productNumberDelivery?: Maybe<Scalars['String']>;
  readonly qst?: Maybe<Scalars['String']>;
  readonly sicom?: Maybe<Scalars['String']>;
  readonly sicomDelivery?: Maybe<Scalars['String']>;
}

export interface IVerticalLinkListWidget {
  readonly __typename?: 'VerticalLinkListWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly linkWidgets?: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>;
}

export interface IVerticalLinkListWithHeaderWidget {
  readonly __typename?: 'VerticalLinkListWithHeaderWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly header?: Maybe<ILocaleString>;
  readonly linkWidgets?: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>;
}

export interface IVideoWidget {
  readonly __typename?: 'VideoWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly attributionLink?: Maybe<Scalars['String']>;
  readonly caption?: Maybe<ILocaleString>;
  readonly video?: Maybe<ILocaleFile>;
}

export interface IVrPaymentConfig {
  readonly __typename?: 'VrPaymentConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly braintreeTokenizationKey?: Maybe<Scalars['String']>;
}

export interface IWebViewWidget {
  readonly __typename?: 'WebViewWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** This field is required only for iframes that required interaction */
  readonly name?: Maybe<Scalars['String']>;
  readonly url?: Maybe<ILocaleString>;
}

export interface IWeekDays {
  readonly __typename?: 'WeekDays';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly friday?: Maybe<Scalars['Boolean']>;
  readonly monday?: Maybe<Scalars['Boolean']>;
  readonly saturday?: Maybe<Scalars['Boolean']>;
  readonly sunday?: Maybe<Scalars['Boolean']>;
  readonly thursday?: Maybe<Scalars['Boolean']>;
  readonly tuesday?: Maybe<Scalars['Boolean']>;
  readonly wednesday?: Maybe<Scalars['Boolean']>;
}

export interface IWordmarkAndSocialIcons {
  readonly __typename?: 'WordmarkAndSocialIcons';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly socialIconsWidget?: Maybe<ISocialIconsWidget>;
}

export interface IWorldpayConfig {
  readonly __typename?: 'WorldpayConfig';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  readonly apiMerchantIdentifier?: Maybe<Scalars['String']>;
  readonly baseUrl?: Maybe<Scalars['String']>;
  readonly eProtectUrl?: Maybe<Scalars['String']>;
  readonly paypageId?: Maybe<Scalars['String']>;
  readonly profileId?: Maybe<Scalars['String']>;
  readonly sharedKey?: Maybe<Scalars['String']>;
}

export interface IYoutubeWidget {
  readonly __typename?: 'YoutubeWidget';
  readonly _key?: Maybe<Scalars['String']>;
  readonly _type?: Maybe<Scalars['String']>;
  /** Used only as an organizational aid. Not displayed in the app. */
  readonly sanityInternalName?: Maybe<Scalars['String']>;
  readonly videoAutoplay?: Maybe<Scalars['Boolean']>;
  readonly videoId?: Maybe<Scalars['String']>;
}

export type IAllItemsQueryVariables = Exact<{
  where?: InputMaybe<IItemFilter>;
}>;


export type IAllItemsQuery = { readonly __typename?: 'RootQuery', readonly allItems: ReadonlyArray<(
    { readonly __typename?: 'Item', readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null }
    & IItemFragment
    & IItemAvailabilityFragment
  )> };

export type IFeatureAccountFormQueryVariables = Exact<{
  featureAccountFormId: Scalars['ID'];
}>;


export type IFeatureAccountFormQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccountForm?: { readonly __typename?: 'FeatureAccountForm', readonly postalOrZipDisclaimer?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly activeCampaigns?: ReadonlyArray<(
      { readonly __typename?: 'FeatureAuthCampaign' }
      & IActiveCampaignFragment
    ) | null> | null } | null };

export type IFeatureAccountQueryVariables = Exact<{
  featureAccountId: Scalars['ID'];
}>;


export type IFeatureAccountQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccount?: { readonly __typename?: 'FeatureAccount', readonly _id: string, readonly emailAndPushOptInSettings?: ReadonlyArray<(
      { readonly __typename?: 'OptInPrivacyPreferences' }
      & IOptInPrivacyPreferencesFragment
    ) | (
      { readonly __typename?: 'OptInSettingBoolean' }
      & IOptInSettingBooleanFragment
    ) | { readonly __typename?: 'OptInSettingEmail' } | (
      { readonly __typename?: 'OptInSettingEmailAndPush' }
      & IOptInSettingEmailAndPushFragment
    ) | (
      { readonly __typename?: 'OptInSettingEnum' }
      & IOptInSettingEnumFragment
    ) | { readonly __typename?: 'OptInSettingPush' } | null> | null } | null };

export type IFeatureLoyaltyClaimPointsContentQueryVariables = Exact<{
  featureClaimPointsUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyClaimPointsContentQuery = { readonly __typename?: 'RootQuery', readonly ClaimPointsUI?: { readonly __typename?: 'ClaimPointsUI', readonly _id: string, readonly claimPointsSimplified?: (
      { readonly __typename?: 'ClaimPointsSimplifiedContent' }
      & IClaimPointsSimplifiedContentFragment
    ) | null, readonly claimPointsHomeScreenContent?: (
      { readonly __typename?: 'ClaimPointsScreenContent' }
      & IClaimPointsScreenContentFragment
    ) | null, readonly claimQrCode?: (
      { readonly __typename?: 'ClaimQrCode' }
      & IClaimPointsQrCodeContentFragment
    ) | null, readonly claimPointsSurveyContent?: (
      { readonly __typename?: 'ClaimPointsSurveyScreenContent' }
      & IClaimPointsSurveyContentFragment
    ) | null, readonly claimPointsSuccessfulSubmissionScreenContent?: (
      { readonly __typename?: 'ClaimPointsScreenContent' }
      & IClaimPointsScreenContentFragment
    ) | null, readonly claimOnHistory?: { readonly __typename?: 'ClaimOnHistory', readonly linkText?: { readonly __typename?: 'LocaleBlockContent', readonly locale?: any | null } | null } | null, readonly claimPointsPendingContent?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsExpiredContent?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsInvalidCodeContent?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsAlreadyClaimedContent?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsTransactionNotFoundContent?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsInvalidRestaurantContent?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsDailyAmountExceededContent?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsDuplicateTransactionId?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null, readonly claimPointsTooManyRequests?: (
      { readonly __typename?: 'ClaimPointsFailedSubmissionContent' }
      & IClaimPointsFailedSubmissionContentFragment
    ) | null } | null };

export type IFeatureDisclaimersQueryVariables = Exact<{
  featureDisclaimersId: Scalars['ID'];
}>;


export type IFeatureDisclaimersQuery = { readonly __typename?: 'RootQuery', readonly FeatureDisclaimers?: { readonly __typename?: 'FeatureDisclaimers', readonly _id: string, readonly superUpsell?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly calorie?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly price?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly itemAvailability?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly images?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly phoneNumber?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly country?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly offers?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly copyrightAndTrademark?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly reservedRights?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly communicationPreferencesBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly signUpDisclaimers?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly signUpMarketDisclaimers?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly deliveryDisclaimer?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly deliveryLogo?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null } | null };

export type IFeatureDonationQueryVariables = Exact<{
  featureDonationId: Scalars['ID'];
}>;


export type IFeatureDonationQuery = { readonly __typename?: 'RootQuery', readonly FeatureDonation?: { readonly __typename?: 'FeatureDonation', readonly _id: string, readonly donationItemList?: ReadonlyArray<(
      { readonly __typename?: 'Item', readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly vendorConfigs?: (
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      ) | null }
      & IItemFragment
    ) | null> | null, readonly logoImage?: { readonly __typename?: 'LocaleImage', readonly locale?: { readonly __typename?: 'Image', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id: string } | null } | null } | null, readonly header?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly subtitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly dialogInformation?: { readonly __typename?: 'DialogInformation', readonly header?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly subtitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonAction?: { readonly __typename?: 'LinkAction', readonly actionText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly actionUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null } | null } | null };

export type IFeatureFooterQueryVariables = Exact<{
  featureFooterId: Scalars['ID'];
}>;


export type IFeatureFooterQuery = { readonly __typename?: 'RootQuery', readonly FeatureFooter?: { readonly __typename?: 'FeatureFooter', readonly rows?: ReadonlyArray<{ readonly __typename?: 'Row', readonly _key?: string | null, readonly columns?: ReadonlyArray<{ readonly __typename?: 'Column', readonly _key?: string | null, readonly options?: ReadonlyArray<(
          { readonly __typename?: 'CopyrightAndLanguageSelector' }
          & ICopyrightAndLanguageSelectorFragment
        ) | (
          { readonly __typename?: 'HighlightedVerticalLinkListWidget' }
          & IHighlightedVerticalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'HorizontalLinkListWidget' }
          & IHorizontalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'ImageWidget' }
          & IImageWidgetFragment
        ) | (
          { readonly __typename?: 'SocialIconsWithHeaderWidget' }
          & ISocialIconsWithHeaderWidgetFragment
        ) | (
          { readonly __typename?: 'TextWidget' }
          & ITextWidgetFragment
        ) | { readonly __typename?: 'TextWidgetWithUrl' } | (
          { readonly __typename?: 'VerticalLinkListWidget' }
          & IVerticalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'VerticalLinkListWithHeaderWidget' }
          & IVerticalLinkListWithHeaderWidgetFragment
        ) | (
          { readonly __typename?: 'WordmarkAndSocialIcons' }
          & IWordmarkAndSocialIconsFragment
        ) | null> | null } | null> | null } | null> | null } | null };

export type IFeatureGeolocationMapMarkersQueryVariables = Exact<{
  featureGeolocationMapMarkersId: Scalars['ID'];
}>;


export type IFeatureGeolocationMapMarkersQuery = { readonly __typename?: 'RootQuery', readonly FeatureGeolocationMapMarkers?: { readonly __typename?: 'FeatureGeolocationMapMarkers', readonly _id: string, readonly driverIcon?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null } | null };

export type IFeatureLayoutQueryVariables = Exact<{
  featureLayoutId: Scalars['ID'];
}>;


export type IFeatureLayoutQuery = { readonly __typename?: 'RootQuery', readonly FeatureLayout?: { readonly __typename?: 'FeatureLayout', readonly _id: string, readonly defaultHeroImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly loadingGraphics?: (
      { readonly __typename?: 'LoadingGraphics' }
      & ILoadingGraphicsFragment
    ) | null, readonly geolocationModalImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly appleWalletImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly googlePayImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly giftCardImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly giftCardTextImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null } | null };

export type IFeatureLoyaltyBackgroundQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyBackgroundQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly imageBackground?: { readonly __typename?: 'ImageBackground', readonly image?: (
        { readonly __typename?: 'Image' }
        & IRefFragment
      ) | null } | null } | null };

export type IFeatureLoyaltyDashboardQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyDashboardQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly loyaltyDashboard?: { readonly __typename?: 'LoyaltyDashboard', readonly widgets?: ReadonlyArray<{ readonly __typename: 'FeaturedRewardsCarouselWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly label?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly rewards?: ReadonlyArray<{ readonly __typename?: 'Reward', readonly _id: string, readonly loyaltyEngineId?: string | null } | null> | null } | { readonly __typename: 'LoyaltyDoubleButtonWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly leftButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly leftButtonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly rightButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly rightButtonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | { readonly __typename: 'LoyaltyGreetingWidget', readonly _key?: string | null, readonly componentKey?: string | null } | { readonly __typename: 'LoyaltyHistoryWidget', readonly _key?: string | null, readonly componentKey?: string | null } | { readonly __typename: 'LoyaltyLinkWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly links?: ReadonlyArray<{ readonly __typename?: 'LinkWidget', readonly _key?: string | null, readonly text?: { readonly __typename?: 'LocaleString', readonly en?: string | null } | null, readonly link?: { readonly __typename?: 'LocaleUrl', readonly en?: string | null } | null } | null> | null } | { readonly __typename: 'LoyaltyLogoWidget', readonly _key?: string | null, readonly componentKey?: string | null } | { readonly __typename: 'LoyaltyMarketingTileGroupWidget' } | { readonly __typename: 'LoyaltyNotificationsWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly notifications?: ReadonlyArray<{ readonly __typename?: 'Reward', readonly loyaltyEngineId?: string | null, readonly notificationDetails?: (
            { readonly __typename?: 'NotificationDetails' }
            & INotificationDetailsFragment
          ) | null } | { readonly __typename?: 'SystemwideOffer', readonly loyaltyEngineId?: string | null, readonly redemptionType?: string | null, readonly notificationDetails?: (
            { readonly __typename?: 'NotificationDetails' }
            & INotificationDetailsFragment
          ) | null } | { readonly __typename?: 'SystemwidePromotion', readonly loyaltyEngineId?: string | null, readonly notificationDetails?: (
            { readonly __typename?: 'NotificationDetails' }
            & INotificationDetailsFragment
          ) | null } | null> | null } | { readonly __typename: 'LoyaltyPointsAndRewardsWidget', readonly _key?: string | null, readonly componentKey?: string | null } | { readonly __typename: 'LoyaltyPointsMeterWidget' } | { readonly __typename: 'LoyaltyQuestsTileWidget' } | { readonly __typename: 'LoyaltyQuestsWidget' } | { readonly __typename: 'LoyaltyTiersWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly sortByPointValue?: string | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | { readonly __typename: 'RewardsListWidget', readonly _key?: string | null, readonly componentKey?: string | null } | null> | null } | null } | null };

export type IFeatureEarningCalculationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IFeatureEarningCalculationQuery = { readonly __typename?: 'RootQuery', readonly EarningCalculation?: { readonly __typename?: 'EarningCalculation', readonly _id: string, readonly offerRedemptionCooldownPeriod?: number | null, readonly transactionEarningConfiguration?: { readonly __typename?: 'TransactionEarningConfiguration', readonly maxRewardRedemptionLimit?: number | null } | null } | null };

export type IFeatureLoyaltyInRestaurantRedemptionQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyInRestaurantRedemptionQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly loyaltyInRestaurantRedemption?: { readonly __typename?: 'LoyaltyInRestaurantRedemption', readonly topWidgets?: ReadonlyArray<(
        { readonly __typename?: 'LoyaltyBasicCardWidget' }
        & ILoyaltyBasicCardWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyButtonArrayWidget' }
        & ILoyaltyButtonArrayWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyButtonWidget' }
        & ILoyaltyButtonWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyCartWidget' }
        & ILoyaltyCartWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyImageWidget' }
        & ILoyaltyImageWidgetFragment
      ) | { readonly __typename?: 'LoyaltyLegacyShortCodeWidget' } | { readonly __typename?: 'LoyaltyMarketingTileGroupWidget' } | (
        { readonly __typename?: 'LoyaltyPaymentMethodWidget' }
        & ILoyaltyPaymentMethodWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRAndShortCodeWidget' }
        & ILoyaltyQrAndShortCodeWidgetFragment
      ) | { readonly __typename?: 'LoyaltyQRCodeLoyaltyIdWidget' } | (
        { readonly __typename?: 'LoyaltyQRCodeWidget' }
        & ILoyaltyQrCodeWidgetFragment
      ) | { readonly __typename?: 'LoyaltyQRScanButtonWidget' } | { readonly __typename?: 'LoyaltyQRScanHeaderWidget' } | (
        { readonly __typename?: 'LoyaltyShortCodeWidget' }
        & ILoyaltyShortCodeWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTextWidget' }
        & ILoyaltyTextWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTitleWidget' }
        & ILoyaltyTitleWidgetFragment
      ) | null> | null, readonly bottomWidgets?: ReadonlyArray<{ readonly __typename?: 'LoyaltyBasicCardWidget' } | (
        { readonly __typename?: 'LoyaltyButtonArrayWidget' }
        & ILoyaltyButtonArrayWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyButtonWidget' }
        & ILoyaltyButtonWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyCartWidget' }
        & ILoyaltyCartWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyImageWidget' }
        & ILoyaltyImageWidgetFragment
      ) | { readonly __typename?: 'LoyaltyLegacyShortCodeWidget' } | { readonly __typename?: 'LoyaltyMarketingTileGroupWidget' } | (
        { readonly __typename?: 'LoyaltyPaymentMethodWidget' }
        & ILoyaltyPaymentMethodWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyQRAndShortCodeWidget' }
        & ILoyaltyQrAndShortCodeWidgetFragment
      ) | { readonly __typename?: 'LoyaltyQRCodeLoyaltyIdWidget' } | (
        { readonly __typename?: 'LoyaltyQRCodeWidget' }
        & ILoyaltyQrCodeWidgetFragment
      ) | { readonly __typename?: 'LoyaltyQRScanButtonWidget' } | { readonly __typename?: 'LoyaltyQRScanHeaderWidget' } | (
        { readonly __typename?: 'LoyaltyShortCodeWidget' }
        & ILoyaltyShortCodeWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTextWidget' }
        & ILoyaltyTextWidgetFragment
      ) | (
        { readonly __typename?: 'LoyaltyTitleWidget' }
        & ILoyaltyTitleWidgetFragment
      ) | null> | null } | null } | null };

export type IFeatureLoyaltyUiNoRewardQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyUiNoRewardQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly noRewardPoints?: (
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    ) | null } | null };

export type IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IFeatureLoyaltyNotAvailableAtDeliveryModeQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly loyaltyNotAvailableAtDeliveryMode?: { readonly __typename?: 'LoyaltyNotAvailableAtDeliveryMode', readonly image?: { readonly __typename?: 'LocaleImages', readonly locale?: (
          { readonly __typename?: 'Images' }
          & IImagesFragment
        ) | null } | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly firstButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly firstRedirectPath?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null } | null };

export type IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IFeatureLoyaltyNotAvailableAtThisRestaurantQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly loyaltyNotAvailableAtThisRestaurant?: { readonly __typename?: 'LoyaltyNotAvailableAtThisRestaurant', readonly image?: { readonly __typename?: 'LocaleImages', readonly locale?: (
          { readonly __typename?: 'Images' }
          & IImagesFragment
        ) | null } | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly firstButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly firstRedirectPath?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly secondButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly secondRedirectPath?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null } | null };

export type IFeatureLoyaltyUiNotEnrolledQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyUiNotEnrolledQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly notEnrolledState?: (
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    ) | null, readonly notEnrolledStateMobile?: (
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    ) | null } | null };

export type ILoyaltyOffersUiIncentiveNotAvailableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ILoyaltyOffersUiIncentiveNotAvailableQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI?: { readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly offerNotAvailableModalContent?: { readonly __typename?: 'IncentiveNotAvailableModalContent', readonly image?: { readonly __typename?: 'LocaleImages', readonly locale?: (
          { readonly __typename?: 'Images' }
          & IImagesFragment
        ) | null } | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly primaryButton?: { readonly __typename?: 'ActionButton', readonly buttonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly secondaryButton?: { readonly __typename?: 'ActionButton', readonly buttonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null } | null, readonly rewardNotAvailableModalContent?: { readonly __typename?: 'IncentiveNotAvailableModalContent', readonly image?: { readonly __typename?: 'LocaleImages', readonly locale?: (
          { readonly __typename?: 'Images' }
          & IImagesFragment
        ) | null } | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly primaryButton?: { readonly __typename?: 'ActionButton', readonly buttonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly secondaryButton?: { readonly __typename?: 'ActionButton', readonly buttonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null } | null } | null };

export type IFeatureSortedLoyaltyOffersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IFeatureSortedLoyaltyOffersQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI?: { readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly sortedSystemwideOffers?: ReadonlyArray<(
      { readonly __typename?: 'SystemwideOffer' }
      & ISystemwideOffersFragment
    ) | null> | null } | null };

export type ILoyaltyOffersUiLoggedInQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ILoyaltyOffersUiLoggedInQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI?: { readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly endOfOffersLoggedIn?: { readonly __typename?: 'EndOfOffersLoggedIn', readonly endOfOffersMessage?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly endOfOffersImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null } | null } | null };

export type ILoyaltyOffersUiLoggedOutQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ILoyaltyOffersUiLoggedOutQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI?: { readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly endOfOffersLoggedOut?: { readonly __typename?: 'EndOfOffersLoggedOut', readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly body?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly ctaButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly link?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null } | null };

export type ILoyaltyOffersUiCooldownContentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ILoyaltyOffersUiCooldownContentQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyOffersUI?: { readonly __typename?: 'LoyaltyOffersUI', readonly _id: string, readonly globalOfferCooldownContent?: { readonly __typename?: 'GlobalOfferCooldownContent', readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly localeRaw?: string | null } | null, readonly actionButton?: { readonly __typename?: 'ActionButton', readonly buttonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly terms?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null } | null };

export type ILoyaltySystemwideOffersByIdsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type ILoyaltySystemwideOffersByIdsQuery = { readonly __typename?: 'RootQuery', readonly allSystemwideOffers: ReadonlyArray<(
    { readonly __typename?: 'SystemwideOffer' }
    & ISystemwideOffersFragment
  )> };

export type IAllSystemwidePromotionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IAllSystemwidePromotionsQuery = { readonly __typename?: 'RootQuery', readonly allSystemwidePromotions: ReadonlyArray<{ readonly __typename?: 'SystemwidePromotion', readonly _id: string, readonly name?: string | null, readonly pointsMultiplier?: number | null, readonly bonusPoints?: number | null, readonly startDate?: any | null, readonly endDate?: any | null, readonly testOnly?: boolean | null, readonly notificationDetails?: { readonly __typename?: 'NotificationDetails', readonly image?: { readonly __typename?: 'LocaleImage', readonly en?: { readonly __typename?: 'Image', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly url?: string | null } | null } | null } | null } | null, readonly desktopImage?: { readonly __typename?: 'LocaleImage', readonly locale?: { readonly __typename?: 'Image', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly url?: string | null } | null } | null } | null, readonly mobileImage?: { readonly __typename?: 'LocaleImage', readonly locale?: { readonly __typename?: 'Image', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly url?: string | null } | null } | null } | null, readonly systemwidePromotion?: ReadonlyArray<{ readonly __typename: 'BirthdayMultiplier' } | { readonly __typename: 'CartLimit' } | { readonly __typename: 'CartRequirement' } | { readonly __typename: 'CartRequirementExclusion' } | { readonly __typename: 'CoolDown' } | { readonly __typename: 'DayOfWeekBand', readonly monday?: boolean | null, readonly tuesday?: boolean | null, readonly wednesday?: boolean | null, readonly thursday?: boolean | null, readonly friday?: boolean | null, readonly saturday?: boolean | null, readonly sunday?: boolean | null } | { readonly __typename: 'EmailVerifiedRequired' } | { readonly __typename: 'FirstOrderOnly' } | { readonly __typename: 'IncentiveRequirement' } | { readonly __typename: 'Limit' } | { readonly __typename: 'LoyaltyBetweenDates', readonly startDate?: any | null, readonly endDate?: any | null } | { readonly __typename: 'LoyaltyBetweenTimes' } | { readonly __typename: 'PaymentMethod' } | { readonly __typename: 'PreDiscountSpend' } | { readonly __typename: 'RequiresAdditionalPurchase' } | { readonly __typename: 'RequiresAdditionalPurchaseMinimumSpend' } | { readonly __typename: 'RequiresAuthentication' } | { readonly __typename: 'RestaurantGroupRestrictions' } | { readonly __typename: 'RestaurantRestrictions' } | { readonly __typename: 'ServiceModeRestrictions' } | { readonly __typename: 'SubtotalSpend' } | { readonly __typename: 'TransactionCount' } | { readonly __typename: 'UserAttributes' } | { readonly __typename: 'UserCreated' } | null> | null }> };

export type ILoyaltyOfferConfigsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type ILoyaltyOfferConfigsQuery = { readonly __typename?: 'RootQuery', readonly allConfigOffers: ReadonlyArray<(
    { readonly __typename?: 'ConfigOffer' }
    & IConfigOfferFragment
  )> };

export type ILoyaltyOfferTemplatesQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type ILoyaltyOfferTemplatesQuery = { readonly __typename?: 'RootQuery', readonly allOfferTemplates: ReadonlyArray<(
    { readonly __typename?: 'OfferTemplate' }
    & ILoyaltyOfferTemplateFragment
  )> };

export type ILoyaltyPersonalizeOffersQueryVariables = Exact<{
  configEngineIds: ReadonlyArray<Scalars['String']> | Scalars['String'];
  templateEngineIds: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type ILoyaltyPersonalizeOffersQuery = { readonly __typename?: 'RootQuery', readonly allConfigOffers: ReadonlyArray<(
    { readonly __typename?: 'ConfigOffer' }
    & IConfigOfferFragment
  )>, readonly allOfferTemplates: ReadonlyArray<(
    { readonly __typename?: 'OfferTemplate' }
    & ILoyaltyOfferTemplateFragment
  )> };

export type IFeatureLoyaltyRewardListCategoriesQueryVariables = Exact<{
  featureLoyaltyRewardListCategoriesId: Scalars['ID'];
}>;


export type IFeatureLoyaltyRewardListCategoriesQuery = { readonly __typename?: 'RootQuery', readonly RewardList?: { readonly __typename?: 'RewardList', readonly _id: string, readonly rewardCategories?: ReadonlyArray<{ readonly __typename?: 'RewardCategory', readonly label?: { readonly __typename?: 'LocaleString', readonly en?: string | null } | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly rewards?: ReadonlyArray<{ readonly __typename?: 'Reward', readonly _id: string, readonly loyaltyEngineId?: string | null } | null> | null } | null> | null } | null };

export type IFeatureLoyaltyShortCodeConfirmationModalQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyShortCodeConfirmationModalQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly shortCodeConfirmationModalContent?: (
      { readonly __typename?: 'ShortCodeConfirmationModalContent' }
      & IShortCodeConfirmationModalFragment
    ) | null } | null };

export type IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltyOverrideShortCodeModalContentQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly overrideShortCodeModalContent?: { readonly __typename?: 'OverrideShortCodeModalContent', readonly header?: (
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      ) | null, readonly body?: (
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      ) | null, readonly confirmButton?: (
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      ) | null, readonly discardButton?: (
        { readonly __typename?: 'LocaleString' }
        & ILocaleStringFragment
      ) | null } | null } | null };

export type IFeatureLoyaltySurpriseModalQueryVariables = Exact<{
  featureLoyaltyUIId: Scalars['ID'];
}>;


export type IFeatureLoyaltySurpriseModalQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI?: { readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly surpriseAndDelightModalContent?: { readonly __typename?: 'SurpriseAndDelightModalContent', readonly backgroundImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null, readonly buttonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly noThanksText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly prompt?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly termsText?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null } | null };

export type IFeatureMenuQueryVariables = Exact<{
  featureMenuId: Scalars['ID'];
}>;


export type IFeatureMenuQuery = { readonly __typename?: 'RootQuery', readonly FeatureMenu?: { readonly __typename?: 'FeatureMenu', readonly _id: string, readonly menuHeroImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly cateringAlertText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly cateringAlertLinkText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly cateringAlertLinkUrl?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly cateringSections?: ReadonlyArray<(
      { readonly __typename?: 'Section' }
      & ISectionFragment
    ) | null> | null, readonly menuHeroText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly dayParts?: ReadonlyArray<{ readonly __typename?: 'DayPart', readonly key?: string | null, readonly endTime?: string | null, readonly startTime?: string | null, readonly weekDays?: { readonly __typename?: 'WeekDays', readonly monday?: boolean | null, readonly tuesday?: boolean | null, readonly wednesday?: boolean | null, readonly thursday?: boolean | null, readonly friday?: boolean | null, readonly saturday?: boolean | null, readonly sunday?: boolean | null } | null, readonly displayName?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly icon?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null> | null, readonly defaultMenu?: { readonly __typename?: 'Menu', readonly _id: string } | null, readonly cateringMenu?: { readonly __typename?: 'Menu', readonly _id: string } | null, readonly donationTermAndConditionUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly donationItemsAtCheckout?: ReadonlyArray<(
      { readonly __typename?: 'Item', readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly vendorConfigs?: (
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      ) | null }
      & IItemFragment
    ) | null> | null, readonly upsellItemsAtCheckoutRestaurant?: ReadonlyArray<(
      { readonly __typename?: 'Item', readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly vendorConfigs?: (
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      ) | null }
      & IItemFragment
    ) | null> | null, readonly upsellItemsAtCheckoutDelivery?: ReadonlyArray<(
      { readonly __typename?: 'Item', readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly vendorConfigs?: (
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      ) | null }
      & IItemFragment
    ) | null> | null, readonly upsellItemsAtCheckoutCatering?: ReadonlyArray<(
      { readonly __typename?: 'Item', readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly vendorConfigs?: (
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      ) | null }
      & IItemFragment
    ) | null> | null, readonly cartAddOnSections?: ReadonlyArray<(
      { readonly __typename?: 'AddOnSection' }
      & IAddOnSectionFragment
    ) | null> | null, readonly cartAddOnSectionsCatering?: ReadonlyArray<(
      { readonly __typename?: 'AddOnSection' }
      & IAddOnSectionFragment
    ) | null> | null, readonly menuSummaryHeaderModifiable?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly menuSummaryHeaderNotModifiable?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null };

export type IFeatureNavigationQueryVariables = Exact<{
  featureNavigationId: Scalars['ID'];
  isDesktop: Scalars['Boolean'];
}>;


export type IFeatureNavigationQuery = { readonly __typename?: 'RootQuery', readonly FeatureNavigation?: (
    { readonly __typename?: 'FeatureNavigation', readonly aboutMenuEntries?: (
      { readonly __typename?: 'NavigationSection' }
      & INavigationSectionFragment
    ) | null }
    & INavigationDesktopFragment
    & INavigationMobileFragment
    & INavigationButtonFragment
  ) | null };

export type IFeatureNutritionQueryVariables = Exact<{
  featureNutritionId: Scalars['ID'];
}>;


export type IFeatureNutritionQuery = { readonly __typename?: 'RootQuery', readonly FeatureNutrition?: { readonly __typename?: 'FeatureNutrition', readonly _id: string, readonly nutritionTables?: ReadonlyArray<(
      { readonly __typename?: 'NutritionTable' }
      & INutritionTableFragment
    ) | null> | null, readonly roundingRules?: (
      { readonly __typename?: 'RoundingRules' }
      & IRoundingRulesFragment
    ) | null } | null };

export type IFeatureOffersQueryVariables = Exact<{
  featureOffersId: Scalars['ID'];
}>;


export type IFeatureOffersQuery = { readonly __typename?: 'RootQuery', readonly FeatureOffers?: { readonly __typename?: 'FeatureOffers', readonly offersBrowsingPanel?: (
      { readonly __typename?: 'OffersBrowsingPanel', readonly endOfOffersMessage?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly endOfOffersImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null, readonly emptyStateTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly emptyStateBody?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly emptyStateImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null }
      & IOffersSelectRestaurantCtaFragment
    ) | null, readonly offersDetailsPanel?: { readonly __typename?: 'OffersDetailsPanel', readonly emptyStateTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly emptyStateBody?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly emptyStateImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null, readonly emptyStateAction?: { readonly __typename?: 'LinkAction', readonly route?: string | null, readonly actionText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly missingOfferTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly missingOfferBody?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly missingOfferImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null, readonly missingOfferAction?: { readonly __typename?: 'LinkAction', readonly route?: string | null, readonly actionText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null } | null, readonly defaultBackgroundImage?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null, readonly offersPageMarketingTiles?: ReadonlyArray<(
      { readonly __typename?: 'OffersPageMarketingTile' }
      & IOffersPageMarketingTileFragment
    ) | null> | null } | null };

export type IFeatureStaticMenuQueryVariables = Exact<{
  featureStaticMenuId: Scalars['ID'];
}>;


export type IFeatureStaticMenuQuery = { readonly __typename?: 'RootQuery', readonly FeatureStaticMenu?: (
    { readonly __typename?: 'FeatureStaticMenu' }
    & IItemUnavailableModalFragment
  ) | null };

export type INavigationSectionFragment = { readonly __typename?: 'NavigationSection', readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly pages?: ReadonlyArray<{ readonly __typename?: 'NavigationSection', readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly pages?: ReadonlyArray<{ readonly __typename?: 'NavigationSection' } | { readonly __typename?: 'StaticPage', readonly title?: string | null, readonly localeTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly path?: { readonly __typename?: 'Slug', readonly current?: string | null } | null, readonly localePath?: { readonly __typename?: 'LocaleSlug', readonly locale?: { readonly __typename?: 'Slug', readonly current?: string | null } | null } | null, readonly redirectUrl?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null> | null } | { readonly __typename?: 'StaticPage', readonly title?: string | null, readonly localeTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly path?: { readonly __typename?: 'Slug', readonly current?: string | null } | null, readonly localePath?: { readonly __typename?: 'LocaleSlug', readonly locale?: { readonly __typename?: 'Slug', readonly current?: string | null } | null } | null, readonly redirectUrl?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null> | null };

export type IActiveCampaignFragment = { readonly __typename?: 'FeatureAuthCampaign', readonly campaignId?: string | null, readonly shouldDisplayExtraFields?: boolean | null, readonly campaignImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly campaignImageAltText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly campaingBackgroundColor?: (
    { readonly __typename?: 'Color' }
    & IColorFragment
  ) | null, readonly campaignText?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null };

export type IAddOnSectionOptionFragment = { readonly __typename?: 'AddOnSectionOption', readonly _key?: string | null, readonly maxAmount?: number | null, readonly option?: (
    { readonly __typename?: 'Item' }
    & IItemFragment
    & IItemAvailabilityFragment
  ) | null };

export type IAddOnSectionFragment = { readonly __typename?: 'AddOnSection', readonly _id: string, readonly _key?: string | null, readonly maxAmount?: number | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly options?: ReadonlyArray<(
    { readonly __typename?: 'AddOnSectionOption' }
    & IAddOnSectionOptionFragment
  ) | null> | null };

export type IAdditionalItemInformationFragment = { readonly __typename?: 'AdditionalItemInformation', readonly ingredients?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly additives?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly producerDetails?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IAllergensFragment = { readonly __typename?: 'OpAllergen', readonly milk?: number | null, readonly eggs?: number | null, readonly fish?: number | null, readonly peanuts?: number | null, readonly shellfish?: number | null, readonly treeNuts?: number | null, readonly soy?: number | null, readonly wheat?: number | null, readonly mustard?: number | null, readonly sesame?: number | null, readonly celery?: number | null, readonly lupin?: number | null, readonly gluten?: number | null, readonly sulphurDioxide?: number | null };

export type IColorFragment = { readonly __typename?: 'Color', readonly alpha?: number | null, readonly hex?: string | null, readonly hsl?: { readonly __typename?: 'HslaColor', readonly _type?: string | null, readonly a?: number | null, readonly h?: number | null, readonly l?: number | null, readonly s?: number | null } | null, readonly hsv?: { readonly __typename?: 'HsvaColor', readonly _type?: string | null, readonly a?: number | null, readonly h?: number | null, readonly s?: number | null, readonly v?: number | null } | null, readonly rgb?: { readonly __typename?: 'RgbaColor', readonly _type?: string | null, readonly a?: number | null, readonly b?: number | null, readonly g?: number | null, readonly r?: number | null } | null };

export type IComboFragment = { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly uiPattern?: string | null, readonly hideMainItemDescription?: boolean | null, readonly forceModifiersToBottom?: boolean | null, readonly isOfferBenefit?: boolean | null, readonly showInStaticMenu?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly image?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly mainItem?: (
    { readonly __typename?: 'Item' }
    & IItemFragment
  ) | null, readonly promotion?: { readonly __typename?: 'SystemwidePromotion', readonly bonusPoints?: number | null, readonly loyaltyEngineId?: string | null } | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'ComboSlot', readonly _type: string, readonly _id: string, readonly uiPattern?: string | null, readonly minAmount?: number | null, readonly maxAmount?: number | null, readonly respectMaximum?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly optionVisibilitySettings?: { readonly __typename?: 'OptionVisibilitySettings', readonly visibleOptions?: number | null, readonly toggleButtonTextClosed?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly toggleButtonTextOpen?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'ComboSlotOption', readonly _key?: string | null, readonly minAmount?: number | null, readonly defaultAmount?: number | null, readonly isPremium?: boolean | null, readonly maxAmount?: number | null, readonly option?: (
        { readonly __typename?: 'Item' }
        & IItemFragment
      ) | { readonly __typename?: 'Picker', readonly _type: string, readonly uiPattern?: string | null, readonly pickerAspects?: ReadonlyArray<{ readonly __typename?: 'PickerAspect', readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly pickerAspectOptions?: ReadonlyArray<{ readonly __typename?: 'PickerAspectValue', readonly identifier?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null> | null } | null> | null } | { readonly __typename?: 'Section' } | null } | null> | null } | null> | null, readonly menuObjectSettings?: { readonly __typename?: 'MenuObjectSettings', readonly limitPerOrder?: number | null } | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type IConfigOfferFragment = { readonly __typename?: 'ConfigOffer', readonly _id: string, readonly _type: string, readonly loyaltyEngineId?: string | null, readonly shortCode?: string | null, readonly mobileOrderOnly?: boolean | null, readonly daypart?: ReadonlyArray<string | null> | null, readonly redemptionType?: string | null, readonly offerPrice?: number | null, readonly uiPattern?: string | null, readonly name?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly moreInfo?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly howToRedeem?: { readonly __typename?: 'LocaleBlockContent', readonly enRaw?: any | null } | null, readonly backgroundImage?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly marketPrice?: { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | null, readonly localizedImage?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    ) | null } | null, readonly lockedOffersPanel?: { readonly __typename?: 'LockedOffersPanel', readonly completedChallengeHeader?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly completedChallengeDescription?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null, readonly promoCodePanel?: { readonly __typename?: 'PromoCodePanel', readonly promoCodeLink?: string | null, readonly promoCodeDescription?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly promoCodeLabel?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null, readonly incentives?: ReadonlyArray<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly isOfferBenefit?: boolean | null, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'FeesV1Discount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null, readonly discountFees?: ReadonlyArray<string | null> | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'ItemGroupDiscount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null, readonly maxItemsDiscount?: number | null, readonly applicableItems?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string } | { readonly __typename?: 'ItemGroup', readonly _id: string, readonly _type: string } | null } | { readonly __typename: 'OfferActivation', readonly _id: string, readonly _type: string } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly isOfferBenefit?: boolean | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'PickerOption', readonly option?: { readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null, readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | null } | null> | null } | { readonly __typename: 'SwapMapping', readonly _type: string } | null> | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type IEmptyStateFragment = { readonly __typename?: 'EmptyState', readonly _id: string, readonly headerText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly logo?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IImagesFragment
    ) | null } | null, readonly backgroundImage?: { readonly __typename?: 'ImageBackground', readonly image?: (
      { readonly __typename?: 'Image' }
      & IRefFragment
    ) | null } | null, readonly marketingTileList?: (
    { readonly __typename?: 'MarketingTileList' }
    & IMarketingTileListFragment
  ) | null, readonly image?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IImagesFragment
    ) | null } | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly subtitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly locale?: any | null } | null, readonly buttonAction?: { readonly __typename?: 'LinkAction', readonly route?: string | null, readonly actionText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly actionUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null, readonly terms?: { readonly __typename?: 'LocaleBlockContent', readonly locale?: any | null } | null };

export type INavigationDesktopFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationDesktop?: (
    { readonly __typename?: 'NavigationDesktop', readonly _key?: string | null, readonly _type?: string | null }
    & INavigationLinksFragment
    & IAboutMenuEntriesDesktopFragment
  ) | null };

export type INavigationLinksFragment = { readonly __typename?: 'NavigationDesktop', readonly navigationLinks?: ReadonlyArray<(
    { readonly __typename?: 'NavigationDesktopLink' }
    & INavigationLinkFragment
  ) | null> | null };

export type IAboutMenuEntriesDesktopFragment = { readonly __typename?: 'NavigationDesktop', readonly aboutMenuEntries?: (
    { readonly __typename?: 'NavigationSection' }
    & INavigationSectionFragment
  ) | null };

export type INavigationLinkFragment = { readonly __typename?: 'NavigationDesktopLink', readonly _key?: string | null, readonly hideLinkBasedOnLdFlag?: { readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag?: string | null } | null, readonly navLink?: (
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null, readonly launchDarklyAlternateNavigationLink?: { readonly __typename?: 'LaunchDarklyNavigationLink', readonly enabled?: boolean | null, readonly launchDarklyFlagDependency?: { readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag?: string | null } | null, readonly navLink?: (
      { readonly __typename?: 'LinkWidget' }
      & ILinkWidgetFragment
    ) | null } | null };

export type INavigationMobileFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationMobile?: (
    { readonly __typename?: 'NavigationMobile', readonly _key?: string | null, readonly _type?: string | null }
    & INavigationTabsFragment
    & IAboutMenuEntriesMobileFragment
  ) | null };

export type INavigationTabsFragment = { readonly __typename?: 'NavigationMobile', readonly navigationTabs?: ReadonlyArray<(
    { readonly __typename?: 'NavigationMobileTab' }
    & INavigationTabFragment
  ) | null> | null };

export type IAboutMenuEntriesMobileFragment = { readonly __typename?: 'NavigationMobile', readonly aboutMenuEntries?: (
    { readonly __typename?: 'NavigationSection' }
    & INavigationSectionFragment
  ) | null };

export type INavigationTabFragment = { readonly __typename?: 'NavigationMobileTab', readonly _key?: string | null, readonly _type?: string | null, readonly hideOnDesktop?: boolean | null, readonly hideLinkBasedOnLdFlag?: { readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag?: string | null } | null, readonly tabIcon?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly tabIconActive?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly tabLink?: (
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null, readonly launchDarklyAlternateMobileTab?: { readonly __typename?: 'LaunchDarklyNavigationTab', readonly _key?: string | null, readonly _type?: string | null, readonly enabled?: boolean | null, readonly launchDarklyFlagDependency?: { readonly __typename?: 'LaunchDarklySelect', readonly launchDarklyFlag?: string | null } | null, readonly tabIcon?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly tabIconActive?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly tabLink?: (
      { readonly __typename?: 'LinkWidget' }
      & ILinkWidgetFragment
    ) | null } | null };

export type INavigationButtonFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationMobileHeaderButton?: { readonly __typename?: 'NavigationMobileHeaderButton', readonly _key?: string | null, readonly icon?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly iconActive?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null, readonly link?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null };

export type INutritionItemFragment = { readonly __typename?: 'NutritionItem', readonly _type?: string | null, readonly nutritionKey?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly unit?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly additionalItems?: ReadonlyArray<{ readonly __typename?: 'NutritionItem', readonly nutritionKey?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly unit?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null> | null };

export type INutritionItemGroupFragment = { readonly __typename?: 'NutritionItemGroup', readonly _key?: string | null, readonly _type?: string | null, readonly mainItem?: (
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  ) | null, readonly lineItems?: ReadonlyArray<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  ) | null> | null };

export type INutritionTableFragment = { readonly __typename?: 'NutritionTable', readonly _key?: string | null, readonly _type?: string | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly items?: ReadonlyArray<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  ) | (
    { readonly __typename?: 'NutritionItemGroup' }
    & INutritionItemGroupFragment
  ) | null> | null };

export type IRoundingRulesFragment = { readonly __typename?: 'RoundingRules', readonly enabled?: boolean | null, readonly decimalPlaces?: number | null, readonly roundingType?: string | null };

export type IOffersPageMarketingTileFragment = { readonly __typename?: 'OffersPageMarketingTile', readonly displayPosition?: string | null, readonly customPosition?: number | null, readonly marketingTileReference?: (
    { readonly __typename?: 'MarketingTile' }
    & IMarketingTileFragment
  ) | null };

export type IItemUnavailableModalFragment = { readonly __typename?: 'FeatureStaticMenu', readonly itemUnavailableModal?: { readonly __typename?: 'ItemUnavailableModal', readonly _key?: string | null, readonly _type?: string | null, readonly header?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly body?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly continue?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly selectNew?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly itemNotAvailableForDelivery?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
        { readonly __typename?: 'Image' }
        & IImageFragment
      ) | null } | null } | null };

export type ICopyrightAndLanguageSelectorFragment = { readonly __typename?: 'CopyrightAndLanguageSelector', readonly _type?: string | null, readonly copyrightText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IHighlightedLinkWidgetFragment = { readonly __typename?: 'HighlightedLinkWidget', readonly _key?: string | null, readonly _type?: string | null, readonly text?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly link?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null };

export type IHighlightedVerticalLinkListWidgetFragment = { readonly __typename?: 'HighlightedVerticalLinkListWidget', readonly _type?: string | null, readonly header?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly subheader?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly highlightedLinks?: ReadonlyArray<(
    { readonly __typename?: 'HighlightedLinkWidget' }
    & IHighlightedLinkWidgetFragment
  ) | null> | null };

export type IHorizontalLinkListWidgetFragment = { readonly __typename?: 'HorizontalLinkListWidget', readonly _type?: string | null, readonly linkWidgets?: ReadonlyArray<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null> | null };

export type IImageWidgetFragment = { readonly __typename?: 'ImageWidget', readonly _type?: string | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type ISocialIconsWithHeaderWidgetFragment = { readonly __typename?: 'SocialIconsWithHeaderWidget', readonly _type?: string | null, readonly header?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly socialIconsWidget?: (
    { readonly __typename?: 'SocialIconsWidget' }
    & ISocialIconsWidgetFragment
  ) | null };

export type ISocialIconsWidgetFragment = { readonly __typename?: 'SocialIconsWidget', readonly _type?: string | null, readonly instagramUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly facebookUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly youtubeUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly twitterUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly tiktokUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null };

export type ITextWidgetFragment = { readonly __typename?: 'TextWidget', readonly _type?: string | null, readonly text?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IVerticalLinkListWithHeaderWidgetFragment = { readonly __typename?: 'VerticalLinkListWithHeaderWidget', readonly _type?: string | null, readonly header?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly linkWidgets?: ReadonlyArray<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null> | null };

export type IVerticalLinkListWidgetFragment = { readonly __typename?: 'VerticalLinkListWidget', readonly _type?: string | null, readonly linkWidgets?: ReadonlyArray<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null> | null };

export type IWordmarkAndSocialIconsFragment = { readonly __typename?: 'WordmarkAndSocialIcons', readonly _type?: string | null, readonly socialIconsWidget?: (
    { readonly __typename?: 'SocialIconsWidget' }
    & ISocialIconsWidgetFragment
  ) | null };

export type IRefFragment = { readonly __typename?: 'Image', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id: string } | null };

export type IImageFragment = { readonly __typename?: 'Image', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly metadata?: { readonly __typename?: 'SanityImageMetadata', readonly blurHash?: string | null } | null } | null };

export type IImagesFragment = { readonly __typename?: 'Images', readonly imageDescription?: string | null, readonly app?: (
    { readonly __typename?: 'Image' }
    & IImageFragment
  ) | null, readonly kiosk?: (
    { readonly __typename?: 'Image' }
    & IImageFragment
  ) | null };

export type IItemAvailabilityFragment = { readonly __typename?: 'Item', readonly showInStaticMenu?: boolean | null, readonly hideCalories?: boolean | null, readonly hideNutritionLegalDisclaimer?: boolean | null, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null, readonly options?: ReadonlyArray<(
    { readonly __typename?: 'ItemOption' }
    & IItemOptionAvailabilityFragment
  ) | null> | null };

export type IItemOptionAvailabilityFragment = { readonly __typename?: 'ItemOption', readonly injectDefaultSelection?: boolean | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'ItemOptionModifier', readonly default?: boolean | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null, readonly modifierMultiplier?: { readonly __typename?: 'ModifierMultiplier', readonly vendorConfigs?: (
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      ) | null, readonly modifier?: { readonly __typename?: 'Modifier', readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | null } | null } | null> | null };

export type IItemOptionFragment = { readonly __typename?: 'ItemOption', readonly componentStyle?: string | null, readonly upsellModifier?: boolean | null, readonly allowMultipleSelections?: boolean | null, readonly displayModifierMultiplierName?: boolean | null, readonly injectDefaultSelection?: boolean | null, readonly singleChoiceOnly?: boolean | null, readonly minAmount?: number | null, readonly maxAmount?: number | null, readonly _key?: string | null, readonly type?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly displayGroup?: { readonly __typename?: 'DisplayGroup', readonly autoExpandAccordion?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'ItemOptionModifier', readonly _key?: string | null, readonly default?: boolean | null, readonly type?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null, readonly modifierMultiplier?: { readonly __typename?: 'ModifierMultiplier', readonly multiplier?: number | null, readonly prefix?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly modifier?: { readonly __typename?: 'Modifier', readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly image?: (
          { readonly __typename?: 'Image' }
          & IMenuImageFragment
        ) | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | null, readonly vendorConfigs?: (
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      ) | null } | null, readonly nutrition?: (
      { readonly __typename?: 'Nutrition' }
      & INutritionFragment
    ) | null } | null> | null };

export type IItemFragment = { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly rewardEligible?: boolean | null, readonly isDummyItem?: boolean | null, readonly labelAsPerPerson?: boolean | null, readonly hideCalories?: boolean | null, readonly hideNutritionLegalDisclaimer?: boolean | null, readonly showInStaticMenu?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly image?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly nutrition?: (
    { readonly __typename?: 'Nutrition' }
    & INutritionFragment
  ) | null, readonly additionalItemInformation?: (
    { readonly __typename?: 'AdditionalItemInformation' }
    & IAdditionalItemInformationFragment
  ) | null, readonly nutritionWithModifiers?: (
    { readonly __typename?: 'Nutrition' }
    & INutritionFragment
  ) | null, readonly allergens?: (
    { readonly __typename?: 'OpAllergen' }
    & IAllergensFragment
  ) | null, readonly options?: ReadonlyArray<(
    { readonly __typename?: 'ItemOption' }
    & IItemOptionFragment
  ) | null> | null, readonly productHierarchy?: { readonly __typename?: 'ProductHierarchy', readonly L1?: string | null, readonly L2?: string | null, readonly L3?: string | null, readonly L4?: string | null, readonly L5?: string | null } | null, readonly menuObjectSettings?: { readonly __typename?: 'MenuObjectSettings', readonly limitPerOrder?: number | null } | null, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type ILinkWidgetFragment = { readonly __typename?: 'LinkWidget', readonly _key?: string | null, readonly _type?: string | null, readonly text?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly link?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null };

export type ILoadingGraphicsFragment = { readonly __typename?: 'LoadingGraphics', readonly cartInitialLoader?: { readonly __typename?: 'Loader', readonly desktopGraphic?: (
      { readonly __typename?: 'Image' }
      & IRefFragment
    ) | null, readonly mobileGraphic?: (
      { readonly __typename?: 'Image' }
      & IRefFragment
    ) | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly text?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null };

export type ILocaleImageFragment = { readonly __typename?: 'LocaleImage', readonly en?: (
    { readonly __typename?: 'Image' }
    & IImageFragment
  ) | null, readonly fr?: (
    { readonly __typename?: 'Image' }
    & IImageFragment
  ) | null, readonly locale?: (
    { readonly __typename?: 'Image' }
    & IImageFragment
  ) | null };

export type ILocaleStringFragment = { readonly __typename?: 'LocaleString', readonly locale?: string | null };

export type ILocaleVideoFileFragment = { readonly __typename?: 'LocaleFile', readonly locale?: (
    { readonly __typename?: 'File' }
    & IVideoFileFragment
  ) | null };

export type IClaimPointsSimplifiedContentFragment = { readonly __typename?: 'ClaimPointsSimplifiedContent', readonly expirationTimeReceipts?: number | null, readonly rewardsIcon?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly secondImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly screenTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly instructionsTextBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly secondInstructionsTextBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly buttonTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly errorDialogButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly errorDialogMessage?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly errorDialogTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly successDialogButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly successDialogMessage?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly successDialogTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly expirationDateInstructionsTextBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly inputBoxExpirationDatePlaceholder?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IClaimPointsScreenContentFragment = { readonly __typename?: 'ClaimPointsScreenContent', readonly rewardsIcon?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly secondImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly screenTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly instructionsTextBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly topButtonTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly topButtonUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly bottomButtonTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly bottomButtonUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null };

export type IClaimPointsSurveyContentFragment = { readonly __typename?: 'ClaimPointsSurveyScreenContent', readonly expirationTimeReceipts?: number | null, readonly rewardsIcon?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly secondImage?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly screenTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly instructionsTextBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly expirationDateInstructionsTextBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly inputBoxExpirationDatePlaceholder?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly topButtonTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly topButtonUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly bottomButtonTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly bottomButtonUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null };

export type IClaimPointsQrCodeContentFragment = { readonly __typename?: 'ClaimQrCode', readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly body?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly link?: (
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null };

export type IClaimPointsFailedSubmissionContentFragment = { readonly __typename?: 'ClaimPointsFailedSubmissionContent', readonly screenTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly failureTextBlock?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly buttonTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null };

export type ILoyaltyOfferTemplateFragment = { readonly __typename?: 'OfferTemplate', readonly _id: string, readonly _type: string, readonly loyaltyEngineId?: string | null, readonly name?: { readonly __typename?: 'LocaleSmartBlockContent', readonly localeRaw?: any | null } | null, readonly description?: { readonly __typename?: 'LocaleSmartBlockContent', readonly localeRaw?: any | null } | null, readonly backgroundImage?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly localizedImage?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    ) | null } | null };

export type IPlaceholderFieldFragment = { readonly __typename?: 'PlaceholderField', readonly _id: string, readonly formatter?: string | null, readonly path?: string | null, readonly fieldId?: string | null };

export type IShortCodeConfirmationModalFragment = { readonly __typename?: 'ShortCodeConfirmationModalContent', readonly image?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IImagesFragment
    ) | null } | null, readonly header?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly body?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly actionButton?: { readonly __typename?: 'ActionButton', readonly buttonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly buttonPath?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly dismissButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type ILoyaltyButtonWidgetFragment = { readonly __typename?: 'LoyaltyButtonWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly link?: (
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null };

export type ILoyaltyImageWidgetFragment = { readonly __typename?: 'LoyaltyImageWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly image?: (
    { readonly __typename?: 'LocaleImage' }
    & ILocaleImageFragment
  ) | null };

export type ILoyaltyTextWidgetFragment = { readonly __typename?: 'LoyaltyTextWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly text?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null };

export type ILoyaltyTitleWidgetFragment = { readonly __typename?: 'LoyaltyTitleWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly title?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null };

export type ILoyaltyPaymentMethodWidgetFragment = { readonly __typename?: 'LoyaltyPaymentMethodWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly title?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null };

export type ILoyaltyCartWidgetFragment = { readonly __typename?: 'LoyaltyCartWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly loyaltyEmptyCartTileWidget?: (
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  ) | null };

export type ILoyaltyShortCodeWidgetFragment = { readonly __typename?: 'LoyaltyShortCodeWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly defaultCode?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null, readonly title?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null, readonly alternativeTitle?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null, readonly subtitle?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null };

export type ILoyaltyQrCodeWidgetFragment = { readonly __typename?: 'LoyaltyQRCodeWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly title?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null, readonly subtitle?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null, readonly expirationMessage?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null, readonly phoneNumberTextMessage?: (
    { readonly __typename?: 'LocaleString' }
    & ILocaleStringFragment
  ) | null };

export type ILoyaltyBasicCardWidgetFragment = { readonly __typename?: 'LoyaltyBasicCardWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly linkedCard?: (
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  ) | null, readonly unlinkedCard?: (
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  ) | null };

export type ILoyaltyButtonLinkTextWidgetFragment = { readonly __typename?: 'LoyaltyButtonLinkTextWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly type?: string | null, readonly link?: (
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  ) | null };

export type ILoyaltyButtonArrayWidgetFragment = { readonly __typename?: 'LoyaltyButtonArrayWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly buttons?: ReadonlyArray<(
    { readonly __typename?: 'LoyaltyButtonLinkTextWidget' }
    & ILoyaltyButtonLinkTextWidgetFragment
  ) | null> | null };

export type ILoyaltyQrAndShortCodeModalContentFragment = { readonly __typename?: 'LoyaltyQRAndShortCodeModalContent', readonly _key?: string | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly details?: { readonly __typename?: 'LocaleBlockContent', readonly locale?: any | null } | null, readonly image?: (
    { readonly __typename?: 'Image' }
    & IImageFragment
  ) | null, readonly buttonCtaLabel?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type ILoyaltyQrAndShortCodeWidgetFragment = { readonly __typename?: 'LoyaltyQRAndShortCodeWidget', readonly _key?: string | null, readonly componentKey?: string | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly shortCodeText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly shortCodeExpirationTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly shortCodeExpirationButtonCtaLabel?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly qrAndShortCodeHowToEarnModalContent?: (
    { readonly __typename?: 'LoyaltyQRAndShortCodeModalContent' }
    & ILoyaltyQrAndShortCodeModalContentFragment
  ) | null, readonly qrAndShortCodeSuccessModalContent?: (
    { readonly __typename?: 'LoyaltyQRAndShortCodeModalContent' }
    & ILoyaltyQrAndShortCodeModalContentFragment
  ) | null, readonly qrAndShortCodeErrorModalContent?: (
    { readonly __typename?: 'LoyaltyQRAndShortCodeModalContent' }
    & ILoyaltyQrAndShortCodeModalContentFragment
  ) | null };

export type IMarketingTileFragment = { readonly __typename?: 'MarketingTile', readonly _id: string, readonly textAlignment?: string | null, readonly buttonAlignment?: string | null, readonly textColor?: string | null, readonly lockedAspectRatio?: boolean | null, readonly backgroundImage?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IImagesFragment
    ) | null } | null, readonly buttonAction?: { readonly __typename?: 'LinkAction', readonly route?: string | null, readonly actionText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly actionUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null, readonly textBlock?: { readonly __typename?: 'LocaleTypographyBlock', readonly localeRaw?: any | null } | null, readonly termsText?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly termsButton?: { readonly __typename?: 'LinkAction', readonly actionText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly actionUrl?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null, readonly ruleSet?: { readonly __typename?: 'MarketingTileRuleSet', readonly dayOfWeek?: { readonly __typename?: 'DayOfWeekBand', readonly monday?: boolean | null, readonly tuesday?: boolean | null, readonly wednesday?: boolean | null, readonly thursday?: boolean | null, readonly friday?: boolean | null, readonly saturday?: boolean | null, readonly sunday?: boolean | null } | null, readonly betweenTimes?: { readonly __typename?: 'BetweenTimes', readonly startTime?: string | null, readonly endTime?: string | null } | null } | null };

export type IMarketingTileBasicFragment = { readonly __typename?: 'MarketingTileBasic', readonly _id: string, readonly marketingBasicTileDescription?: { readonly __typename?: 'LocaleTypographyBlock', readonly localeRaw?: any | null } | null, readonly marketingBasicTileImage?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IImagesFragment
    ) | null } | null, readonly marketingBasicTileTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly link?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly linkLabel?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IMarketingTileListFragment = { readonly __typename: 'MarketingTileList', readonly _type?: string | null, readonly tiles?: ReadonlyArray<(
    { readonly __typename?: 'MarketingTileBasic' }
    & IMarketingTileBasicFragment
  ) | null> | null };

export type IMenuImageFragment = { readonly __typename?: 'Image', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id: string } | null };

export type IMenuImagesFragment = { readonly __typename?: 'Images', readonly imageDescription?: string | null, readonly app?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly kiosk?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null };

export type INotificationDetailsFragment = { readonly __typename?: 'NotificationDetails', readonly enabled?: boolean | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly path?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type INutritionFragment = { readonly __typename?: 'Nutrition', readonly calories?: number | null, readonly fat?: number | null, readonly saturatedFat?: number | null, readonly transFat?: number | null, readonly cholesterol?: number | null, readonly sodium?: number | null, readonly salt?: number | null, readonly carbohydrates?: number | null, readonly fiber?: number | null, readonly sugar?: number | null, readonly proteins?: number | null, readonly weight?: number | null };

export type IOffersSelectRestaurantCtaFragment = { readonly __typename?: 'OffersBrowsingPanel', readonly offersSelectRestaurantCta?: { readonly __typename?: 'OffersSelectRestaurantCta', readonly minimumNumberOfOffers?: number | null, readonly title?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly body?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly ctaButtonText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly link?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null } | null };

export type IAllowRedemptionWithoutLoginFragment = { readonly __typename?: 'AllowRedemptionWithoutLogin', readonly ruleSetType?: string | null };

export type IBetweenDatesFragment = { readonly __typename?: 'BetweenDates', readonly endDate?: any | null, readonly startDate?: any | null, readonly ruleSetType?: string | null };

export type IBetweenTimesFragment = { readonly __typename?: 'BetweenTimes', readonly endTime?: string | null, readonly startTime?: string | null, readonly ruleSetType?: string | null };

export type ICartPropertyFragment = { readonly __typename?: 'CartProperty', readonly key?: string | null, readonly negated?: boolean | null, readonly operator?: string | null, readonly value?: string | null, readonly ruleSetType?: string | null };

export type ICoolDownFragment = { readonly __typename?: 'CoolDown', readonly minimumElapsedTimeSeconds?: number | null, readonly ruleSetType?: string | null };

export type IDayOfWeekBandFragment = { readonly __typename?: 'DayOfWeekBand', readonly monday?: boolean | null, readonly tuesday?: boolean | null, readonly wednesday?: boolean | null, readonly thursday?: boolean | null, readonly friday?: boolean | null, readonly saturday?: boolean | null, readonly sunday?: boolean | null, readonly ruleSetType?: string | null };

export type IFirstOrderOnlyFragment = { readonly __typename?: 'FirstOrderOnly', readonly ruleSetType?: string | null };

export type ILimitFragment = { readonly __typename?: 'Limit', readonly interval?: string | null, readonly maximumRedemptions?: number | null, readonly ruleSetType?: string | null };

export type IPaymentCardTypeFragment = { readonly __typename?: 'PaymentCardType', readonly cardType?: string | null, readonly ruleSetType?: string | null };

export type IPurchaseFragment = { readonly __typename?: 'Purchase', readonly quantity?: number | null, readonly sanityId?: string | null, readonly ruleSetType?: string | null, readonly option?: (
    { readonly __typename?: 'Combo' }
    & IComboMetaFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  ) | (
    { readonly __typename?: 'Picker' }
    & IPickerMetaFragment
  ) | (
    { readonly __typename?: 'ProductCategory' }
    & IProductCategoryFragment
  ) | null };

export type IRequiresAssignmentFragment = { readonly __typename?: 'RequiresAssignment', readonly ruleSetType?: string | null };

export type IRestaurantGroupRestrictionListFragment = { readonly __typename?: 'RestaurantGroupRestrictions', readonly ruleSetType?: string | null, readonly restaurantGroupRestrictionList?: ReadonlyArray<{ readonly __typename?: 'RestaurantGroup', readonly restaurants?: ReadonlyArray<{ readonly __typename?: 'Restaurant', readonly number?: string | null } | null> | null } | null> | null };

export type IItemMetaFragment = { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type IComboMetaFragment = { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem?: (
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  ) | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type IPickerMetaFragment = { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly options?: ReadonlyArray<{ readonly __typename?: 'PickerOption', readonly option?: (
      { readonly __typename?: 'Combo' }
      & IComboMetaFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemMetaFragment
    ) | null } | null> | null };

export type IActivateOfferMetaFragment = { readonly __typename?: 'OfferActivation', readonly _type: string };

export type IDiscountOfferMetaFragment = { readonly __typename?: 'OfferDiscount', readonly discountValue?: number | null, readonly discountType?: string | null, readonly _type: string };

export type IOffersFragment = { readonly __typename?: 'Offer', readonly _id: string, readonly _type: string, readonly daypart?: ReadonlyArray<string | null> | null, readonly forSupport?: boolean | null, readonly redemptionMethod?: string | null, readonly offerPrice?: number | null, readonly uiPattern?: string | null, readonly shortCode?: string | null, readonly name?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly headerSuperText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly moreInfo?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly howToRedeem?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly backgroundImage?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly offerTags?: ReadonlyArray<{ readonly __typename?: 'Tag', readonly value?: string | null, readonly _id: string } | null> | null, readonly offerCTA?: { readonly __typename?: 'LinkAction', readonly route?: string | null, readonly actionText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly marketPrice?: { readonly __typename?: 'Combo', readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename?: 'Item', readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | null, readonly localizedImage?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    ) | null } | null, readonly option?: (
    { readonly __typename?: 'Combo' }
    & IComboMetaFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  ) | (
    { readonly __typename?: 'OfferActivation' }
    & IActivateOfferMetaFragment
  ) | (
    { readonly __typename?: 'OfferDiscount' }
    & IDiscountOfferMetaFragment
  ) | { readonly __typename?: 'OfferLoyaltyAction' } | (
    { readonly __typename?: 'Picker' }
    & IPickerMetaFragment
  ) | null, readonly lockedOffersPanel?: { readonly __typename?: 'LockedOffersPanel', readonly completedChallengeHeader?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly completedChallengeDescription?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null, readonly promoCodePanel?: { readonly __typename?: 'PromoCodePanel', readonly promoCodeLink?: string | null, readonly promoCodeDescription?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly promoCodeLabel?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null, readonly ruleSet?: ReadonlyArray<(
    { readonly __typename?: 'AllowRedemptionWithoutLogin' }
    & IAllowRedemptionWithoutLoginFragment
  ) | { readonly __typename?: 'And', readonly ruleSetType?: string | null, readonly ruleSet?: ReadonlyArray<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | { readonly __typename?: 'IsStackable' } | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    ) | null> | null } | (
    { readonly __typename?: 'BetweenDates' }
    & IBetweenDatesFragment
  ) | (
    { readonly __typename?: 'BetweenTimes' }
    & IBetweenTimesFragment
  ) | { readonly __typename?: 'CartContainsPlu' } | (
    { readonly __typename?: 'CartProperty' }
    & ICartPropertyFragment
  ) | (
    { readonly __typename?: 'CoolDown' }
    & ICoolDownFragment
  ) | (
    { readonly __typename?: 'DayOfWeekBand' }
    & IDayOfWeekBandFragment
  ) | (
    { readonly __typename?: 'FirstOrderOnly' }
    & IFirstOrderOnlyFragment
  ) | (
    { readonly __typename?: 'Limit' }
    & ILimitFragment
  ) | { readonly __typename?: 'Or', readonly ruleSetType?: string | null, readonly ruleSet?: ReadonlyArray<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    ) | null> | null } | (
    { readonly __typename?: 'OrderHistory' }
    & IOrderHistoryFragment
  ) | (
    { readonly __typename?: 'PaymentCardType' }
    & IPaymentCardTypeFragment
  ) | (
    { readonly __typename?: 'Purchase' }
    & IPurchaseFragment
  ) | (
    { readonly __typename?: 'RequiresAssignment' }
    & IRequiresAssignmentFragment
  ) | (
    { readonly __typename?: 'RestaurantGroupRestrictions' }
    & IRestaurantGroupRestrictionListFragment
  ) | null> | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type IOptInSettingBooleanFragment = { readonly __typename?: 'OptInSettingBoolean', readonly _key?: string | null, readonly _type?: string | null, readonly key?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IOptInSettingEmailAndPushFragment = { readonly __typename?: 'OptInSettingEmailAndPush', readonly _key?: string | null, readonly _type?: string | null, readonly pushKey?: string | null, readonly emailKey?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IOptInSettingEnumFragment = { readonly __typename?: 'OptInSettingEnum', readonly _key?: string | null, readonly _type?: string | null, readonly key?: string | null, readonly enumStrings?: ReadonlyArray<string | null> | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IOptInPrivacyPreferencesFragment = { readonly __typename?: 'OptInPrivacyPreferences', readonly _key?: string | null, readonly _type?: string | null, readonly key?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly view?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null };

export type IOrderHistoryFragment = { readonly __typename?: 'OrderHistory', readonly rangeType?: string | null, readonly from?: any | null, readonly to?: any | null, readonly lastNSeconds?: number | null, readonly isSequential?: boolean | null, readonly ruleSetType?: string | null, readonly ruleSet?: ReadonlyArray<{ readonly __typename?: 'And', readonly ruleSetType?: string | null, readonly ruleSet?: ReadonlyArray<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | { readonly __typename?: 'IsStackable' } | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    ) | null> | null } | (
    { readonly __typename?: 'BetweenTimes' }
    & IBetweenTimesFragment
  ) | { readonly __typename?: 'CartContainsPlu' } | (
    { readonly __typename?: 'CartProperty' }
    & ICartPropertyFragment
  ) | (
    { readonly __typename?: 'DayOfWeekBand' }
    & IDayOfWeekBandFragment
  ) | { readonly __typename?: 'Or', readonly ruleSetType?: string | null, readonly ruleSet?: ReadonlyArray<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | { readonly __typename?: 'CartRequirement' } | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    ) | null> | null } | (
    { readonly __typename?: 'PaymentCardType' }
    & IPaymentCardTypeFragment
  ) | (
    { readonly __typename?: 'Purchase' }
    & IPurchaseFragment
  ) | null> | null };

export type IPickerFragment = { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly uiPattern?: string | null, readonly isOfferBenefit?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly pickerDefaults?: ReadonlyArray<{ readonly __typename?: 'PickerItemMapping', readonly _key?: string | null, readonly pickerAspectValueIdentifier?: string | null, readonly pickerAspect?: { readonly __typename?: 'PickerAspect', readonly _id: string, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null } | null> | null, readonly pickerAspects?: ReadonlyArray<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly _type: string, readonly uiPattern?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly pickerAspectOptions?: ReadonlyArray<{ readonly __typename?: 'PickerAspectValue', readonly identifier?: string | null, readonly hideNameInItemPreview?: boolean | null, readonly showInStaticMenu?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly image?: (
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      ) | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null> | null } | null> | null, readonly pickerAspectItemOptionMappings?: ReadonlyArray<{ readonly __typename?: 'PickerAspectItemOptions', readonly pickerAspect?: { readonly __typename?: 'PickerAspect', readonly _id: string, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'ListItem', readonly value?: string | null } | null> | null } | null> | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'PickerOption', readonly _key?: string | null, readonly default?: boolean | null, readonly type?: string | null, readonly pickerItemMappings?: ReadonlyArray<{ readonly __typename?: 'PickerItemMapping', readonly pickerAspectValueIdentifier?: string | null, readonly pickerAspect?: { readonly __typename?: 'PickerAspect', readonly _id: string } | null } | null> | null, readonly option?: (
      { readonly __typename?: 'Combo', readonly _key?: string | null, readonly _id: string, readonly promotion?: { readonly __typename?: 'SystemwidePromotion', readonly bonusPoints?: number | null, readonly loyaltyEngineId?: string | null } | null }
      & IComboFragment
    ) | (
      { readonly __typename?: 'Item', readonly _key?: string | null, readonly promotion?: { readonly __typename?: 'SystemwidePromotion', readonly bonusPoints?: number | null, readonly loyaltyEngineId?: string | null } | null }
      & IItemFragment
    ) | null } | null> | null, readonly image?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly quickConfigs?: ReadonlyArray<(
    { readonly __typename?: 'QuickConfig' }
    & IQuickConfigFragment
  ) | null> | null, readonly channelExclusions?: { readonly __typename?: 'ChannelExclusions', readonly delivery?: boolean | null, readonly pickup?: boolean | null, readonly kiosk?: boolean | null, readonly googleFoodOrdering?: boolean | null } | null };

export type IProductCategoryFragment = { readonly __typename?: 'ProductCategory', readonly _id: string, readonly hierarchyLevel?: string | null, readonly ruleSetType: string, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly image?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null };

export type IQuickConfigFragment = { readonly __typename?: 'QuickConfig', readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly rules?: ReadonlyArray<{ readonly __typename?: 'QuickConfigRule', readonly itemOptions?: ReadonlyArray<{ readonly __typename?: 'ListItem', readonly value?: string | null } | null> | null, readonly modifier?: { readonly __typename?: 'ListItem', readonly value?: string | null } | null } | null> | null };

export type IRewardFragment = { readonly __typename?: 'Reward', readonly _id: string, readonly loyaltyEngineId?: string | null, readonly incentiveNotInMenu?: boolean | null, readonly mobileOrderOnly?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly enRaw?: any | null } | null, readonly moreInfo?: { readonly __typename?: 'LocaleBlockContent', readonly enRaw?: any | null } | null, readonly howToRedeem?: { readonly __typename?: 'LocaleBlockContent', readonly enRaw?: any | null } | null, readonly backgroundImage?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly incentives?: ReadonlyArray<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly options?: ReadonlyArray<{ readonly __typename?: 'PickerOption', readonly option?: { readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null, readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | null } | null> | null } | null> | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type ICmsConfigRewardFragment = { readonly __typename?: 'ConfigReward', readonly _id: string, readonly loyaltyEngineId?: string | null, readonly incentiveNotInMenu?: boolean | null, readonly mobileOrderOnly?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly locale?: any | null } | null, readonly moreInfo?: { readonly __typename?: 'LocaleBlockContent', readonly enRaw?: any | null } | null, readonly howToRedeem?: { readonly __typename?: 'LocaleBlockContent', readonly enRaw?: any | null } | null, readonly backgroundImage?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
      { readonly __typename?: 'Image' }
      & IImageFragment
    ) | null } | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly incentives?: ReadonlyArray<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly options?: ReadonlyArray<{ readonly __typename?: 'PickerOption', readonly option?: { readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null } | null> | null } | null> | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type IRewardsSectionFragment = { readonly __typename?: 'RewardsSection', readonly _id: string, readonly rewardsList?: ReadonlyArray<{ readonly __typename?: 'FeaturedReward', readonly reward?: (
      { readonly __typename?: 'Reward' }
      & IRewardFragment
    ) | null, readonly category?: { readonly __typename?: 'RewardCategory', readonly label?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly image?: { readonly __typename?: 'LocaleImage', readonly locale?: (
          { readonly __typename?: 'Image' }
          & IImageFragment
        ) | null } | null } | null } | null> | null };

export type ISectionFragment = { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly uiPattern?: string | null, readonly redirectLink?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly image?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly carouselImage?: (
    { readonly __typename?: 'Image' }
    & IImageFragment
  ) | null, readonly carouselImageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly headerSuperText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly headerText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly options?: ReadonlyArray<(
    { readonly __typename?: 'Combo' }
    & IComboFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemFragment
  ) | { readonly __typename?: 'Offer' } | (
    { readonly __typename?: 'Picker' }
    & IPickerFragment
  ) | { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly uiPattern?: string | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly redirectLink?: { readonly __typename?: 'LocaleUrl', readonly locale?: string | null } | null, readonly channelExclusions?: { readonly __typename?: 'ChannelExclusions', readonly delivery?: boolean | null, readonly pickup?: boolean | null, readonly kiosk?: boolean | null, readonly googleFoodOrdering?: boolean | null } | null, readonly image?: (
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    ) | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly headerSuperText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly imageDescription?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly options?: ReadonlyArray<(
      { readonly __typename?: 'Combo' }
      & IComboFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemFragment
    ) | { readonly __typename?: 'Offer' } | (
      { readonly __typename?: 'Picker' }
      & IPickerFragment
    ) | { readonly __typename?: 'Section', readonly _type: string, readonly _id: string, readonly uiPattern?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly options?: ReadonlyArray<(
        { readonly __typename?: 'Combo' }
        & IComboFragment
      ) | (
        { readonly __typename?: 'Item' }
        & IItemFragment
      ) | { readonly __typename?: 'Offer' } | (
        { readonly __typename?: 'Picker' }
        & IPickerFragment
      ) | { readonly __typename?: 'Section' } | null> | null } | null> | null } | null> | null };

export type ISystemwideOffersFragment = { readonly __typename?: 'SystemwideOffer', readonly _id: string, readonly _type: string, readonly loyaltyEngineId?: string | null, readonly shortCode?: string | null, readonly mobileOrderOnly?: boolean | null, readonly daypart?: ReadonlyArray<string | null> | null, readonly redemptionType?: string | null, readonly offerPrice?: number | null, readonly uiPattern?: string | null, readonly name?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly description?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly moreInfo?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly howToRedeem?: { readonly __typename?: 'LocaleBlockContent', readonly enRaw?: any | null } | null, readonly backgroundImage?: (
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  ) | null, readonly marketPrice?: { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | null, readonly localizedImage?: { readonly __typename?: 'LocaleImages', readonly locale?: (
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    ) | null } | null, readonly lockedOffersPanel?: { readonly __typename?: 'LockedOffersPanel', readonly completedChallengeHeader?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly completedChallengeDescription?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null, readonly promoCodePanel?: { readonly __typename?: 'PromoCodePanel', readonly promoCodeLink?: string | null, readonly promoCodeDescription?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null, readonly promoCodeLabel?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null, readonly incentives?: ReadonlyArray<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly isOfferBenefit?: boolean | null, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'FeesV1Discount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null, readonly discountFees?: ReadonlyArray<string | null> | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    ) | null } | { readonly __typename: 'ItemGroupDiscount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null, readonly maxItemsDiscount?: number | null, readonly applicableItems?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string } | { readonly __typename?: 'ItemGroup', readonly _id: string, readonly _type: string } | null } | { readonly __typename: 'OfferActivation', readonly _id: string, readonly _type: string } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string, readonly discountValue?: number | null, readonly discountType?: string | null } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly isOfferBenefit?: boolean | null, readonly options?: ReadonlyArray<{ readonly __typename?: 'PickerOption', readonly option?: { readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem?: { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null } | null, readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem?: { readonly __typename?: 'OpItem', readonly daypart?: ReadonlyArray<string | null> | null } | null, readonly vendorConfigs?: (
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        ) | null } | null } | null> | null } | { readonly __typename: 'SwapMapping', readonly _type: string } | null> | null, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  ) | null };

export type IVendorConfigFragment = { readonly __typename?: 'VendorConfig', readonly pluType?: string | null, readonly parentSanityId?: string | null, readonly pullUpLevels?: number | null, readonly constantPlu?: string | null, readonly discountPlu?: string | null, readonly quantityBasedPlu?: ReadonlyArray<{ readonly __typename?: 'Plu', readonly quantity?: number | null, readonly plu?: string | null, readonly qualifier?: string | null } | null> | null, readonly multiConstantPlus?: ReadonlyArray<{ readonly __typename?: 'Plu', readonly quantity?: number | null, readonly plu?: string | null, readonly qualifier?: string | null } | null> | null, readonly parentChildPlu?: { readonly __typename?: 'ParentChildPlu', readonly plu?: string | null, readonly childPlu?: string | null } | null, readonly sizeBasedPlu?: { readonly __typename?: 'SizeBasedPlu', readonly comboPlu?: string | null, readonly comboSize?: string | null } | null };

export type IVendorConfigsFragment = { readonly __typename?: 'VendorConfigs', readonly ncr?: (
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  ) | null, readonly ncrDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  ) | null, readonly toast?: (
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  ) | null, readonly toastDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  ) | null };

export type IVideoFileFragment = { readonly __typename?: 'File', readonly asset?: { readonly __typename?: 'SanityFileAsset', readonly assetId?: string | null, readonly path?: string | null, readonly url?: string | null } | null };

export type ISingleLoyaltyContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ISingleLoyaltyContentQuery = { readonly __typename?: 'RootQuery', readonly allLoyaltyContents: ReadonlyArray<{ readonly __typename?: 'LoyaltyContent', readonly _id: string }> };

export type IBirthdayLegalTextQueryVariables = Exact<{
  loyaltyContentId: Scalars['ID'];
}>;


export type IBirthdayLegalTextQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyContent?: { readonly __typename?: 'LoyaltyContent', readonly birthdayLegalText?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null };

export type IGetOfferByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetOfferByIdQuery = { readonly __typename?: 'RootQuery', readonly Offer?: (
    { readonly __typename?: 'Offer' }
    & IOffersFragment
  ) | null };

export type IPlaceholderFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type IPlaceholderFieldsQuery = { readonly __typename?: 'RootQuery', readonly allPlaceholderFields: ReadonlyArray<(
    { readonly __typename?: 'PlaceholderField' }
    & IPlaceholderFieldFragment
  )> };

export type IGetProductCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetProductCategoryQuery = { readonly __typename?: 'RootQuery', readonly ProductCategory?: (
    { readonly __typename?: 'ProductCategory' }
    & IProductCategoryFragment
  ) | null };

export type IGetRestaurantsQueryVariables = Exact<{
  filter?: InputMaybe<IRestaurantFilter>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type IGetRestaurantsQuery = { readonly __typename?: 'RootQuery', readonly allRestaurants: ReadonlyArray<(
    { readonly __typename?: 'Restaurant' }
    & IRestaurantFragment
  )> };

export type IRestaurantFragment = { readonly __typename?: 'Restaurant', readonly _id: string, readonly environment?: string | null, readonly chaseMerchantId?: string | null, readonly drinkStationType?: string | null, readonly driveThruLaneType?: string | null, readonly email?: ReadonlyArray<string | null> | null, readonly franchiseGroupId?: number | null, readonly franchiseGroupName?: string | null, readonly frontCounterClosed?: boolean | null, readonly hasBreakfast?: boolean | null, readonly hasBurgersForBreakfast?: boolean | null, readonly hasCurbside?: boolean | null, readonly hasDineIn?: boolean | null, readonly hasCatering?: boolean | null, readonly hasDelivery?: boolean | null, readonly hasDriveThru?: boolean | null, readonly hasMobileOrdering?: boolean | null, readonly hasParking?: boolean | null, readonly hasPlayground?: boolean | null, readonly hasTakeOut?: boolean | null, readonly hasWifi?: boolean | null, readonly hasLoyalty?: boolean | null, readonly hasPickupWindow?: boolean | null, readonly isDarkKitchen?: boolean | null, readonly isHalal?: boolean | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly mobileOrderingStatus?: string | null, readonly name?: string | null, readonly number?: string | null, readonly parkingType?: string | null, readonly phoneNumber?: string | null, readonly playgroundType?: string | null, readonly posRestaurantId?: string | null, readonly status?: string | null, readonly timezone?: string | null, readonly vatNumber?: string | null, readonly deliveryHours?: (
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  ) | null, readonly diningRoomHours?: (
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  ) | null, readonly curbsideHours?: (
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  ) | null, readonly driveThruHours?: (
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  ) | null, readonly pickupWindowHours?: (
    { readonly __typename?: 'HoursOfOperation' }
    & IHoursFragment
  ) | null, readonly pos?: { readonly __typename?: 'Pos', readonly _type?: string | null, readonly vendor?: string | null } | null, readonly physicalAddress?: { readonly __typename?: 'Address', readonly _type?: string | null, readonly address1?: string | null, readonly address2?: string | null, readonly city?: string | null, readonly country?: string | null, readonly postalCode?: string | null, readonly stateProvince?: string | null } | null, readonly restaurantPosData?: { readonly __typename?: 'RestaurantPosData', readonly _id: string } | null, readonly restaurantImage?: { readonly __typename?: 'Image', readonly asset?: (
      { readonly __typename?: 'SanityImageAsset' }
      & IImageAssetFragment
    ) | null } | null, readonly amenities?: ReadonlyArray<{ readonly __typename?: 'RestaurantAmenity', readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly icon?: { readonly __typename?: 'Image', readonly asset?: (
        { readonly __typename?: 'SanityImageAsset' }
        & IImageAssetFragment
      ) | null } | null } | null> | null };

export type IHoursFragment = { readonly __typename?: 'HoursOfOperation', readonly _type?: string | null, readonly friClose?: string | null, readonly friOpen?: string | null, readonly monClose?: string | null, readonly monOpen?: string | null, readonly satClose?: string | null, readonly satOpen?: string | null, readonly sunClose?: string | null, readonly sunOpen?: string | null, readonly thrClose?: string | null, readonly thrOpen?: string | null, readonly tueClose?: string | null, readonly tueOpen?: string | null, readonly wedClose?: string | null, readonly wedOpen?: string | null };

export type IImageAssetFragment = { readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly label?: string | null, readonly title?: string | null, readonly url?: string | null, readonly source?: { readonly __typename?: 'SanityAssetSourceData', readonly id?: string | null, readonly url?: string | null } | null, readonly metadata?: { readonly __typename?: 'SanityImageMetadata', readonly blurHash?: string | null } | null };

export type IGetRestaurantLoyaltyEnabledQueryVariables = Exact<{
  storeId: Scalars['ID'];
}>;


export type IGetRestaurantLoyaltyEnabledQuery = { readonly __typename?: 'RootQuery', readonly Restaurant?: { readonly __typename?: 'Restaurant', readonly hasLoyalty?: boolean | null } | null };

export type ILoyaltyRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type ILoyaltyRewardsQuery = { readonly __typename?: 'RootQuery', readonly allRewards: ReadonlyArray<(
    { readonly __typename?: 'Reward' }
    & IRewardFragment
  )> };

export type ICmsConfigRewardsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type ICmsConfigRewardsQuery = { readonly __typename?: 'RootQuery', readonly allConfigRewards: ReadonlyArray<(
    { readonly __typename?: 'ConfigReward' }
    & ICmsConfigRewardFragment
  )> };

export type ILoyaltyFeaturedRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type ILoyaltyFeaturedRewardsQuery = { readonly __typename?: 'RootQuery', readonly allRewardsSections: ReadonlyArray<(
    { readonly __typename?: 'RewardsSection' }
    & IRewardsSectionFragment
  )> };

export type IGetSupportDataQueryVariables = Exact<{
  supportDataId: Scalars['ID'];
}>;


export type IGetSupportDataQuery = { readonly __typename?: 'RootQuery', readonly SupportData?: { readonly __typename?: 'SupportData', readonly _id: string, readonly supportCategoryGroups?: ReadonlyArray<{ readonly __typename?: 'SupportCategoryGroup', readonly _id: string, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportSubcategories?: ReadonlyArray<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId?: string | null, readonly supportSubcategoryForwardToOrders?: boolean | null, readonly supportSubcategoryServiceModeSelector?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportSubcategoryFaqs?: ReadonlyArray<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent?: string | null, readonly supportFaqTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportFaqContent?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null> | null } | null> | null } | null> | null, readonly deliveryNeverArriveSubcategory?: { readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly deliveryMissingItemsSubcategory?: { readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId?: string | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null } | null, readonly orderingIssuesCategoryGroup?: { readonly __typename?: 'SupportCategoryGroup', readonly _id: string } | null, readonly supportDataFaqs?: ReadonlyArray<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent?: string | null, readonly supportFaqTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportFaqContent?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null> | null } | null };

export type IGetSupportSubcategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetSupportSubcategoryQuery = { readonly __typename?: 'RootQuery', readonly SupportSubcategory?: { readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly _type: string, readonly _createdAt: any, readonly _key?: string | null, readonly _rev: string, readonly _updatedAt: any, readonly knowledgeForceIssueId?: string | null, readonly directTicketProcessingPercentage?: number | null, readonly supportSubcategoryForwardToOrders?: boolean | null, readonly supportSubcategoryServiceModeSelector?: boolean | null, readonly supportSubcategorySubmitToSutherland?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportSubcategoryFaqs?: ReadonlyArray<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent?: string | null, readonly supportFaqTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportFaqContent?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null> | null, readonly supportSubcategoryFaq?: { readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent?: string | null, readonly supportFaqTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportFaqContent?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null } | null };

export type IGetSupportCategoryGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetSupportCategoryGroupQuery = { readonly __typename?: 'RootQuery', readonly SupportCategoryGroup?: { readonly __typename?: 'SupportCategoryGroup', readonly _id: string, readonly showRestaurantSelector?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportSubcategories?: ReadonlyArray<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId?: string | null, readonly supportSubcategoryForwardToOrders?: boolean | null, readonly supportSubcategoryServiceModeSelector?: boolean | null, readonly name?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportSubcategoryFaqs?: ReadonlyArray<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent?: string | null, readonly supportFaqTitle?: { readonly __typename?: 'LocaleString', readonly locale?: string | null } | null, readonly supportFaqContent?: { readonly __typename?: 'LocaleBlockContent', readonly localeRaw?: any | null } | null } | null> | null } | null> | null } | null };
export const ImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const ColorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alpha"}},{"kind":"Field","name":{"kind":"Name","value":"hex"}},{"kind":"Field","name":{"kind":"Name","value":"hsl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"a"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"l"}},{"kind":"Field","name":{"kind":"Name","value":"s"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hsv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"a"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"s"}},{"kind":"Field","name":{"kind":"Name","value":"v"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rgb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"a"}},{"kind":"Field","name":{"kind":"Name","value":"b"}},{"kind":"Field","name":{"kind":"Name","value":"g"}},{"kind":"Field","name":{"kind":"Name","value":"r"}}]}}]}}]} as unknown as DocumentNode;
export const ActiveCampaignFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureAuthCampaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignImageAltText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaingBackgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldDisplayExtraFields"}}]}}]} as unknown as DocumentNode;
export const ImagesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kiosk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"}}]}}]} as unknown as DocumentNode;
export const VendorConfigFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorConfigFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"pullUpLevels"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"discountPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}}]} as unknown as DocumentNode;
export const VendorConfigsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorConfigsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toastDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigFragment"}}]}}]}}]} as unknown as DocumentNode;
export const ItemOptionAvailabilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemOptionAvailabilityFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ItemOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"injectDefaultSelection"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifierMultiplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const ItemAvailabilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showInStaticMenu"}},{"kind":"Field","name":{"kind":"Name","value":"hideCalories"}},{"kind":"Field","name":{"kind":"Name","value":"hideNutritionLegalDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemOptionAvailabilityFragment"}}]}}]}}]} as unknown as DocumentNode;
export const MenuImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuImageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const NutritionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Nutrition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calories"}},{"kind":"Field","name":{"kind":"Name","value":"fat"}},{"kind":"Field","name":{"kind":"Name","value":"saturatedFat"}},{"kind":"Field","name":{"kind":"Name","value":"transFat"}},{"kind":"Field","name":{"kind":"Name","value":"cholesterol"}},{"kind":"Field","name":{"kind":"Name","value":"sodium"}},{"kind":"Field","name":{"kind":"Name","value":"salt"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates"}},{"kind":"Field","name":{"kind":"Name","value":"fiber"}},{"kind":"Field","name":{"kind":"Name","value":"sugar"}},{"kind":"Field","name":{"kind":"Name","value":"proteins"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]} as unknown as DocumentNode;
export const AdditionalItemInformationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalItemInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdditionalItemInformation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ingredients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"producerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const AllergensFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllergensFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OpAllergen"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"milk"}},{"kind":"Field","name":{"kind":"Name","value":"eggs"}},{"kind":"Field","name":{"kind":"Name","value":"fish"}},{"kind":"Field","name":{"kind":"Name","value":"peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"shellfish"}},{"kind":"Field","name":{"kind":"Name","value":"treeNuts"}},{"kind":"Field","name":{"kind":"Name","value":"soy"}},{"kind":"Field","name":{"kind":"Name","value":"wheat"}},{"kind":"Field","name":{"kind":"Name","value":"mustard"}},{"kind":"Field","name":{"kind":"Name","value":"sesame"}},{"kind":"Field","name":{"kind":"Name","value":"celery"}},{"kind":"Field","name":{"kind":"Name","value":"lupin"}},{"kind":"Field","name":{"kind":"Name","value":"gluten"}},{"kind":"Field","name":{"kind":"Name","value":"sulphurDioxide"}}]}}]} as unknown as DocumentNode;
export const ItemOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemOptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ItemOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoExpandAccordion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"componentStyle"}},{"kind":"Field","name":{"kind":"Name","value":"upsellModifier"}},{"kind":"Field","name":{"kind":"Name","value":"allowMultipleSelections"}},{"kind":"Field","name":{"kind":"Name","value":"displayModifierMultiplierName"}},{"kind":"Field","name":{"kind":"Name","value":"injectDefaultSelection"}},{"kind":"Field","name":{"kind":"Name","value":"singleChoiceOnly"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"modifierMultiplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nutrition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionFragment"}}]}}]}}]}}]} as unknown as DocumentNode;
export const ItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardEligible"}},{"kind":"Field","name":{"kind":"Name","value":"isDummyItem"}},{"kind":"Field","name":{"kind":"Name","value":"labelAsPerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalItemInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalItemInformationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nutritionWithModifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allergens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllergensFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemOptionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productHierarchy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"L1"}},{"kind":"Field","name":{"kind":"Name","value":"L2"}},{"kind":"Field","name":{"kind":"Name","value":"L3"}},{"kind":"Field","name":{"kind":"Name","value":"L4"}},{"kind":"Field","name":{"kind":"Name","value":"L5"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuObjectSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitPerOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideCalories"}},{"kind":"Field","name":{"kind":"Name","value":"hideNutritionLegalDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showInStaticMenu"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const AddOnSectionOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddOnSectionOptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddOnSectionOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityFragment"}}]}}]}}]} as unknown as DocumentNode;
export const AddOnSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddOnSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddOnSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddOnSectionOptionFragment"}}]}}]}}]} as unknown as DocumentNode;
export const MenuImagesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kiosk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"}}]}}]} as unknown as DocumentNode;
export const ConfigOfferFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConfigOfferFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moreInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"howToRedeem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderOnly"}},{"kind":"Field","name":{"kind":"Name","value":"daypart"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionType"}},{"kind":"Field","name":{"kind":"Name","value":"offerPrice"}},{"kind":"Field","name":{"kind":"Name","value":"marketPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localizedImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"lockedOffersPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedChallengeHeader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedChallengeDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodePanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodeLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodeLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOfferBenefit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOfferBenefit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ItemGroupDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"applicableItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxItemsDiscount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeesV1Discount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountFees"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferActivation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapMapping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const RefFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ref"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;
export const MarketingTileBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingTileBasicFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketingTileBasic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"marketingBasicTileDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketingBasicTileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketingBasicTileTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const MarketingTileListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingTileListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketingTileList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"tiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingTileBasicFragment"}}]}}]}}]} as unknown as DocumentNode;
export const EmptyStateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmptyStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptyState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"headerText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketingTileList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingTileListFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"enRaw"}}]}}]}}]} as unknown as DocumentNode;
export const MarketingTileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingTileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketingTile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"textAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"textBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockedAspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"termsText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ruleSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monday"}},{"kind":"Field","name":{"kind":"Name","value":"tuesday"}},{"kind":"Field","name":{"kind":"Name","value":"wednesday"}},{"kind":"Field","name":{"kind":"Name","value":"thursday"}},{"kind":"Field","name":{"kind":"Name","value":"friday"}},{"kind":"Field","name":{"kind":"Name","value":"saturday"}},{"kind":"Field","name":{"kind":"Name","value":"sunday"}}]}},{"kind":"Field","name":{"kind":"Name","value":"betweenTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]}}]} as unknown as DocumentNode;
export const LinkWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const NavigationLinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationDesktopLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"hideLinkBasedOnLdFlag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"launchDarklyFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"navLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"launchDarklyAlternateNavigationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"launchDarklyFlagDependency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"launchDarklyFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"navLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const NavigationLinksFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationLinksFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationDesktop"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationLinkFragment"}}]}}]}}]} as unknown as DocumentNode;
export const NavigationSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaticPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"localeTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localePath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaticPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"localeTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localePath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const AboutMenuEntriesDesktopFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AboutMenuEntriesDesktopFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationDesktop"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aboutMenuEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationSectionFragment"}}]}}]}}]} as unknown as DocumentNode;
export const NavigationDesktopFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationDesktopFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureNavigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationDesktop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationLinksFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AboutMenuEntriesDesktopFragment"}}]}}]}}]} as unknown as DocumentNode;
export const NavigationTabFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationTabFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationMobileTab"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"hideLinkBasedOnLdFlag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"launchDarklyFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabIconActive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideOnDesktop"}},{"kind":"Field","name":{"kind":"Name","value":"launchDarklyAlternateMobileTab"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"launchDarklyFlagDependency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"launchDarklyFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabIconActive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const NavigationTabsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationTabsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationMobile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationTabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationTabFragment"}}]}}]}}]} as unknown as DocumentNode;
export const AboutMenuEntriesMobileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AboutMenuEntriesMobileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationMobile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aboutMenuEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationSectionFragment"}}]}}]}}]} as unknown as DocumentNode;
export const NavigationMobileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationMobileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureNavigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationMobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationTabsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AboutMenuEntriesMobileFragment"}}]}}]}}]} as unknown as DocumentNode;
export const NavigationButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationButtonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureNavigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationMobileHeaderButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconActive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]} as unknown as DocumentNode;
export const NutritionItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NutritionItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"nutritionKey"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NutritionItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nutritionKey"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const NutritionItemGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionItemGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NutritionItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionItemFragment"}}]}}]}}]} as unknown as DocumentNode;
export const NutritionTableFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionTableFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NutritionTable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NutritionItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionItemFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NutritionItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionItemGroupFragment"}}]}}]}}]}}]} as unknown as DocumentNode;
export const RoundingRulesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoundingRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoundingRules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"decimalPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"roundingType"}}]}}]} as unknown as DocumentNode;
export const OffersPageMarketingTileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OffersPageMarketingTileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OffersPageMarketingTile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingTileReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingTileFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayPosition"}},{"kind":"Field","name":{"kind":"Name","value":"customPosition"}}]}}]} as unknown as DocumentNode;
export const ItemUnavailableModalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"itemUnavailableModalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureStaticMenu"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemUnavailableModal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"continue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectNew"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemNotAvailableForDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const CopyrightAndLanguageSelectorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopyrightAndLanguageSelectorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightAndLanguageSelector"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"copyrightText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const HighlightedLinkWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightedLinkWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightedLinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const HighlightedVerticalLinkListWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightedVerticalLinkListWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightedVerticalLinkListWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subheader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highlightedLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighlightedLinkWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const HorizontalLinkListWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HorizontalLinkListWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HorizontalLinkListWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"linkWidgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const ImageWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const SocialIconsWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SocialIconsWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SocialIconsWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"instagramUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"youtubeUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"twitterUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiktokUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const SocialIconsWithHeaderWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SocialIconsWithHeaderWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SocialIconsWithHeaderWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialIconsWidget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SocialIconsWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const TextWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const VerticalLinkListWithHeaderWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VerticalLinkListWithHeaderWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerticalLinkListWithHeaderWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkWidgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const VerticalLinkListWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VerticalLinkListWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerticalLinkListWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"linkWidgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const WordmarkAndSocialIconsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WordmarkAndSocialIconsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WordmarkAndSocialIcons"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"socialIconsWidget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SocialIconsWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoadingGraphicsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoadingGraphicsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoadingGraphics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartInitialLoader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desktopGraphic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ref"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileGraphic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ref"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]} as unknown as DocumentNode;
export const VideoFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoFileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode;
export const LocaleVideoFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocaleVideoFileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoFileFragment"}}]}}]}}]} as unknown as DocumentNode;
export const ClaimPointsSimplifiedContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClaimPointsSimplifiedContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClaimPointsSimplifiedContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructionsTextBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondInstructionsTextBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errorDialogButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errorDialogMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errorDialogTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"successDialogButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"successDialogMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"successDialogTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDateInstructionsTextBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputBoxExpirationDatePlaceholder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationTimeReceipts"}}]}}]} as unknown as DocumentNode;
export const ClaimPointsScreenContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClaimPointsScreenContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClaimPointsScreenContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructionsTextBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topButtonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topButtonUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bottomButtonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bottomButtonUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const ClaimPointsSurveyContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClaimPointsSurveyContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClaimPointsSurveyScreenContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructionsTextBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDateInstructionsTextBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputBoxExpirationDatePlaceholder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationTimeReceipts"}},{"kind":"Field","name":{"kind":"Name","value":"topButtonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topButtonUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bottomButtonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bottomButtonUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const ClaimPointsQrCodeContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClaimPointsQrCodeContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClaimQrCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]}}]} as unknown as DocumentNode;
export const ClaimPointsFailedSubmissionContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"screenTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failureTextBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyOfferTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyOfferTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localizedImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImagesFragment"}}]}}]}}]}}]} as unknown as DocumentNode;
export const PlaceholderFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaceholderFieldFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaceholderField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"formatter"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}}]}}]} as unknown as DocumentNode;
export const ShortCodeConfirmationModalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShortCodeConfirmationModalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShortCodeConfirmationModalContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dismissButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyButtonWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyButtonWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyButtonWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LocaleImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocaleImageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyImageWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyImageWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyImageWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleImageFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LocaleStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocaleStringFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]} as unknown as DocumentNode;
export const LoyaltyTextWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyTextWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTextWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyTitleWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyTitleWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTitleWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyPaymentMethodWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyPaymentMethodWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyPaymentMethodWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyCartWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyCartWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyCartWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEmptyCartTileWidget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingTileBasicFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyShortCodeWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyShortCodeWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyShortCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alternativeTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyQrCodeWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyQRCodeWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQRCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberTextMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyBasicCardWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyBasicCardWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBasicCardWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"linkedCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingTileBasicFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unlinkedCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingTileBasicFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyButtonLinkTextWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyButtonLinkTextWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyButtonLinkTextWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyButtonArrayWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyButtonArrayWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyButtonArrayWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyButtonLinkTextWidgetFragment"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyQrAndShortCodeModalContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeModalContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeModalContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonCtaLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const LoyaltyQrAndShortCodeWidgetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeWidgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortCodeText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortCodeExpirationTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortCodeExpirationButtonCtaLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qrAndShortCodeHowToEarnModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeModalContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qrAndShortCodeSuccessModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeModalContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qrAndShortCodeErrorModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeModalContentFragment"}}]}}]}}]} as unknown as DocumentNode;
export const NotificationDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const OffersSelectRestaurantCtaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OffersSelectRestaurantCtaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OffersBrowsingPanel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offersSelectRestaurantCta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumNumberOfOffers"}}]}}]}}]} as unknown as DocumentNode;
export const ItemMetaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const ComboMetaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComboMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemMetaFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const PickerMetaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickerMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemMetaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComboMetaFragment"}}]}}]}}]}}]} as unknown as DocumentNode;
export const ActivateOfferMetaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivateOfferMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferActivation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]} as unknown as DocumentNode;
export const DiscountOfferMetaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountOfferMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]} as unknown as DocumentNode;
export const AllowRedemptionWithoutLoginFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}}]}}]} as unknown as DocumentNode;
export const BetweenDatesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BetweenDates"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenDates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]} as unknown as DocumentNode;
export const BetweenTimesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BetweenTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenTimes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]} as unknown as DocumentNode;
export const CartPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"negated"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode;
export const CoolDownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoolDown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoolDown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"minimumElapsedTimeSeconds"}}]}}]} as unknown as DocumentNode;
export const DayOfWeekBandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DayOfWeekBand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"monday"}},{"kind":"Field","name":{"kind":"Name","value":"tuesday"}},{"kind":"Field","name":{"kind":"Name","value":"wednesday"}},{"kind":"Field","name":{"kind":"Name","value":"thursday"}},{"kind":"Field","name":{"kind":"Name","value":"friday"}},{"kind":"Field","name":{"kind":"Name","value":"saturday"}},{"kind":"Field","name":{"kind":"Name","value":"sunday"}}]}}]} as unknown as DocumentNode;
export const FirstOrderOnlyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FirstOrderOnly"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirstOrderOnly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}}]}}]} as unknown as DocumentNode;
export const LimitFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Limit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Limit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"maximumRedemptions"}}]}}]} as unknown as DocumentNode;
export const PaymentCardTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentCardType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCardType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}}]}}]} as unknown as DocumentNode;
export const ProductCategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCategoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyLevel"}}]}}]} as unknown as DocumentNode;
export const PurchaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Purchase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCategoryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComboMetaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemMetaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickerMetaFragment"}}]}}]}}]} as unknown as DocumentNode;
export const RequiresAssignmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequiresAssignment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequiresAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}}]}}]} as unknown as DocumentNode;
export const RestaurantGroupRestrictionListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestaurantGroupRestrictionListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantGroupRestrictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantGroupRestrictionList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]} as unknown as DocumentNode;
export const OrderHistoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderHistoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"rangeType"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"lastNSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"isSequential"}},{"kind":"Field","name":{"kind":"Name","value":"ruleSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenTimes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenTimes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartProperty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DayOfWeekBand"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCardType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentCardType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Purchase"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"And"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"ruleSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenDates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenDates"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenTimes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenTimes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartProperty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoolDown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoolDown"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DayOfWeekBand"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirstOrderOnly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirstOrderOnly"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Limit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Limit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCardType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentCardType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Purchase"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequiresAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequiresAssignment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantGroupRestrictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantGroupRestrictionListFragment"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Or"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"ruleSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenDates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenDates"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenTimes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenTimes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartProperty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoolDown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoolDown"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DayOfWeekBand"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirstOrderOnly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirstOrderOnly"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Limit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Limit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCardType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentCardType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Purchase"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequiresAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequiresAssignment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantGroupRestrictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantGroupRestrictionListFragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const OffersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OffersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Offer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"headerSuperText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moreInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"howToRedeem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offerTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offerCTA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daypart"}},{"kind":"Field","name":{"kind":"Name","value":"forSupport"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"offerPrice"}},{"kind":"Field","name":{"kind":"Name","value":"marketPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localizedImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComboMetaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemMetaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickerMetaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivateOfferMetaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountOfferMetaFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"lockedOffersPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedChallengeHeader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedChallengeDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodePanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodeLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodeLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"ruleSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenDates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenDates"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenTimes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenTimes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartProperty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoolDown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoolDown"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DayOfWeekBand"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirstOrderOnly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirstOrderOnly"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Limit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Limit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderHistoryFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCardType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentCardType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Purchase"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequiresAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequiresAssignment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantGroupRestrictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantGroupRestrictionListFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"And"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"ruleSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenDates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenDates"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenTimes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenTimes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartProperty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoolDown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoolDown"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DayOfWeekBand"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirstOrderOnly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirstOrderOnly"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Limit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Limit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCardType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentCardType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Purchase"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequiresAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequiresAssignment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantGroupRestrictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantGroupRestrictionListFragment"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Or"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleSetType"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"ruleSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllowRedemptionWithoutLogin"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenDates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenDates"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BetweenTimes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BetweenTimes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartProperty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoolDown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoolDown"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DayOfWeekBand"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirstOrderOnly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirstOrderOnly"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Limit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Limit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCardType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentCardType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Purchase"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequiresAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequiresAssignment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantGroupRestrictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantGroupRestrictionListFragment"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const OptInSettingBooleanFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OptInSettingBooleanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptInSettingBoolean"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const OptInSettingEmailAndPushFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OptInSettingEmailAndPushFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptInSettingEmailAndPush"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"pushKey"}},{"kind":"Field","name":{"kind":"Name","value":"emailKey"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const OptInSettingEnumFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OptInSettingEnumFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptInSettingEnum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enumStrings"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const OptInPrivacyPreferencesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OptInPrivacyPreferencesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptInPrivacyPreferences"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"view"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]} as unknown as DocumentNode;
export const ComboFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComboFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"hideMainItemDescription"}},{"kind":"Field","name":{"kind":"Name","value":"forceModifiersToBottom"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bonusPoints"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"respectMaximum"}},{"kind":"Field","name":{"kind":"Name","value":"optionVisibilitySettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibleOptions"}},{"kind":"Field","name":{"kind":"Name","value":"toggleButtonTextClosed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toggleButtonTextOpen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspectOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuObjectSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitPerOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOfferBenefit"}},{"kind":"Field","name":{"kind":"Name","value":"showInStaticMenu"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const QuickConfigFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickConfigFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuickConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode;
export const CmsConfigRewardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmsConfigRewardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigReward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentiveNotInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderOnly"}},{"kind":"Field","name":{"kind":"Name","value":"moreInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"howToRedeem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const RewardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentiveNotInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderOnly"}},{"kind":"Field","name":{"kind":"Name","value":"moreInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"howToRedeem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const RewardsSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const PickerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickerDefaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspectValueIdentifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspectOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideNameInItemPreview"}},{"kind":"Field","name":{"kind":"Name","value":"showInStaticMenu"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspectItemOptionMappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickerAspect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"pickerItemMappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickerAspectValueIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"pickerAspect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bonusPoints"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComboFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bonusPoints"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickConfigFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelExclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"kiosk"}},{"kind":"Field","name":{"kind":"Name","value":"googleFoodOrdering"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"isOfferBenefit"}}]}}]} as unknown as DocumentNode;
export const SectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"redirectLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carouselImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carouselImageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"headerSuperText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"headerText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickerFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComboFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"redirectLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelExclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"kiosk"}},{"kind":"Field","name":{"kind":"Name","value":"googleFoodOrdering"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"headerSuperText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickerFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComboFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickerFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComboFragment"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const SystemwideOffersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SystemwideOffersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SystemwideOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moreInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"howToRedeem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderOnly"}},{"kind":"Field","name":{"kind":"Name","value":"daypart"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionType"}},{"kind":"Field","name":{"kind":"Name","value":"offerPrice"}},{"kind":"Field","name":{"kind":"Name","value":"marketPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localizedImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uiPattern"}},{"kind":"Field","name":{"kind":"Name","value":"lockedOffersPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedChallengeHeader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedChallengeDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodePanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodeLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promoCodeLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOfferBenefit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mainItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"operationalItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daypart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOfferBenefit"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ItemGroupDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"applicableItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxItemsDiscount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeesV1Discount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountFees"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferActivation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapMapping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]} as unknown as DocumentNode;
export const HoursFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HoursOfOperation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"friClose"}},{"kind":"Field","name":{"kind":"Name","value":"friOpen"}},{"kind":"Field","name":{"kind":"Name","value":"monClose"}},{"kind":"Field","name":{"kind":"Name","value":"monOpen"}},{"kind":"Field","name":{"kind":"Name","value":"satClose"}},{"kind":"Field","name":{"kind":"Name","value":"satOpen"}},{"kind":"Field","name":{"kind":"Name","value":"sunClose"}},{"kind":"Field","name":{"kind":"Name","value":"sunOpen"}},{"kind":"Field","name":{"kind":"Name","value":"thrClose"}},{"kind":"Field","name":{"kind":"Name","value":"thrOpen"}},{"kind":"Field","name":{"kind":"Name","value":"tueClose"}},{"kind":"Field","name":{"kind":"Name","value":"tueOpen"}},{"kind":"Field","name":{"kind":"Name","value":"wedClose"}},{"kind":"Field","name":{"kind":"Name","value":"wedOpen"}}]}}]} as unknown as DocumentNode;
export const ImageAssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SanityImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurHash"}}]}}]}}]} as unknown as DocumentNode;
export const RestaurantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestaurantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Restaurant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"chaseMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diningRoomHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"curbsideHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driveThruHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickupWindowHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drinkStationType"}},{"kind":"Field","name":{"kind":"Name","value":"driveThruLaneType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"frontCounterClosed"}},{"kind":"Field","name":{"kind":"Name","value":"hasBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasBurgersForBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasCurbside"}},{"kind":"Field","name":{"kind":"Name","value":"hasDineIn"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatering"}},{"kind":"Field","name":{"kind":"Name","value":"hasDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"hasDriveThru"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobileOrdering"}},{"kind":"Field","name":{"kind":"Name","value":"hasParking"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayground"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakeOut"}},{"kind":"Field","name":{"kind":"Name","value":"hasWifi"}},{"kind":"Field","name":{"kind":"Name","value":"hasLoyalty"}},{"kind":"Field","name":{"kind":"Name","value":"hasPickupWindow"}},{"kind":"Field","name":{"kind":"Name","value":"isDarkKitchen"}},{"kind":"Field","name":{"kind":"Name","value":"isHalal"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"parkingType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"playgroundType"}},{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posRestaurantId"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantPosData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amenities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAssetFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}}]} as unknown as DocumentNode;

export const AllItemsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}}]}}]}}]}},...ItemFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...NutritionFragmentDoc.definitions,...AdditionalItemInformationFragmentDoc.definitions,...AllergensFragmentDoc.definitions,...ItemOptionFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions,...ItemAvailabilityFragmentDoc.definitions,...ItemOptionAvailabilityFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useAllItemsQuery__
 *
 * To run a query within a React component, call `useAllItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAllItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAllItemsQuery, IAllItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IAllItemsQuery, IAllItemsQueryVariables>(AllItemsDocument, options);
      }
export function useAllItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAllItemsQuery, IAllItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IAllItemsQuery, IAllItemsQueryVariables>(AllItemsDocument, options);
        }
export function useAllItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IAllItemsQuery, IAllItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IAllItemsQuery, IAllItemsQueryVariables>(AllItemsDocument, options);
        }
export type AllItemsQueryHookResult = ReturnType<typeof useAllItemsQuery>;
export type AllItemsLazyQueryHookResult = ReturnType<typeof useAllItemsLazyQuery>;
export type AllItemsSuspenseQueryHookResult = ReturnType<typeof useAllItemsSuspenseQuery>;
export type AllItemsQueryResult = Apollo.QueryResult<IAllItemsQuery, IAllItemsQueryVariables>;
export const FeatureAccountFormDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureAccountForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureAccountFormId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureAccountForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureAccountFormId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postalOrZipDisclaimer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeCampaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveCampaignFragment"}}]}}]}}]}},...ActiveCampaignFragmentDoc.definitions,...ImageFragmentDoc.definitions,...ColorFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureAccountFormQuery__
 *
 * To run a query within a React component, call `useFeatureAccountFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountFormQuery({
 *   variables: {
 *      featureAccountFormId: // value for 'featureAccountFormId'
 *   },
 * });
 */
export function useFeatureAccountFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables> & ({ variables: IFeatureAccountFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>(FeatureAccountFormDocument, options);
      }
export function useFeatureAccountFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>(FeatureAccountFormDocument, options);
        }
export function useFeatureAccountFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>(FeatureAccountFormDocument, options);
        }
export type FeatureAccountFormQueryHookResult = ReturnType<typeof useFeatureAccountFormQuery>;
export type FeatureAccountFormLazyQueryHookResult = ReturnType<typeof useFeatureAccountFormLazyQuery>;
export type FeatureAccountFormSuspenseQueryHookResult = ReturnType<typeof useFeatureAccountFormSuspenseQuery>;
export type FeatureAccountFormQueryResult = Apollo.QueryResult<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>;
export const FeatureAccountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAndPushOptInSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OptInSettingBooleanFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OptInSettingEnumFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OptInSettingEmailAndPushFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OptInPrivacyPreferencesFragment"}}]}}]}}]}},...OptInSettingBooleanFragmentDoc.definitions,...OptInSettingEnumFragmentDoc.definitions,...OptInSettingEmailAndPushFragmentDoc.definitions,...OptInPrivacyPreferencesFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureAccountQuery__
 *
 * To run a query within a React component, call `useFeatureAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountQuery({
 *   variables: {
 *      featureAccountId: // value for 'featureAccountId'
 *   },
 * });
 */
export function useFeatureAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureAccountQuery, IFeatureAccountQueryVariables> & ({ variables: IFeatureAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureAccountQuery, IFeatureAccountQueryVariables>(FeatureAccountDocument, options);
      }
export function useFeatureAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountQuery, IFeatureAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureAccountQuery, IFeatureAccountQueryVariables>(FeatureAccountDocument, options);
        }
export function useFeatureAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureAccountQuery, IFeatureAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureAccountQuery, IFeatureAccountQueryVariables>(FeatureAccountDocument, options);
        }
export type FeatureAccountQueryHookResult = ReturnType<typeof useFeatureAccountQuery>;
export type FeatureAccountLazyQueryHookResult = ReturnType<typeof useFeatureAccountLazyQuery>;
export type FeatureAccountSuspenseQueryHookResult = ReturnType<typeof useFeatureAccountSuspenseQuery>;
export type FeatureAccountQueryResult = Apollo.QueryResult<IFeatureAccountQuery, IFeatureAccountQueryVariables>;
export const FeatureLoyaltyClaimPointsContentDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyClaimPointsContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureClaimPointsUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClaimPointsUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureClaimPointsUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsSimplified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsSimplifiedContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsHomeScreenContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsScreenContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimQrCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsQrCodeContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsSurveyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsSurveyContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsSuccessfulSubmissionScreenContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsScreenContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimOnHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"enRaw"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsPendingContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsExpiredContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsInvalidCodeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsAlreadyClaimedContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsTransactionNotFoundContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsInvalidRestaurantContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsDailyAmountExceededContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsDuplicateTransactionId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimPointsTooManyRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClaimPointsFailedSubmissionContentFragment"}}]}}]}}]}},...ClaimPointsSimplifiedContentFragmentDoc.definitions,...ImageFragmentDoc.definitions,...ClaimPointsScreenContentFragmentDoc.definitions,...ClaimPointsQrCodeContentFragmentDoc.definitions,...LinkWidgetFragmentDoc.definitions,...ClaimPointsSurveyContentFragmentDoc.definitions,...ClaimPointsFailedSubmissionContentFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyClaimPointsContentQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyClaimPointsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyClaimPointsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyClaimPointsContentQuery({
 *   variables: {
 *      featureClaimPointsUIId: // value for 'featureClaimPointsUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyClaimPointsContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables> & ({ variables: IFeatureLoyaltyClaimPointsContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>(FeatureLoyaltyClaimPointsContentDocument, options);
      }
export function useFeatureLoyaltyClaimPointsContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>(FeatureLoyaltyClaimPointsContentDocument, options);
        }
export function useFeatureLoyaltyClaimPointsContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>(FeatureLoyaltyClaimPointsContentDocument, options);
        }
export type FeatureLoyaltyClaimPointsContentQueryHookResult = ReturnType<typeof useFeatureLoyaltyClaimPointsContentQuery>;
export type FeatureLoyaltyClaimPointsContentLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyClaimPointsContentLazyQuery>;
export type FeatureLoyaltyClaimPointsContentSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyClaimPointsContentSuspenseQuery>;
export type FeatureLoyaltyClaimPointsContentQueryResult = Apollo.QueryResult<IFeatureLoyaltyClaimPointsContentQuery, IFeatureLoyaltyClaimPointsContentQueryVariables>;
export const FeatureDisclaimersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureDisclaimers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureDisclaimersId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureDisclaimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureDisclaimersId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"superUpsell"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calorie"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyrightAndTrademark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservedRights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"communicationPreferencesBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpDisclaimers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpMarketDisclaimers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDisclaimer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}}]}},...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureDisclaimersQuery__
 *
 * To run a query within a React component, call `useFeatureDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureDisclaimersQuery({
 *   variables: {
 *      featureDisclaimersId: // value for 'featureDisclaimersId'
 *   },
 * });
 */
export function useFeatureDisclaimersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables> & ({ variables: IFeatureDisclaimersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>(FeatureDisclaimersDocument, options);
      }
export function useFeatureDisclaimersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>(FeatureDisclaimersDocument, options);
        }
export function useFeatureDisclaimersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>(FeatureDisclaimersDocument, options);
        }
export type FeatureDisclaimersQueryHookResult = ReturnType<typeof useFeatureDisclaimersQuery>;
export type FeatureDisclaimersLazyQueryHookResult = ReturnType<typeof useFeatureDisclaimersLazyQuery>;
export type FeatureDisclaimersSuspenseQueryHookResult = ReturnType<typeof useFeatureDisclaimersSuspenseQuery>;
export type FeatureDisclaimersQueryResult = Apollo.QueryResult<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>;
export const FeatureDonationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureDonation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureDonationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureDonation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureDonationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"donationItemList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dialogInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}}]}},...ItemFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...NutritionFragmentDoc.definitions,...AdditionalItemInformationFragmentDoc.definitions,...AllergensFragmentDoc.definitions,...ItemOptionFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureDonationQuery__
 *
 * To run a query within a React component, call `useFeatureDonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureDonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureDonationQuery({
 *   variables: {
 *      featureDonationId: // value for 'featureDonationId'
 *   },
 * });
 */
export function useFeatureDonationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureDonationQuery, IFeatureDonationQueryVariables> & ({ variables: IFeatureDonationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureDonationQuery, IFeatureDonationQueryVariables>(FeatureDonationDocument, options);
      }
export function useFeatureDonationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureDonationQuery, IFeatureDonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureDonationQuery, IFeatureDonationQueryVariables>(FeatureDonationDocument, options);
        }
export function useFeatureDonationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureDonationQuery, IFeatureDonationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureDonationQuery, IFeatureDonationQueryVariables>(FeatureDonationDocument, options);
        }
export type FeatureDonationQueryHookResult = ReturnType<typeof useFeatureDonationQuery>;
export type FeatureDonationLazyQueryHookResult = ReturnType<typeof useFeatureDonationLazyQuery>;
export type FeatureDonationSuspenseQueryHookResult = ReturnType<typeof useFeatureDonationSuspenseQuery>;
export type FeatureDonationQueryResult = Apollo.QueryResult<IFeatureDonationQuery, IFeatureDonationQueryVariables>;
export const FeatureFooterDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureFooter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureFooterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureFooter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureFooterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"columns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightAndLanguageSelector"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CopyrightAndLanguageSelectorFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightedVerticalLinkListWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighlightedVerticalLinkListWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HorizontalLinkListWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HorizontalLinkListWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SocialIconsWithHeaderWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SocialIconsWithHeaderWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerticalLinkListWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VerticalLinkListWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerticalLinkListWithHeaderWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VerticalLinkListWithHeaderWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WordmarkAndSocialIcons"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WordmarkAndSocialIconsFragment"}}]}}]}}]}}]}}]}}]}},...CopyrightAndLanguageSelectorFragmentDoc.definitions,...HighlightedVerticalLinkListWidgetFragmentDoc.definitions,...HighlightedLinkWidgetFragmentDoc.definitions,...HorizontalLinkListWidgetFragmentDoc.definitions,...LinkWidgetFragmentDoc.definitions,...ImageWidgetFragmentDoc.definitions,...ImageFragmentDoc.definitions,...SocialIconsWithHeaderWidgetFragmentDoc.definitions,...SocialIconsWidgetFragmentDoc.definitions,...TextWidgetFragmentDoc.definitions,...VerticalLinkListWidgetFragmentDoc.definitions,...VerticalLinkListWithHeaderWidgetFragmentDoc.definitions,...WordmarkAndSocialIconsFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureFooterQuery__
 *
 * To run a query within a React component, call `useFeatureFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFooterQuery({
 *   variables: {
 *      featureFooterId: // value for 'featureFooterId'
 *   },
 * });
 */
export function useFeatureFooterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureFooterQuery, IFeatureFooterQueryVariables> & ({ variables: IFeatureFooterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureFooterQuery, IFeatureFooterQueryVariables>(FeatureFooterDocument, options);
      }
export function useFeatureFooterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureFooterQuery, IFeatureFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureFooterQuery, IFeatureFooterQueryVariables>(FeatureFooterDocument, options);
        }
export function useFeatureFooterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureFooterQuery, IFeatureFooterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureFooterQuery, IFeatureFooterQueryVariables>(FeatureFooterDocument, options);
        }
export type FeatureFooterQueryHookResult = ReturnType<typeof useFeatureFooterQuery>;
export type FeatureFooterLazyQueryHookResult = ReturnType<typeof useFeatureFooterLazyQuery>;
export type FeatureFooterSuspenseQueryHookResult = ReturnType<typeof useFeatureFooterSuspenseQuery>;
export type FeatureFooterQueryResult = Apollo.QueryResult<IFeatureFooterQuery, IFeatureFooterQueryVariables>;
export const FeatureGeolocationMapMarkersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureGeolocationMapMarkers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureGeolocationMapMarkersId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureGeolocationMapMarkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureGeolocationMapMarkersId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"driverIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}}]}},...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureGeolocationMapMarkersQuery__
 *
 * To run a query within a React component, call `useFeatureGeolocationMapMarkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGeolocationMapMarkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGeolocationMapMarkersQuery({
 *   variables: {
 *      featureGeolocationMapMarkersId: // value for 'featureGeolocationMapMarkersId'
 *   },
 * });
 */
export function useFeatureGeolocationMapMarkersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables> & ({ variables: IFeatureGeolocationMapMarkersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>(FeatureGeolocationMapMarkersDocument, options);
      }
export function useFeatureGeolocationMapMarkersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>(FeatureGeolocationMapMarkersDocument, options);
        }
export function useFeatureGeolocationMapMarkersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>(FeatureGeolocationMapMarkersDocument, options);
        }
export type FeatureGeolocationMapMarkersQueryHookResult = ReturnType<typeof useFeatureGeolocationMapMarkersQuery>;
export type FeatureGeolocationMapMarkersLazyQueryHookResult = ReturnType<typeof useFeatureGeolocationMapMarkersLazyQuery>;
export type FeatureGeolocationMapMarkersSuspenseQueryHookResult = ReturnType<typeof useFeatureGeolocationMapMarkersSuspenseQuery>;
export type FeatureGeolocationMapMarkersQueryResult = Apollo.QueryResult<IFeatureGeolocationMapMarkersQuery, IFeatureGeolocationMapMarkersQueryVariables>;
export const FeatureLayoutDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLayoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLayoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultHeroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"loadingGraphics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoadingGraphicsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geolocationModalImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appleWalletImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"googlePayImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardTextImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}}]}},...ImageFragmentDoc.definitions,...LoadingGraphicsFragmentDoc.definitions,...RefFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLayoutQuery__
 *
 * To run a query within a React component, call `useFeatureLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLayoutQuery({
 *   variables: {
 *      featureLayoutId: // value for 'featureLayoutId'
 *   },
 * });
 */
export function useFeatureLayoutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLayoutQuery, IFeatureLayoutQueryVariables> & ({ variables: IFeatureLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>(FeatureLayoutDocument, options);
      }
export function useFeatureLayoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>(FeatureLayoutDocument, options);
        }
export function useFeatureLayoutSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>(FeatureLayoutDocument, options);
        }
export type FeatureLayoutQueryHookResult = ReturnType<typeof useFeatureLayoutQuery>;
export type FeatureLayoutLazyQueryHookResult = ReturnType<typeof useFeatureLayoutLazyQuery>;
export type FeatureLayoutSuspenseQueryHookResult = ReturnType<typeof useFeatureLayoutSuspenseQuery>;
export type FeatureLayoutQueryResult = Apollo.QueryResult<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>;
export const FeatureLoyaltyBackgroundDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyBackground"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"imageBackground"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}},...RefFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyBackgroundQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyBackgroundQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyBackgroundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyBackgroundQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyBackgroundQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables> & ({ variables: IFeatureLoyaltyBackgroundQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>(FeatureLoyaltyBackgroundDocument, options);
      }
export function useFeatureLoyaltyBackgroundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>(FeatureLoyaltyBackgroundDocument, options);
        }
export function useFeatureLoyaltyBackgroundSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>(FeatureLoyaltyBackgroundDocument, options);
        }
export type FeatureLoyaltyBackgroundQueryHookResult = ReturnType<typeof useFeatureLoyaltyBackgroundQuery>;
export type FeatureLoyaltyBackgroundLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyBackgroundLazyQuery>;
export type FeatureLoyaltyBackgroundSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyBackgroundSuspenseQuery>;
export type FeatureLoyaltyBackgroundQueryResult = Apollo.QueryResult<IFeatureLoyaltyBackgroundQuery, IFeatureLoyaltyBackgroundQueryVariables>;
export const FeatureLoyaltyDashboardDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyGreetingWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyLinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyHistoryWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyPointsAndRewardsWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyLinkWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyLogoWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTiersWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"sortByPointValue"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyDoubleButtonWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"leftButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leftButtonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rightButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rightButtonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyNotificationsWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"notificationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationDetailsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SystemwideOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionType"}},{"kind":"Field","name":{"kind":"Name","value":"notificationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationDetailsFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SystemwidePromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}},{"kind":"Field","name":{"kind":"Name","value":"notificationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationDetailsFragment"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsListWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeaturedRewardsCarouselWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"componentKey"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}}]}}]}}]}}]}}]}}]}},...NotificationDetailsFragmentDoc.definitions,...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyDashboardQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyDashboardQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables> & ({ variables: IFeatureLoyaltyDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>(FeatureLoyaltyDashboardDocument, options);
      }
export function useFeatureLoyaltyDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>(FeatureLoyaltyDashboardDocument, options);
        }
export function useFeatureLoyaltyDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>(FeatureLoyaltyDashboardDocument, options);
        }
export type FeatureLoyaltyDashboardQueryHookResult = ReturnType<typeof useFeatureLoyaltyDashboardQuery>;
export type FeatureLoyaltyDashboardLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyDashboardLazyQuery>;
export type FeatureLoyaltyDashboardSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyDashboardSuspenseQuery>;
export type FeatureLoyaltyDashboardQueryResult = Apollo.QueryResult<IFeatureLoyaltyDashboardQuery, IFeatureLoyaltyDashboardQueryVariables>;
export const FeatureEarningCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureEarningCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EarningCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"offerRedemptionCooldownPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"transactionEarningConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxRewardRedemptionLimit"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFeatureEarningCalculationQuery__
 *
 * To run a query within a React component, call `useFeatureEarningCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureEarningCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureEarningCalculationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureEarningCalculationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables> & ({ variables: IFeatureEarningCalculationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>(FeatureEarningCalculationDocument, options);
      }
export function useFeatureEarningCalculationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>(FeatureEarningCalculationDocument, options);
        }
export function useFeatureEarningCalculationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>(FeatureEarningCalculationDocument, options);
        }
export type FeatureEarningCalculationQueryHookResult = ReturnType<typeof useFeatureEarningCalculationQuery>;
export type FeatureEarningCalculationLazyQueryHookResult = ReturnType<typeof useFeatureEarningCalculationLazyQuery>;
export type FeatureEarningCalculationSuspenseQueryHookResult = ReturnType<typeof useFeatureEarningCalculationSuspenseQuery>;
export type FeatureEarningCalculationQueryResult = Apollo.QueryResult<IFeatureEarningCalculationQuery, IFeatureEarningCalculationQueryVariables>;
export const FeatureLoyaltyInRestaurantRedemptionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyInRestaurantRedemption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyInRestaurantRedemption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topWidgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyImageWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyImageWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTextWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyTextWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTitleWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyTitleWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyPaymentMethodWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyPaymentMethodWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyButtonWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyButtonWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyButtonArrayWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyButtonArrayWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQRCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyQRCodeWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyShortCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyShortCodeWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyCartWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyCartWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBasicCardWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyBasicCardWidgetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bottomWidgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyImageWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyImageWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTextWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyTextWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTitleWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyTitleWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyPaymentMethodWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyPaymentMethodWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyButtonWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyButtonWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyButtonArrayWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyButtonArrayWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyQRAndShortCodeWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQRCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyQRCodeWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyShortCodeWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyShortCodeWidgetFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyCartWidget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyCartWidgetFragment"}}]}}]}}]}}]}}]}},...LoyaltyImageWidgetFragmentDoc.definitions,...LocaleImageFragmentDoc.definitions,...ImageFragmentDoc.definitions,...LoyaltyTextWidgetFragmentDoc.definitions,...LocaleStringFragmentDoc.definitions,...LoyaltyTitleWidgetFragmentDoc.definitions,...LoyaltyPaymentMethodWidgetFragmentDoc.definitions,...LoyaltyButtonWidgetFragmentDoc.definitions,...LinkWidgetFragmentDoc.definitions,...LoyaltyButtonArrayWidgetFragmentDoc.definitions,...LoyaltyButtonLinkTextWidgetFragmentDoc.definitions,...LoyaltyQrAndShortCodeWidgetFragmentDoc.definitions,...LoyaltyQrAndShortCodeModalContentFragmentDoc.definitions,...LoyaltyQrCodeWidgetFragmentDoc.definitions,...LoyaltyShortCodeWidgetFragmentDoc.definitions,...LoyaltyCartWidgetFragmentDoc.definitions,...MarketingTileBasicFragmentDoc.definitions,...ImagesFragmentDoc.definitions,...LoyaltyBasicCardWidgetFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyInRestaurantRedemptionQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyInRestaurantRedemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyInRestaurantRedemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyInRestaurantRedemptionQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyInRestaurantRedemptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables> & ({ variables: IFeatureLoyaltyInRestaurantRedemptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>(FeatureLoyaltyInRestaurantRedemptionDocument, options);
      }
export function useFeatureLoyaltyInRestaurantRedemptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>(FeatureLoyaltyInRestaurantRedemptionDocument, options);
        }
export function useFeatureLoyaltyInRestaurantRedemptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>(FeatureLoyaltyInRestaurantRedemptionDocument, options);
        }
export type FeatureLoyaltyInRestaurantRedemptionQueryHookResult = ReturnType<typeof useFeatureLoyaltyInRestaurantRedemptionQuery>;
export type FeatureLoyaltyInRestaurantRedemptionLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyInRestaurantRedemptionLazyQuery>;
export type FeatureLoyaltyInRestaurantRedemptionSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyInRestaurantRedemptionSuspenseQuery>;
export type FeatureLoyaltyInRestaurantRedemptionQueryResult = Apollo.QueryResult<IFeatureLoyaltyInRestaurantRedemptionQuery, IFeatureLoyaltyInRestaurantRedemptionQueryVariables>;
export const FeatureLoyaltyUiNoRewardDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyUINoReward"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"noRewardPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmptyStateFragment"}}]}}]}}]}},...EmptyStateFragmentDoc.definitions,...ImagesFragmentDoc.definitions,...ImageFragmentDoc.definitions,...RefFragmentDoc.definitions,...MarketingTileListFragmentDoc.definitions,...MarketingTileBasicFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyUiNoRewardQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiNoRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiNoRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiNoRewardQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiNoRewardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables> & ({ variables: IFeatureLoyaltyUiNoRewardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>(FeatureLoyaltyUiNoRewardDocument, options);
      }
export function useFeatureLoyaltyUiNoRewardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>(FeatureLoyaltyUiNoRewardDocument, options);
        }
export function useFeatureLoyaltyUiNoRewardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>(FeatureLoyaltyUiNoRewardDocument, options);
        }
export type FeatureLoyaltyUiNoRewardQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNoRewardQuery>;
export type FeatureLoyaltyUiNoRewardLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNoRewardLazyQuery>;
export type FeatureLoyaltyUiNoRewardSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNoRewardSuspenseQuery>;
export type FeatureLoyaltyUiNoRewardQueryResult = Apollo.QueryResult<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>;
export const FeatureLoyaltyNotAvailableAtDeliveryModeDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyNotAvailableAtDeliveryMode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyNotAvailableAtDeliveryMode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstRedirectPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}},...ImagesFragmentDoc.definitions,...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyNotAvailableAtDeliveryModeQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyNotAvailableAtDeliveryModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyNotAvailableAtDeliveryModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyNotAvailableAtDeliveryModeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureLoyaltyNotAvailableAtDeliveryModeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyNotAvailableAtDeliveryModeQuery, IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables> & ({ variables: IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyNotAvailableAtDeliveryModeQuery, IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables>(FeatureLoyaltyNotAvailableAtDeliveryModeDocument, options);
      }
export function useFeatureLoyaltyNotAvailableAtDeliveryModeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyNotAvailableAtDeliveryModeQuery, IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyNotAvailableAtDeliveryModeQuery, IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables>(FeatureLoyaltyNotAvailableAtDeliveryModeDocument, options);
        }
export function useFeatureLoyaltyNotAvailableAtDeliveryModeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyNotAvailableAtDeliveryModeQuery, IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyNotAvailableAtDeliveryModeQuery, IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables>(FeatureLoyaltyNotAvailableAtDeliveryModeDocument, options);
        }
export type FeatureLoyaltyNotAvailableAtDeliveryModeQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtDeliveryModeQuery>;
export type FeatureLoyaltyNotAvailableAtDeliveryModeLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtDeliveryModeLazyQuery>;
export type FeatureLoyaltyNotAvailableAtDeliveryModeSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtDeliveryModeSuspenseQuery>;
export type FeatureLoyaltyNotAvailableAtDeliveryModeQueryResult = Apollo.QueryResult<IFeatureLoyaltyNotAvailableAtDeliveryModeQuery, IFeatureLoyaltyNotAvailableAtDeliveryModeQueryVariables>;
export const FeatureLoyaltyNotAvailableAtThisRestaurantDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyNotAvailableAtThisRestaurant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyNotAvailableAtThisRestaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstRedirectPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondRedirectPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}},...ImagesFragmentDoc.definitions,...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyNotAvailableAtThisRestaurantQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyNotAvailableAtThisRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyNotAvailableAtThisRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyNotAvailableAtThisRestaurantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureLoyaltyNotAvailableAtThisRestaurantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables> & ({ variables: IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>(FeatureLoyaltyNotAvailableAtThisRestaurantDocument, options);
      }
export function useFeatureLoyaltyNotAvailableAtThisRestaurantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>(FeatureLoyaltyNotAvailableAtThisRestaurantDocument, options);
        }
export function useFeatureLoyaltyNotAvailableAtThisRestaurantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>(FeatureLoyaltyNotAvailableAtThisRestaurantDocument, options);
        }
export type FeatureLoyaltyNotAvailableAtThisRestaurantQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtThisRestaurantQuery>;
export type FeatureLoyaltyNotAvailableAtThisRestaurantLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtThisRestaurantLazyQuery>;
export type FeatureLoyaltyNotAvailableAtThisRestaurantSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyNotAvailableAtThisRestaurantSuspenseQuery>;
export type FeatureLoyaltyNotAvailableAtThisRestaurantQueryResult = Apollo.QueryResult<IFeatureLoyaltyNotAvailableAtThisRestaurantQuery, IFeatureLoyaltyNotAvailableAtThisRestaurantQueryVariables>;
export const FeatureLoyaltyUiNotEnrolledDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyUINotEnrolled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"notEnrolledState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmptyStateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notEnrolledStateMobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmptyStateFragment"}}]}}]}}]}},...EmptyStateFragmentDoc.definitions,...ImagesFragmentDoc.definitions,...ImageFragmentDoc.definitions,...RefFragmentDoc.definitions,...MarketingTileListFragmentDoc.definitions,...MarketingTileBasicFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyUiNotEnrolledQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiNotEnrolledQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiNotEnrolledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiNotEnrolledQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiNotEnrolledQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables> & ({ variables: IFeatureLoyaltyUiNotEnrolledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>(FeatureLoyaltyUiNotEnrolledDocument, options);
      }
export function useFeatureLoyaltyUiNotEnrolledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>(FeatureLoyaltyUiNotEnrolledDocument, options);
        }
export function useFeatureLoyaltyUiNotEnrolledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>(FeatureLoyaltyUiNotEnrolledDocument, options);
        }
export type FeatureLoyaltyUiNotEnrolledQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNotEnrolledQuery>;
export type FeatureLoyaltyUiNotEnrolledLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNotEnrolledLazyQuery>;
export type FeatureLoyaltyUiNotEnrolledSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNotEnrolledSuspenseQuery>;
export type FeatureLoyaltyUiNotEnrolledQueryResult = Apollo.QueryResult<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>;
export const LoyaltyOffersUiIncentiveNotAvailableDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loyaltyOffersUIIncentiveNotAvailable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyOffersUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"offerNotAvailableModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardNotAvailableModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImagesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}}]}},...ImagesFragmentDoc.definitions,...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyOffersUiIncentiveNotAvailableQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiIncentiveNotAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiIncentiveNotAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiIncentiveNotAvailableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiIncentiveNotAvailableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables> & ({ variables: ILoyaltyOffersUiIncentiveNotAvailableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>(LoyaltyOffersUiIncentiveNotAvailableDocument, options);
      }
export function useLoyaltyOffersUiIncentiveNotAvailableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>(LoyaltyOffersUiIncentiveNotAvailableDocument, options);
        }
export function useLoyaltyOffersUiIncentiveNotAvailableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>(LoyaltyOffersUiIncentiveNotAvailableDocument, options);
        }
export type LoyaltyOffersUiIncentiveNotAvailableQueryHookResult = ReturnType<typeof useLoyaltyOffersUiIncentiveNotAvailableQuery>;
export type LoyaltyOffersUiIncentiveNotAvailableLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiIncentiveNotAvailableLazyQuery>;
export type LoyaltyOffersUiIncentiveNotAvailableSuspenseQueryHookResult = ReturnType<typeof useLoyaltyOffersUiIncentiveNotAvailableSuspenseQuery>;
export type LoyaltyOffersUiIncentiveNotAvailableQueryResult = Apollo.QueryResult<ILoyaltyOffersUiIncentiveNotAvailableQuery, ILoyaltyOffersUiIncentiveNotAvailableQueryVariables>;
export const FeatureSortedLoyaltyOffersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureSortedLoyaltyOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyOffersUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"sortedSystemwideOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SystemwideOffersFragment"}}]}}]}}]}},...SystemwideOffersFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions,...MenuImagesFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureSortedLoyaltyOffersQuery__
 *
 * To run a query within a React component, call `useFeatureSortedLoyaltyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureSortedLoyaltyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureSortedLoyaltyOffersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureSortedLoyaltyOffersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables> & ({ variables: IFeatureSortedLoyaltyOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>(FeatureSortedLoyaltyOffersDocument, options);
      }
export function useFeatureSortedLoyaltyOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>(FeatureSortedLoyaltyOffersDocument, options);
        }
export function useFeatureSortedLoyaltyOffersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>(FeatureSortedLoyaltyOffersDocument, options);
        }
export type FeatureSortedLoyaltyOffersQueryHookResult = ReturnType<typeof useFeatureSortedLoyaltyOffersQuery>;
export type FeatureSortedLoyaltyOffersLazyQueryHookResult = ReturnType<typeof useFeatureSortedLoyaltyOffersLazyQuery>;
export type FeatureSortedLoyaltyOffersSuspenseQueryHookResult = ReturnType<typeof useFeatureSortedLoyaltyOffersSuspenseQuery>;
export type FeatureSortedLoyaltyOffersQueryResult = Apollo.QueryResult<IFeatureSortedLoyaltyOffersQuery, IFeatureSortedLoyaltyOffersQueryVariables>;
export const LoyaltyOffersUiLoggedInDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loyaltyOffersUILoggedIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyOffersUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"endOfOffersLoggedIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endOfOffersMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endOfOffersImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}}]}}]}},...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyOffersUiLoggedInQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiLoggedInQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiLoggedInQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables> & ({ variables: ILoyaltyOffersUiLoggedInQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>(LoyaltyOffersUiLoggedInDocument, options);
      }
export function useLoyaltyOffersUiLoggedInLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>(LoyaltyOffersUiLoggedInDocument, options);
        }
export function useLoyaltyOffersUiLoggedInSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>(LoyaltyOffersUiLoggedInDocument, options);
        }
export type LoyaltyOffersUiLoggedInQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedInQuery>;
export type LoyaltyOffersUiLoggedInLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedInLazyQuery>;
export type LoyaltyOffersUiLoggedInSuspenseQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedInSuspenseQuery>;
export type LoyaltyOffersUiLoggedInQueryResult = Apollo.QueryResult<ILoyaltyOffersUiLoggedInQuery, ILoyaltyOffersUiLoggedInQueryVariables>;
export const LoyaltyOffersUiLoggedOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loyaltyOffersUILoggedOut"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyOffersUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"endOfOffersLoggedOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyOffersUiLoggedOutQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiLoggedOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiLoggedOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiLoggedOutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiLoggedOutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables> & ({ variables: ILoyaltyOffersUiLoggedOutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>(LoyaltyOffersUiLoggedOutDocument, options);
      }
export function useLoyaltyOffersUiLoggedOutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>(LoyaltyOffersUiLoggedOutDocument, options);
        }
export function useLoyaltyOffersUiLoggedOutSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>(LoyaltyOffersUiLoggedOutDocument, options);
        }
export type LoyaltyOffersUiLoggedOutQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedOutQuery>;
export type LoyaltyOffersUiLoggedOutLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedOutLazyQuery>;
export type LoyaltyOffersUiLoggedOutSuspenseQueryHookResult = ReturnType<typeof useLoyaltyOffersUiLoggedOutSuspenseQuery>;
export type LoyaltyOffersUiLoggedOutQueryResult = Apollo.QueryResult<ILoyaltyOffersUiLoggedOutQuery, ILoyaltyOffersUiLoggedOutQueryVariables>;
export const LoyaltyOffersUiCooldownContentDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loyaltyOffersUICooldownContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyOffersUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"globalOfferCooldownContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}}]}}]}}]}},...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyOffersUiCooldownContentQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersUiCooldownContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersUiCooldownContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersUiCooldownContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyOffersUiCooldownContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables> & ({ variables: ILoyaltyOffersUiCooldownContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>(LoyaltyOffersUiCooldownContentDocument, options);
      }
export function useLoyaltyOffersUiCooldownContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>(LoyaltyOffersUiCooldownContentDocument, options);
        }
export function useLoyaltyOffersUiCooldownContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>(LoyaltyOffersUiCooldownContentDocument, options);
        }
export type LoyaltyOffersUiCooldownContentQueryHookResult = ReturnType<typeof useLoyaltyOffersUiCooldownContentQuery>;
export type LoyaltyOffersUiCooldownContentLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersUiCooldownContentLazyQuery>;
export type LoyaltyOffersUiCooldownContentSuspenseQueryHookResult = ReturnType<typeof useLoyaltyOffersUiCooldownContentSuspenseQuery>;
export type LoyaltyOffersUiCooldownContentQueryResult = Apollo.QueryResult<ILoyaltyOffersUiCooldownContentQuery, ILoyaltyOffersUiCooldownContentQueryVariables>;
export const LoyaltySystemwideOffersByIdsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltySystemwideOffersByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allSystemwideOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SystemwideOffersFragment"}}]}}]}},...SystemwideOffersFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions,...MenuImagesFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltySystemwideOffersByIdsQuery__
 *
 * To run a query within a React component, call `useLoyaltySystemwideOffersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltySystemwideOffersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltySystemwideOffersByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltySystemwideOffersByIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables> & ({ variables: ILoyaltySystemwideOffersByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>(LoyaltySystemwideOffersByIdsDocument, options);
      }
export function useLoyaltySystemwideOffersByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>(LoyaltySystemwideOffersByIdsDocument, options);
        }
export function useLoyaltySystemwideOffersByIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>(LoyaltySystemwideOffersByIdsDocument, options);
        }
export type LoyaltySystemwideOffersByIdsQueryHookResult = ReturnType<typeof useLoyaltySystemwideOffersByIdsQuery>;
export type LoyaltySystemwideOffersByIdsLazyQueryHookResult = ReturnType<typeof useLoyaltySystemwideOffersByIdsLazyQuery>;
export type LoyaltySystemwideOffersByIdsSuspenseQueryHookResult = ReturnType<typeof useLoyaltySystemwideOffersByIdsSuspenseQuery>;
export type LoyaltySystemwideOffersByIdsQueryResult = Apollo.QueryResult<ILoyaltySystemwideOffersByIdsQuery, ILoyaltySystemwideOffersByIdsQueryVariables>;
export const AllSystemwidePromotionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllSystemwidePromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allSystemwidePromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pointsMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"bonusPoints"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"testOnly"}},{"kind":"Field","name":{"kind":"Name","value":"notificationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemwidePromotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBetweenDates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOfWeekBand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monday"}},{"kind":"Field","name":{"kind":"Name","value":"tuesday"}},{"kind":"Field","name":{"kind":"Name","value":"wednesday"}},{"kind":"Field","name":{"kind":"Name","value":"thursday"}},{"kind":"Field","name":{"kind":"Name","value":"friday"}},{"kind":"Field","name":{"kind":"Name","value":"saturday"}},{"kind":"Field","name":{"kind":"Name","value":"sunday"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAllSystemwidePromotionsQuery__
 *
 * To run a query within a React component, call `useAllSystemwidePromotionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSystemwidePromotionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSystemwidePromotionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSystemwidePromotionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>(AllSystemwidePromotionsDocument, options);
      }
export function useAllSystemwidePromotionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>(AllSystemwidePromotionsDocument, options);
        }
// @ts-ignore
export function useAllSystemwidePromotionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>;
// @ts-ignore
export function useAllSystemwidePromotionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IAllSystemwidePromotionsQuery | undefined, IAllSystemwidePromotionsQueryVariables>;
export function useAllSystemwidePromotionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>(AllSystemwidePromotionsDocument, options);
        }
export type AllSystemwidePromotionsQueryHookResult = ReturnType<typeof useAllSystemwidePromotionsQuery>;
export type AllSystemwidePromotionsLazyQueryHookResult = ReturnType<typeof useAllSystemwidePromotionsLazyQuery>;
export type AllSystemwidePromotionsSuspenseQueryHookResult = ReturnType<typeof useAllSystemwidePromotionsSuspenseQuery>;
export type AllSystemwidePromotionsQueryResult = Apollo.QueryResult<IAllSystemwidePromotionsQuery, IAllSystemwidePromotionsQueryVariables>;
export const LoyaltyOfferConfigsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyOfferConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allConfigOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loyaltyEngineId_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigOfferFragment"}}]}}]}},...ConfigOfferFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions,...MenuImagesFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyOfferConfigsQuery__
 *
 * To run a query within a React component, call `useLoyaltyOfferConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOfferConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOfferConfigsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltyOfferConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables> & ({ variables: ILoyaltyOfferConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>(LoyaltyOfferConfigsDocument, options);
      }
export function useLoyaltyOfferConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>(LoyaltyOfferConfigsDocument, options);
        }
export function useLoyaltyOfferConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>(LoyaltyOfferConfigsDocument, options);
        }
export type LoyaltyOfferConfigsQueryHookResult = ReturnType<typeof useLoyaltyOfferConfigsQuery>;
export type LoyaltyOfferConfigsLazyQueryHookResult = ReturnType<typeof useLoyaltyOfferConfigsLazyQuery>;
export type LoyaltyOfferConfigsSuspenseQueryHookResult = ReturnType<typeof useLoyaltyOfferConfigsSuspenseQuery>;
export type LoyaltyOfferConfigsQueryResult = Apollo.QueryResult<ILoyaltyOfferConfigsQuery, ILoyaltyOfferConfigsQueryVariables>;
export const LoyaltyOfferTemplatesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyOfferTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allOfferTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loyaltyEngineId_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyOfferTemplate"}}]}}]}},...LoyaltyOfferTemplateFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...MenuImagesFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyOfferTemplatesQuery__
 *
 * To run a query within a React component, call `useLoyaltyOfferTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOfferTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOfferTemplatesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltyOfferTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables> & ({ variables: ILoyaltyOfferTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>(LoyaltyOfferTemplatesDocument, options);
      }
export function useLoyaltyOfferTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>(LoyaltyOfferTemplatesDocument, options);
        }
export function useLoyaltyOfferTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>(LoyaltyOfferTemplatesDocument, options);
        }
export type LoyaltyOfferTemplatesQueryHookResult = ReturnType<typeof useLoyaltyOfferTemplatesQuery>;
export type LoyaltyOfferTemplatesLazyQueryHookResult = ReturnType<typeof useLoyaltyOfferTemplatesLazyQuery>;
export type LoyaltyOfferTemplatesSuspenseQueryHookResult = ReturnType<typeof useLoyaltyOfferTemplatesSuspenseQuery>;
export type LoyaltyOfferTemplatesQueryResult = Apollo.QueryResult<ILoyaltyOfferTemplatesQuery, ILoyaltyOfferTemplatesQueryVariables>;
export const LoyaltyPersonalizeOffersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyPersonalizeOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"configEngineIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateEngineIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allConfigOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loyaltyEngineId_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"configEngineIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigOfferFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allOfferTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loyaltyEngineId_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateEngineIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyOfferTemplate"}}]}}]}},...ConfigOfferFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions,...MenuImagesFragmentDoc.definitions,...LoyaltyOfferTemplateFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyPersonalizeOffersQuery__
 *
 * To run a query within a React component, call `useLoyaltyPersonalizeOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyPersonalizeOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyPersonalizeOffersQuery({
 *   variables: {
 *      configEngineIds: // value for 'configEngineIds'
 *      templateEngineIds: // value for 'templateEngineIds'
 *   },
 * });
 */
export function useLoyaltyPersonalizeOffersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ILoyaltyPersonalizeOffersQuery, ILoyaltyPersonalizeOffersQueryVariables> & ({ variables: ILoyaltyPersonalizeOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyPersonalizeOffersQuery, ILoyaltyPersonalizeOffersQueryVariables>(LoyaltyPersonalizeOffersDocument, options);
      }
export function useLoyaltyPersonalizeOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyPersonalizeOffersQuery, ILoyaltyPersonalizeOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyPersonalizeOffersQuery, ILoyaltyPersonalizeOffersQueryVariables>(LoyaltyPersonalizeOffersDocument, options);
        }
export function useLoyaltyPersonalizeOffersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyPersonalizeOffersQuery, ILoyaltyPersonalizeOffersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyPersonalizeOffersQuery, ILoyaltyPersonalizeOffersQueryVariables>(LoyaltyPersonalizeOffersDocument, options);
        }
export type LoyaltyPersonalizeOffersQueryHookResult = ReturnType<typeof useLoyaltyPersonalizeOffersQuery>;
export type LoyaltyPersonalizeOffersLazyQueryHookResult = ReturnType<typeof useLoyaltyPersonalizeOffersLazyQuery>;
export type LoyaltyPersonalizeOffersSuspenseQueryHookResult = ReturnType<typeof useLoyaltyPersonalizeOffersSuspenseQuery>;
export type LoyaltyPersonalizeOffersQueryResult = Apollo.QueryResult<ILoyaltyPersonalizeOffersQuery, ILoyaltyPersonalizeOffersQueryVariables>;
export const FeatureLoyaltyRewardListCategoriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyRewardListCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyRewardListCategoriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RewardList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyRewardListCategoriesId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyEngineId"}}]}}]}}]}}]}},...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyRewardListCategoriesQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyRewardListCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyRewardListCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyRewardListCategoriesQuery({
 *   variables: {
 *      featureLoyaltyRewardListCategoriesId: // value for 'featureLoyaltyRewardListCategoriesId'
 *   },
 * });
 */
export function useFeatureLoyaltyRewardListCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables> & ({ variables: IFeatureLoyaltyRewardListCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>(FeatureLoyaltyRewardListCategoriesDocument, options);
      }
export function useFeatureLoyaltyRewardListCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>(FeatureLoyaltyRewardListCategoriesDocument, options);
        }
export function useFeatureLoyaltyRewardListCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>(FeatureLoyaltyRewardListCategoriesDocument, options);
        }
export type FeatureLoyaltyRewardListCategoriesQueryHookResult = ReturnType<typeof useFeatureLoyaltyRewardListCategoriesQuery>;
export type FeatureLoyaltyRewardListCategoriesLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyRewardListCategoriesLazyQuery>;
export type FeatureLoyaltyRewardListCategoriesSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyRewardListCategoriesSuspenseQuery>;
export type FeatureLoyaltyRewardListCategoriesQueryResult = Apollo.QueryResult<IFeatureLoyaltyRewardListCategoriesQuery, IFeatureLoyaltyRewardListCategoriesQueryVariables>;
export const FeatureLoyaltyShortCodeConfirmationModalDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyShortCodeConfirmationModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"shortCodeConfirmationModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShortCodeConfirmationModalFragment"}}]}}]}}]}},...ShortCodeConfirmationModalFragmentDoc.definitions,...ImagesFragmentDoc.definitions,...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyShortCodeConfirmationModalQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyShortCodeConfirmationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyShortCodeConfirmationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyShortCodeConfirmationModalQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyShortCodeConfirmationModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables> & ({ variables: IFeatureLoyaltyShortCodeConfirmationModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>(FeatureLoyaltyShortCodeConfirmationModalDocument, options);
      }
export function useFeatureLoyaltyShortCodeConfirmationModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>(FeatureLoyaltyShortCodeConfirmationModalDocument, options);
        }
export function useFeatureLoyaltyShortCodeConfirmationModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>(FeatureLoyaltyShortCodeConfirmationModalDocument, options);
        }
export type FeatureLoyaltyShortCodeConfirmationModalQueryHookResult = ReturnType<typeof useFeatureLoyaltyShortCodeConfirmationModalQuery>;
export type FeatureLoyaltyShortCodeConfirmationModalLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyShortCodeConfirmationModalLazyQuery>;
export type FeatureLoyaltyShortCodeConfirmationModalSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyShortCodeConfirmationModalSuspenseQuery>;
export type FeatureLoyaltyShortCodeConfirmationModalQueryResult = Apollo.QueryResult<IFeatureLoyaltyShortCodeConfirmationModalQuery, IFeatureLoyaltyShortCodeConfirmationModalQueryVariables>;
export const FeatureLoyaltyOverrideShortCodeModalContentDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltyOverrideShortCodeModalContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"overrideShortCodeModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discardButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocaleStringFragment"}}]}}]}}]}}]}},...LocaleStringFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltyOverrideShortCodeModalContentQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyOverrideShortCodeModalContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyOverrideShortCodeModalContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyOverrideShortCodeModalContentQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyOverrideShortCodeModalContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables> & ({ variables: IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>(FeatureLoyaltyOverrideShortCodeModalContentDocument, options);
      }
export function useFeatureLoyaltyOverrideShortCodeModalContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>(FeatureLoyaltyOverrideShortCodeModalContentDocument, options);
        }
export function useFeatureLoyaltyOverrideShortCodeModalContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>(FeatureLoyaltyOverrideShortCodeModalContentDocument, options);
        }
export type FeatureLoyaltyOverrideShortCodeModalContentQueryHookResult = ReturnType<typeof useFeatureLoyaltyOverrideShortCodeModalContentQuery>;
export type FeatureLoyaltyOverrideShortCodeModalContentLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyOverrideShortCodeModalContentLazyQuery>;
export type FeatureLoyaltyOverrideShortCodeModalContentSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltyOverrideShortCodeModalContentSuspenseQuery>;
export type FeatureLoyaltyOverrideShortCodeModalContentQueryResult = Apollo.QueryResult<IFeatureLoyaltyOverrideShortCodeModalContentQuery, IFeatureLoyaltyOverrideShortCodeModalContentQueryVariables>;
export const FeatureLoyaltySurpriseModalDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureLoyaltySurpriseModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyUI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureLoyaltyUIId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"surpriseAndDelightModalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noThanksText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prompt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]}},...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureLoyaltySurpriseModalQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltySurpriseModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltySurpriseModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltySurpriseModalQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltySurpriseModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables> & ({ variables: IFeatureLoyaltySurpriseModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>(FeatureLoyaltySurpriseModalDocument, options);
      }
export function useFeatureLoyaltySurpriseModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>(FeatureLoyaltySurpriseModalDocument, options);
        }
export function useFeatureLoyaltySurpriseModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>(FeatureLoyaltySurpriseModalDocument, options);
        }
export type FeatureLoyaltySurpriseModalQueryHookResult = ReturnType<typeof useFeatureLoyaltySurpriseModalQuery>;
export type FeatureLoyaltySurpriseModalLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltySurpriseModalLazyQuery>;
export type FeatureLoyaltySurpriseModalSuspenseQueryHookResult = ReturnType<typeof useFeatureLoyaltySurpriseModalSuspenseQuery>;
export type FeatureLoyaltySurpriseModalQueryResult = Apollo.QueryResult<IFeatureLoyaltySurpriseModalQuery, IFeatureLoyaltySurpriseModalQueryVariables>;
export const FeatureMenuDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureMenuId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureMenu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureMenuId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"menuHeroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cateringAlertText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cateringAlertLinkText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cateringAlertLinkUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cateringSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuHeroText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dayParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"weekDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monday"}},{"kind":"Field","name":{"kind":"Name","value":"tuesday"}},{"kind":"Field","name":{"kind":"Name","value":"wednesday"}},{"kind":"Field","name":{"kind":"Name","value":"thursday"}},{"kind":"Field","name":{"kind":"Name","value":"friday"}},{"kind":"Field","name":{"kind":"Name","value":"saturday"}},{"kind":"Field","name":{"kind":"Name","value":"sunday"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMenu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cateringMenu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"donationTermAndConditionUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"donationItemsAtCheckout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"upsellItemsAtCheckoutRestaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"upsellItemsAtCheckoutDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"upsellItemsAtCheckoutCatering"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorConfigsFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartAddOnSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddOnSectionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartAddOnSectionsCatering"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddOnSectionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuSummaryHeaderModifiable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuSummaryHeaderNotModifiable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}},...ImageFragmentDoc.definitions,...SectionFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...PickerFragmentDoc.definitions,...ComboFragmentDoc.definitions,...ItemFragmentDoc.definitions,...NutritionFragmentDoc.definitions,...AdditionalItemInformationFragmentDoc.definitions,...AllergensFragmentDoc.definitions,...ItemOptionFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions,...QuickConfigFragmentDoc.definitions,...AddOnSectionFragmentDoc.definitions,...AddOnSectionOptionFragmentDoc.definitions,...ItemAvailabilityFragmentDoc.definitions,...ItemOptionAvailabilityFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureMenuQuery__
 *
 * To run a query within a React component, call `useFeatureMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureMenuQuery({
 *   variables: {
 *      featureMenuId: // value for 'featureMenuId'
 *   },
 * });
 */
export function useFeatureMenuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureMenuQuery, IFeatureMenuQueryVariables> & ({ variables: IFeatureMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureMenuQuery, IFeatureMenuQueryVariables>(FeatureMenuDocument, options);
      }
export function useFeatureMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureMenuQuery, IFeatureMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureMenuQuery, IFeatureMenuQueryVariables>(FeatureMenuDocument, options);
        }
export function useFeatureMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureMenuQuery, IFeatureMenuQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureMenuQuery, IFeatureMenuQueryVariables>(FeatureMenuDocument, options);
        }
export type FeatureMenuQueryHookResult = ReturnType<typeof useFeatureMenuQuery>;
export type FeatureMenuLazyQueryHookResult = ReturnType<typeof useFeatureMenuLazyQuery>;
export type FeatureMenuSuspenseQueryHookResult = ReturnType<typeof useFeatureMenuSuspenseQuery>;
export type FeatureMenuQueryResult = Apollo.QueryResult<IFeatureMenuQuery, IFeatureMenuQueryVariables>;
export const FeatureNavigationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureNavigation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureNavigationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDesktop"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureNavigation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureNavigationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationDesktopFragment"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDesktop"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationMobileFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationButtonFragment"}},{"kind":"Field","name":{"kind":"Name","value":"aboutMenuEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavigationSectionFragment"}}]}}]}}]}},...NavigationDesktopFragmentDoc.definitions,...NavigationLinksFragmentDoc.definitions,...NavigationLinkFragmentDoc.definitions,...LinkWidgetFragmentDoc.definitions,...AboutMenuEntriesDesktopFragmentDoc.definitions,...NavigationSectionFragmentDoc.definitions,...NavigationMobileFragmentDoc.definitions,...NavigationTabsFragmentDoc.definitions,...NavigationTabFragmentDoc.definitions,...ImageFragmentDoc.definitions,...AboutMenuEntriesMobileFragmentDoc.definitions,...NavigationButtonFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureNavigationQuery__
 *
 * To run a query within a React component, call `useFeatureNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureNavigationQuery({
 *   variables: {
 *      featureNavigationId: // value for 'featureNavigationId'
 *      isDesktop: // value for 'isDesktop'
 *   },
 * });
 */
export function useFeatureNavigationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureNavigationQuery, IFeatureNavigationQueryVariables> & ({ variables: IFeatureNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>(FeatureNavigationDocument, options);
      }
export function useFeatureNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>(FeatureNavigationDocument, options);
        }
export function useFeatureNavigationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>(FeatureNavigationDocument, options);
        }
export type FeatureNavigationQueryHookResult = ReturnType<typeof useFeatureNavigationQuery>;
export type FeatureNavigationLazyQueryHookResult = ReturnType<typeof useFeatureNavigationLazyQuery>;
export type FeatureNavigationSuspenseQueryHookResult = ReturnType<typeof useFeatureNavigationSuspenseQuery>;
export type FeatureNavigationQueryResult = Apollo.QueryResult<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>;
export const FeatureNutritionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureNutrition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureNutritionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureNutrition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureNutritionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritionTables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionTableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roundingRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoundingRulesFragment"}}]}}]}}]}},...NutritionTableFragmentDoc.definitions,...NutritionItemFragmentDoc.definitions,...NutritionItemGroupFragmentDoc.definitions,...RoundingRulesFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureNutritionQuery__
 *
 * To run a query within a React component, call `useFeatureNutritionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureNutritionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureNutritionQuery({
 *   variables: {
 *      featureNutritionId: // value for 'featureNutritionId'
 *   },
 * });
 */
export function useFeatureNutritionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureNutritionQuery, IFeatureNutritionQueryVariables> & ({ variables: IFeatureNutritionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>(FeatureNutritionDocument, options);
      }
export function useFeatureNutritionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>(FeatureNutritionDocument, options);
        }
export function useFeatureNutritionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>(FeatureNutritionDocument, options);
        }
export type FeatureNutritionQueryHookResult = ReturnType<typeof useFeatureNutritionQuery>;
export type FeatureNutritionLazyQueryHookResult = ReturnType<typeof useFeatureNutritionLazyQuery>;
export type FeatureNutritionSuspenseQueryHookResult = ReturnType<typeof useFeatureNutritionSuspenseQuery>;
export type FeatureNutritionQueryResult = Apollo.QueryResult<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>;
export const FeatureOffersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureOffersId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureOffersId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offersBrowsingPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endOfOffersMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endOfOffersImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emptyStateTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emptyStateBody"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emptyStateImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OffersSelectRestaurantCtaFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offersDetailsPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emptyStateTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emptyStateBody"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emptyStateImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emptyStateAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missingOfferTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missingOfferBody"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missingOfferImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"missingOfferAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offersPageMarketingTiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OffersPageMarketingTileFragment"}}]}}]}}]}},...ImageFragmentDoc.definitions,...OffersSelectRestaurantCtaFragmentDoc.definitions,...OffersPageMarketingTileFragmentDoc.definitions,...MarketingTileFragmentDoc.definitions,...ImagesFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureOffersQuery__
 *
 * To run a query within a React component, call `useFeatureOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureOffersQuery({
 *   variables: {
 *      featureOffersId: // value for 'featureOffersId'
 *   },
 * });
 */
export function useFeatureOffersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureOffersQuery, IFeatureOffersQueryVariables> & ({ variables: IFeatureOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureOffersQuery, IFeatureOffersQueryVariables>(FeatureOffersDocument, options);
      }
export function useFeatureOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureOffersQuery, IFeatureOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureOffersQuery, IFeatureOffersQueryVariables>(FeatureOffersDocument, options);
        }
export function useFeatureOffersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureOffersQuery, IFeatureOffersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureOffersQuery, IFeatureOffersQueryVariables>(FeatureOffersDocument, options);
        }
export type FeatureOffersQueryHookResult = ReturnType<typeof useFeatureOffersQuery>;
export type FeatureOffersLazyQueryHookResult = ReturnType<typeof useFeatureOffersLazyQuery>;
export type FeatureOffersSuspenseQueryHookResult = ReturnType<typeof useFeatureOffersSuspenseQuery>;
export type FeatureOffersQueryResult = Apollo.QueryResult<IFeatureOffersQuery, IFeatureOffersQueryVariables>;
export const FeatureStaticMenuDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featureStaticMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureStaticMenuId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeatureStaticMenu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureStaticMenuId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"itemUnavailableModalFragment"}}]}}]}},...ItemUnavailableModalFragmentDoc.definitions,...ImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useFeatureStaticMenuQuery__
 *
 * To run a query within a React component, call `useFeatureStaticMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureStaticMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureStaticMenuQuery({
 *   variables: {
 *      featureStaticMenuId: // value for 'featureStaticMenuId'
 *   },
 * });
 */
export function useFeatureStaticMenuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables> & ({ variables: IFeatureStaticMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>(FeatureStaticMenuDocument, options);
      }
export function useFeatureStaticMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>(FeatureStaticMenuDocument, options);
        }
export function useFeatureStaticMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>(FeatureStaticMenuDocument, options);
        }
export type FeatureStaticMenuQueryHookResult = ReturnType<typeof useFeatureStaticMenuQuery>;
export type FeatureStaticMenuLazyQueryHookResult = ReturnType<typeof useFeatureStaticMenuLazyQuery>;
export type FeatureStaticMenuSuspenseQueryHookResult = ReturnType<typeof useFeatureStaticMenuSuspenseQuery>;
export type FeatureStaticMenuQueryResult = Apollo.QueryResult<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>;
export const SingleLoyaltyContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"singleLoyaltyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLoyaltyContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSingleLoyaltyContentQuery__
 *
 * To run a query within a React component, call `useSingleLoyaltyContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLoyaltyContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLoyaltyContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSingleLoyaltyContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>(SingleLoyaltyContentDocument, options);
      }
export function useSingleLoyaltyContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>(SingleLoyaltyContentDocument, options);
        }
export function useSingleLoyaltyContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>(SingleLoyaltyContentDocument, options);
        }
export type SingleLoyaltyContentQueryHookResult = ReturnType<typeof useSingleLoyaltyContentQuery>;
export type SingleLoyaltyContentLazyQueryHookResult = ReturnType<typeof useSingleLoyaltyContentLazyQuery>;
export type SingleLoyaltyContentSuspenseQueryHookResult = ReturnType<typeof useSingleLoyaltyContentSuspenseQuery>;
export type SingleLoyaltyContentQueryResult = Apollo.QueryResult<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>;
export const BirthdayLegalTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"birthdayLegalText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyContentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LoyaltyContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyContentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthdayLegalText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useBirthdayLegalTextQuery__
 *
 * To run a query within a React component, call `useBirthdayLegalTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useBirthdayLegalTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBirthdayLegalTextQuery({
 *   variables: {
 *      loyaltyContentId: // value for 'loyaltyContentId'
 *   },
 * });
 */
export function useBirthdayLegalTextQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables> & ({ variables: IBirthdayLegalTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>(BirthdayLegalTextDocument, options);
      }
export function useBirthdayLegalTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>(BirthdayLegalTextDocument, options);
        }
export function useBirthdayLegalTextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>(BirthdayLegalTextDocument, options);
        }
export type BirthdayLegalTextQueryHookResult = ReturnType<typeof useBirthdayLegalTextQuery>;
export type BirthdayLegalTextLazyQueryHookResult = ReturnType<typeof useBirthdayLegalTextLazyQuery>;
export type BirthdayLegalTextSuspenseQueryHookResult = ReturnType<typeof useBirthdayLegalTextSuspenseQuery>;
export type BirthdayLegalTextQueryResult = Apollo.QueryResult<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>;
export const GetOfferByIdDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOfferById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Offer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OffersFragment"}}]}}]}},...OffersFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions,...MenuImagesFragmentDoc.definitions,...ComboMetaFragmentDoc.definitions,...ItemMetaFragmentDoc.definitions,...PickerMetaFragmentDoc.definitions,...ActivateOfferMetaFragmentDoc.definitions,...DiscountOfferMetaFragmentDoc.definitions,...AllowRedemptionWithoutLoginFragmentDoc.definitions,...BetweenDatesFragmentDoc.definitions,...BetweenTimesFragmentDoc.definitions,...CartPropertyFragmentDoc.definitions,...CoolDownFragmentDoc.definitions,...DayOfWeekBandFragmentDoc.definitions,...FirstOrderOnlyFragmentDoc.definitions,...LimitFragmentDoc.definitions,...OrderHistoryFragmentDoc.definitions,...PaymentCardTypeFragmentDoc.definitions,...PurchaseFragmentDoc.definitions,...ProductCategoryFragmentDoc.definitions,...RequiresAssignmentFragmentDoc.definitions,...RestaurantGroupRestrictionListFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useGetOfferByIdQuery__
 *
 * To run a query within a React component, call `useGetOfferByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IGetOfferByIdQuery, IGetOfferByIdQueryVariables> & ({ variables: IGetOfferByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>(GetOfferByIdDocument, options);
      }
export function useGetOfferByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>(GetOfferByIdDocument, options);
        }
export function useGetOfferByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>(GetOfferByIdDocument, options);
        }
export type GetOfferByIdQueryHookResult = ReturnType<typeof useGetOfferByIdQuery>;
export type GetOfferByIdLazyQueryHookResult = ReturnType<typeof useGetOfferByIdLazyQuery>;
export type GetOfferByIdSuspenseQueryHookResult = ReturnType<typeof useGetOfferByIdSuspenseQuery>;
export type GetOfferByIdQueryResult = Apollo.QueryResult<IGetOfferByIdQuery, IGetOfferByIdQueryVariables>;
export const PlaceholderFieldsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaceholderFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPlaceholderFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaceholderFieldFragment"}}]}}]}},...PlaceholderFieldFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __usePlaceholderFieldsQuery__
 *
 * To run a query within a React component, call `usePlaceholderFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaceholderFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>(PlaceholderFieldsDocument, options);
      }
export function usePlaceholderFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>(PlaceholderFieldsDocument, options);
        }
export function usePlaceholderFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>(PlaceholderFieldsDocument, options);
        }
export type PlaceholderFieldsQueryHookResult = ReturnType<typeof usePlaceholderFieldsQuery>;
export type PlaceholderFieldsLazyQueryHookResult = ReturnType<typeof usePlaceholderFieldsLazyQuery>;
export type PlaceholderFieldsSuspenseQueryHookResult = ReturnType<typeof usePlaceholderFieldsSuspenseQuery>;
export type PlaceholderFieldsQueryResult = Apollo.QueryResult<IPlaceholderFieldsQuery, IPlaceholderFieldsQueryVariables>;
export const GetProductCategoryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProductCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCategoryFragment"}}]}}]}},...ProductCategoryFragmentDoc.definitions,...MenuImageFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useGetProductCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IGetProductCategoryQuery, IGetProductCategoryQueryVariables> & ({ variables: IGetProductCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
      }
export function useGetProductCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
        }
export function useGetProductCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
        }
export type GetProductCategoryQueryHookResult = ReturnType<typeof useGetProductCategoryQuery>;
export type GetProductCategoryLazyQueryHookResult = ReturnType<typeof useGetProductCategoryLazyQuery>;
export type GetProductCategorySuspenseQueryHookResult = ReturnType<typeof useGetProductCategorySuspenseQuery>;
export type GetProductCategoryQueryResult = Apollo.QueryResult<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>;
export const GetRestaurantsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRestaurants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allRestaurants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantFragment"}}]}}]}},...RestaurantFragmentDoc.definitions,...HoursFragmentDoc.definitions,...ImageAssetFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useGetRestaurantsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRestaurantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, options);
      }
export function useGetRestaurantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, options);
        }
export function useGetRestaurantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, options);
        }
export type GetRestaurantsQueryHookResult = ReturnType<typeof useGetRestaurantsQuery>;
export type GetRestaurantsLazyQueryHookResult = ReturnType<typeof useGetRestaurantsLazyQuery>;
export type GetRestaurantsSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantsSuspenseQuery>;
export type GetRestaurantsQueryResult = Apollo.QueryResult<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>;
export const GetRestaurantLoyaltyEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRestaurantLoyaltyEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Restaurant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasLoyalty"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetRestaurantLoyaltyEnabledQuery__
 *
 * To run a query within a React component, call `useGetRestaurantLoyaltyEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantLoyaltyEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantLoyaltyEnabledQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useGetRestaurantLoyaltyEnabledQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables> & ({ variables: IGetRestaurantLoyaltyEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>(GetRestaurantLoyaltyEnabledDocument, options);
      }
export function useGetRestaurantLoyaltyEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>(GetRestaurantLoyaltyEnabledDocument, options);
        }
export function useGetRestaurantLoyaltyEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>(GetRestaurantLoyaltyEnabledDocument, options);
        }
export type GetRestaurantLoyaltyEnabledQueryHookResult = ReturnType<typeof useGetRestaurantLoyaltyEnabledQuery>;
export type GetRestaurantLoyaltyEnabledLazyQueryHookResult = ReturnType<typeof useGetRestaurantLoyaltyEnabledLazyQuery>;
export type GetRestaurantLoyaltyEnabledSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantLoyaltyEnabledSuspenseQuery>;
export type GetRestaurantLoyaltyEnabledQueryResult = Apollo.QueryResult<IGetRestaurantLoyaltyEnabledQuery, IGetRestaurantLoyaltyEnabledQueryVariables>;
export const LoyaltyRewardsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardFragment"}}]}}]}},...RewardFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...ImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>(LoyaltyRewardsDocument, options);
      }
export function useLoyaltyRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>(LoyaltyRewardsDocument, options);
        }
export function useLoyaltyRewardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>(LoyaltyRewardsDocument, options);
        }
export type LoyaltyRewardsQueryHookResult = ReturnType<typeof useLoyaltyRewardsQuery>;
export type LoyaltyRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyRewardsLazyQuery>;
export type LoyaltyRewardsSuspenseQueryHookResult = ReturnType<typeof useLoyaltyRewardsSuspenseQuery>;
export type LoyaltyRewardsQueryResult = Apollo.QueryResult<ILoyaltyRewardsQuery, ILoyaltyRewardsQueryVariables>;
export const CmsConfigRewardsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmsConfigRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allConfigRewards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmsConfigRewardFragment"}}]}}]}},...CmsConfigRewardFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...ImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useCmsConfigRewardsQuery__
 *
 * To run a query within a React component, call `useCmsConfigRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsConfigRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsConfigRewardsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCmsConfigRewardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ICmsConfigRewardsQuery, ICmsConfigRewardsQueryVariables> & ({ variables: ICmsConfigRewardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ICmsConfigRewardsQuery, ICmsConfigRewardsQueryVariables>(CmsConfigRewardsDocument, options);
      }
export function useCmsConfigRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ICmsConfigRewardsQuery, ICmsConfigRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ICmsConfigRewardsQuery, ICmsConfigRewardsQueryVariables>(CmsConfigRewardsDocument, options);
        }
export function useCmsConfigRewardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ICmsConfigRewardsQuery, ICmsConfigRewardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ICmsConfigRewardsQuery, ICmsConfigRewardsQueryVariables>(CmsConfigRewardsDocument, options);
        }
export type CmsConfigRewardsQueryHookResult = ReturnType<typeof useCmsConfigRewardsQuery>;
export type CmsConfigRewardsLazyQueryHookResult = ReturnType<typeof useCmsConfigRewardsLazyQuery>;
export type CmsConfigRewardsSuspenseQueryHookResult = ReturnType<typeof useCmsConfigRewardsSuspenseQuery>;
export type CmsConfigRewardsQueryResult = Apollo.QueryResult<ICmsConfigRewardsQuery, ICmsConfigRewardsQueryVariables>;
export const LoyaltyFeaturedRewardsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyFeaturedRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allRewardsSections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sanityInternalName"},"value":{"kind":"StringValue","value":"FeatureRewards","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardsSectionFragment"}}]}}]}},...RewardsSectionFragmentDoc.definitions,...RewardFragmentDoc.definitions,...MenuImageFragmentDoc.definitions,...ImageFragmentDoc.definitions,...VendorConfigsFragmentDoc.definitions,...VendorConfigFragmentDoc.definitions]} as unknown as DocumentNode;

/**
 * __useLoyaltyFeaturedRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyFeaturedRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyFeaturedRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyFeaturedRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyFeaturedRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>(LoyaltyFeaturedRewardsDocument, options);
      }
export function useLoyaltyFeaturedRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>(LoyaltyFeaturedRewardsDocument, options);
        }
export function useLoyaltyFeaturedRewardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>(LoyaltyFeaturedRewardsDocument, options);
        }
export type LoyaltyFeaturedRewardsQueryHookResult = ReturnType<typeof useLoyaltyFeaturedRewardsQuery>;
export type LoyaltyFeaturedRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyFeaturedRewardsLazyQuery>;
export type LoyaltyFeaturedRewardsSuspenseQueryHookResult = ReturnType<typeof useLoyaltyFeaturedRewardsSuspenseQuery>;
export type LoyaltyFeaturedRewardsQueryResult = Apollo.QueryResult<ILoyaltyFeaturedRewardsQuery, ILoyaltyFeaturedRewardsQueryVariables>;
export const GetSupportDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportDataId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SupportData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportDataId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"supportCategoryGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeForceIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryForwardToOrders"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryServiceModeSelector"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryFaqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportFaqTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqMParticleEvent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryNeverArriveSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeForceIssueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMissingItemsSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeForceIssueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderingIssuesCategoryGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportDataFaqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportFaqTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqMParticleEvent"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetSupportDataQuery__
 *
 * To run a query within a React component, call `useGetSupportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportDataQuery({
 *   variables: {
 *      supportDataId: // value for 'supportDataId'
 *   },
 * });
 */
export function useGetSupportDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IGetSupportDataQuery, IGetSupportDataQueryVariables> & ({ variables: IGetSupportDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IGetSupportDataQuery, IGetSupportDataQueryVariables>(GetSupportDataDocument, options);
      }
export function useGetSupportDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportDataQuery, IGetSupportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IGetSupportDataQuery, IGetSupportDataQueryVariables>(GetSupportDataDocument, options);
        }
export function useGetSupportDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IGetSupportDataQuery, IGetSupportDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IGetSupportDataQuery, IGetSupportDataQueryVariables>(GetSupportDataDocument, options);
        }
export type GetSupportDataQueryHookResult = ReturnType<typeof useGetSupportDataQuery>;
export type GetSupportDataLazyQueryHookResult = ReturnType<typeof useGetSupportDataLazyQuery>;
export type GetSupportDataSuspenseQueryHookResult = ReturnType<typeof useGetSupportDataSuspenseQuery>;
export type GetSupportDataQueryResult = Apollo.QueryResult<IGetSupportDataQuery, IGetSupportDataQueryVariables>;
export const GetSupportSubcategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportSubcategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SupportSubcategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_rev"}},{"kind":"Field","name":{"kind":"Name","value":"_updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeForceIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryFaqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportFaqTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqMParticleEvent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directTicketProcessingPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryFaq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportFaqTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqMParticleEvent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryForwardToOrders"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryServiceModeSelector"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategorySubmitToSutherland"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetSupportSubcategoryQuery__
 *
 * To run a query within a React component, call `useGetSupportSubcategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportSubcategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportSubcategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupportSubcategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables> & ({ variables: IGetSupportSubcategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>(GetSupportSubcategoryDocument, options);
      }
export function useGetSupportSubcategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>(GetSupportSubcategoryDocument, options);
        }
export function useGetSupportSubcategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>(GetSupportSubcategoryDocument, options);
        }
export type GetSupportSubcategoryQueryHookResult = ReturnType<typeof useGetSupportSubcategoryQuery>;
export type GetSupportSubcategoryLazyQueryHookResult = ReturnType<typeof useGetSupportSubcategoryLazyQuery>;
export type GetSupportSubcategorySuspenseQueryHookResult = ReturnType<typeof useGetSupportSubcategorySuspenseQuery>;
export type GetSupportSubcategoryQueryResult = Apollo.QueryResult<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>;
export const GetSupportCategoryGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportCategoryGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SupportCategoryGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showRestaurantSelector"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeForceIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryForwardToOrders"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryServiceModeSelector"}},{"kind":"Field","name":{"kind":"Name","value":"supportSubcategoryFaqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportFaqTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"localeRaw"},"name":{"kind":"Name","value":"enRaw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportFaqMParticleEvent"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetSupportCategoryGroupQuery__
 *
 * To run a query within a React component, call `useGetSupportCategoryGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportCategoryGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportCategoryGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupportCategoryGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables> & ({ variables: IGetSupportCategoryGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>(GetSupportCategoryGroupDocument, options);
      }
export function useGetSupportCategoryGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>(GetSupportCategoryGroupDocument, options);
        }
export function useGetSupportCategoryGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>(GetSupportCategoryGroupDocument, options);
        }
export type GetSupportCategoryGroupQueryHookResult = ReturnType<typeof useGetSupportCategoryGroupQuery>;
export type GetSupportCategoryGroupLazyQueryHookResult = ReturnType<typeof useGetSupportCategoryGroupLazyQuery>;
export type GetSupportCategoryGroupSuspenseQueryHookResult = ReturnType<typeof useGetSupportCategoryGroupSuspenseQuery>;
export type GetSupportCategoryGroupQueryResult = Apollo.QueryResult<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>;
import { disableFragmentWarnings } from '@apollo/client';
disableFragmentWarnings();
